
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9aCz1", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6ad2f62f86b85704$export$6503ec6e8aabbaf; }, function (v) { return $6ad2f62f86b85704$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $6ad2f62f86b85704$export$f7ad0328861e2f03; }, function (v) { return $6ad2f62f86b85704$export$f7ad0328861e2f03 = v; });
var $6ad2f62f86b85704$export$6503ec6e8aabbaf;
var $6ad2f62f86b85704$export$f7ad0328861e2f03;
"use strict";
var $6ad2f62f86b85704$var$mapping = new Map();
function $6ad2f62f86b85704$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$6ad2f62f86b85704$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $6ad2f62f86b85704$var$resolve(id) {
    var resolved = $6ad2f62f86b85704$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$6ad2f62f86b85704$export$6503ec6e8aabbaf = $6ad2f62f86b85704$var$register;
$6ad2f62f86b85704$export$f7ad0328861e2f03 = $6ad2f62f86b85704$var$resolve;

});

parcelRegister("6tzh6", function(module, exports) {

var $kBBWp = parcelRequire("kBBWp");
module.exports = $kBBWp("fvYZz").then(()=>parcelRequire('ajb0n'));

});
parcelRegister("kBBWp", function(module, exports) {
"use strict";

function $f004b1a8624782fc$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("9aCz1")).resolve(id));
}
module.exports = $f004b1a8624782fc$var$load;

});


var $63c49fbefcfd75d8$exports = {};

(parcelRequire("9aCz1")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"fVHhy\",\"index.55723f0c.js\",\"gGNDl\",\"../lightningcss_node.a3d2d83a.wasm\",\"fvYZz\",\"../_empty.7f8e24fc.js\"]"));

var $4e05f0b265294e4f$exports = {};

$parcel$defineInteropFlag($4e05f0b265294e4f$exports);

$parcel$export($4e05f0b265294e4f$exports, "default", function () { return $4e05f0b265294e4f$export$2e2bcd8739ae039; });
$parcel$export($4e05f0b265294e4f$exports, "transform", function () { return $4e05f0b265294e4f$export$51186ad6e864892a; });
$parcel$export($4e05f0b265294e4f$exports, "transformStyleAttribute", function () { return $4e05f0b265294e4f$export$79db19e3a95e21e3; });
$parcel$export($4e05f0b265294e4f$exports, "bundle", function () { return $4e05f0b265294e4f$export$1f0ba71ea6f249e7; });
$parcel$export($4e05f0b265294e4f$exports, "bundleAsync", function () { return $4e05f0b265294e4f$export$307411107219ba12; });
$parcel$export($4e05f0b265294e4f$exports, "browserslistToTargets", function () { return $4d7b4285d75b240f$export$a04aae4fa31ab2f6; });
$parcel$export($4e05f0b265294e4f$exports, "Features", function () { return $afc1711c436a5a81$export$617d79dae526d2cf; });
$parcel$export($4e05f0b265294e4f$exports, "composeVisitors", function () { return $4279369ed1bb0163$export$b055b48f61c84d24; });
const $8631b56d5d253785$var$NAPI_OK = 0;
const $8631b56d5d253785$var$NAPI_INVALID_ARG = 1;
const $8631b56d5d253785$var$NAPI_STRING_EXPECTED = 3;
const $8631b56d5d253785$var$NAPI_NUMBER_EXPECTED = 6;
const $8631b56d5d253785$var$NAPI_BOOLEAN_EXPECTED = 7;
const $8631b56d5d253785$var$NAPI_GENERIC_FAILURE = 9;
const $8631b56d5d253785$var$NAPI_PENDING_EXCEPTION = 10;
const $8631b56d5d253785$var$NAPI_CANCELED = 11;
const $8631b56d5d253785$var$NAPI_HANDLE_SCOPE_MISMATCH = 13;
const $8631b56d5d253785$var$NAPI_BIGINT_EXPECTED = 17;
const $8631b56d5d253785$var$NAPI_NO_EXTERNAL_BUFFERS_ALLOWED = 22;
// https://nodejs.org/api/n-api.html#napi_property_attributes
const $8631b56d5d253785$var$NAPI_WRITABLE = 1;
const $8631b56d5d253785$var$NAPI_ENUMERABLE = 2;
const $8631b56d5d253785$var$NAPI_CONFIGURABLE = 4;
const $8631b56d5d253785$var$NAPI_STATIC = 1024;
// https://nodejs.org/api/n-api.html#napi_typedarray_type
const $8631b56d5d253785$var$typedArrays = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    BigInt64Array,
    BigUint64Array
];
const $8631b56d5d253785$var$environments = [];
class $8631b56d5d253785$export$7dc6752a22ab011a {
    scopes = [];
    referenceId = 1;
    references = new Map();
    deferred = [
        null
    ];
    wrappedObjects = new WeakMap();
    externalObjects = new WeakMap();
    buffers = new Map();
    instanceData = 0;
    pendingException = null;
    constructor(instance){
        this.id = $8631b56d5d253785$var$environments.length;
        $8631b56d5d253785$var$environments.push(this);
        this.instance = instance;
        this.table = instance.exports.__indirect_function_table;
        this.exports = {};
        this.pushScope();
        let values = this.scopes[this.scopes.length - 1];
        let exports = values.length;
        values.push(this.exports);
        try {
            if (this.instance.exports.napi_register_module_v1) this.instance.exports.napi_register_module_v1(this.id, exports);
            if (this.instance.exports.napi_register_wasm_v1) this.instance.exports.napi_register_wasm_v1(this.id, exports);
        } finally{
            this.popScope();
            if (this.pendingException) {
                let e = this.pendingException;
                this.pendingException = null;
                throw e;
            }
        }
    }
    destroy() {
        $8631b56d5d253785$var$environments[this.id] = undefined;
    }
    getString(ptr, len = $8631b56d5d253785$var$strlen(this.memory, ptr)) {
        return $8631b56d5d253785$var$decoder.decode(this.memory.subarray(ptr, Math.max(0, ptr + len)));
    }
    pushScope() {
        let id = this.scopes.length;
        this.scopes.push(id ? [
            ...this.scopes[id - 1]
        ] : [
            undefined,
            null,
            globalThis,
            true,
            false
        ]);
        return id;
    }
    popScope() {
        this.scopes.pop();
        // Update any buffers with values which might have been modified in WASM copy.
        for (let [buffer, slice] of this.buffers)// Ignore if buffer or slice has been detached.
        if (buffer.byteLength && slice.byteLength) buffer.set(slice);
        this.buffers.clear();
    }
    get(idx) {
        return this.scopes[this.scopes.length - 1][idx];
    }
    set(idx, value) {
        this.scopes[this.scopes.length - 1][idx] = value;
    }
    pushValue(value, scope = this.scopes.length - 1) {
        let values = this.scopes[scope];
        let id = values.length;
        values.push(value);
        return id;
    }
    createValue(value, result, scope) {
        if (typeof value === 'boolean') {
            this.setPointer(result, value ? 3 : 4);
            return $8631b56d5d253785$var$NAPI_OK;
        } else if (typeof value === 'undefined') {
            this.setPointer(result, 0);
            return $8631b56d5d253785$var$NAPI_OK;
        } else if (value === null) {
            this.setPointer(result, 1);
            return $8631b56d5d253785$var$NAPI_OK;
        } else if (value === globalThis) {
            this.setPointer(result, 2);
            return $8631b56d5d253785$var$NAPI_OK;
        }
        let id = this.pushValue(value, scope);
        this.setPointer(result, id);
        return $8631b56d5d253785$var$NAPI_OK;
    }
    setPointer(ptr, value) {
        this.u32[ptr >> 2] = value;
        return $8631b56d5d253785$var$NAPI_OK;
    }
    _u32 = new Uint32Array();
    get u32() {
        if (this._u32.byteLength === 0) this._u32 = new Uint32Array(this.instance.exports.memory.buffer);
        return this._u32;
    }
    _i32 = new Int32Array();
    get i32() {
        if (this._i32.byteLength === 0) this._i32 = new Int32Array(this.instance.exports.memory.buffer);
        return this._i32;
    }
    _u16 = new Uint16Array();
    get u16() {
        if (this._u16.byteLength === 0) this._u16 = new Uint16Array(this.instance.exports.memory.buffer);
        return this._u16;
    }
    _u64 = new BigUint64Array();
    get u64() {
        if (this._u64.byteLength === 0) this._u64 = new BigUint64Array(this.instance.exports.memory.buffer);
        return this._u64;
    }
    _i64 = new BigInt64Array();
    get i64() {
        if (this._i64.byteLength === 0) this._i64 = new BigInt64Array(this.instance.exports.memory.buffer);
        return this._i64;
    }
    _f64 = new Float64Array();
    get f64() {
        if (this._f64.byteLength === 0) this._f64 = new Float64Array(this.instance.exports.memory.buffer);
        return this._f64;
    }
    _buf = new Uint8Array();
    get memory() {
        if (this._buf.byteLength === 0) this._buf = new Uint8Array(this.instance.exports.memory.buffer);
        return this._buf;
    }
    getBufferInfo(buf1, ptr) {
        if (this.buffers.has(buf1)) {
            let b = this.buffers.get(buf1);
            this.setPointer(ptr, b.byteOffset);
            return b.byteLength;
        }
        if (buf1 instanceof ArrayBuffer) {
            let b = this.copyBuffer(new Uint8Array(buf1));
            this.setPointer(ptr, b.byteOffset);
            return b.byteLength;
        }
        // If this is a view into WASM memory, no copies needed.
        if (buf1.buffer === this.instance.exports.memory.buffer) {
            this.setPointer(ptr, buf1.byteOffset);
            return buf1.byteLength;
        }
        let b = this.copyBuffer(new Uint8Array(buf1.buffer, buf1.byteOffset, buf1.byteLength));
        this.setPointer(ptr, b.byteOffset);
        return b.byteLength;
    }
    copyBuffer(data) {
        let ptr = this.instance.exports.napi_wasm_malloc(data.byteLength);
        let mem = this.memory;
        mem.set(data, ptr);
        let buf1 = mem.subarray(ptr, ptr + data.byteLength);
        let finalize = (_env, data)=>{
            if (this.instance.exports.napi_wasm_free) this.instance.exports.napi_wasm_free(data);
        };
        $8631b56d5d253785$var$finalizationRegistry.register(buf1, new $8631b56d5d253785$var$FinalizeRecord(this.id, finalize, 0, ptr));
        this.buffers.set(data, buf1);
        return buf1;
    }
    createFunction(cb, data) {
        let env1 = this;
        let fn = env1.table.get(cb);
        let func = function(...args) {
            let scope = env1.pushScope();
            try {
                let values = env1.scopes[scope];
                let info = values.length;
                values.push({
                    thisArg: this,
                    args: args,
                    data: data,
                    newTarget: new.target
                });
                let res = fn(env1.id, info);
                return env1.get(res);
            } finally{
                env1.popScope();
                if (env1.pendingException) {
                    let e = env1.pendingException;
                    env1.pendingException = null;
                    throw e;
                }
            }
        };
        return func;
    }
    readPropertyDescriptor(ptr) {
        // https://nodejs.org/api/n-api.html#napi_property_descriptor
        let buf1 = this.u32;
        let utf8name = buf1[ptr++];
        let nameValue = buf1[ptr++];
        let method = buf1[ptr++];
        let getter = buf1[ptr++];
        let setter = buf1[ptr++];
        let val = buf1[ptr++];
        let attrs = buf1[ptr++];
        let data = buf1[ptr++];
        let name = utf8name ? this.getString(utf8name) : this.get(nameValue);
        let writable = Boolean(attrs & $8631b56d5d253785$var$NAPI_WRITABLE);
        let enumerable = Boolean(attrs & $8631b56d5d253785$var$NAPI_ENUMERABLE);
        let configurable = Boolean(attrs & $8631b56d5d253785$var$NAPI_CONFIGURABLE);
        let isStatic = Boolean(attrs & $8631b56d5d253785$var$NAPI_STATIC);
        let get = getter ? this.createFunction(getter, data) : undefined;
        let set = setter ? this.createFunction(setter, data) : undefined;
        let value = method ? this.createFunction(method, data) : val ? this.get(val) : undefined;
        let descriptor = {
            name: name,
            static: isStatic,
            configurable: configurable,
            enumerable: enumerable
        };
        if (get || set) {
            descriptor.get = get;
            descriptor.set = set;
        } else if (value) {
            descriptor.writable = writable;
            descriptor.value = value;
        }
        return descriptor;
    }
}
const $8631b56d5d253785$var$decoder = new TextDecoder("utf-8", {
    ignoreBOM: true,
    fatal: true
});
const $8631b56d5d253785$var$latin1Decoder = new TextDecoder('latin1');
const $8631b56d5d253785$var$utf16Decoder = new TextDecoder('utf-16');
const $8631b56d5d253785$var$encoder = new TextEncoder();
class $8631b56d5d253785$var$FinalizeRecord {
    constructor(env1, finalize, hint, data){
        this.env = env1;
        this.finalize = finalize;
        this.hint = hint;
        this.data = data;
    }
}
const $8631b56d5d253785$var$finalizationRegistry = new FinalizationRegistry((buffer)=>{
    if (buffer.finalize) buffer.finalize(buffer.env, buffer.data, buffer.hint);
});
class $8631b56d5d253785$var$ExternalValue {
}
const $8631b56d5d253785$var$threadsafeFunctions = [];
class $8631b56d5d253785$var$ThreadSafeFunction {
    constructor(env1, fn, nativeFn, context){
        this.env = env1;
        this.fn = fn;
        this.nativeFn = nativeFn;
        this.context = context;
        this.id = $8631b56d5d253785$var$threadsafeFunctions.length;
        $8631b56d5d253785$var$threadsafeFunctions.push(this);
    }
}
const $8631b56d5d253785$var$asyncWork = [
    null
];
class $8631b56d5d253785$var$AsyncWork {
    constructor(env1, execute, complete, data){
        this.env = env1;
        this.execute = execute;
        this.complete = complete;
        this.data = data;
        this.id = $8631b56d5d253785$var$asyncWork.length;
        $8631b56d5d253785$var$asyncWork.push(this);
    }
}
const $8631b56d5d253785$export$463bd622e1f7aed9 = {
    napi_open_handle_scope (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let id = env1.pushScope();
        return env1.setPointer(result, id);
    },
    napi_close_handle_scope (env_id, scope) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        if (scope !== env1.scopes.length - 1) return $8631b56d5d253785$var$NAPI_HANDLE_SCOPE_MISMATCH;
        env1.popScope();
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_open_escapable_handle_scope (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let id = env1.pushScope();
        return env1.setPointer(result, id);
    },
    napi_close_escapable_handle_scope (env_id, scope) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        if (scope !== env1.scopes.length - 1) return $8631b56d5d253785$var$NAPI_HANDLE_SCOPE_MISMATCH;
        env1.popScope();
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_escape_handle (env_id, scope_id, escapee, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let value = env1.get(escapee);
        // Create a value in the outer scope.
        return env1.createValue(value, result, scope_id - 1);
    },
    napi_create_object (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue({}, result);
    },
    napi_set_property (env_id, object, key, value) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.get(key);
        let val = env1.get(value);
        obj[name] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_property (env_id, object, key, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.get(key);
        return env1.createValue(obj[name], result);
    },
    napi_delete_property (env_id, object, key, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.get(key);
        let res = false;
        try {
            res = delete obj[name];
        } catch (err) {}
        if (result) env1.memory[result] = res ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_has_property (env_id, object, key, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.get(key);
        // return env.setPointer(result, name in obj ? 1 : 0);
        env1.memory[result] = name in obj ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_has_own_property (env_id, object, key, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.get(key);
        env1.memory[result] = obj.hasOwnProperty(name) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_set_named_property (env_id, object, utf8Name, value) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let val = env1.get(value);
        let name = env1.getString(utf8Name);
        obj[name] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_named_property (env_id, object, utf8Name, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.getString(utf8Name);
        return env1.createValue(obj[name], result);
    },
    napi_has_named_property (env_id, object, utf8Name, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let name = env1.getString(utf8Name);
        env1.memory[result] = name in obj ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_property_names (env_id, object, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let properties = Object.keys(obj);
        return env1.createValue(properties, result);
    },
    napi_get_all_property_names (env_id, object, key_mode, key_filter, key_conversion, result) {
        throw new Error('not implemented');
    },
    napi_define_properties (env_id, object, property_count, properties) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let ptr = properties >> 2;
        for(let i = 0; i < property_count; i++){
            let descriptor = env1.readPropertyDescriptor(ptr);
            Object.defineProperty(obj, descriptor.name, descriptor);
            ptr += 8;
        }
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_object_freeze (env_id, object) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        Object.freeze(obj);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_object_seal (env_id, object) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        Object.seal(obj);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_prototype (env_id, object, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        return env1.createValue(Object.getPrototypeOf(obj), result);
    },
    napi_define_class (env_id, utf8name, length, constructor, data, property_count, properties, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let func = env1.createFunction(constructor, data);
        Object.defineProperty(func, 'name', {
            value: env1.getString(utf8name, length),
            configurable: true
        });
        let ptr = properties >> 2;
        for(let i = 0; i < property_count; i++){
            let descriptor = env1.readPropertyDescriptor(ptr);
            if (descriptor.static) Object.defineProperty(func, descriptor.name, descriptor);
            else Object.defineProperty(func.prototype, descriptor.name, descriptor);
            ptr += 8;
        }
        return env1.createValue(func, result);
    },
    napi_create_reference (env_id, value, refcount, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let id = env1.referenceId++;
        env1.references.set(id, {
            value: env1.get(value),
            refcount: refcount
        });
        return env1.setPointer(result, id);
    },
    napi_delete_reference (env_id, ref) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        env1.references.delete(ref);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_reference_value (env_id, ref, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let reference = env1.references.get(ref);
        return env1.createValue(reference.value, result);
    },
    napi_reference_ref (env_id, ref, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let reference = env1.references.get(ref);
        reference.refcount++;
        return env1.setPointer(result, reference.refcount);
    },
    napi_reference_unref (env_id, ref, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let reference = env1.references.get(ref);
        if (reference.refcount === 0) return $8631b56d5d253785$var$NAPI_GENERIC_FAILURE;
        reference.refcount--;
        return env1.setPointer(result, reference.refcount);
    },
    napi_add_env_cleanup_hook () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_remove_env_cleanup_hook () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_add_async_cleanup_hook () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_remove_async_cleanup_hook () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_set_instance_data (env_id, data, finalize_cb, finalize_hint) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        env1.instanceData = data;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_instance_data (env_id, data) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.setPointer(data, env1.instanceData);
    },
    napi_get_boolean (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.setPointer(result, value ? 3 : 4);
    },
    napi_get_value_bool (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "boolean") return $8631b56d5d253785$var$NAPI_BOOLEAN_EXPECTED;
        env1.memory[result] = val ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_int32 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(value, result);
    },
    napi_get_value_int32 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "number") return $8631b56d5d253785$var$NAPI_NUMBER_EXPECTED;
        env1.i32[result >> 2] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_uint32 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(value, result);
    },
    napi_get_value_uint32 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "number") return $8631b56d5d253785$var$NAPI_NUMBER_EXPECTED;
        return env1.setPointer(result, val);
    },
    napi_create_int64 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(Number(value), result);
    },
    napi_get_value_int64 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "number") return $8631b56d5d253785$var$NAPI_NUMBER_EXPECTED;
        env1.i64[result >> 3] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_double (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(value, result);
    },
    napi_get_value_double (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "number") return $8631b56d5d253785$var$NAPI_NUMBER_EXPECTED;
        env1.f64[result >> 3] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_bigint_int64 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(BigInt.asIntN(64, value), result);
    },
    napi_get_value_bigint_int64 (env_id, value, result, lossless) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "bigint") return $8631b56d5d253785$var$NAPI_BIGINT_EXPECTED;
        env1.i64[result >> 3] = val;
        if (lossless) env1.memory[lossless] = BigInt.asIntN(64, val) === val ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_bigint_uint64 (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(BigInt.asUintN(64, value), result);
    },
    napi_get_value_bigint_uint64 (env_id, value, result, lossless) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "bigint") return $8631b56d5d253785$var$NAPI_BIGINT_EXPECTED;
        env1.u64[result >> 3] = val;
        if (lossless) env1.memory[lossless] = BigInt.asUintN(64, val) === val ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_bigint_words (env_id, sign_bit, word_count, words, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buf1 = env1.u64;
        let ptr = words >> 3;
        let res = 0n;
        let shift = 0n;
        for(let i = 0; i < word_count; i++){
            let word = buf1[ptr++];
            res += word << shift;
            shift += 64n;
        }
        res *= BigInt((-1) ** sign_bit);
        return env1.createValue(res, result);
    },
    napi_get_value_bigint_words (env_id, value, sign_bit, word_count, words) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "bigint") return $8631b56d5d253785$var$NAPI_BIGINT_EXPECTED;
        let count = env1.u32[word_count >> 2];
        if (sign_bit) env1.i32[sign_bit] = val < 0n ? 1 : 0;
        let i = 0;
        if (words) {
            let mask = (1n << 64n) - 1n;
            let buf1 = env1.u64;
            let ptr = words >> 3;
            if (val < 0n) val = -val;
            for(; i < count && val !== 0n; i++){
                buf1[ptr++] = val & mask;
                val >>= 64n;
            }
        }
        while(val > 0n){
            i++;
            val >>= 64n;
        }
        return env1.setPointer(word_count, i);
    },
    napi_get_null (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.setPointer(result, 1);
    },
    napi_create_array (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue([], result);
    },
    napi_create_array_with_length (env_id, length, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(new Array(length), result);
    },
    napi_set_element (env_id, object, index, value) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let val = env1.get(value);
        obj[index] = val;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_element (env_id, object, index, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let val = obj[index];
        return env1.createValue(val, result);
    },
    napi_has_element (env_id, object, index, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        env1.memory[result] = obj.hasOwnProperty(index) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_delete_element (env_id, object, index, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let res = false;
        try {
            res = delete obj[index];
        } catch (err) {}
        if (result) env1.memory[result] = res ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_array_length (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        return env1.setPointer(result, val.length);
    },
    napi_get_undefined (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.setPointer(result, 0);
    },
    napi_create_function (env_id, utf8name, length, cb, data, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let func = env1.createFunction(cb, data);
        Object.defineProperty(func, 'name', {
            value: env1.getString(utf8name, length),
            configurable: true
        });
        return env1.createValue(func, result);
    },
    napi_call_function (env_id, recv, func, argc, argv, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let thisArg = env1.get(recv);
        let fn = env1.get(func);
        let args = new Array(argc);
        let mem = env1.u32;
        for(let i = 0; i < argc; i++){
            args[i] = env1.get(mem[argv >> 2]);
            argv += 4;
        }
        try {
            let res = fn.apply(thisArg, args);
            return env1.createValue(res, result);
        } catch (err) {
            env1.pendingException = err;
            return $8631b56d5d253785$var$NAPI_PENDING_EXCEPTION;
        }
    },
    napi_new_instance (env_id, cons, argc, argv, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let Class = env1.get(cons);
        let args = new Array(argc);
        let mem = env1.u32;
        for(let i = 0; i < argc; i++){
            args[i] = env1.get(mem[argv >> 2]);
            argv += 4;
        }
        try {
            let value = new Class(...args);
            return env1.createValue(value, result);
        } catch (err) {
            env1.pendingException = err;
            return $8631b56d5d253785$var$NAPI_PENDING_EXCEPTION;
        }
    },
    napi_get_cb_info (env_id, cbinfo, argc, argv, thisArg, data) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let info = env1.get(cbinfo);
        env1.setPointer(argc, info.args.length);
        for(let i = 0; i < info.args.length; i++){
            env1.createValue(info.args[i], argv);
            argv += 4;
        }
        env1.createValue(info.thisArg, thisArg);
        env1.setPointer(data, info.data);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_get_new_target (env_id, cbinfo, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let info = env1.get(cbinfo);
        return env1.createValue(info.newTarget, result);
    },
    napi_create_threadsafe_function (env_id, func, async_resource, async_resource_name, max_queue_size, initial_thread_count, thread_finalize_data, thread_finalize_cb, context, call_js_cb, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let fn = func ? env1.get(func) : undefined;
        let cb = call_js_cb ? env1.table.get(call_js_cb) : undefined;
        let f = new $8631b56d5d253785$var$ThreadSafeFunction(env1, fn, cb, context);
        if (thread_finalize_cb) {
            let cb = env1.table.get(thread_finalize_cb);
            $8631b56d5d253785$var$finalizationRegistry.register(f, new $8631b56d5d253785$var$FinalizeRecord(env_id, cb, 0, f.id));
        }
        env1.setPointer(result, f.id);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_ref_threadsafe_function () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_unref_threadsafe_function () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_acquire_threadsafe_function () {
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_release_threadsafe_function (func, mode) {
        $8631b56d5d253785$var$threadsafeFunctions[func] = undefined;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_call_threadsafe_function (func, data, is_blocking) {
        let f = $8631b56d5d253785$var$threadsafeFunctions[func];
        f.env.pushScope();
        try {
            if (f.nativeFn) {
                let id = f.fn ? f.env.pushValue(f.fn) : 0;
                f.nativeFn(f.env.id, id, f.context, data);
            } else if (f.fn) f.fn();
        } finally{
            f.env.popScope();
        }
    },
    napi_get_threadsafe_function_context (func, result) {
        let f = $8631b56d5d253785$var$threadsafeFunctions[func];
        f.env.setPointer(result, f.context);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_async_work (env_id, async_resource, async_resource_name, execute, complete, data, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let executeFn = execute ? env1.table.get(execute) : undefined;
        let completeFn = complete ? env1.table.get(complete) : undefined;
        let w = new $8631b56d5d253785$var$AsyncWork(env1, executeFn, completeFn, data);
        env1.setPointer(result, w.id);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_delete_async_work (env1, work1) {
        $8631b56d5d253785$var$asyncWork[work1] = undefined;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_queue_async_work (env1, work1) {
        queueMicrotask(()=>{
            let w = $8631b56d5d253785$var$asyncWork[work1];
            if (w) {
                w.execute(env1, w.data);
                w.complete(env1, $8631b56d5d253785$var$NAPI_OK, w.data);
            }
        });
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_cancel_async_work () {
        let w = $8631b56d5d253785$var$asyncWork[work];
        w.complete(env, $8631b56d5d253785$var$NAPI_CANCELED, w.data);
        $8631b56d5d253785$var$asyncWork[work] = undefined;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_throw (env_id, error) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        env1.pendingException = env1.get(error);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_throw_error (env_id, code, msg) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new Error(env1.getString(msg));
        err.code = code;
        env1.pendingException = err;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_throw_type_error (env_id, code, msg) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new TypeError(env1.getString(msg));
        err.code = code;
        env1.pendingException = err;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_throw_range_error (env_id, code, msg) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new RangeError(env1.getString(msg));
        err.code = code;
        env1.pendingException = err;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_error (env_id, code, msg, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new Error(env1.get(msg));
        err.code = env1.get(code);
        return env1.createValue(err, result);
    },
    napi_create_type_error (env_id, code, msg, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new TypeError(env1.get(msg));
        err.code = env1.get(code);
        return env1.createValue(err, result);
    },
    napi_create_range_error (env_id, code, msg, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = new RangeError(env1.get(msg));
        err.code = env1.get(code);
        return env1.createValue(err, result);
    },
    napi_get_and_clear_last_exception (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let e = env1.pendingException;
        env1.pendingException = null;
        return env1.createValue(e, result);
    },
    napi_is_exception_pending (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        env1.memory[result] = env1.pendingException ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_fatal_exception (env_id, err) {
        throw new Error('not implemented');
    },
    napi_fatal_error (location, location_len, message, message_len) {
        throw new Error('not implemented');
    },
    napi_get_global (env_id, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.setPointer(result, 2);
    },
    napi_create_buffer (env_id, length, data, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let ptr = env1.instance.exports.napi_wasm_malloc(length);
        if (data) env1.setPointer(data, ptr);
        // Return a view into WASM memory.
        let buf1 = typeof globalThis.Buffer !== 'undefined' ? globalThis.Buffer.from(env1.memory.buffer, ptr, length) : env1.memory.subarray(ptr, ptr + length);
        let finalize = (_env, data)=>{
            if (env1.instance.exports.napi_wasm_free) env1.instance.exports.napi_wasm_free(data);
        };
        $8631b56d5d253785$var$finalizationRegistry.register(buf1, new $8631b56d5d253785$var$FinalizeRecord(env_id, finalize, 0, ptr));
        return env1.createValue(buf1, result);
    },
    napi_create_buffer_copy (env_id, length, data, result_data, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let ptr = env1.instance.exports.napi_wasm_malloc(length);
        env1.memory.set(env1.memory.subarray(data, data + length), ptr);
        if (result_data) env1.setPointer(result_data, ptr);
        // Return a view into WASM memory.
        let res = typeof globalThis.Buffer !== 'undefined' ? globalThis.Buffer.from(env1.memory.buffer, ptr, length) : env1.memory.subarray(ptr, ptr + length);
        let finalize = (_env, data)=>{
            if (env1.instance.exports.napi_wasm_free) env1.instance.exports.napi_wasm_free(data);
        };
        $8631b56d5d253785$var$finalizationRegistry.register(buf, new $8631b56d5d253785$var$FinalizeRecord(env_id, finalize, 0, ptr));
        return env1.createValue(res, result);
    },
    napi_create_external_buffer (env_id, length, data, finalize_cb, finalize_hint, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buf1 = typeof globalThis.Buffer !== 'undefined' ? globalThis.Buffer.from(env1.memory.buffer, data, length) : env1.memory.subarray(data, data + length);
        if (finalize_cb) {
            let cb = env1.table.get(finalize_cb);
            $8631b56d5d253785$var$finalizationRegistry.register(buf1, new $8631b56d5d253785$var$FinalizeRecord(env_id, cb, finalize_hint, data));
        }
        return env1.createValue(buf1, result);
    },
    napi_get_buffer_info (env_id, value, data, length) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buf1 = env1.get(value);
        let len = env1.getBufferInfo(buf1, data);
        return env1.setPointer(length, len);
    },
    napi_create_arraybuffer (env_id, length, data, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buf1 = new ArrayBuffer(length);
        if (data) // This copies the ArrayBuffer into the WASM memory.
        env1.getBufferInfo(buf1, data);
        return env1.createValue(buf1, result);
    },
    napi_create_external_arraybuffer (env_id, data, length, finalize_cb, finalize_hint, result) {
        // There is no way to actually create an external ArrayBuffer without copying.
        // You can only create typed arrays as subarrays, not ArrayBuffer.
        return $8631b56d5d253785$var$NAPI_NO_EXTERNAL_BUFFERS_ALLOWED;
    },
    napi_get_arraybuffer_info (env_id, value, data, length) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let len = env1.getBufferInfo(env1.get(value), data);
        return env1.setPointer(length, len);
    },
    napi_detach_arraybuffer (env_id, arraybuffer) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buffer = env1.get(arraybuffer);
        if (typeof structuredClone === 'function') structuredClone(buffer, {
            transfer: [
                buffer
            ]
        });
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_detached_arraybuffer (env_id, arraybuffer, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buffer = env1.get(arraybuffer);
        env1.memory[result] = buffer.byteLength === 0 ? 1 : 0; // ??
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_typedarray (env_id, type, length, arraybuffer, offset, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let Class = $8631b56d5d253785$var$typedArrays[type];
        let buffer = env1.get(arraybuffer);
        let buf1 = new Class(buffer, offset, length);
        return env1.createValue(buf1, result);
    },
    napi_create_dataview (env_id, byte_length, arraybuffer, byte_offset, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buffer = env1.get(arraybuffer);
        let view = new DataView(buffer, byte_offset, byte_length);
        return env1.createValue(view, result);
    },
    napi_get_typedarray_info (env_id, typedarray, type, length, data, arraybuffer, byte_offset) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(typedarray);
        env1.setPointer(type, $8631b56d5d253785$var$typedArrays.findIndex((constructor)=>val instanceof constructor));
        env1.setPointer(length, val.length);
        env1.getBufferInfo(val, data);
        env1.createValue(val.buffer, arraybuffer);
        return env1.setPointer(byte_offset, val.byteOffset);
    },
    napi_get_dataview_info (env_id, dataview, byte_length, data, arraybuffer, byte_offset) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(dataview);
        env1.setPointer(byte_length, val.byteLength);
        env1.getBufferInfo(val, data);
        env1.createValue(val.buffer, arraybuffer);
        return env1.setPointer(byte_offset, val.byteOffset);
    },
    napi_create_string_utf8 (env_id, str, length, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let s = $8631b56d5d253785$var$decoder.decode(env1.memory.subarray(str, str + length));
        return env1.createValue(s, result);
    },
    napi_get_value_string_utf8 (env_id, value, buf1, bufsize, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "string") return $8631b56d5d253785$var$NAPI_STRING_EXPECTED;
        if (buf1 == 0) return env1.setPointer(result, $8631b56d5d253785$var$utf8Length(val));
        let res = $8631b56d5d253785$var$encoder.encodeInto(val, env1.memory.subarray(buf1, buf1 + bufsize - 1));
        env1.memory[buf1 + res.written] = 0; // null terminate
        return env1.setPointer(result, res.written);
    },
    napi_create_string_latin1 (env_id, str, length, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let s = $8631b56d5d253785$var$latin1Decoder.decode(env1.memory.subarray(str, str + length));
        return env1.createValue(s, result);
    },
    napi_get_value_string_latin1 (env_id, value, buf1, bufsize, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "string") return $8631b56d5d253785$var$NAPI_STRING_EXPECTED;
        if (buf1 == 0) return env1.setPointer(result, val.length);
        let mem = env1.memory;
        let len = Math.min(val.length, bufsize - 1);
        for(let i = 0; i < len; i++){
            let code = val.charCodeAt(i);
            mem[buf1++] = code;
        }
        mem[buf1] = 0; // null terminate
        return env1.setPointer(result, len);
    },
    napi_create_string_utf16 (env_id, str, length, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let s = $8631b56d5d253785$var$utf16Decoder.decode(env1.memory.subarray(str, str + length * 2));
        return env1.createValue(s, result);
    },
    napi_get_value_string_utf16 (env_id, value, buf1, bufsize, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        if (typeof val !== "string") return $8631b56d5d253785$var$NAPI_STRING_EXPECTED;
        if (buf1 == 0) return env1.setPointer(result, val.length);
        let mem = env1.u16;
        let ptr = buf1 >> 1;
        let len = Math.min(val.length, bufsize - 1);
        for(let i = 0; i < len; i++){
            let code = val.charCodeAt(i);
            mem[ptr++] = code;
        }
        mem[ptr] = 0; // null terminate
        return env1.setPointer(result, len);
    },
    napi_create_date (env_id, time, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(new Date(time), result);
    },
    napi_get_date_value (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let date = env1.get(value);
        env1.f64[result >> 3] = date.valueOf();
    },
    napi_create_symbol (env_id, description, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let desc = env1.get(description);
        return env1.createValue(Symbol(desc), result);
    },
    napi_coerce_to_bool (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(Boolean(env1.get(value)), result);
    },
    napi_coerce_to_number (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(Number(env1.get(value)), result);
    },
    napi_coerce_to_object (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(Object(env1.get(value)), result);
    },
    napi_coerce_to_string (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        return env1.createValue(String(env1.get(value)), result);
    },
    napi_typeof (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        return env1.setPointer(result, (()=>{
            switch(typeof val){
                case 'undefined':
                    return 0;
                case 'boolean':
                    return 2;
                case 'number':
                    return 3;
                case 'string':
                    return 4;
                case 'symbol':
                    return 5;
                case 'object':
                    if (val === null) return 1;
                    else if (val instanceof $8631b56d5d253785$var$ExternalValue) return 8;
                    return 6;
                case 'function':
                    return 7;
                case 'bigint':
                    return 9;
            }
        })());
    },
    napi_instanceof (env_id, object, constructor, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(object);
        let cons = env1.get(constructor);
        env1.memory[result] = obj instanceof cons ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_array (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        env1.memory[result] = Array.isArray(val) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_buffer (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        env1.memory[result] = (typeof globalThis.Buffer !== 'undefined' ? globalThis.Buffer.isBuffer(val) : val instanceof Uint8Array) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_date (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        env1.memory[result] = val instanceof Date ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_error (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let err = env1.get(value);
        env1.memory[result] = err instanceof Error ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_typedarray (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let buf1 = env1.get(value);
        env1.memory[result] = ArrayBuffer.isView(buf1) && !(buf1 instanceof DataView) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_dataview (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        env1.memory[result] = val instanceof DataView ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_strict_equals (env_id, lhs, rhs, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        env1.memory[result] = env1.get(lhs) === env1.get(rhs) ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_wrap (env_id, js_object, native_object, finalize_cb, finalize_hint, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(js_object);
        env1.wrappedObjects.set(obj, native_object);
        if (finalize_cb) {
            let cb = env1.table.get(finalize_cb);
            $8631b56d5d253785$var$finalizationRegistry.register(obj, new $8631b56d5d253785$var$FinalizeRecord(env_id, cb, finalize_hint, native_object));
        }
        if (result) return $8631b56d5d253785$export$463bd622e1f7aed9.napi_create_reference(env_id, js_object, 1, result);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_unwrap (env_id, js_object, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(js_object);
        let native_object = env1.wrappedObjects.get(obj);
        env1.setPointer(result, native_object);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_remove_wrap (env_id, js_object, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(js_object);
        let native_object = env1.wrappedObjects.get(obj);
        $8631b56d5d253785$var$finalizationRegistry.unregister(obj);
        env1.wrappedObjects.delete(obj);
        return env1.setPointer(result, native_object);
    },
    napi_type_tag_object (env_id, js_object, type_tag) {
        throw new Error('not implemented');
    },
    napi_check_object_type_tag (env_id, js_object, type_tag) {
        throw new Error('not implemented');
    },
    napi_add_finalizer (env_id, js_object, native_object, finalize_cb, finalize_hint, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let obj = env1.get(js_object);
        let cb = env1.table.get(finalize_cb);
        $8631b56d5d253785$var$finalizationRegistry.register(obj, new $8631b56d5d253785$var$FinalizeRecord(env_id, cb, finalize_hint, native_object));
        if (result) return $8631b56d5d253785$export$463bd622e1f7aed9.napi_create_reference(env_id, js_object, 1, result);
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_create_promise (env_id, deferred, promise) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let p = new Promise((resolve, reject)=>{
            let id = env1.deferred.length;
            env1.deferred.push({
                resolve: resolve,
                reject: reject
            });
            env1.setPointer(deferred, id);
        });
        return env1.createValue(p, promise);
    },
    napi_resolve_deferred (env_id, deferred, resolution) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let { resolve: resolve } = env1.deferred[deferred];
        let value = env1.get(resolution);
        resolve(value);
        env1.deferred[deferred] = undefined;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_reject_deferred (env_id, deferred, rejection) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let { reject: reject } = env1.deferred[deferred];
        let value = env1.get(rejection);
        reject(value);
        env1.deferred[deferred] = undefined;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_is_promise (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let val = env1.get(value);
        env1.memory[result] = val instanceof Promise ? 1 : 0;
        return $8631b56d5d253785$var$NAPI_OK;
    },
    napi_run_script (env_id, script, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let source = env1.get(script);
        let res = (0, eval)(source);
        return env1.createValue(res, result);
    },
    napi_create_external (env_id, data, finalize_cb, finalize_hint, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let external = new $8631b56d5d253785$var$ExternalValue;
        env1.externalObjects.set(external, data);
        if (finalize_cb) {
            let cb = env1.table.get(finalize_cb);
            $8631b56d5d253785$var$finalizationRegistry.register(external, new $8631b56d5d253785$var$FinalizeRecord(env_id, cb, finalize_hint, data));
        }
        return env1.createValue(external, result);
    },
    napi_get_value_external (env_id, value, result) {
        let env1 = $8631b56d5d253785$var$environments[env_id];
        let external = env1.get(value);
        let val = env1.externalObjects.get(external);
        if (!val) return $8631b56d5d253785$var$NAPI_INVALID_ARG;
        return env1.setPointer(result, val);
    },
    napi_adjust_external_memory () {
        return $8631b56d5d253785$var$NAPI_OK;
    }
};
function $8631b56d5d253785$var$strlen(buf1, ptr) {
    let len = 0;
    while(buf1[ptr] !== 0){
        len++;
        ptr++;
    }
    return len;
}
function $8631b56d5d253785$var$utf8Length(string) {
    let len = 0;
    for(let i = 0; i < string.length; i++){
        let c = string.charCodeAt(i);
        if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
            let c2 = string.charCodeAt(++i);
            if ((c2 & 0xfc00) === 0xdc00) c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
            else // unmatched surrogate.
            i--;
        }
        if ((c & 0xffffff80) === 0) len++;
        else if ((c & 0xfffff800) === 0) len += 2;
        else if ((c & 0xffff0000) === 0) len += 3;
        else if ((c & 0xffe00000) === 0) len += 4;
    }
    return len;
}


let $6ea8a56f578e840e$var$cur_await_promise_sync;
function $6ea8a56f578e840e$export$1a58951129f35a8e(promise_addr, result_addr, error_addr) {
    $6ea8a56f578e840e$var$cur_await_promise_sync(promise_addr, result_addr, error_addr);
}
const $6ea8a56f578e840e$var$State = {
    None: 0,
    Unwinding: 1,
    Rewinding: 2
};
function $6ea8a56f578e840e$export$3022179c136161b1(env) {
    let { instance: instance, exports: exports } = env;
    let { asyncify_get_state: asyncify_get_state, asyncify_start_unwind: asyncify_start_unwind, asyncify_stop_unwind: asyncify_stop_unwind, asyncify_start_rewind: asyncify_start_rewind, asyncify_stop_rewind: asyncify_stop_rewind } = instance.exports;
    // allocate __asyncify_data
    // Stack data goes right after the initial descriptor.
    let DATA_ADDR = instance.exports.napi_wasm_malloc(4104);
    let DATA_START = DATA_ADDR + 8;
    let DATA_END = DATA_ADDR + 8 + 4096;
    new Int32Array(env.memory.buffer, DATA_ADDR).set([
        DATA_START,
        DATA_END
    ]);
    function assertNoneState() {
        if (asyncify_get_state() !== $6ea8a56f578e840e$var$State.None) throw new Error(`Invalid async state ${asyncify_get_state()}, expected 0.`);
    }
    let promise, result, error;
    $6ea8a56f578e840e$var$cur_await_promise_sync = (promise_addr, result_addr, error_addr)=>{
        let state = asyncify_get_state();
        if (state === $6ea8a56f578e840e$var$State.Rewinding) {
            asyncify_stop_rewind();
            if (result != null) env.createValue(result, result_addr);
            if (error != null) env.createValue(error, error_addr);
            promise = result = error = null;
            return;
        }
        assertNoneState();
        promise = env.get(promise_addr);
        asyncify_start_unwind(DATA_ADDR);
    };
    return async function bundleAsync(options) {
        assertNoneState();
        let res = exports.bundle(options);
        while(asyncify_get_state() === $6ea8a56f578e840e$var$State.Unwinding){
            asyncify_stop_unwind();
            try {
                result = await promise;
            } catch (err) {
                error = err;
            }
            assertNoneState();
            asyncify_start_rewind(DATA_ADDR);
            res = exports.bundle(options);
        }
        assertNoneState();
        return res;
    };
}


const $4d7b4285d75b240f$var$BROWSER_MAPPING = {
    and_chr: 'chrome',
    and_ff: 'firefox',
    ie_mob: 'ie',
    op_mob: 'opera',
    and_qq: null,
    and_uc: null,
    baidu: null,
    bb: null,
    kaios: null,
    op_mini: null
};
function $4d7b4285d75b240f$export$a04aae4fa31ab2f6(browserslist) {
    let targets = {};
    for (let browser of browserslist){
        let [name, v] = browser.split(' ');
        if ($4d7b4285d75b240f$var$BROWSER_MAPPING[name] === null) continue;
        let version = $4d7b4285d75b240f$var$parseVersion(v);
        if (version == null) continue;
        if (targets[name] == null || version < targets[name]) targets[name] = version;
    }
    return targets;
}
function $4d7b4285d75b240f$var$parseVersion(version) {
    let [major, minor = 0, patch = 0] = version.split('-')[0].split('.').map((v)=>parseInt(v, 10));
    if (isNaN(major) || isNaN(minor) || isNaN(patch)) return null;
    return major << 16 | minor << 8 | patch;
}


// This file is autogenerated by build-prefixes.js. DO NOT EDIT!
const $afc1711c436a5a81$export$617d79dae526d2cf = {
    Nesting: 1,
    NotSelectorList: 2,
    DirSelector: 4,
    LangSelectorList: 8,
    IsSelector: 16,
    TextDecorationThicknessPercent: 32,
    MediaIntervalSyntax: 64,
    MediaRangeSyntax: 128,
    CustomMediaQueries: 256,
    ClampFunction: 512,
    ColorFunction: 1024,
    OklabColors: 2048,
    LabColors: 4096,
    P3Colors: 8192,
    HexAlphaColors: 16384,
    SpaceSeparatedColorNotation: 32768,
    FontFamilySystemUi: 65536,
    DoublePositionGradients: 131072,
    VendorPrefixes: 262144,
    LogicalProperties: 524288,
    LightDark: 1048576,
    Selectors: 31,
    MediaQueries: 448,
    Colors: 1113088
};


// @ts-check
/** @typedef {import('./index').Visitor} Visitor */ /** @typedef {import('./index').VisitorFunction} VisitorFunction */ /**
 * Composes multiple visitor objects into a single one.
 * @param {(Visitor | VisitorFunction)[]} visitors 
 * @return {Visitor | VisitorFunction}
 */ function $4279369ed1bb0163$export$b055b48f61c84d24(visitors) {
    if (visitors.length === 1) return visitors[0];
    if (visitors.some((v)=>typeof v === 'function')) return (opts)=>{
        let v = visitors.map((v)=>typeof v === 'function' ? v(opts) : v);
        return $4279369ed1bb0163$export$b055b48f61c84d24(v);
    };
    /** @type Visitor */ let res = {};
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'StyleSheet');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'StyleSheetExit');
    $4279369ed1bb0163$var$composeObjectVisitors(res, visitors, 'Rule', $4279369ed1bb0163$var$ruleVisitor, $4279369ed1bb0163$var$wrapCustomAndUnknownAtRule);
    $4279369ed1bb0163$var$composeObjectVisitors(res, visitors, 'RuleExit', $4279369ed1bb0163$var$ruleVisitor, $4279369ed1bb0163$var$wrapCustomAndUnknownAtRule);
    $4279369ed1bb0163$var$composeObjectVisitors(res, visitors, 'Declaration', $4279369ed1bb0163$var$declarationVisitor, $4279369ed1bb0163$var$wrapCustomProperty);
    $4279369ed1bb0163$var$composeObjectVisitors(res, visitors, 'DeclarationExit', $4279369ed1bb0163$var$declarationVisitor, $4279369ed1bb0163$var$wrapCustomProperty);
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Url');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Color');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Image');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'ImageExit');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Length');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Angle');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Ratio');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Resolution');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'Time');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'CustomIdent');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'DashedIdent');
    $4279369ed1bb0163$var$composeArrayFunctions(res, visitors, 'MediaQuery');
    $4279369ed1bb0163$var$composeArrayFunctions(res, visitors, 'MediaQueryExit');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'SupportsCondition');
    $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, 'SupportsConditionExit');
    $4279369ed1bb0163$var$composeArrayFunctions(res, visitors, 'Selector');
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'Token', 'token', false);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'Function', 'function', false);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'FunctionExit', 'function', true);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'Variable', 'var', false);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'VariableExit', 'var', true);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'EnvironmentVariable', 'env', false);
    $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, 'EnvironmentVariableExit', 'env', true);
    return res;
}
function $4279369ed1bb0163$var$wrapCustomAndUnknownAtRule(k, f) {
    if (k === 'unknown') return (value)=>f({
            type: 'unknown',
            value: value
        });
    if (k === 'custom') return (value)=>f({
            type: 'custom',
            value: value
        });
    return f;
}
function $4279369ed1bb0163$var$wrapCustomProperty(k, f) {
    return k === 'custom' ? (value)=>f({
            property: 'custom',
            value: value
        }) : f;
}
/**
 * @param {import('./index').Visitor['Rule']} f 
 * @param {import('./ast').Rule} item 
 */ function $4279369ed1bb0163$var$ruleVisitor(f, item) {
    if (typeof f === 'object') {
        if (item.type === 'unknown') {
            let v = f.unknown;
            if (typeof v === 'object') v = v[item.value.name];
            return v?.(item.value);
        }
        if (item.type === 'custom') {
            let v = f.custom;
            if (typeof v === 'object') v = v[item.value.name];
            return v?.(item.value);
        }
        return f[item.type]?.(item);
    }
    return f?.(item);
}
/**
 * @param {import('./index').Visitor['Declaration']} f 
 * @param {import('./ast').Declaration} item 
 */ function $4279369ed1bb0163$var$declarationVisitor(f, item) {
    if (typeof f === 'object') {
        /** @type {string} */ let name = item.property;
        if (item.property === 'unparsed') name = item.value.propertyId.property;
        else if (item.property === 'custom') {
            let v = f.custom;
            if (typeof v === 'object') v = v[item.value.name];
            return v?.(item.value);
        }
        return f[name]?.(item);
    }
    return f?.(item);
}
/**
 * 
 * @param {Visitor[]} visitors 
 * @param {string} key 
 * @returns {[any[], boolean, Set<string>]}
 */ function $4279369ed1bb0163$var$extractObjectsOrFunctions(visitors, key) {
    let values = [];
    let hasFunction = false;
    let allKeys = new Set();
    for (let visitor of visitors){
        let v = visitor[key];
        if (v) {
            if (typeof v === 'function') hasFunction = true;
            else for(let key in v)allKeys.add(key);
            values.push(v);
        }
    }
    return [
        values,
        hasFunction,
        allKeys
    ];
}
/**
 * @template {keyof Visitor} K
 * @param {Visitor} res
 * @param {Visitor[]} visitors
 * @param {K} key
 * @param {(visitor: Visitor[K], item: any) => any | any[] | void} apply 
 * @param {(k: string, f: any) => any} wrapKey 
 */ function $4279369ed1bb0163$var$composeObjectVisitors(res, visitors, key, apply, wrapKey) {
    let [values, hasFunction, allKeys] = $4279369ed1bb0163$var$extractObjectsOrFunctions(visitors, key);
    if (values.length === 0) return;
    if (values.length === 1) {
        res[key] = values[0];
        return;
    }
    let f = $4279369ed1bb0163$var$createArrayVisitor(visitors, (visitor, item)=>apply(visitor[key], item));
    if (hasFunction) res[key] = f;
    else {
        /** @type {any} */ let v = {};
        for (let k of allKeys)v[k] = wrapKey(k, f);
        res[key] = v;
    }
}
/**
 * @param {Visitor} res 
 * @param {Visitor[]} visitors 
 * @param {string} key 
 * @param {import('./ast').TokenOrValue['type']} type 
 * @param {boolean} isExit 
 */ function $4279369ed1bb0163$var$composeTokenVisitors(res, visitors, key, type, isExit) {
    let [values, hasFunction, allKeys] = $4279369ed1bb0163$var$extractObjectsOrFunctions(visitors, key);
    if (values.length === 0) return;
    if (values.length === 1) {
        res[key] = values[0];
        return;
    }
    let f = $4279369ed1bb0163$var$createTokenVisitor(visitors, type, isExit);
    if (hasFunction) res[key] = f;
    else {
        let v = {};
        for (let key of allKeys)v[key] = f;
        res[key] = v;
    }
}
/**
 * @param {Visitor[]} visitors 
 * @param {import('./ast').TokenOrValue['type']} type 
 */ function $4279369ed1bb0163$var$createTokenVisitor(visitors, type, isExit) {
    let v = $4279369ed1bb0163$var$createArrayVisitor(visitors, (visitor, /** @type {import('./ast').TokenOrValue} */ item)=>{
        let f;
        switch(item.type){
            case 'token':
                f = visitor.Token;
                if (typeof f === 'object') f = f[item.value.type];
                break;
            case 'function':
                f = isExit ? visitor.FunctionExit : visitor.Function;
                if (typeof f === 'object') f = f[item.value.name];
                break;
            case 'var':
                f = isExit ? visitor.VariableExit : visitor.Variable;
                break;
            case 'env':
                f = isExit ? visitor.EnvironmentVariableExit : visitor.EnvironmentVariable;
                if (typeof f === 'object') {
                    let name;
                    switch(item.value.name.type){
                        case 'ua':
                        case 'unknown':
                            name = item.value.name.value;
                            break;
                        case 'custom':
                            name = item.value.name.ident;
                            break;
                    }
                    f = f[name];
                }
                break;
            case 'color':
                f = visitor.Color;
                break;
            case 'url':
                f = visitor.Url;
                break;
            case 'length':
                f = visitor.Length;
                break;
            case 'angle':
                f = visitor.Angle;
                break;
            case 'time':
                f = visitor.Time;
                break;
            case 'resolution':
                f = visitor.Resolution;
                break;
            case 'dashed-ident':
                f = visitor.DashedIdent;
                break;
        }
        if (!f) return;
        let res = f(item.value);
        switch(item.type){
            case 'color':
            case 'url':
            case 'length':
            case 'angle':
            case 'time':
            case 'resolution':
            case 'dashed-ident':
                if (Array.isArray(res)) res = res.map((value)=>({
                        type: item.type,
                        value: value
                    }));
                else if (res) res = {
                    type: item.type,
                    value: res
                };
                break;
        }
        return res;
    });
    return (value)=>v({
            type: type,
            value: value
        });
}
/**
 * @param {Visitor[]} visitors 
 * @param {string} key 
 */ function $4279369ed1bb0163$var$extractFunctions(visitors, key) {
    let functions = [];
    for (let visitor of visitors){
        let f = visitor[key];
        if (f) functions.push(f);
    }
    return functions;
}
/**
 * @param {Visitor} res 
 * @param {Visitor[]} visitors 
 * @param {string} key 
 */ function $4279369ed1bb0163$var$composeSimpleVisitors(res, visitors, key) {
    let functions = $4279369ed1bb0163$var$extractFunctions(visitors, key);
    if (functions.length === 0) return;
    if (functions.length === 1) {
        res[key] = functions[0];
        return;
    }
    res[key] = (arg)=>{
        let mutated = false;
        for (let f of functions){
            let res = f(arg);
            if (res) {
                arg = res;
                mutated = true;
            }
        }
        return mutated ? arg : undefined;
    };
}
/**
 * @param {Visitor} res 
 * @param {Visitor[]} visitors 
 * @param {string} key 
 */ function $4279369ed1bb0163$var$composeArrayFunctions(res, visitors, key) {
    let functions = $4279369ed1bb0163$var$extractFunctions(visitors, key);
    if (functions.length === 0) return;
    if (functions.length === 1) {
        res[key] = functions[0];
        return;
    }
    res[key] = $4279369ed1bb0163$var$createArrayVisitor(functions, (f, item)=>f(item));
}
/**
 * @template T
 * @template V
 * @param {T[]} visitors 
 * @param {(visitor: T, item: V) => V | V[] | void} apply 
 * @returns {(item: V) => V | V[] | void}
 */ function $4279369ed1bb0163$var$createArrayVisitor(visitors, apply) {
    let seen = new $4279369ed1bb0163$var$Bitset(visitors.length);
    return (arg)=>{
        let arr = [
            arg
        ];
        let mutated = false;
        seen.clear();
        for(let i = 0; i < arr.length; i++)// For each value, call all visitors. If a visitor returns a new value,
        // we start over, but skip the visitor that generated the value or saw
        // it before (to avoid cycles). This way, visitors can be composed in any order. 
        for(let v = 0; v < visitors.length && i < arr.length;){
            if (seen.get(v)) {
                v++;
                continue;
            }
            let item = arr[i];
            let visitor = visitors[v];
            let res = apply(visitor, item);
            if (Array.isArray(res)) {
                if (res.length === 0) arr.splice(i, 1);
                else if (res.length === 1) arr[i] = res[0];
                else arr.splice(i, 1, ...res);
                mutated = true;
                seen.set(v);
                v = 0;
            } else if (res) {
                arr[i] = res;
                mutated = true;
                seen.set(v);
                v = 0;
            } else v++;
        }
        if (!mutated) return;
        return arr.length === 1 ? arr[0] : arr;
    };
}
class $4279369ed1bb0163$var$Bitset {
    constructor(maxBits = 32){
        this.bits = 0;
        this.more = maxBits > 32 ? new Uint32Array(Math.ceil((maxBits - 32) / 32)) : null;
    }
    /** @param {number} bit */ get(bit) {
        if (bit >= 32 && this.more) {
            let i = Math.floor((bit - 32) / 32);
            let b = bit % 32;
            return Boolean(this.more[i] & 1 << b);
        } else return Boolean(this.bits & 1 << bit);
    }
    /** @param {number} bit */ set(bit) {
        if (bit >= 32 && this.more) {
            let i = Math.floor((bit - 32) / 32);
            let b = bit % 32;
            this.more[i] |= 1 << b;
        } else this.bits |= 1 << bit;
    }
    clear() {
        this.bits = 0;
        if (this.more) this.more.fill(0);
    }
}


let $4e05f0b265294e4f$var$wasm, $4e05f0b265294e4f$var$initPromise, $4e05f0b265294e4f$var$bundleAsyncInternal;
var $8605ffc5e8a96d43$exports = {};
$8605ffc5e8a96d43$exports = new URL("../lightningcss_node.a3d2d83a.wasm", import.meta.url).toString();


async function $4e05f0b265294e4f$export$2e2bcd8739ae039(input) {
    if ($4e05f0b265294e4f$var$wasm) return;
    if ($4e05f0b265294e4f$var$initPromise) {
        await $4e05f0b265294e4f$var$initPromise;
        return;
    }
    input = input ?? new URL($8605ffc5e8a96d43$exports);
    if (typeof input === 'string' || typeof Request === 'function' && input instanceof Request || typeof URL === 'function' && input instanceof URL) input = $4e05f0b265294e4f$var$fetchOrReadFromFs(input);
    let env;
    $4e05f0b265294e4f$var$initPromise = input.then((input)=>$4e05f0b265294e4f$var$load(input, {
            env: {
                ...(0, $8631b56d5d253785$export$463bd622e1f7aed9),
                await_promise_sync: $6ea8a56f578e840e$export$1a58951129f35a8e,
                __getrandom_v03_custom: (ptr, len)=>{
                    let buf = env.memory.subarray(ptr, ptr + len);
                    crypto.getRandomValues(buf);
                }
            }
        })).then(({ instance: instance })=>{
        instance.exports.register_module();
        env = new (0, $8631b56d5d253785$export$7dc6752a22ab011a)(instance);
        $4e05f0b265294e4f$var$bundleAsyncInternal = (0, $6ea8a56f578e840e$export$3022179c136161b1)(env);
        $4e05f0b265294e4f$var$wasm = env.exports;
    });
    await $4e05f0b265294e4f$var$initPromise;
}
function $4e05f0b265294e4f$export$51186ad6e864892a(options) {
    return $4e05f0b265294e4f$var$wrap($4e05f0b265294e4f$var$wasm.transform, options);
}
function $4e05f0b265294e4f$export$79db19e3a95e21e3(options) {
    return $4e05f0b265294e4f$var$wrap($4e05f0b265294e4f$var$wasm.transformStyleAttribute, options);
}
function $4e05f0b265294e4f$export$1f0ba71ea6f249e7(options) {
    return $4e05f0b265294e4f$var$wrap($4e05f0b265294e4f$var$wasm.bundle, options);
}
function $4e05f0b265294e4f$export$307411107219ba12(options) {
    return $4e05f0b265294e4f$var$wrap($4e05f0b265294e4f$var$bundleAsyncInternal, options);
}
function $4e05f0b265294e4f$var$wrap(call, options) {
    if (typeof options.visitor === 'function') {
        let deps = [];
        options.visitor = options.visitor({
            addDependency (dep) {
                deps.push(dep);
            }
        });
        let result = call(options);
        if (result instanceof Promise) result = result.then((res)=>{
            if (deps.length) {
                res.dependencies ??= [];
                res.dependencies.push(...deps);
            }
            return res;
        });
        else if (deps.length) {
            result.dependencies ??= [];
            result.dependencies.push(...deps);
        }
        return result;
    } else return call(options);
}
async function $4e05f0b265294e4f$var$load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            if (module.headers.get('Content-Type') != 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
}

async function $4e05f0b265294e4f$var$fetchOrReadFromFs(inputPath) {
    try {
        const fs = await (parcelRequire("6tzh6"));
        return fs.readFileSync(inputPath);
    } catch  {
        return fetch(inputPath);
    }
}


// These are filled with ranges (rangeFrom[i] up to but not including
// rangeTo[i]) of code points that count as extending characters.
let $de98d89a332e9308$var$rangeFrom = [], $de98d89a332e9308$var$rangeTo = [];
(()=>{
    // Compressed representation of the Grapheme_Cluster_Break=Extend
    // information from
    // http://www.unicode.org/Public/16.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
    // Each pair of elements represents a range, as an offet from the
    // previous range and a length. Numbers are in base-36, with the empty
    // string being a shorthand for 1.
    let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
    for(let i = 0, n = 0; i < numbers.length; i++)(i % 2 ? $de98d89a332e9308$var$rangeTo : $de98d89a332e9308$var$rangeFrom).push(n = n + numbers[i]);
})();
function $de98d89a332e9308$export$5ff7ae0b7231f50b(code) {
    if (code < 768) return false;
    for(let from = 0, to = $de98d89a332e9308$var$rangeFrom.length;;){
        let mid = from + to >> 1;
        if (code < $de98d89a332e9308$var$rangeFrom[mid]) to = mid;
        else if (code >= $de98d89a332e9308$var$rangeTo[mid]) from = mid + 1;
        else return true;
        if (from == to) return false;
    }
}
function $de98d89a332e9308$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
function $de98d89a332e9308$var$check(code) {
    for(let i = 0; i < $de98d89a332e9308$var$rangeFrom.length; i++){
        if ($de98d89a332e9308$var$rangeTo[i] > code) return $de98d89a332e9308$var$rangeFrom[i] <= code;
    }
    return false;
}
const $de98d89a332e9308$var$ZWJ = 0x200d;
function $de98d89a332e9308$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $de98d89a332e9308$var$nextClusterBreak : $de98d89a332e9308$var$prevClusterBreak)(str, pos, includeExtending);
}
function $de98d89a332e9308$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $de98d89a332e9308$var$surrogateLow(str.charCodeAt(pos)) && $de98d89a332e9308$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $de98d89a332e9308$var$codePointAt(str, pos);
    pos += $de98d89a332e9308$var$codePointSize(prev);
    while(pos < str.length){
        let next = $de98d89a332e9308$var$codePointAt(str, pos);
        if (prev == $de98d89a332e9308$var$ZWJ || next == $de98d89a332e9308$var$ZWJ || includeExtending && $de98d89a332e9308$export$5ff7ae0b7231f50b(next)) {
            pos += $de98d89a332e9308$var$codePointSize(next);
            prev = next;
        } else if ($de98d89a332e9308$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $de98d89a332e9308$var$isRegionalIndicator($de98d89a332e9308$var$codePointAt(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $de98d89a332e9308$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $de98d89a332e9308$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $de98d89a332e9308$var$codePointAt(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$de98d89a332e9308$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$de98d89a332e9308$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
function $de98d89a332e9308$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $de98d89a332e9308$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
function $de98d89a332e9308$var$codePointSize(code) {
    return code < 0x10000 ? 1 : 2;
}


/**
The data structure for documents. @nonabstract
*/ class $0f49217316d01287$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $0f49217316d01287$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $0f49217316d01287$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $0f49217316d01287$var$RawTextCursor(this), b = new $0f49217316d01287$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $0f49217316d01287$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $0f49217316d01287$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $0f49217316d01287$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $0f49217316d01287$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $0f49217316d01287$var$TextLeaf(text) : $0f49217316d01287$var$TextNode.from($0f49217316d01287$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $0f49217316d01287$var$TextLeaf extends $0f49217316d01287$export$5f1af8db9871e1d6 {
    constructor(text, length = $0f49217316d01287$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $0f49217316d01287$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $0f49217316d01287$var$TextLeaf($0f49217316d01287$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $0f49217316d01287$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $0f49217316d01287$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $0f49217316d01287$var$TextLeaf(joined.slice(0, mid)), new $0f49217316d01287$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $0f49217316d01287$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        let lines = $0f49217316d01287$var$appendText(this.text, $0f49217316d01287$var$appendText(text.text, $0f49217316d01287$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $0f49217316d01287$var$TextLeaf(lines, newLen);
        return $0f49217316d01287$var$TextNode.from($0f49217316d01287$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $0f49217316d01287$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $0f49217316d01287$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $0f49217316d01287$var$TextNode extends $0f49217316d01287$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $0f49217316d01287$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $0f49217316d01287$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $0f49217316d01287$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $0f49217316d01287$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $0f49217316d01287$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $0f49217316d01287$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $0f49217316d01287$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $0f49217316d01287$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $0f49217316d01287$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $0f49217316d01287$var$TextNode(chunked, length);
    }
}
$0f49217316d01287$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $0f49217316d01287$var$TextLeaf([
    ""
], 0);
function $0f49217316d01287$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $0f49217316d01287$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $0f49217316d01287$var$sliceText(text, from, to) {
    return $0f49217316d01287$var$appendText(text, [
        ""
    ], from, to);
}
class $0f49217316d01287$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $0f49217316d01287$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $0f49217316d01287$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $0f49217316d01287$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $0f49217316d01287$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $0f49217316d01287$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $0f49217316d01287$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $0f49217316d01287$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $0f49217316d01287$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $0f49217316d01287$var$RawTextCursor.prototype[Symbol.iterator] = $0f49217316d01287$var$PartialTextCursor.prototype[Symbol.iterator] = $0f49217316d01287$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $0f49217316d01287$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $0f49217316d01287$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $0f49217316d01287$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (0, $de98d89a332e9308$export$a0fa439fd515e1ed)(str, pos, forward, includeExtending);
}
function $0f49217316d01287$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $0f49217316d01287$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $0f49217316d01287$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$0f49217316d01287$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$0f49217316d01287$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $0f49217316d01287$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up in a JavaScript string.
*/ function $0f49217316d01287$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $0f49217316d01287$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $0f49217316d01287$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($0f49217316d01287$export$39cf3280165f92aa || ($0f49217316d01287$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $0f49217316d01287$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $0f49217316d01287$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $0f49217316d01287$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $0f49217316d01287$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `this` happened before the ones in `other`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $0f49217316d01287$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $0f49217316d01287$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $0f49217316d01287$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $0f49217316d01287$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $0f49217316d01287$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $0f49217316d01287$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $0f49217316d01287$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $0f49217316d01287$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $0f49217316d01287$export$29d7fbdcb1f8b71c extends $0f49217316d01287$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $0f49217316d01287$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $0f49217316d01287$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($0f49217316d01287$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $0f49217316d01287$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $0f49217316d01287$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $0f49217316d01287$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $0f49217316d01287$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $0f49217316d01287$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $0f49217316d01287$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $0f49217316d01287$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $0f49217316d01287$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $0f49217316d01287$var$addSection(resultSections, len, ins);
                if (ins > 0) $0f49217316d01287$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $0f49217316d01287$var$addSection(resultSections, len, -1);
                $0f49217316d01287$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $0f49217316d01287$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $0f49217316d01287$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $0f49217316d01287$var$addSection(sections, length - pos, -1);
            let set = new $0f49217316d01287$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $0f49217316d01287$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $0f49217316d01287$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $0f49217316d01287$export$5f1af8db9871e1d6.of(insert.split(lineSep || $0f49217316d01287$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $0f49217316d01287$var$addSection(sections, from - pos, -1);
                $0f49217316d01287$var$addSection(sections, to - from, insLen);
                $0f49217316d01287$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $0f49217316d01287$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($0f49217316d01287$export$5f1af8db9871e1d6.empty);
                inserted[i] = $0f49217316d01287$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $0f49217316d01287$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $0f49217316d01287$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $0f49217316d01287$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (last >= 0 && len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $0f49217316d01287$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($0f49217316d01287$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $0f49217316d01287$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $0f49217316d01287$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $0f49217316d01287$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $0f49217316d01287$var$SectionIter(setA), b = new $0f49217316d01287$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.done && b.len || b.done && a.len) throw new Error("Mismatched change set lengths");
        else if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $0f49217316d01287$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $0f49217316d01287$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $0f49217316d01287$var$addSection(sections, 0, a.ins);
                    if (insert) $0f49217316d01287$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $0f49217316d01287$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $0f49217316d01287$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $0f49217316d01287$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $0f49217316d01287$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $0f49217316d01287$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $0f49217316d01287$var$SectionIter(setA), b = new $0f49217316d01287$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $0f49217316d01287$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $0f49217316d01287$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $0f49217316d01287$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $0f49217316d01287$var$addSection(sections, 0, b.ins, open);
            if (insert) $0f49217316d01287$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $0f49217316d01287$var$addSection(sections, len, insB, open);
                if (insert && insB) $0f49217316d01287$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $0f49217316d01287$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $0f49217316d01287$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $0f49217316d01287$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $0f49217316d01287$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $0f49217316d01287$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $0f49217316d01287$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $0f49217316d01287$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $0f49217316d01287$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $0f49217316d01287$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $0f49217316d01287$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $0f49217316d01287$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $0f49217316d01287$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $0f49217316d01287$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $0f49217316d01287$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $0f49217316d01287$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $0f49217316d01287$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $0f49217316d01287$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $0f49217316d01287$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $0f49217316d01287$export$3bb1bd44aee62999(json.ranges.map((r)=>$0f49217316d01287$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $0f49217316d01287$export$3bb1bd44aee62999([
            $0f49217316d01287$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $0f49217316d01287$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $0f49217316d01287$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $0f49217316d01287$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        return head < anchor ? $0f49217316d01287$export$7bd1839c3c5d5bd4.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : $0f49217316d01287$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 8 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $0f49217316d01287$export$3bb1bd44aee62999.range(to, from) : $0f49217316d01287$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $0f49217316d01287$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $0f49217316d01287$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $0f49217316d01287$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $0f49217316d01287$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $0f49217316d01287$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $0f49217316d01287$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $0f49217316d01287$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $0f49217316d01287$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $0f49217316d01287$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $0f49217316d01287$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $0f49217316d01287$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $0f49217316d01287$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $0f49217316d01287$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $0f49217316d01287$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$0f49217316d01287$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $0f49217316d01287$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $0f49217316d01287$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $0f49217316d01287$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $0f49217316d01287$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $0f49217316d01287$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $0f49217316d01287$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($0f49217316d01287$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $0f49217316d01287$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $0f49217316d01287$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$0f49217316d01287$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$0f49217316d01287$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $0f49217316d01287$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $0f49217316d01287$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $0f49217316d01287$var$initField = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $0f49217316d01287$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $0f49217316d01287$export$34381b1ce2130245($0f49217316d01287$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($0f49217316d01287$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $0f49217316d01287$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $0f49217316d01287$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $0f49217316d01287$var$prec(value) {
    return (ext)=>new $0f49217316d01287$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $0f49217316d01287$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $0f49217316d01287$var$prec($0f49217316d01287$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $0f49217316d01287$var$prec($0f49217316d01287$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $0f49217316d01287$var$prec($0f49217316d01287$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $0f49217316d01287$var$prec($0f49217316d01287$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $0f49217316d01287$var$prec($0f49217316d01287$var$Prec_.lowest)
};
class $0f49217316d01287$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $0f49217316d01287$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $0f49217316d01287$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $0f49217316d01287$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $0f49217316d01287$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $0f49217316d01287$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $0f49217316d01287$var$flatten(base, compartments, newCompartments))if (ext instanceof $0f49217316d01287$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($0f49217316d01287$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$0f49217316d01287$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $0f49217316d01287$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $0f49217316d01287$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $0f49217316d01287$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $0f49217316d01287$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $0f49217316d01287$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $0f49217316d01287$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $0f49217316d01287$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $0f49217316d01287$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $0f49217316d01287$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $0f49217316d01287$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $0f49217316d01287$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $0f49217316d01287$var$languageData = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define();
const $0f49217316d01287$var$allowMultipleSelections = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $0f49217316d01287$var$lineSeparator = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $0f49217316d01287$var$changeFilter = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define();
const $0f49217316d01287$var$transactionFilter = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define();
const $0f49217316d01287$var$transactionExtender = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define();
const $0f49217316d01287$var$readOnly = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $0f49217316d01287$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $0f49217316d01287$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $0f49217316d01287$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $0f49217316d01287$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $0f49217316d01287$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $0f49217316d01287$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $0f49217316d01287$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $0f49217316d01287$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $0f49217316d01287$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $0f49217316d01287$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $0f49217316d01287$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $0f49217316d01287$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $0f49217316d01287$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $0f49217316d01287$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $0f49217316d01287$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $0f49217316d01287$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($0f49217316d01287$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $0f49217316d01287$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($0f49217316d01287$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $0f49217316d01287$export$febc5573c75cefb0.time = /*@__PURE__*/ $0f49217316d01287$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $0f49217316d01287$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $0f49217316d01287$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $0f49217316d01287$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $0f49217316d01287$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $0f49217316d01287$export$febc5573c75cefb0.remote = /*@__PURE__*/ $0f49217316d01287$export$9279461326b8700a.define();
function $0f49217316d01287$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $0f49217316d01287$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $0f49217316d01287$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $0f49217316d01287$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($0f49217316d01287$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $0f49217316d01287$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $0f49217316d01287$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($0f49217316d01287$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $0f49217316d01287$export$29d7fbdcb1f8b71c ? spec.changes : $0f49217316d01287$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($0f49217316d01287$var$lineSeparator)),
        selection: sel && (sel instanceof $0f49217316d01287$export$3bb1bd44aee62999 ? sel : $0f49217316d01287$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $0f49217316d01287$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $0f49217316d01287$var$resolveTransaction(state, specs, filter) {
    let s = $0f49217316d01287$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $0f49217316d01287$var$mergeTransaction(s, $0f49217316d01287$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $0f49217316d01287$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $0f49217316d01287$var$extendTransaction(filter ? $0f49217316d01287$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $0f49217316d01287$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($0f49217316d01287$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $0f49217316d01287$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $0f49217316d01287$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $0f49217316d01287$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $0f49217316d01287$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($0f49217316d01287$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $0f49217316d01287$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $0f49217316d01287$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $0f49217316d01287$var$resolveTransaction(state, $0f49217316d01287$var$asArray(filtered), false);
    }
    return tr;
}
function $0f49217316d01287$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($0f49217316d01287$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $0f49217316d01287$var$mergeTransaction(spec, $0f49217316d01287$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $0f49217316d01287$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $0f49217316d01287$var$none = [];
function $0f49217316d01287$var$asArray(value) {
    return value == null ? $0f49217316d01287$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $0f49217316d01287$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($0f49217316d01287$export$239a3d59567c1401 || ($0f49217316d01287$export$239a3d59567c1401 = {}));
const $0f49217316d01287$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $0f49217316d01287$var$wordChar;
try {
    $0f49217316d01287$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $0f49217316d01287$var$hasWordChar(str) {
    if ($0f49217316d01287$var$wordChar) return $0f49217316d01287$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $0f49217316d01287$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $0f49217316d01287$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $0f49217316d01287$export$239a3d59567c1401.Space;
        if ($0f49217316d01287$var$hasWordChar(char)) return $0f49217316d01287$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $0f49217316d01287$export$239a3d59567c1401.Word;
        return $0f49217316d01287$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $0f49217316d01287$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$0f49217316d01287$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $0f49217316d01287$var$ensureAddr(this, addr);
        return $0f49217316d01287$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $0f49217316d01287$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($0f49217316d01287$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($0f49217316d01287$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($0f49217316d01287$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $0f49217316d01287$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $0f49217316d01287$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $0f49217316d01287$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($0f49217316d01287$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $0f49217316d01287$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $0f49217316d01287$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $0f49217316d01287$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $0f49217316d01287$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($0f49217316d01287$export$95000d4efaa4321f.mapEffects($0f49217316d01287$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $0f49217316d01287$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $0f49217316d01287$export$29d7fbdcb1f8b71c) return spec;
        return $0f49217316d01287$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($0f49217316d01287$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $0f49217316d01287$export$5f1af8db9871e1d6.of(string.split(this.facet($0f49217316d01287$export$afa855cbfaff27f2.lineSeparator) || $0f49217316d01287$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $0f49217316d01287$var$ensureAddr(this, addr);
        return $0f49217316d01287$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $0f49217316d01287$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $0f49217316d01287$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $0f49217316d01287$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $0f49217316d01287$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $0f49217316d01287$export$5f1af8db9871e1d6 ? config.doc : $0f49217316d01287$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($0f49217316d01287$export$afa855cbfaff27f2.lineSeparator) || $0f49217316d01287$var$DefaultSplit));
        let selection = !config.selection ? $0f49217316d01287$export$3bb1bd44aee62999.single(0) : config.selection instanceof $0f49217316d01287$export$3bb1bd44aee62999 ? config.selection : $0f49217316d01287$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $0f49217316d01287$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($0f49217316d01287$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $0f49217316d01287$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($0f49217316d01287$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($0f49217316d01287$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($0f49217316d01287$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($0f49217316d01287$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($0f49217316d01287$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $0f49217316d01287$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $0f49217316d01287$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $0f49217316d01287$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $0f49217316d01287$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $0f49217316d01287$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $0f49217316d01287$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $0f49217316d01287$export$afa855cbfaff27f2.allowMultipleSelections = $0f49217316d01287$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $0f49217316d01287$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $0f49217316d01287$export$afa855cbfaff27f2.lineSeparator = $0f49217316d01287$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $0f49217316d01287$export$afa855cbfaff27f2.readOnly = $0f49217316d01287$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $0f49217316d01287$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $0f49217316d01287$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $0f49217316d01287$export$afa855cbfaff27f2.languageData = $0f49217316d01287$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $0f49217316d01287$export$afa855cbfaff27f2.changeFilter = $0f49217316d01287$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $0f49217316d01287$export$afa855cbfaff27f2.transactionFilter = $0f49217316d01287$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $0f49217316d01287$export$afa855cbfaff27f2.transactionExtender = $0f49217316d01287$var$transactionExtender;
$0f49217316d01287$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $0f49217316d01287$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $0f49217316d01287$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $0f49217316d01287$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $0f49217316d01287$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$0f49217316d01287$export$d60f08ed93a48611.prototype.startSide = $0f49217316d01287$export$d60f08ed93a48611.prototype.endSide = 0;
$0f49217316d01287$export$d60f08ed93a48611.prototype.point = false;
$0f49217316d01287$export$d60f08ed93a48611.prototype.mapMode = $0f49217316d01287$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $0f49217316d01287$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $0f49217316d01287$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $0f49217316d01287$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $0f49217316d01287$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $0f49217316d01287$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $0f49217316d01287$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $0f49217316d01287$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($0f49217316d01287$var$cmpRange);
        if (this.isEmpty) return add.length ? $0f49217316d01287$export$34cb5241245008dd.of(add) : this;
        let cur = new $0f49217316d01287$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $0f49217316d01287$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($0f49217316d01287$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $0f49217316d01287$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $0f49217316d01287$export$34cb5241245008dd(chunkPos, chunks, next || $0f49217316d01287$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $0f49217316d01287$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $0f49217316d01287$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $0f49217316d01287$var$findSharedChunks(a, b, textDiff);
        let sideA = new $0f49217316d01287$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $0f49217316d01287$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$0f49217316d01287$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $0f49217316d01287$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $0f49217316d01287$var$findSharedChunks(a, b);
        let sideA = new $0f49217316d01287$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $0f49217316d01287$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$0f49217316d01287$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $0f49217316d01287$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $0f49217316d01287$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $0f49217316d01287$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $0f49217316d01287$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $0f49217316d01287$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $0f49217316d01287$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $0f49217316d01287$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $0f49217316d01287$export$34cb5241245008dd.empty = /*@__PURE__*/ new $0f49217316d01287$export$34cb5241245008dd([], [], null, -1);
function $0f49217316d01287$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($0f49217316d01287$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($0f49217316d01287$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$0f49217316d01287$export$34cb5241245008dd.empty.nextLayer = $0f49217316d01287$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $0f49217316d01287$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $0f49217316d01287$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $0f49217316d01287$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($0f49217316d01287$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $0f49217316d01287$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $0f49217316d01287$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $0f49217316d01287$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $0f49217316d01287$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $0f49217316d01287$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $0f49217316d01287$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$0f49217316d01287$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$0f49217316d01287$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $0f49217316d01287$var$heapBubble(this.heap, 0);
        }
    }
}
function $0f49217316d01287$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $0f49217316d01287$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $0f49217316d01287$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $0f49217316d01287$var$remove(this.active, index);
        $0f49217316d01287$var$remove(this.activeTo, index);
        $0f49217316d01287$var$remove(this.activeRank, index);
        this.minActive = $0f49217316d01287$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $0f49217316d01287$var$insert(this.active, i, value);
        $0f49217316d01287$var$insert(this.activeTo, i, to);
        $0f49217316d01287$var$insert(this.activeRank, i, rank);
        if (trackOpen) $0f49217316d01287$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $0f49217316d01287$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $0f49217316d01287$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $0f49217316d01287$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let dEnd = a.to + dPos - b.to, diff = dEnd || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $0f49217316d01287$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$0f49217316d01287$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        if ((dEnd || a.openEnd != b.openEnd) && comparator.boundChange) comparator.boundChange(end);
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $0f49217316d01287$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $0f49217316d01287$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $0f49217316d01287$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $0f49217316d01287$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $0f49217316d01287$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $0f49217316d01287$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $0f49217316d01287$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $0f49217316d01287$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}


const $df51ea96bfd6fa5c$var$C = "\u037c";
const $df51ea96bfd6fa5c$var$COUNT = typeof Symbol == "undefined" ? "__" + $df51ea96bfd6fa5c$var$C : Symbol.for($df51ea96bfd6fa5c$var$C);
const $df51ea96bfd6fa5c$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $df51ea96bfd6fa5c$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $df51ea96bfd6fa5c$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $df51ea96bfd6fa5c$var$top[$df51ea96bfd6fa5c$var$COUNT] || 1;
        $df51ea96bfd6fa5c$var$top[$df51ea96bfd6fa5c$var$COUNT] = id + 1;
        return $df51ea96bfd6fa5c$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$df51ea96bfd6fa5c$var$SET], nonce = options && options.nonce;
        if (!set) set = new $df51ea96bfd6fa5c$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $df51ea96bfd6fa5c$var$adoptedSet = new Map //<Document, StyleSet>
;
class $df51ea96bfd6fa5c$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $df51ea96bfd6fa5c$var$adoptedSet.get(doc);
            if (adopted) return root[$df51ea96bfd6fa5c$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $df51ea96bfd6fa5c$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$df51ea96bfd6fa5c$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $1b4fb3054140d77f$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $1b4fb3054140d77f$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $1b4fb3054140d77f$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $1b4fb3054140d77f$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $1b4fb3054140d77f$var$i = 0; $1b4fb3054140d77f$var$i < 10; $1b4fb3054140d77f$var$i++)$1b4fb3054140d77f$export$e2253033e6e1df16[48 + $1b4fb3054140d77f$var$i] = $1b4fb3054140d77f$export$e2253033e6e1df16[96 + $1b4fb3054140d77f$var$i] = String($1b4fb3054140d77f$var$i);
// The function keys
for(var $1b4fb3054140d77f$var$i = 1; $1b4fb3054140d77f$var$i <= 24; $1b4fb3054140d77f$var$i++)$1b4fb3054140d77f$export$e2253033e6e1df16[$1b4fb3054140d77f$var$i + 111] = "F" + $1b4fb3054140d77f$var$i;
// And the alphabetic keys
for(var $1b4fb3054140d77f$var$i = 65; $1b4fb3054140d77f$var$i <= 90; $1b4fb3054140d77f$var$i++){
    $1b4fb3054140d77f$export$e2253033e6e1df16[$1b4fb3054140d77f$var$i] = String.fromCharCode($1b4fb3054140d77f$var$i + 32);
    $1b4fb3054140d77f$export$fba63a578e423eb[$1b4fb3054140d77f$var$i] = String.fromCharCode($1b4fb3054140d77f$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $1b4fb3054140d77f$var$code in $1b4fb3054140d77f$export$e2253033e6e1df16)if (!$1b4fb3054140d77f$export$fba63a578e423eb.hasOwnProperty($1b4fb3054140d77f$var$code)) $1b4fb3054140d77f$export$fba63a578e423eb[$1b4fb3054140d77f$var$code] = $1b4fb3054140d77f$export$e2253033e6e1df16[$1b4fb3054140d77f$var$code];
function $1b4fb3054140d77f$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $1b4fb3054140d77f$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $1b4fb3054140d77f$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $1b4fb3054140d77f$export$fba63a578e423eb : $1b4fb3054140d77f$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $e1533ef606a339de$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $e1533ef606a339de$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $e1533ef606a339de$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $e1533ef606a339de$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $e1533ef606a339de$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $e1533ef606a339de$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $e1533ef606a339de$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $e1533ef606a339de$var$scanFor(node, off, targetNode, targetOff, -1) || $e1533ef606a339de$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $e1533ef606a339de$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $e1533ef606a339de$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $e1533ef606a339de$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $e1533ef606a339de$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $e1533ef606a339de$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $e1533ef606a339de$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $e1533ef606a339de$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $e1533ef606a339de$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $e1533ef606a339de$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $e1533ef606a339de$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $e1533ef606a339de$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $e1533ef606a339de$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $e1533ef606a339de$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $e1533ef606a339de$var$scrollableParents(dom) {
    let doc = dom.ownerDocument, x, y;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body || x && y) break;
        else if (cur.nodeType == 1) {
            if (!y && cur.scrollHeight > cur.clientHeight) y = cur;
            if (!x && cur.scrollWidth > cur.clientWidth) x = cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return {
        x: x,
        y: y
    };
}
class $e1533ef606a339de$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $e1533ef606a339de$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $e1533ef606a339de$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $e1533ef606a339de$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $e1533ef606a339de$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($e1533ef606a339de$var$preventScrollSupported) return dom.focus($e1533ef606a339de$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($e1533ef606a339de$var$preventScrollSupported == null ? {
        get preventScroll () {
            $e1533ef606a339de$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$e1533ef606a339de$var$preventScrollSupported) {
        $e1533ef606a339de$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $e1533ef606a339de$var$scratchRange;
function $e1533ef606a339de$var$textRange(node, from, to = from) {
    let range = $e1533ef606a339de$var$scratchRange || ($e1533ef606a339de$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $e1533ef606a339de$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $e1533ef606a339de$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $e1533ef606a339de$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function $e1533ef606a339de$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $e1533ef606a339de$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $e1533ef606a339de$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $e1533ef606a339de$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $e1533ef606a339de$var$isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $e1533ef606a339de$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $e1533ef606a339de$var$maxOffset(node);
        } else if (node.parentNode && !$e1533ef606a339de$var$isBlockElement(node)) {
            offset = $e1533ef606a339de$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $e1533ef606a339de$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$e1533ef606a339de$var$isBlockElement(node)) {
            offset = $e1533ef606a339de$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $e1533ef606a339de$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $e1533ef606a339de$var$DOMPos(dom.parentNode, $e1533ef606a339de$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $e1533ef606a339de$var$DOMPos(dom.parentNode, $e1533ef606a339de$var$domIndex(dom) + 1, precise);
    }
}
const $e1533ef606a339de$var$noChildren = [];
class $e1533ef606a339de$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.flags = 2 /* ViewFlag.NodeDirty */ ;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.flags & 2 /* ViewFlag.NodeDirty */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $e1533ef606a339de$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                    }
                    child.sync(view, track);
                    child.flags &= -8 /* ViewFlag.Dirty */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $e1533ef606a339de$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $e1533ef606a339de$var$rm$1(next);
        } else if (this.flags & 1 /* ViewFlag.ChildDirty */ ) {
            for (let child of this.children)if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                child.sync(view, track);
                child.flags &= -8 /* ViewFlag.Dirty */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $e1533ef606a339de$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$e1533ef606a339de$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.flags |= 2 /* ViewFlag.NodeDirty */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.flags |= 2 /* ViewFlag.NodeDirty */ ;
            if (parent.flags & 1 /* ViewFlag.ChildDirty */ ) return;
            parent.flags |= 1 /* ViewFlag.ChildDirty */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.flags & 7 /* ViewFlag.Dirty */ ) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom == dom) return;
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $e1533ef606a339de$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this && children.indexOf(child) < 0) child.destroy();
        }
        if (children.length < 250) this.children.splice(from, to - from, ...children);
        else this.children = [].concat(this.children.slice(0, from), children, this.children.slice(to));
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $e1533ef606a339de$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        for (let child of this.children)if (child.parent == this) child.destroy();
        this.parent = null;
    }
}
$e1533ef606a339de$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $e1533ef606a339de$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $e1533ef606a339de$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $e1533ef606a339de$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && (toOff < after.length || after.breakAfter && (last === null || last === void 0 ? void 0 : last.breakAfter))) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff || after.children.length && !after.children[0].length) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $e1533ef606a339de$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $e1533ef606a339de$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
let $e1533ef606a339de$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $e1533ef606a339de$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $e1533ef606a339de$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($e1533ef606a339de$var$nav.userAgent);
const $e1533ef606a339de$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($e1533ef606a339de$var$nav.userAgent);
const $e1533ef606a339de$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($e1533ef606a339de$var$nav.userAgent);
const $e1533ef606a339de$var$ie = !!($e1533ef606a339de$var$ie_upto10 || $e1533ef606a339de$var$ie_11up || $e1533ef606a339de$var$ie_edge);
const $e1533ef606a339de$var$gecko = !$e1533ef606a339de$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($e1533ef606a339de$var$nav.userAgent);
const $e1533ef606a339de$var$chrome = !$e1533ef606a339de$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($e1533ef606a339de$var$nav.userAgent);
const $e1533ef606a339de$var$webkit = "webkitFontSmoothing" in $e1533ef606a339de$var$doc.documentElement.style;
const $e1533ef606a339de$var$safari = !$e1533ef606a339de$var$ie && /*@__PURE__*/ /Apple Computer/.test($e1533ef606a339de$var$nav.vendor);
const $e1533ef606a339de$var$ios = $e1533ef606a339de$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($e1533ef606a339de$var$nav.userAgent) || $e1533ef606a339de$var$nav.maxTouchPoints > 2);
var $e1533ef606a339de$var$browser = {
    mac: $e1533ef606a339de$var$ios || /*@__PURE__*/ /Mac/.test($e1533ef606a339de$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($e1533ef606a339de$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($e1533ef606a339de$var$nav.platform),
    ie: $e1533ef606a339de$var$ie,
    ie_version: $e1533ef606a339de$var$ie_upto10 ? $e1533ef606a339de$var$doc.documentMode || 6 : $e1533ef606a339de$var$ie_11up ? +$e1533ef606a339de$var$ie_11up[1] : $e1533ef606a339de$var$ie_edge ? +$e1533ef606a339de$var$ie_edge[1] : 0,
    gecko: $e1533ef606a339de$var$gecko,
    gecko_version: $e1533ef606a339de$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($e1533ef606a339de$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$e1533ef606a339de$var$chrome,
    chrome_version: $e1533ef606a339de$var$chrome ? +$e1533ef606a339de$var$chrome[1] : 0,
    ios: $e1533ef606a339de$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($e1533ef606a339de$var$nav.userAgent),
    webkit: $e1533ef606a339de$var$webkit,
    safari: $e1533ef606a339de$var$safari,
    webkit_version: $e1533ef606a339de$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($e1533ef606a339de$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $e1533ef606a339de$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $e1533ef606a339de$var$MaxJoinLen = 256;
class $e1533ef606a339de$var$TextView extends $e1533ef606a339de$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (this.flags & 8 /* ViewFlag.Composition */  || source && (!(source instanceof $e1533ef606a339de$var$TextView) || this.length - (to - from) + source.length > $e1533ef606a339de$var$MaxJoinLen || source.flags & 8 /* ViewFlag.Composition */ )) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $e1533ef606a339de$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        result.flags |= this.flags & 8 /* ViewFlag.Composition */ ;
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $e1533ef606a339de$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $e1533ef606a339de$var$textCoords(this.dom, pos, side);
    }
}
class $e1533ef606a339de$var$MarkView extends $e1533ef606a339de$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $e1533ef606a339de$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    canReuseDOM(other) {
        return super.canReuseDOM(other) && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $e1533ef606a339de$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $e1533ef606a339de$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $e1533ef606a339de$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $e1533ef606a339de$var$inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return $e1533ef606a339de$var$coordsInChildren(this, pos, side);
    }
}
function $e1533ef606a339de$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($e1533ef606a339de$var$browser.chrome || $e1533ef606a339de$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $e1533ef606a339de$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($e1533ef606a339de$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $e1533ef606a339de$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $e1533ef606a339de$var$WidgetView extends $e1533ef606a339de$var$ContentView {
    static create(widget, length, side) {
        return new $e1533ef606a339de$var$WidgetView(widget, length, side);
    }
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    split(from) {
        let result = $e1533ef606a339de$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $e1533ef606a339de$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof $e1533ef606a339de$var$WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let { view: view } = top, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? $e1533ef606a339de$var$DOMPos.before(this.dom) : $e1533ef606a339de$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        let fromBack = this.side ? this.side < 0 : pos > 0;
        for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return $e1533ef606a339de$var$flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $e1533ef606a339de$var$WidgetBufferView extends $e1533ef606a339de$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $e1533ef606a339de$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $e1533ef606a339de$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? $e1533ef606a339de$var$DOMPos.before(this.dom) : $e1533ef606a339de$var$DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty;
    }
    get isHidden() {
        return true;
    }
}
$e1533ef606a339de$var$TextView.prototype.children = $e1533ef606a339de$var$WidgetView.prototype.children = $e1533ef606a339de$var$WidgetBufferView.prototype.children = $e1533ef606a339de$var$noChildren;
function $e1533ef606a339de$var$inlineDOMAtPos(parent, pos) {
    let dom = parent.dom, { children: children } = parent, i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(let j = i; j > 0; j--){
        let prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(let j = i; j < children.length; j++){
        let next = children[j];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new $e1533ef606a339de$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $e1533ef606a339de$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $e1533ef606a339de$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $e1533ef606a339de$var$MarkView && last.mark.eq(view.mark)) $e1533ef606a339de$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $e1533ef606a339de$var$coordsInChildren(view, pos, side) {
    let before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(let i = 0, off = 0; i < view.children.length && off <= pos; i++){
            let child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && side > 0) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    let target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return $e1533ef606a339de$var$fallbackRect(view);
}
function $e1533ef606a339de$var$fallbackRect(view) {
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $e1533ef606a339de$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $e1533ef606a339de$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $e1533ef606a339de$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $e1533ef606a339de$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $e1533ef606a339de$var$noAttrs;
    if (!b) b = $e1533ef606a339de$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $e1533ef606a339de$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $e1533ef606a339de$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $e1533ef606a339de$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $e1533ef606a339de$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($e1533ef606a339de$export$48808c686fe495c4 || ($e1533ef606a339de$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $e1533ef606a339de$export$10e30b733df217ea extends (0, $0f49217316d01287$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $e1533ef606a339de$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $e1533ef606a339de$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $e1533ef606a339de$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $e1533ef606a339de$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $e1533ef606a339de$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $0f49217316d01287$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $e1533ef606a339de$export$10e30b733df217ea.none = (0, $0f49217316d01287$export$34cb5241245008dd).empty;
class $e1533ef606a339de$var$MarkDecoration extends $e1533ef606a339de$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $e1533ef606a339de$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        var _a, _b;
        return this == other || other instanceof $e1533ef606a339de$var$MarkDecoration && this.tagName == other.tagName && (this.class || ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && $e1533ef606a339de$var$attrsEq(this.attrs, other.attrs, "class");
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$e1533ef606a339de$var$MarkDecoration.prototype.point = false;
class $e1533ef606a339de$var$LineDecoration extends $e1533ef606a339de$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $e1533ef606a339de$var$LineDecoration && this.spec.class == other.spec.class && $e1533ef606a339de$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$e1533ef606a339de$var$LineDecoration.prototype.mapMode = (0, $0f49217316d01287$export$39cf3280165f92aa).TrackBefore;
$e1533ef606a339de$var$LineDecoration.prototype.point = true;
class $e1533ef606a339de$var$PointDecoration extends $e1533ef606a339de$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $0f49217316d01287$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $0f49217316d01287$export$39cf3280165f92aa).TrackBefore : (0, $0f49217316d01287$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $e1533ef606a339de$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $e1533ef606a339de$export$48808c686fe495c4.WidgetBefore : $e1533ef606a339de$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $e1533ef606a339de$var$PointDecoration && $e1533ef606a339de$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$e1533ef606a339de$var$PointDecoration.prototype.point = true;
function $e1533ef606a339de$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $e1533ef606a339de$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $e1533ef606a339de$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $e1533ef606a339de$var$LineView extends $e1533ef606a339de$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $e1533ef606a339de$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $e1533ef606a339de$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $e1533ef606a339de$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$e1533ef606a339de$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $e1533ef606a339de$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $e1533ef606a339de$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $e1533ef606a339de$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $e1533ef606a339de$var$inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) {
            $e1533ef606a339de$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $e1533ef606a339de$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        let last = this.dom.lastChild;
        while(last && $e1533ef606a339de$var$ContentView.get(last) instanceof $e1533ef606a339de$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $e1533ef606a339de$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$e1533ef606a339de$var$browser.ios || !this.children.some((ch)=>ch instanceof $e1533ef606a339de$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0, textHeight;
        for (let child of this.children){
            if (!(child instanceof $e1533ef606a339de$var$TextView) || /[^ -~]/.test(child.text)) return null;
            let rects = $e1533ef606a339de$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
            textHeight = rects[0].height;
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight: textHeight
        };
    }
    coordsAt(pos, side) {
        let rect = $e1533ef606a339de$var$coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            let { heightOracle: heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                let dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(other) {
        return other instanceof $e1533ef606a339de$var$LineView && this.children.length == 0 && other.children.length == 0 && $e1533ef606a339de$var$attrsEq(this.attrs, other.attrs) && this.breakAfter == other.breakAfter;
    }
    covers() {
        return true;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $e1533ef606a339de$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $e1533ef606a339de$var$BlockWidgetView extends $e1533ef606a339de$var$ContentView {
    constructor(widget, length, deco){
        super();
        this.widget = widget;
        this.length = length;
        this.deco = deco;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $e1533ef606a339de$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $e1533ef606a339de$var$DOMPos.before(this.dom) : $e1533ef606a339de$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $e1533ef606a339de$var$BlockWidgetView(this.widget, len, this.deco);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $e1533ef606a339de$var$noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $e1533ef606a339de$var$BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.deco = other.deco;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        if (this.widget instanceof $e1533ef606a339de$var$BlockGapWidget) return null;
        return $e1533ef606a339de$var$flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
    covers(side) {
        let { startSide: startSide, endSide: endSide } = this.deco;
        return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
    }
}
class $e1533ef606a339de$var$BlockGapWidget extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
class $e1533ef606a339de$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* Buf.No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !(last.breakAfter || last instanceof $e1533ef606a339de$var$BlockWidgetView && last.deco.endSide < 0);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $e1533ef606a339de$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active = this.bufferMarks) {
        if (this.pendingBuffer) {
            this.curLine.append($e1533ef606a339de$var$wrapMarks(new $e1533ef606a339de$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* Buf.No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* Buf.No */ ;
        if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof $e1533ef606a339de$var$BlockWidgetView)) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* T.Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append($e1533ef606a339de$var$wrapMarks(new $e1533ef606a339de$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $e1533ef606a339de$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $e1533ef606a339de$var$PointDecoration) {
            if (deco.block) {
                if (deco.startSide > 0 && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $e1533ef606a339de$var$BlockWidgetView(deco.widget || $e1533ef606a339de$var$NullWidget.block, len, deco));
            } else {
                let view = $e1533ef606a339de$var$WidgetView.create(deco.widget || $e1533ef606a339de$var$NullWidget.inline, len, len ? 0 : deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* Buf.IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* Buf.No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($e1533ef606a339de$var$wrapMarks(new $e1533ef606a339de$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($e1533ef606a339de$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* Buf.No */  : from < to || openStart > active.length ? 1 /* Buf.Yes */  : 2 /* Buf.IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $e1533ef606a339de$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $0f49217316d01287$export$34cb5241245008dd).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $e1533ef606a339de$var$wrapMarks(view, active) {
    for (let mark of active)view = new $e1533ef606a339de$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $e1533ef606a339de$var$NullWidget extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$e1533ef606a339de$var$NullWidget.inline = /*@__PURE__*/ new $e1533ef606a339de$var$NullWidget("span");
$e1533ef606a339de$var$NullWidget.block = /*@__PURE__*/ new $e1533ef606a339de$var$NullWidget("div");
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $e1533ef606a339de$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($e1533ef606a339de$export$cacd6541cfeeb6c1 || ($e1533ef606a339de$export$cacd6541cfeeb6c1 = {}));
const $e1533ef606a339de$var$LTR = $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR, $e1533ef606a339de$var$RTL = $e1533ef606a339de$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $e1533ef606a339de$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $e1533ef606a339de$var$LowTypes = /*@__PURE__*/ $e1533ef606a339de$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $e1533ef606a339de$var$ArabicTypes = /*@__PURE__*/ $e1533ef606a339de$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $e1533ef606a339de$var$Brackets = /*@__PURE__*/ Object.create(null), $e1533ef606a339de$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $e1533ef606a339de$var$Brackets[l] = r;
    $e1533ef606a339de$var$Brackets[r] = -l;
}
function $e1533ef606a339de$var$charType(ch) {
    return ch <= 0xf7 ? $e1533ef606a339de$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $e1533ef606a339de$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $e1533ef606a339de$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $e1533ef606a339de$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $e1533ef606a339de$var$RTL : $e1533ef606a339de$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $e1533ef606a339de$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$e1533ef606a339de$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $e1533ef606a339de$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $e1533ef606a339de$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $e1533ef606a339de$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $e1533ef606a339de$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $e1533ef606a339de$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $e1533ef606a339de$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $e1533ef606a339de$var$types[i] = prev;
                else $e1533ef606a339de$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $e1533ef606a339de$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $e1533ef606a339de$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$e1533ef606a339de$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $e1533ef606a339de$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $e1533ef606a339de$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $e1533ef606a339de$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($e1533ef606a339de$var$BracketStack[sJ + 1] == -br) {
                        let flags = $e1533ef606a339de$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $e1533ef606a339de$var$types[i] = $e1533ef606a339de$var$types[$e1533ef606a339de$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($e1533ef606a339de$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $e1533ef606a339de$var$BracketStack[sI++] = i;
                    $e1533ef606a339de$var$BracketStack[sI++] = ch;
                    $e1533ef606a339de$var$BracketStack[sI++] = context;
                }
            } else if ((type = $e1533ef606a339de$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $e1533ef606a339de$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $e1533ef606a339de$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $e1533ef606a339de$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $e1533ef606a339de$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $e1533ef606a339de$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($e1533ef606a339de$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $e1533ef606a339de$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $e1533ef606a339de$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $e1533ef606a339de$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $e1533ef606a339de$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($e1533ef606a339de$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $e1533ef606a339de$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $e1533ef606a339de$var$LTR != !(localLevel % 2);
                    $e1533ef606a339de$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $e1533ef606a339de$var$types[iScan] != ourType : $e1533ef606a339de$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $e1533ef606a339de$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $e1533ef606a339de$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $e1533ef606a339de$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($e1533ef606a339de$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $e1533ef606a339de$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $e1533ef606a339de$var$LTR != !(localLevel % 2);
                    $e1533ef606a339de$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $e1533ef606a339de$var$types[iScan - 1] != ourType : $e1533ef606a339de$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $e1533ef606a339de$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $e1533ef606a339de$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $e1533ef606a339de$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $e1533ef606a339de$var$computeCharTypes(line, from, to, isolates, outerType);
    $e1533ef606a339de$var$processBracketPairs(line, from, to, isolates, outerType);
    $e1533ef606a339de$var$processNeutrals(from, to, isolates, outerType);
    $e1533ef606a339de$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $e1533ef606a339de$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $e1533ef606a339de$export$e1ed96b746bb516a(0, 0, direction == $e1533ef606a339de$var$RTL ? 1 : 0)
    ];
    if (direction == $e1533ef606a339de$var$LTR && !isolates.length && !$e1533ef606a339de$var$BidiRE.test(line)) return $e1533ef606a339de$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $e1533ef606a339de$var$types.length)$e1533ef606a339de$var$types[$e1533ef606a339de$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $e1533ef606a339de$var$LTR ? 0 : 1;
    $e1533ef606a339de$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $e1533ef606a339de$var$trivialOrder(length) {
    return [
        new $e1533ef606a339de$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $e1533ef606a339de$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $e1533ef606a339de$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $e1533ef606a339de$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $e1533ef606a339de$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $e1533ef606a339de$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $e1533ef606a339de$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $e1533ef606a339de$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $e1533ef606a339de$var$RTL;
    }
    return $e1533ef606a339de$var$LTR;
}
const $e1533ef606a339de$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$mouseSelectionStyle = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$exceptionSink = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$updateListener = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$inputHandler = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$focusChangeEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$clipboardInputFilter = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$clipboardOutputFilter = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$perLineTextDirection = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $e1533ef606a339de$var$nativeSelectionHidden = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $e1533ef606a339de$var$scrollHandler = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
class $e1533ef606a339de$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $e1533ef606a339de$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $e1533ef606a339de$var$ScrollTarget((0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $e1533ef606a339de$var$scrollIntoView = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $e1533ef606a339de$var$setEditContextFormatting = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $e1533ef606a339de$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($e1533ef606a339de$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $e1533ef606a339de$var$editable = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $e1533ef606a339de$var$nextPluginID = 0;
const $e1533ef606a339de$var$viewPlugin = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class $e1533ef606a339de$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.extension = buildExtensions(this);
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $e1533ef606a339de$export$44d5eccfd62adda7($e1533ef606a339de$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [
                $e1533ef606a339de$var$viewPlugin.of(plugin)
            ];
            if (deco) ext.push($e1533ef606a339de$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $e1533ef606a339de$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $e1533ef606a339de$export$44d5eccfd62adda7.define((view)=>new cls(view), spec);
    }
}
class $e1533ef606a339de$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                $e1533ef606a339de$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $e1533ef606a339de$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $e1533ef606a339de$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $e1533ef606a339de$var$editorAttributes = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$contentAttributes = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $e1533ef606a339de$var$decorations = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$outerDecorations = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$atomicRanges = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
function $e1533ef606a339de$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($e1533ef606a339de$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $0f49217316d01287$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $e1533ef606a339de$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $e1533ef606a339de$var$scrollMargins = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
function $e1533ef606a339de$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($e1533ef606a339de$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $e1533ef606a339de$var$styleModule = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
class $e1533ef606a339de$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $e1533ef606a339de$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $e1533ef606a339de$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $e1533ef606a339de$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $e1533ef606a339de$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $0f49217316d01287$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $e1533ef606a339de$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $e1533ef606a339de$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Returns true when
    [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
    and the viewport change is not just the result of mapping it in
    response to document changes.
    */ get viewportMoved() {
        return (this.flags & 8 /* UpdateFlag.ViewportMoved */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 18 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
class $e1533ef606a339de$var$DocView extends $e1533ef606a339de$var$ContentView {
    get length() {
        return this.view.state.doc.length;
    }
    constructor(view){
        super();
        this.view = view;
        this.decorations = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.markedForComposition = new Set;
        this.editContextFormatting = $e1533ef606a339de$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $e1533ef606a339de$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $e1533ef606a339de$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0, null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$e1533ef606a339de$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $e1533ef606a339de$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            this.markedForComposition.clear();
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $e1533ef606a339de$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($e1533ef606a339de$var$browser.ie || $e1533ef606a339de$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $e1533ef606a339de$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $e1533ef606a339de$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (!(this.flags & 7 /* ViewFlag.Dirty */ ) && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength, composition) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength, composition);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $e1533ef606a339de$var$browser.chrome || $e1533ef606a339de$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.flags &= -8 /* ViewFlag.Dirty */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        this.markedForComposition.forEach((cView)=>cView.flags &= -9 /* ViewFlag.Composition */ );
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $e1533ef606a339de$var$BlockWidgetView && child.widget instanceof $e1533ef606a339de$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength, composition) {
        let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
        let cursor = this.childCursor(oldLength);
        for(let i = ranges.length - 1;; i--){
            let next = i >= 0 ? ranges[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next, content, breakAtStart, openStart, openEnd;
            if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
                let before = $e1533ef606a339de$var$ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
                let after = $e1533ef606a339de$var$ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
                breakAtStart = before.breakAtStart;
                openStart = before.openStart;
                openEnd = after.openEnd;
                let compLine = this.compositionView(composition);
                if (after.breakAtStart) compLine.breakAfter = 1;
                else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
                    compLine.breakAfter = after.content[0].breakAfter;
                    after.content.shift();
                }
                if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) before.content.pop();
                content = before.content.concat(compLine).concat(after.content);
            } else ({ content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $e1533ef606a339de$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $e1533ef606a339de$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
        if (composition) this.fixCompositionDOM(composition);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($e1533ef606a339de$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    compositionView(composition) {
        let cur = new $e1533ef606a339de$var$TextView(composition.text.nodeValue);
        cur.flags |= 8 /* ViewFlag.Composition */ ;
        for (let { deco: deco } of composition.marks)cur = new $e1533ef606a339de$var$MarkView(deco, [
            cur
        ], cur.length);
        let line = new $e1533ef606a339de$var$LineView;
        line.append(cur, 0);
        return line;
    }
    fixCompositionDOM(composition) {
        let fix = (dom, cView)=>{
            cView.flags |= 8 /* ViewFlag.Composition */  | (cView.children.some((c)=>c.flags & 7 /* ViewFlag.Dirty */ ) ? 1 /* ViewFlag.ChildDirty */  : 0);
            this.markedForComposition.add(cView);
            let prev = $e1533ef606a339de$var$ContentView.get(dom);
            if (prev && prev != cView) prev.dom = null;
            cView.setDOM(dom);
        };
        let pos = this.childPos(composition.range.fromB, 1);
        let cView = this.children[pos.i];
        fix(composition.line, cView);
        for(let i = composition.marks.length - 1; i >= -1; i--){
            pos = cView.childPos(pos.off, 1);
            cView = cView.children[pos.i];
            fix(i >= 0 ? composition.marks[i].node : composition.text, cView);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        let selectionNotFocus = !focused && !(this.view.state.facet($e1533ef606a339de$var$editable) || this.dom.tabIndex > -1) && $e1533ef606a339de$var$hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        let anchor = this.moveToLine(this.domAtPos(main.anchor));
        let head = main.empty ? anchor : this.moveToLine(this.domAtPos(main.head));
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($e1533ef606a339de$var$browser.gecko && main.empty && !this.hasComposition && $e1533ef606a339de$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $e1533ef606a339de$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$e1533ef606a339de$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$e1533ef606a339de$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($e1533ef606a339de$var$browser.android && $e1533ef606a339de$var$browser.chrome && this.dom.contains(domSel.focusNode) && $e1533ef606a339de$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $e1533ef606a339de$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($e1533ef606a339de$var$browser.gecko) {
                        let nextTo = $e1533ef606a339de$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $e1533ef606a339de$var$textNodeBefore : $e1533ef606a339de$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $e1533ef606a339de$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $e1533ef606a339de$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $e1533ef606a339de$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $e1533ef606a339de$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $e1533ef606a339de$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $e1533ef606a339de$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    // If a position is in/near a block widget, move it to a nearby text
    // line, since we don't want the cursor inside a block widget.
    moveToLine(pos) {
        // Block widgets will return positions before/after them, which
        // are thus directly in the document DOM element.
        let dom = this.dom, newPos;
        if (pos.node != dom) return pos;
        for(let i = pos.offset; !newPos && i < dom.childNodes.length; i++){
            let view = $e1533ef606a339de$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $e1533ef606a339de$var$LineView) newPos = view.domAtPos(0);
        }
        for(let i = pos.offset - 1; !newPos && i >= 0; i--){
            let view = $e1533ef606a339de$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $e1533ef606a339de$var$LineView) newPos = view.domAtPos(view.length);
        }
        return newPos ? new $e1533ef606a339de$var$DOMPos(newPos.node, newPos.offset, true) : pos;
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $e1533ef606a339de$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $e1533ef606a339de$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        let best = null, bestPos = 0;
        for(let off = this.length, i = this.children.length - 1; i >= 0; i--){
            let child = this.children[i], end = off - child.breakAfter, start = end - child.length;
            if (end < pos) break;
            if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof $e1533ef606a339de$var$LineView && !(best instanceof $e1533ef606a339de$var$LineView && side >= 0))) {
                best = child;
                bestPos = start;
            } else if (best && start == pos && end == pos && child instanceof $e1533ef606a339de$var$BlockWidgetView && Math.abs(side) < 2) {
                if (child.deco.startSide < 0) break;
                else if (i) best = null;
            }
            off = start;
        }
        return best ? best.coordsAt(pos - bestPos, side) : null;
    }
    coordsForChar(pos) {
        let { i: i, off: off } = this.childPos(pos, 1), child = this.children[i];
        if (!(child instanceof $e1533ef606a339de$var$LineView)) return null;
        while(child.children.length){
            let { i: i, off: childOff } = child.childPos(off, 1);
            for(;; i++){
                if (i == child.children.length) return null;
                if ((child = child.children[i]).length) break;
            }
            off = childOff;
        }
        if (!(child instanceof $e1533ef606a339de$var$TextView)) return null;
        let end = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(child.text, off);
        if (end == off) return null;
        let rects = $e1533ef606a339de$var$textRange(child.dom, off, end).getClientRects();
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
        }
        return null;
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $e1533ef606a339de$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $e1533ef606a339de$export$cacd6541cfeeb6c1.RTL : $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $e1533ef606a339de$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $e1533ef606a339de$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $e1533ef606a339de$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($e1533ef606a339de$export$10e30b733df217ea.replace({
                    widget: new $e1533ef606a339de$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $e1533ef606a339de$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($e1533ef606a339de$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($e1533ef606a339de$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $0f49217316d01287$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        return this.decorations;
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($e1533ef606a339de$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $e1533ef606a339de$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $e1533ef606a339de$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $e1533ef606a339de$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR);
    }
}
function $e1533ef606a339de$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function $e1533ef606a339de$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $e1533ef606a339de$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $e1533ef606a339de$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let descAfter = $e1533ef606a339de$var$ContentView.get(textAfter.node);
        if (!descAfter || descAfter instanceof $e1533ef606a339de$var$TextView && descAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let descBefore = $e1533ef606a339de$var$ContentView.get(textBefore.node);
            if (!(!descBefore || descBefore instanceof $e1533ef606a339de$var$TextView && descBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $e1533ef606a339de$var$findCompositionRange(view, changes, headPos) {
    let found = $e1533ef606a339de$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    let range = new $e1533ef606a339de$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to);
    let marks = [];
    for(let parent = textNode.parentNode;; parent = parent.parentNode){
        let parentView = $e1533ef606a339de$var$ContentView.get(parent);
        if (parentView instanceof $e1533ef606a339de$var$MarkView) marks.push({
            node: parent,
            deco: parentView.mark
        });
        else if (parentView instanceof $e1533ef606a339de$var$LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM) return {
            range: range,
            text: textNode,
            marks: marks,
            line: parent
        };
        else if (parent != view.contentDOM) marks.push({
            node: parent,
            deco: new $e1533ef606a339de$var$MarkDecoration({
                inclusive: true,
                attributes: $e1533ef606a339de$var$getAttrs(parent),
                tagName: parent.tagName.toLowerCase()
            })
        });
        else return null;
    }
}
function $e1533ef606a339de$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $e1533ef606a339de$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $e1533ef606a339de$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $e1533ef606a339de$var$addRange(from, to, this.changes);
    }
    boundChange(pos) {
        $e1533ef606a339de$var$addRange(pos, pos, this.changes);
    }
};
function $e1533ef606a339de$var$findChangedDeco(a, b, diff) {
    let comp = new $e1533ef606a339de$var$DecorationComparator$1;
    (0, $0f49217316d01287$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $e1533ef606a339de$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == 'false') return true;
    }
    return false;
}
function $e1533ef606a339de$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
function $e1533ef606a339de$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $e1533ef606a339de$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $e1533ef606a339de$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $e1533ef606a339de$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $e1533ef606a339de$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $e1533ef606a339de$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $e1533ef606a339de$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY, closestOverlap = false;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $e1533ef606a339de$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $e1533ef606a339de$var$yOverlap(closestRect, rect)) rect = $e1533ef606a339de$var$upTop($e1533ef606a339de$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $e1533ef606a339de$var$getdx(x, rect), dy = $e1533ef606a339de$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $e1533ef606a339de$var$domPosInText(child, x, y) : $e1533ef606a339de$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                let side = dy ? y < rect.top ? -1 : 1 : dx ? x < rect.left ? -1 : 1 : 0;
                closestOverlap = !side || (side > 0 ? i < rects.length - 1 : i > 0);
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $e1533ef606a339de$var$yOverlap(aboveRect, rect)) aboveRect = $e1533ef606a339de$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $e1533ef606a339de$var$yOverlap(belowRect, rect)) belowRect = $e1533ef606a339de$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $e1533ef606a339de$var$domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return $e1533ef606a339de$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $e1533ef606a339de$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $e1533ef606a339de$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($e1533ef606a339de$var$browser.chrome || $e1533ef606a339de$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $e1533ef606a339de$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $e1533ef606a339de$var$posAtCoords(view, coords, precise, bias = -1) {
    var _a, _b;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let { x: x, y: y } = coords, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $e1533ef606a339de$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $e1533ef606a339de$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $e1533ef606a339de$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if (!view.contentDOM.contains(node) || $e1533ef606a339de$var$browser.safari && $e1533ef606a339de$var$isSuspiciousSafariCaretResult(node, offset, x) || $e1533ef606a339de$var$browser.chrome && $e1533ef606a339de$var$isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
        // Chrome will return offsets into <input> elements without child
        // nodes, which will lead to a null deref below, so clip the
        // offset to the node size.
        if (node) offset = Math.min($e1533ef606a339de$var$maxOffset(node), offset);
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $e1533ef606a339de$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $e1533ef606a339de$var$domPosAtCoords(line.dom, x, y));
    }
    let nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        let rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function $e1533ef606a339de$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $0f49217316d01287$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $e1533ef606a339de$var$isSuspiciousSafariCaretResult(node, offset, x) {
    let len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(let next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return $e1533ef606a339de$var$textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
// Chrome will move positions between lines to the start of the next line
function $e1533ef606a339de$var$isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(let cur = node;;){
        let parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    let rect = node.nodeType == 1 ? node.getBoundingClientRect() : $e1533ef606a339de$var$textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function $e1533ef606a339de$var$blockAt(view, pos) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) for (let l of line.type){
        if (l.to > pos || l.to == pos && (l.to == line.to || l.type == $e1533ef606a339de$export$48808c686fe495c4.Text)) return l;
    }
    return line;
}
function $e1533ef606a339de$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $e1533ef606a339de$var$blockAt(view, start.head);
    let coords = !includeWrap || line.type != $e1533ef606a339de$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $e1533ef606a339de$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $e1533ef606a339de$var$moveVisually(line, spans, direction, cur, forward), char = $e1533ef606a339de$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $e1533ef606a339de$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $0f49217316d01287$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $e1533ef606a339de$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $e1533ef606a339de$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
            let charRect = view.docView.coordsForChar(pos);
            let assoc = !charRect || curY < charRect.top ? -1 : 1;
            return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos, assoc, undefined, goal);
        }
    }
}
function $e1533ef606a339de$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $e1533ef606a339de$var$skipAtoms(view, oldPos, pos) {
    let newPos = $e1533ef606a339de$var$skipAtomicRanges(view.state.facet($e1533ef606a339de$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
const $e1533ef606a339de$var$LineBreakPlaceholder = "\uffff";
class $e1533ef606a339de$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $0f49217316d01287$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $e1533ef606a339de$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $e1533ef606a339de$var$ContentView.get(cur), nextView = $e1533ef606a339de$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $e1533ef606a339de$var$isBlockElement(cur)) || $e1533ef606a339de$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $e1533ef606a339de$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($e1533ef606a339de$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $e1533ef606a339de$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $e1533ef606a339de$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $e1533ef606a339de$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
class $e1533ef606a339de$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $e1533ef606a339de$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $e1533ef606a339de$var$selectionPoints(view);
            let reader = new $e1533ef606a339de$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $e1533ef606a339de$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$e1533ef606a339de$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$e1533ef606a339de$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($e1533ef606a339de$var$browser.ios || $e1533ef606a339de$var$browser.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            this.newSel = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $e1533ef606a339de$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $e1533ef606a339de$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $e1533ef606a339de$var$findDiff(view.state.doc.sliceString(from, to, $e1533ef606a339de$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($e1533ef606a339de$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $e1533ef606a339de$var$LineBreakPlaceholder + $e1533ef606a339de$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($e1533ef606a339de$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($e1533ef606a339de$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (($e1533ef606a339de$var$browser.mac || $e1533ef606a339de$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    } else if ($e1533ef606a339de$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $e1533ef606a339de$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $e1533ef606a339de$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($e1533ef606a339de$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($e1533ef606a339de$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $e1533ef606a339de$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $e1533ef606a339de$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $e1533ef606a339de$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $e1533ef606a339de$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($e1533ef606a339de$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $e1533ef606a339de$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main;
    if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $e1533ef606a339de$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to, size = sel.to - sel.from;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $0f49217316d01287$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $e1533ef606a339de$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $e1533ef606a339de$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $e1533ef606a339de$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $e1533ef606a339de$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $e1533ef606a339de$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $0f49217316d01287$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
class $e1533ef606a339de$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        /**
        When enabled (>-1), tab presses are not given to key handlers,
        leaving the browser's default behavior. If >0, the mode expires
        at that timestamp, and any other keypress clears it.
        Esc enables temporary tab focus mode for two seconds when not
        otherwise handled.
        */ this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($e1533ef606a339de$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($e1533ef606a339de$var$browser.gecko) $e1533ef606a339de$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$e1533ef606a339de$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $e1533ef606a339de$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $e1533ef606a339de$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($e1533ef606a339de$var$browser.android && $e1533ef606a339de$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($e1533ef606a339de$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $e1533ef606a339de$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $e1533ef606a339de$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $e1533ef606a339de$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($e1533ef606a339de$var$browser.safari && !$e1533ef606a339de$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $e1533ef606a339de$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $e1533ef606a339de$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $e1533ef606a339de$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec;
        if (spec && spec.domEventHandlers) for(let type in spec.domEventHandlers){
            let f = spec.domEventHandlers[type];
            if (f) record(type).handlers.push($e1533ef606a339de$var$bindHandler(plugin.value, f));
        }
        if (spec && spec.domEventObservers) for(let type in spec.domEventObservers){
            let f = spec.domEventObservers[type];
            if (f) record(type).observers.push($e1533ef606a339de$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $e1533ef606a339de$var$handlers)record(type).handlers.push($e1533ef606a339de$var$handlers[type]);
    for(let type in $e1533ef606a339de$var$observers)record(type).observers.push($e1533ef606a339de$var$observers[type]);
    return result;
}
const $e1533ef606a339de$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $e1533ef606a339de$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $e1533ef606a339de$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $e1533ef606a339de$var$dragScrollMargin = 6;
function $e1533ef606a339de$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $e1533ef606a339de$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $e1533ef606a339de$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParents = $e1533ef606a339de$var$scrollableParents(view.contentDOM);
        this.atoms = view.state.facet($e1533ef606a339de$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $0f49217316d01287$export$afa855cbfaff27f2).allowMultipleSelections) && $e1533ef606a339de$var$addsSelectionRange(view, startEvent);
        this.dragging = $e1533ef606a339de$var$isInPrimarySelection(view, startEvent) && $e1533ef606a339de$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $e1533ef606a339de$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let left = 0, top = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
        if (this.scrollParents.x) ({ left: left, right: right } = this.scrollParents.x.getBoundingClientRect());
        if (this.scrollParents.y) ({ top: top, bottom: bottom } = this.scrollParents.y.getBoundingClientRect());
        let margins = $e1533ef606a339de$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= left + $e1533ef606a339de$var$dragScrollMargin) sx = -$e1533ef606a339de$var$dragScrollSpeed(left - event.clientX);
        else if (event.clientX + margins.right >= right - $e1533ef606a339de$var$dragScrollMargin) sx = $e1533ef606a339de$var$dragScrollSpeed(event.clientX - right);
        if (event.clientY - margins.top <= top + $e1533ef606a339de$var$dragScrollMargin) sy = -$e1533ef606a339de$var$dragScrollSpeed(top - event.clientY);
        else if (event.clientY + margins.bottom >= bottom - $e1533ef606a339de$var$dragScrollMargin) sy = $e1533ef606a339de$var$dragScrollSpeed(event.clientY - bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        let { x: x, y: y } = this.scrollSpeed;
        if (x && this.scrollParents.x) {
            this.scrollParents.x.scrollLeft += x;
            x = 0;
        }
        if (y && this.scrollParents.y) {
            this.scrollParents.y.scrollTop += y;
            y = 0;
        }
        if (x || y) this.view.win.scrollBy(x, y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        let ranges = null;
        for(let i = 0; i < sel.ranges.length; i++){
            let range = sel.ranges[i], updated = null;
            if (range.empty) {
                let pos = $e1533ef606a339de$var$skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos, -1);
            } else {
                let from = $e1533ef606a339de$var$skipAtomicRanges(this.atoms, range.from, -1);
                let to = $e1533ef606a339de$var$skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        let { view: view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $e1533ef606a339de$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($e1533ef606a339de$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $e1533ef606a339de$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $e1533ef606a339de$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($e1533ef606a339de$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $e1533ef606a339de$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $e1533ef606a339de$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $e1533ef606a339de$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $e1533ef606a339de$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $e1533ef606a339de$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $e1533ef606a339de$var$handlers = /*@__PURE__*/ Object.create(null);
const $e1533ef606a339de$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $e1533ef606a339de$var$brokenClipboardAPI = $e1533ef606a339de$var$browser.ie && $e1533ef606a339de$var$browser.ie_version < 15 || $e1533ef606a339de$var$browser.ios && $e1533ef606a339de$var$browser.webkit_version < 604;
function $e1533ef606a339de$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $e1533ef606a339de$var$doPaste(view, target.value);
    }, 50);
}
function $e1533ef606a339de$var$textFilter(state, facet, text) {
    for (let filter of state.facet(facet))text = filter(text, state);
    return text;
}
function $e1533ef606a339de$var$doPaste(view, input) {
    input = $e1533ef606a339de$var$textFilter(view.state, $e1533ef606a339de$var$clipboardInputFilter, input);
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $e1533ef606a339de$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $e1533ef606a339de$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$e1533ef606a339de$var$observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
$e1533ef606a339de$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$e1533ef606a339de$var$observers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$e1533ef606a339de$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$e1533ef606a339de$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($e1533ef606a339de$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $e1533ef606a339de$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $e1533ef606a339de$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $e1533ef606a339de$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    }
    return false;
};
function $e1533ef606a339de$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $e1533ef606a339de$var$groupAt(view.state, pos, bias);
    else {
        let visual = $e1533ef606a339de$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $0f49217316d01287$export$3bb1bd44aee62999).range(from, to);
    }
}
let $e1533ef606a339de$var$inside = (x, y, rect)=>y >= rect.top && y <= rect.bottom && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $e1533ef606a339de$var$findPositionSide(view, pos, x, y) {
    let line = $e1533ef606a339de$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $e1533ef606a339de$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $e1533ef606a339de$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // above its bottom.
    return before && before.bottom >= y ? -1 : 1;
}
function $e1533ef606a339de$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $e1533ef606a339de$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $e1533ef606a339de$var$BadMouseDetail = $e1533ef606a339de$var$browser.ie && $e1533ef606a339de$var$browser.ie_version <= 11;
let $e1533ef606a339de$var$lastMouseDown = null, $e1533ef606a339de$var$lastMouseDownCount = 0, $e1533ef606a339de$var$lastMouseDownTime = 0;
function $e1533ef606a339de$var$getClickType(event) {
    if (!$e1533ef606a339de$var$BadMouseDetail) return event.detail;
    let last = $e1533ef606a339de$var$lastMouseDown, lastTime = $e1533ef606a339de$var$lastMouseDownTime;
    $e1533ef606a339de$var$lastMouseDown = event;
    $e1533ef606a339de$var$lastMouseDownTime = Date.now();
    return $e1533ef606a339de$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($e1533ef606a339de$var$lastMouseDownCount + 1) % 3 : 1;
}
function $e1533ef606a339de$var$basicMouseSelection(view, event) {
    let start = $e1533ef606a339de$var$queryPos(view, event), type = $e1533ef606a339de$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $e1533ef606a339de$var$queryPos(view, event), removed;
            let range = $e1533ef606a339de$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $e1533ef606a339de$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $0f49217316d01287$export$3bb1bd44aee62999).range(from, to) : (0, $0f49217316d01287$export$3bb1bd44aee62999).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $e1533ef606a339de$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $0f49217316d01287$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $e1533ef606a339de$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $0f49217316d01287$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$e1533ef606a339de$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let cView = view.docView.nearest(event.target);
        if (cView && cView.isWidget) {
            let from = cView.posAtStart, to = from + cView.length;
            if (from >= range.to || to <= range.from) range = (0, $0f49217316d01287$export$3bb1bd44aee62999).range(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", $e1533ef606a339de$var$textFilter(view.state, $e1533ef606a339de$var$clipboardOutputFilter, view.state.sliceDoc(range.from, range.to)));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$e1533ef606a339de$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $e1533ef606a339de$var$dropText(view, event, text, direct) {
    text = $e1533ef606a339de$var$textFilter(view.state, $e1533ef606a339de$var$clipboardInputFilter, text);
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $e1533ef606a339de$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$e1533ef606a339de$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $e1533ef606a339de$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $e1533ef606a339de$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$e1533ef606a339de$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $e1533ef606a339de$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $e1533ef606a339de$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $e1533ef606a339de$var$capturePaste(view);
        return false;
    }
};
function $e1533ef606a339de$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $e1533ef606a339de$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: $e1533ef606a339de$var$textFilter(state, $e1533ef606a339de$var$clipboardOutputFilter, content.join(state.lineBreak)),
        ranges: ranges,
        linewise: linewise
    };
}
let $e1533ef606a339de$var$lastLinewiseCopy = null;
$e1533ef606a339de$var$handlers.copy = $e1533ef606a339de$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $e1533ef606a339de$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $e1533ef606a339de$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $e1533ef606a339de$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $e1533ef606a339de$var$captureCopy(view, text);
        return false;
    }
};
const $e1533ef606a339de$var$isFocusChange = /*@__PURE__*/ (0, $0f49217316d01287$export$9279461326b8700a).define();
function $e1533ef606a339de$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($e1533ef606a339de$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects ? state.update({
        effects: effects,
        annotations: $e1533ef606a339de$var$isFocusChange.of(true)
    }) : null;
}
function $e1533ef606a339de$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $e1533ef606a339de$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$e1533ef606a339de$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $e1533ef606a339de$var$updateForFocusChange(view);
};
$e1533ef606a339de$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $e1533ef606a339de$var$updateForFocusChange(view);
};
$e1533ef606a339de$var$observers.compositionstart = $e1533ef606a339de$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$e1533ef606a339de$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($e1533ef606a339de$var$browser.chrome && $e1533ef606a339de$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$e1533ef606a339de$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$e1533ef606a339de$var$handlers.beforeinput = (view, event)=>{
    var _a, _b;
    // In EditContext mode, we must handle insertReplacementText events
    // directly, to make spell checking corrections work
    if (event.inputType == "insertReplacementText" && view.observer.editContext) {
        let text = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.getData("text/plain"), ranges = event.getTargetRanges();
        if (text && ranges.length) {
            let r = ranges[0];
            let from = view.posAtDOM(r.startContainer, r.startOffset), to = view.posAtDOM(r.endContainer, r.endOffset);
            $e1533ef606a339de$var$applyDOMChangeInner(view, {
                from: from,
                to: to,
                insert: view.state.toText(text)
            }, null);
            return true;
        }
    }
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($e1533ef606a339de$var$browser.chrome && $e1533ef606a339de$var$browser.android && (pending = $e1533ef606a339de$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($e1533ef606a339de$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($e1533ef606a339de$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$e1533ef606a339de$var$observers.compositionend(view, event), 20);
    return false;
};
const $e1533ef606a339de$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See https://github.com/codemirror/dev/issues/1082
// and https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $e1533ef606a339de$var$firefoxCopyCutHack(doc) {
    if (!$e1533ef606a339de$var$appliedFirefoxHack.has(doc)) {
        $e1533ef606a339de$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $e1533ef606a339de$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
// Used to track, during updateHeight, if any actual heights changed
let $e1533ef606a339de$var$heightChangeFlag = false;
function $e1533ef606a339de$var$clearHeightChangeFlag() {
    $e1533ef606a339de$var$heightChangeFlag = false;
}
class $e1533ef606a339de$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $e1533ef606a339de$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $e1533ef606a339de$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $e1533ef606a339de$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $e1533ef606a339de$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $e1533ef606a339de$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $e1533ef606a339de$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $e1533ef606a339de$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($e1533ef606a339de$var$QueryType || ($e1533ef606a339de$var$QueryType = {}));
const $e1533ef606a339de$var$Epsilon = 1e-3;
class $e1533ef606a339de$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $e1533ef606a339de$var$Epsilon) $e1533ef606a339de$var$heightChangeFlag = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $e1533ef606a339de$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $e1533ef606a339de$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $e1533ef606a339de$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $e1533ef606a339de$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $e1533ef606a339de$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = $e1533ef606a339de$var$replace(me, me.replace(fromA, toA, nodes));
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $e1533ef606a339de$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $e1533ef606a339de$var$HeightMapBranch($e1533ef606a339de$var$HeightMap.of(nodes.slice(0, i)), brk, $e1533ef606a339de$var$HeightMap.of(nodes.slice(j)));
    }
}
function $e1533ef606a339de$var$replace(old, val) {
    if (old == val) return old;
    if (old.constructor != val.constructor) $e1533ef606a339de$var$heightChangeFlag = true;
    return val;
}
$e1533ef606a339de$var$HeightMap.prototype.size = 1;
class $e1533ef606a339de$var$HeightMapBlock extends $e1533ef606a339de$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
    blockAt(_height, _oracle, top, offset) {
        return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $e1533ef606a339de$var$HeightMapText extends $e1533ef606a339de$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
    blockAt(_height, _oracle, top, offset) {
        return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $e1533ef606a339de$var$HeightMapText || node instanceof $e1533ef606a339de$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $e1533ef606a339de$var$HeightMapGap) node = new $e1533ef606a339de$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $e1533ef606a339de$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $e1533ef606a339de$var$HeightMapGap extends $e1533ef606a339de$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $e1533ef606a339de$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $e1533ef606a339de$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $e1533ef606a339de$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $e1533ef606a339de$var$HeightMapGap) nodes[nodes.length - 1] = new $e1533ef606a339de$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $e1533ef606a339de$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $e1533ef606a339de$var$HeightMapGap) nodes[0] = new $e1533ef606a339de$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $e1533ef606a339de$var$HeightMapGap(from - 1), null);
        }
        return $e1533ef606a339de$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $e1533ef606a339de$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $e1533ef606a339de$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $e1533ef606a339de$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $e1533ef606a339de$var$Epsilon) singleHeight = -2;
                let line = new $e1533ef606a339de$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $e1533ef606a339de$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $e1533ef606a339de$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $e1533ef606a339de$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $e1533ef606a339de$var$Epsilon) $e1533ef606a339de$var$heightChangeFlag = true;
            return $e1533ef606a339de$var$replace(this, result);
        } else if (force || this.outdated) {
            this.setHeight(oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $e1533ef606a339de$var$HeightMapBranch extends $e1533ef606a339de$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $e1533ef606a339de$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $e1533ef606a339de$var$QueryType.ByPosNoHeight ? $e1533ef606a339de$var$QueryType.ByPosNoHeight : $e1533ef606a339de$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $e1533ef606a339de$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $e1533ef606a339de$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $e1533ef606a339de$var$mergeGaps(result, right);
        }
        return $e1533ef606a339de$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $e1533ef606a339de$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = $e1533ef606a339de$var$replace(this.left, left);
        this.right = $e1533ef606a339de$var$replace(this.right, right);
        this.setHeight(left.height + right.height);
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $e1533ef606a339de$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $e1533ef606a339de$var$HeightMapGap && (after = nodes[around + 1]) instanceof $e1533ef606a339de$var$HeightMapGap) nodes.splice(around - 1, 3, new $e1533ef606a339de$var$HeightMapGap(before.length + 1 + after.length));
}
const $e1533ef606a339de$var$relevantWidgetHeight = 5;
class $e1533ef606a339de$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $e1533ef606a339de$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $e1533ef606a339de$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $e1533ef606a339de$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $e1533ef606a339de$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $e1533ef606a339de$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $e1533ef606a339de$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $e1533ef606a339de$var$HeightMapText) return last;
        let line = new $e1533ef606a339de$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $e1533ef606a339de$var$HeightMapText) && !this.isCovered) this.nodes.push(new $e1533ef606a339de$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $e1533ef606a339de$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $e1533ef606a339de$var$NodeBuilder(from, oracle);
        (0, $0f49217316d01287$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $e1533ef606a339de$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $e1533ef606a339de$var$DecorationComparator;
    (0, $0f49217316d01287$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $e1533ef606a339de$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $e1533ef606a339de$var$addRange(from, to, this.changes, 5);
    }
}
function $e1533ef606a339de$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $e1533ef606a339de$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $e1533ef606a339de$var$LineGap {
    constructor(from, to, size, displaySize){
        this.from = from;
        this.to = to;
        this.size = size;
        this.displaySize = displaySize;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $e1533ef606a339de$export$10e30b733df217ea.replace({
            widget: new $e1533ef606a339de$var$LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $e1533ef606a339de$var$LineGapWidget extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $e1533ef606a339de$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        this.scrollTop = 0; // Last seen scrollDOM.scrollTop, scaled
        this.scrolledToBottom = false;
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $e1533ef606a339de$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($e1533ef606a339de$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $e1533ef606a339de$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($e1533ef606a339de$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $e1533ef606a339de$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $e1533ef606a339de$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $e1533ef606a339de$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $e1533ef606a339de$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $e1533ef606a339de$var$IdScaler : new $e1533ef606a339de$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($e1533ef606a339de$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($e1533ef606a339de$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $e1533ef606a339de$var$ChangedRange.extendWithRanges(contentChanges, $e1533ef606a339de$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $0f49217316d01287$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        $e1533ef606a339de$var$clearHeightChangeFlag();
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight || $e1533ef606a339de$var$heightChangeFlag) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = this.heightMap.height;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges(update.changes);
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($e1533ef606a339de$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $e1533ef606a339de$export$cacd6541cfeeb6c1.RTL : $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $e1533ef606a339de$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 16 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 18 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
        if (this.scrollTop != scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = scrollTop;
        }
        this.scrolledToBottom = $e1533ef606a339de$var$isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        let pixelViewport = (this.printing ? $e1533ef606a339de$var$fullPixelRange : $e1533ef606a339de$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 16 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 16 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            $e1533ef606a339de$var$clearHeightChangeFlag();
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $e1533ef606a339de$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $0f49217316d01287$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $e1533ef606a339de$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $e1533ef606a339de$var$MeasuredHeights(vp.from, heights));
            }
            if ($e1533ef606a339de$var$heightChangeFlag) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $e1533ef606a339de$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $e1533ef606a339de$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $e1533ef606a339de$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $e1533ef606a339de$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $e1533ef606a339de$var$Viewport(map.lineAt(topPos - 500, $e1533ef606a339de$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $e1533ef606a339de$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $e1533ef606a339de$var$Viewport(this.heightMap.lineAt(from, $e1533ef606a339de$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $e1533ef606a339de$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $e1533ef606a339de$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $e1533ef606a339de$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $e1533ef606a339de$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $e1533ef606a339de$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                let size = this.gapSize(line, from, to, structure);
                let displaySize = wrapping || size < 2000000 /* VP.MaxHorizGap */  ? size : 2000000 /* VP.MaxHorizGap */ ;
                gap = new $e1533ef606a339de$var$LineGap(from, to, size, displaySize);
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $e1533ef606a339de$export$48808c686fe495c4.Text) return;
            let structure = $e1533ef606a339de$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $e1533ef606a339de$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $e1533ef606a339de$var$findPosition(structure, top);
                viewTo = $e1533ef606a339de$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let horizOffset = 0;
                if (totalWidth > 2000000 /* VP.MaxHorizGap */ ) {
                    for (let old of current)if (old.from >= line.from && old.from < line.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left) horizOffset = old.size - old.displaySize;
                }
                let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
                let left, right;
                if (target != null) {
                    let targetFrac = $e1533ef606a339de$var$findFraction(structure, target);
                    let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (pxLeft - marginWidth) / totalWidth;
                    right = (pxRight + marginWidth) / totalWidth;
                }
                viewFrom = $e1533ef606a339de$var$findPosition(structure, left);
                viewTo = $e1533ef606a339de$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $e1533ef606a339de$var$findFraction(structure, to) - $e1533ef606a339de$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$e1533ef606a339de$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $e1533ef606a339de$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges(changes) {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $0f49217316d01287$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = 0;
        if (ranges.length != this.visibleRanges.length) changed = 12 /* UpdateFlag.Viewport */ ;
        else for(let i = 0; i < ranges.length && !(changed & 8 /* UpdateFlag.ViewportMoved */ ); i++){
            let old = this.visibleRanges[i], nw = ranges[i];
            if (old.from != nw.from || old.to != nw.to) {
                changed |= 4 /* UpdateFlag.Viewport */ ;
                if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to)) changed |= 8 /* UpdateFlag.ViewportMoved */ ;
            }
        }
        this.visibleRanges = ranges;
        return changed;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $e1533ef606a339de$var$scaleBlock(this.heightMap.lineAt(pos, $e1533ef606a339de$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $e1533ef606a339de$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $e1533ef606a339de$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        let block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $e1533ef606a339de$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $e1533ef606a339de$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $e1533ef606a339de$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $0f49217316d01287$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $e1533ef606a339de$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $e1533ef606a339de$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $e1533ef606a339de$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $e1533ef606a339de$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $e1533ef606a339de$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $e1533ef606a339de$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $e1533ef606a339de$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $e1533ef606a339de$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $e1533ef606a339de$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $e1533ef606a339de$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$e1533ef606a339de$var$scaleBlock(b, scaler)) : block._content);
}
const $e1533ef606a339de$var$theme = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $e1533ef606a339de$var$darkTheme = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $e1533ef606a339de$var$baseThemeID = /*@__PURE__*/ (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).newName(), $e1533ef606a339de$var$baseLightID = /*@__PURE__*/ (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).newName(), $e1533ef606a339de$var$baseDarkID = /*@__PURE__*/ (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).newName();
const $e1533ef606a339de$var$lightDarkIDs = {
    "&light": "." + $e1533ef606a339de$var$baseLightID,
    "&dark": "." + $e1533ef606a339de$var$baseDarkID
};
function $e1533ef606a339de$var$buildTheme(main, spec, scopes) {
    return new (0, $df51ea96bfd6fa5c$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $e1533ef606a339de$var$baseTheme$1 = /*@__PURE__*/ $e1533ef606a339de$var$buildTheme("." + $e1533ef606a339de$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0,
        overflowAnchor: "none"
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#ddd"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        insetInlineStart: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0,
        zIndex: 300
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace": {
        backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
        backgroundPosition: "center"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $e1533ef606a339de$var$lightDarkIDs);
const $e1533ef606a339de$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $e1533ef606a339de$var$useCharData = $e1533ef606a339de$var$browser.ie && $e1533ef606a339de$var$browser.ie_version <= 11;
class $e1533ef606a339de$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $e1533ef606a339de$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($e1533ef606a339de$var$browser.ie && $e1533ef606a339de$var$browser.ie_version <= 11 || $e1533ef606a339de$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($e1533ef606a339de$var$browser.chrome && $e1533ef606a339de$var$browser.chrome_version < 126)) {
            this.editContext = new $e1533ef606a339de$var$EditContextManager(view);
            if (view.state.facet($e1533ef606a339de$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($e1533ef606a339de$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if ((event.type == "change" || !event.type) && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($e1533ef606a339de$var$editable) ? view.root.activeElement != this.dom : !$e1533ef606a339de$var$hasSelection(this.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($e1533ef606a339de$var$browser.ie && $e1533ef606a339de$var$browser.ie_version <= 11 || $e1533ef606a339de$var$browser.android && $e1533ef606a339de$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $e1533ef606a339de$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let selection = $e1533ef606a339de$var$getSelection(view.root);
        if (!selection) return false;
        let range = $e1533ef606a339de$var$browser.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && $e1533ef606a339de$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $e1533ef606a339de$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $e1533ef606a339de$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $e1533ef606a339de$var$observeOptions);
        if ($e1533ef606a339de$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($e1533ef606a339de$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $e1533ef606a339de$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $e1533ef606a339de$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $e1533ef606a339de$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $e1533ef606a339de$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.flags |= 4 /* ViewFlag.AttrsDirty */ ;
        if (rec.type == "childList") {
            let childBefore = $e1533ef606a339de$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $e1533ef606a339de$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.addEventListener) this.printQuery.addEventListener("change", this.onPrint);
            else this.printQuery.addListener(this.onPrint);
        } else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) {
            if (this.printQuery.removeEventListener) this.printQuery.removeEventListener("change", this.onPrint);
            else this.printQuery.removeListener(this.onPrint);
        } else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($e1533ef606a339de$var$editable) != update.state.facet($e1533ef606a339de$var$editable)) update.view.contentDOM.editContext = update.state.facet($e1533ef606a339de$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        if (this.editContext) {
            this.view.contentDOM.editContext = null;
            this.editContext.destroy();
        }
    }
}
function $e1533ef606a339de$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $e1533ef606a339de$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $e1533ef606a339de$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($e1533ef606a339de$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $e1533ef606a339de$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $e1533ef606a339de$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $e1533ef606a339de$var$buildSelectionRangeFromRange(view, found) : null;
}
class $e1533ef606a339de$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.handlers = Object.create(null);
        // Kludge to work around the fact that EditContext does not respond
        // well to having its content updated during a composition (see #1472)
        this.composing = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        this.handlers.textupdate = (e)=>{
            let { anchor: anchor } = view.state.selection.main;
            let from = this.toEditorPos(e.updateRangeStart), to = this.toEditorPos(e.updateRangeEnd);
            if (view.inputState.composing >= 0 && !this.composing) this.composing = {
                contextBase: e.updateRangeStart,
                editorBase: from,
                drifted: false
            };
            let change = {
                from: from,
                to: to,
                insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of(e.text.split("\n"))
            };
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (change.from == this.from && anchor < this.from) change.from = anchor;
            else if (change.to == this.to && anchor > this.to) change.to = anchor;
            // Edit contexts sometimes fire empty changes
            if (change.from == change.to && !change.insert.length) return;
            this.pendingContextChange = change;
            if (!view.state.readOnly) {
                let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
                $e1533ef606a339de$var$applyDOMChangeInner(view, change, (0, $0f49217316d01287$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart, newLen), this.toEditorPos(e.selectionEnd, newLen)));
            }
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) {
                this.revertPending(view.state);
                this.setSelection(view.state);
            }
        };
        this.handlers.characterboundsupdate = (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        };
        this.handlers.textformatupdate = (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (lineStyle != "None" && thickness != "None") {
                    let from = this.toEditorPos(format.rangeStart), to = this.toEditorPos(format.rangeEnd);
                    if (from < to) {
                        let style = `text-decoration: underline ${lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${thickness == "Thin" ? 1 : 2}px`;
                        deco.push($e1533ef606a339de$export$10e30b733df217ea.mark({
                            attributes: {
                                style: style
                            }
                        }).range(from, to));
                    }
                }
            }
            view.dispatch({
                effects: $e1533ef606a339de$var$setEditContextFormatting.of($e1533ef606a339de$export$10e30b733df217ea.set(deco))
            });
        };
        this.handlers.compositionstart = ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        };
        this.handlers.compositionend = ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
            if (this.composing) {
                let { drifted: drifted } = this.composing;
                this.composing = null;
                if (drifted) this.reset(view.state);
            }
        };
        for(let event in this.handlers)context.addEventListener(event, this.handlers[event]);
        this.measureReq = {
            read: (view)=>{
                this.editContext.updateControlBounds(view.contentDOM.getBoundingClientRect());
                let sel = $e1533ef606a339de$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    this.to += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        let reverted = this.pendingContextChange;
        if (this.composing && (this.composing.drifted || update.transactions.some((tr)=>!tr.isUserEvent("input.type") && tr.changes.touchesRange(this.from, this.to)))) {
            this.composing.drifted = true;
            this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
        } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.reset(update.state);
        } else if (update.docChanged || update.selectionSet || reverted) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    reset(state) {
        this.resetRange(state);
        this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
        this.setSelection(state);
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos, clipLen = this.to - this.from) {
        contextPos = Math.min(contextPos, clipLen);
        let c = this.composing;
        return c && c.drifted ? c.editorBase + (contextPos - c.contextBase) : contextPos + this.from;
    }
    toContextPos(editorPos) {
        let c = this.composing;
        return c && c.drifted ? c.contextBase + (editorPos - c.editorBase) : editorPos - this.from;
    }
    destroy() {
        for(let event in this.handlers)this.editContext.removeEventListener(event, this.handlers[event]);
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $e1533ef606a339de$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        var _a;
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $e1533ef606a339de$var$getRoot(config.parent) || document;
        this.viewState = new $e1533ef606a339de$var$ViewState(config.state || (0, $0f49217316d01287$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($e1533ef606a339de$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($e1533ef606a339de$var$viewPlugin).map((spec)=>new $e1533ef606a339de$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $e1533ef606a339de$var$DOMObserver(this);
        this.inputState = new $e1533ef606a339de$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $e1533ef606a339de$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
        if ((_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) document.fonts.ready.then(()=>this.requestMeasure());
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $0f49217316d01287$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($e1533ef606a339de$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $e1533ef606a339de$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $0f49217316d01287$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $0f49217316d01287$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $e1533ef606a339de$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $e1533ef606a339de$var$ScrollTarget(main.empty ? main : (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($e1533ef606a339de$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $e1533ef606a339de$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($e1533ef606a339de$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($e1533ef606a339de$var$theme) != update.state.facet($e1533ef606a339de$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($e1533ef606a339de$var$updateListener))try {
            listener(update);
        } catch (e) {
            $e1533ef606a339de$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$e1533ef606a339de$var$applyDOMChange(this, domChange) && pendingKey.force) $e1533ef606a339de$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $e1533ef606a339de$var$ViewState(newState);
            this.plugins = newState.facet($e1533ef606a339de$var$viewPlugin).map((spec)=>new $e1533ef606a339de$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $e1533ef606a339de$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($e1533ef606a339de$var$viewPlugin), specs = update.state.facet($e1533ef606a339de$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $e1533ef606a339de$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $e1533ef606a339de$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollTop - this.viewState.scrollTop) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($e1533ef606a339de$var$isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $e1533ef606a339de$export$f86b2a1a2ce291b3(this.state, e);
                        return $e1533ef606a339de$var$BadMeasure;
                    }
                });
                let update = $e1533ef606a339de$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $e1533ef606a339de$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $e1533ef606a339de$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = scrollTop + diff;
                                sDOM.scrollTop = scrollTop / this.scaleY;
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($e1533ef606a339de$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $e1533ef606a339de$var$baseThemeID + " " + (this.state.facet($e1533ef606a339de$var$darkTheme) ? $e1533ef606a339de$var$baseDarkID : $e1533ef606a339de$var$baseLightID) + " " + this.state.facet($e1533ef606a339de$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $e1533ef606a339de$var$attrsFromFacet(this, $e1533ef606a339de$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            writingsuggestions: "false",
            translate: "no",
            contenteditable: !this.state.facet($e1533ef606a339de$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$e1533ef606a339de$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $e1533ef606a339de$var$attrsFromFacet(this, $e1533ef606a339de$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $e1533ef606a339de$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $e1533ef606a339de$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($e1533ef606a339de$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($e1533ef606a339de$var$styleModule);
        let nonce = this.state.facet($e1533ef606a339de$export$eece2fccabbb77c5.cspNonce);
        (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($e1533ef606a339de$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $e1533ef606a339de$var$skipAtoms(this, start, $e1533ef606a339de$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $e1533ef606a339de$var$skipAtoms(this, start, $e1533ef606a339de$var$moveByChar(this, start, forward, (initial)=>$e1533ef606a339de$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $e1533ef606a339de$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $e1533ef606a339de$var$skipAtoms(this, start, $e1533ef606a339de$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $e1533ef606a339de$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$e1533ef606a339de$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $e1533ef606a339de$var$flattenRect(rect, span.dir == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($e1533ef606a339de$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $e1533ef606a339de$var$MaxBidiLine) return $e1533ef606a339de$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $e1533ef606a339de$var$isolatesEq(entry.isolates, isolates = $e1533ef606a339de$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $e1533ef606a339de$var$getIsolatedRanges(this, line);
        let order = $e1533ef606a339de$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $e1533ef606a339de$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $e1533ef606a339de$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $e1533ef606a339de$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $e1533ef606a339de$var$scrollIntoView.of(new $e1533ef606a339de$var$ScrollTarget(typeof pos == "number" ? (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $e1533ef606a339de$var$scrollIntoView.of(new $e1533ef606a339de$var$ScrollTarget((0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $e1533ef606a339de$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $e1533ef606a339de$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).newName();
        let result = [
            $e1533ef606a339de$var$theme.of(prefix),
            $e1533ef606a339de$var$styleModule.of($e1533ef606a339de$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($e1533ef606a339de$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $0f49217316d01287$export$b92464a736444411).lowest($e1533ef606a339de$var$styleModule.of($e1533ef606a339de$var$buildTheme("." + $e1533ef606a339de$var$baseThemeID, spec, $e1533ef606a339de$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let cView = content && $e1533ef606a339de$var$ContentView.get(content) || $e1533ef606a339de$var$ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.styleModule = $e1533ef606a339de$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.inputHandler = $e1533ef606a339de$var$inputHandler;
/**
Functions provided in this facet will be used to transform text
pasted or dropped into the editor.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.clipboardInputFilter = $e1533ef606a339de$var$clipboardInputFilter;
/**
Transform text copied or dragged from the editor.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.clipboardOutputFilter = $e1533ef606a339de$var$clipboardOutputFilter;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.scrollHandler = $e1533ef606a339de$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.focusChangeEffect = $e1533ef606a339de$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.perLineTextDirection = $e1533ef606a339de$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.exceptionSink = $e1533ef606a339de$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.updateListener = $e1533ef606a339de$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $e1533ef606a339de$export$eece2fccabbb77c5.editable = $e1533ef606a339de$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.mouseSelectionStyle = $e1533ef606a339de$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.dragMovesSelection = $e1533ef606a339de$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.clickAddsSelectionRange = $e1533ef606a339de$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.decorations = $e1533ef606a339de$var$decorations;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping \`outerDecorations\` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.outerDecorations = $e1533ef606a339de$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.atomicRanges = $e1533ef606a339de$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $e1533ef606a339de$export$eece2fccabbb77c5.bidiIsolatedRanges = $e1533ef606a339de$var$bidiIsolatedRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.scrollMargins = $e1533ef606a339de$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.darkTheme = $e1533ef606a339de$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.contentAttributes = $e1533ef606a339de$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $e1533ef606a339de$export$eece2fccabbb77c5.editorAttributes = $e1533ef606a339de$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $e1533ef606a339de$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $e1533ef606a339de$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $e1533ef606a339de$var$MaxBidiLine = 4096;
const $e1533ef606a339de$var$BadMeasure = {};
class $e1533ef606a339de$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $e1533ef606a339de$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $e1533ef606a339de$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $e1533ef606a339de$var$combineAttrs(value, base);
    }
    return base;
}
const $e1533ef606a339de$var$currentPlatform = $e1533ef606a339de$var$browser.mac ? "mac" : $e1533ef606a339de$var$browser.windows ? "win" : $e1533ef606a339de$var$browser.linux ? "linux" : "key";
function $e1533ef606a339de$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $e1533ef606a339de$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $e1533ef606a339de$var$handleKeyEvents = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).default(/*@__PURE__*/ $e1533ef606a339de$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $e1533ef606a339de$var$runHandlers($e1533ef606a339de$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $e1533ef606a339de$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    enables: $e1533ef606a339de$var$handleKeyEvents
});
const $e1533ef606a339de$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $e1533ef606a339de$var$getKeymap(state) {
    let bindings = state.facet($e1533ef606a339de$export$5043418e2ef368d5);
    let map = $e1533ef606a339de$var$Keymaps.get(bindings);
    if (!map) $e1533ef606a339de$var$Keymaps.set(bindings, map = $e1533ef606a339de$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $e1533ef606a339de$export$bce154f45536286e(view, event, scope) {
    return $e1533ef606a339de$var$runHandlers($e1533ef606a339de$var$getKeymap(view.state), event, view, scope);
}
let $e1533ef606a339de$var$storedPrefix = null;
const $e1533ef606a339de$var$PrefixTimeout = 4000;
function $e1533ef606a339de$var$buildKeymap(bindings, platform = $e1533ef606a339de$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$e1533ef606a339de$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $e1533ef606a339de$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($e1533ef606a339de$var$storedPrefix == ourObj) $e1533ef606a339de$var$storedPrefix = null;
                        }, $e1533ef606a339de$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $e1533ef606a339de$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $e1533ef606a339de$var$currentKeyEvent = null;
function $e1533ef606a339de$var$runHandlers(map, event, view, scope) {
    $e1533ef606a339de$var$currentKeyEvent = event;
    let name = (0, $1b4fb3054140d77f$export$fb33aafd75404f4c)(event);
    let charCode = (0, $0f49217316d01287$export$42977f40461e1360)(name, 0), isChar = (0, $0f49217316d01287$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($e1533ef606a339de$var$storedPrefix && $e1533ef606a339de$var$storedPrefix.view == view && $e1533ef606a339de$var$storedPrefix.scope == scope) {
        prefix = $e1533ef606a339de$var$storedPrefix.prefix + " ";
        if ($e1533ef606a339de$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $e1533ef606a339de$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $e1533ef606a339de$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($e1533ef606a339de$var$browser.windows && event.ctrlKey && event.altKey) && (baseName = (0, $1b4fb3054140d77f$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $e1533ef606a339de$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $1b4fb3054140d77f$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $e1533ef606a339de$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $e1533ef606a339de$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $e1533ef606a339de$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $e1533ef606a339de$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $e1533ef606a339de$var$getBase(view);
            return [
                new $e1533ef606a339de$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $e1533ef606a339de$var$rectanglesForRange(view, className, range);
    }
}
function $e1533ef606a339de$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $e1533ef606a339de$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $e1533ef606a339de$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $e1533ef606a339de$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $e1533ef606a339de$var$blockAt(view, from), endBlock = $e1533ef606a339de$var$blockAt(view, to);
    let visualStart = startBlock.type == $e1533ef606a339de$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $e1533ef606a339de$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $e1533ef606a339de$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $e1533ef606a339de$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $e1533ef606a339de$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $e1533ef606a339de$export$9ddce7bd14f42a78(className, left - base.left, top - base.top, right - left, bottom - top);
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $e1533ef606a339de$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $e1533ef606a339de$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($e1533ef606a339de$var$layerOrder) != update.state.facet($e1533ef606a339de$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($e1533ef606a339de$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$e1533ef606a339de$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $e1533ef606a339de$var$layerOrder = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $e1533ef606a339de$export$50a222d9023da98b(config) {
    return [
        $e1533ef606a339de$export$44d5eccfd62adda7.define((v)=>new $e1533ef606a339de$var$LayerView(v, config)),
        $e1533ef606a339de$var$layerOrder.of(config)
    ];
}
const $e1533ef606a339de$var$CanHidePrimary = !($e1533ef606a339de$var$browser.ios && $e1533ef606a339de$var$browser.webkit && $e1533ef606a339de$var$browser.webkit_version < 534);
const $e1533ef606a339de$var$selectionConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $e1533ef606a339de$export$17a3d0ab3687347d(config = {}) {
    return [
        $e1533ef606a339de$var$selectionConfig.of(config),
        $e1533ef606a339de$var$cursorLayer,
        $e1533ef606a339de$var$selectionLayer,
        $e1533ef606a339de$var$hideNativeSelection,
        $e1533ef606a339de$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $e1533ef606a339de$export$74e411a7b5f41f23(state) {
    return state.facet($e1533ef606a339de$var$selectionConfig);
}
function $e1533ef606a339de$var$configChanged(update) {
    return update.startState.facet($e1533ef606a339de$var$selectionConfig) != update.state.facet($e1533ef606a339de$var$selectionConfig);
}
const $e1533ef606a339de$var$cursorLayer = /*@__PURE__*/ $e1533ef606a339de$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($e1533ef606a339de$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty ? !prim || $e1533ef606a339de$var$CanHidePrimary : conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $e1533ef606a339de$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $e1533ef606a339de$var$configChanged(update);
        if (confChange) $e1533ef606a339de$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $e1533ef606a339de$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $e1533ef606a339de$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($e1533ef606a339de$var$selectionConfig).cursorBlinkRate + "ms";
}
const $e1533ef606a339de$var$selectionLayer = /*@__PURE__*/ $e1533ef606a339de$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $e1533ef606a339de$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $e1533ef606a339de$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $e1533ef606a339de$var$themeSpec = {
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: "transparent !important"
        }
    },
    ".cm-content": {
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
};
if ($e1533ef606a339de$var$CanHidePrimary) $e1533ef606a339de$var$themeSpec[".cm-line"].caretColor = $e1533ef606a339de$var$themeSpec[".cm-content"].caretColor = "transparent !important";
const $e1533ef606a339de$var$hideNativeSelection = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).highest(/*@__PURE__*/ $e1533ef606a339de$export$eece2fccabbb77c5.theme($e1533ef606a339de$var$themeSpec));
const $e1533ef606a339de$var$setDropCursorPos = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $e1533ef606a339de$var$dropCursorPos = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($e1533ef606a339de$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $e1533ef606a339de$var$drawDropCursor = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($e1533ef606a339de$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($e1533ef606a339de$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($e1533ef606a339de$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($e1533ef606a339de$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $e1533ef606a339de$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $e1533ef606a339de$export$b8e3092a3bfa2062() {
    return [
        $e1533ef606a339de$var$dropCursorPos,
        $e1533ef606a339de$var$drawDropCursor
    ];
}
function $e1533ef606a339de$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $e1533ef606a339de$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $e1533ef606a339de$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $0f49217316d01287$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $e1533ef606a339de$var$matchRanges(view, this.maxLength))$e1533ef606a339de$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to >= update.view.viewport.from && from <= update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportMoved || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to > from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $e1533ef606a339de$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $e1533ef606a339de$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $e1533ef606a339de$var$Specials = /*@__PURE__*/ new RegExp("[\u0000-\u0008\u000a-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]", $e1533ef606a339de$var$UnicodeRegexpSupport);
const $e1533ef606a339de$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $e1533ef606a339de$var$_supportsTabSize = null;
function $e1533ef606a339de$var$supportsTabSize() {
    var _a;
    if ($e1533ef606a339de$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $e1533ef606a339de$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $e1533ef606a339de$var$_supportsTabSize || false;
}
const $e1533ef606a339de$var$specialCharConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $e1533ef606a339de$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$e1533ef606a339de$var$supportsTabSize()) config.specialChars = new RegExp("\t|" + config.specialChars.source, $e1533ef606a339de$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $e1533ef606a339de$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $e1533ef606a339de$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $e1533ef606a339de$var$specialCharConfig.of(config),
        $e1533ef606a339de$var$specialCharPlugin()
    ];
}
let $e1533ef606a339de$var$_plugin = null;
function $e1533ef606a339de$var$specialCharPlugin() {
    return $e1533ef606a339de$var$_plugin || ($e1533ef606a339de$var$_plugin = $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $e1533ef606a339de$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($e1533ef606a339de$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $e1533ef606a339de$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $0f49217316d01287$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $0f49217316d01287$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $e1533ef606a339de$export$10e30b733df217ea.replace({
                            widget: new $e1533ef606a339de$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $e1533ef606a339de$export$10e30b733df217ea.replace({
                        widget: new $e1533ef606a339de$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($e1533ef606a339de$var$specialCharConfig);
            if (update.startState.facet($e1533ef606a339de$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $e1533ef606a339de$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $e1533ef606a339de$var$placeholder$1(code) {
    if (code >= 32) return $e1533ef606a339de$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $e1533ef606a339de$var$SpecialCharWidget extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $e1533ef606a339de$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($e1533ef606a339de$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $e1533ef606a339de$var$TabWidget extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "\t";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $e1533ef606a339de$var$plugin = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $e1533ef606a339de$export$1f905ef5d6deb4f() {
    return [
        $e1533ef606a339de$var$plugin,
        $e1533ef606a339de$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($e1533ef606a339de$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $e1533ef606a339de$export$1a7e096bee9035c() {
    return $e1533ef606a339de$var$activeLineHighlighter;
}
const $e1533ef606a339de$var$lineDeco = /*@__PURE__*/ $e1533ef606a339de$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $e1533ef606a339de$var$activeLineHighlighter = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($e1533ef606a339de$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $e1533ef606a339de$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $e1533ef606a339de$var$Placeholder extends $e1533ef606a339de$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM(view) {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $e1533ef606a339de$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $e1533ef606a339de$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $e1533ef606a339de$export$c7187bbd1a7a9244(content) {
    return $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $e1533ef606a339de$export$10e30b733df217ea.set([
                $e1533ef606a339de$export$10e30b733df217ea.widget({
                    widget: new $e1533ef606a339de$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $e1533ef606a339de$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $e1533ef606a339de$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $e1533ef606a339de$var$MaxOff = 2000;
function $e1533ef606a339de$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $e1533ef606a339de$var$MaxOff || b.off > $e1533ef606a339de$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $0f49217316d01287$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $0f49217316d01287$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $e1533ef606a339de$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $e1533ef606a339de$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $e1533ef606a339de$var$MaxOff ? -1 : off == line.length ? $e1533ef606a339de$var$absoluteColumn(view, event.clientX) : (0, $0f49217316d01287$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $e1533ef606a339de$var$rectangleSelectionStyle(view, event) {
    let start = $e1533ef606a339de$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $e1533ef606a339de$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $e1533ef606a339de$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $e1533ef606a339de$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $e1533ef606a339de$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $e1533ef606a339de$var$rectangleSelectionStyle(view, event) : null);
}
const $e1533ef606a339de$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $e1533ef606a339de$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $e1533ef606a339de$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $e1533ef606a339de$var$keys[options.key || "Alt"];
    let plugin = $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $e1533ef606a339de$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $e1533ef606a339de$var$showCrosshair : null;
        })
    ];
}
const $e1533ef606a339de$var$Outside = "-10000px";
class $e1533ef606a339de$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $e1533ef606a339de$export$1fc29293196e3bc(config = {}) {
    return $e1533ef606a339de$var$tooltipConfig.of(config);
}
function $e1533ef606a339de$var$windowSpace(view) {
    let { win: win } = view;
    return {
        top: 0,
        left: 0,
        bottom: win.innerHeight,
        right: win.innerWidth
    };
}
const $e1533ef606a339de$var$tooltipConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $e1533ef606a339de$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $e1533ef606a339de$var$windowSpace
        };
    }
});
const $e1533ef606a339de$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $e1533ef606a339de$var$tooltipPlugin = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($e1533ef606a339de$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $e1533ef606a339de$var$TooltipViewManager(view, $e1533ef606a339de$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($e1533ef606a339de$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $e1533ef606a339de$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($e1533ef606a339de$var$browser.gecko) // Firefox sets the element's `offsetParent` to the
            // transformed element when a transform interferes with fixed
            // positioning.
            makeAbsolute = dom.offsetParent != this.container.ownerDocument.body;
            else if (dom.style.top == $e1533ef606a339de$var$Outside && dom.style.left == "0px") {
                // On other browsers, we have to awkwardly try and use other
                // information to detect a transform.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            }
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        let visible = this.view.scrollDOM.getBoundingClientRect(), margins = $e1533ef606a339de$var$getScrollMargins(this.view);
        return {
            visible: {
                left: visible.left + margins.left,
                top: visible.top + margins.top,
                right: visible.right - margins.right,
                bottom: visible.bottom - margins.bottom
            },
            parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($e1533ef606a339de$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { visible: visible, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - .1 || pos.left > Math.min(visible.right, space.right) + .1)) {
                dom.style.top = $e1533ef606a339de$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $e1533ef606a339de$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $e1533ef606a339de$var$noOffset, ltr = this.view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x), space.right - width);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset.y < space.top : pos.bottom + height + arrowHeight + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $e1533ef606a339de$var$Outside;
                    continue;
                }
                $e1533ef606a339de$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                $e1533ef606a339de$var$setLeftStyle(dom, (left - measured.parent.left) / scaleX);
            } else {
                dom.style.top = top / scaleY + "px";
                $e1533ef606a339de$var$setLeftStyle(dom, left / scaleX);
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $e1533ef606a339de$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
function $e1533ef606a339de$var$setLeftStyle(elt, value) {
    let current = parseInt(elt.style.left, 10);
    if (isNaN(current) || Math.abs(value - current) > 1) elt.style.left = value + "px";
}
const $e1533ef606a339de$var$baseTheme = /*@__PURE__*/ $e1533ef606a339de$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 500,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $e1533ef606a339de$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $e1533ef606a339de$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    enables: [
        $e1533ef606a339de$var$tooltipPlugin,
        $e1533ef606a339de$var$baseTheme
    ]
});
const $e1533ef606a339de$var$showHoverTooltip = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $e1533ef606a339de$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $e1533ef606a339de$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $e1533ef606a339de$var$TooltipViewManager(view, $e1533ef606a339de$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $e1533ef606a339de$var$showHoverTooltipHost = /*@__PURE__*/ $e1533ef606a339de$export$dba11b50e1aa3c12.compute([
    $e1533ef606a339de$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($e1533ef606a339de$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $e1533ef606a339de$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $e1533ef606a339de$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let desc = view.docView.nearest(lastMove.target);
        if (!desc) return;
        let pos, side = 1;
        if (desc instanceof $e1533ef606a339de$var$WidgetView) pos = desc.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $e1533ef606a339de$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        let open = this.source(view, pos, side);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result && !(Array.isArray(result) && !result.length)) view.dispatch({
                        effects: this.setHover.of(Array.isArray(result) ? result : [
                            result
                        ])
                    });
                }
            }, (e)=>$e1533ef606a339de$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else if (open && !(Array.isArray(open) && !open.length)) view.dispatch({
            effects: this.setHover.of(Array.isArray(open) ? open : [
                open
            ])
        });
    }
    get tooltip() {
        let plugin = this.view.plugin($e1533ef606a339de$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $e1533ef606a339de$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && tooltip && !$e1533ef606a339de$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$e1533ef606a339de$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            if (this.active.length && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $e1533ef606a339de$var$tooltipMargin = 4;
function $e1533ef606a339de$var$isInTooltip(tooltip, event) {
    let { left: left, right: right, top: top, bottom: bottom } = tooltip.getBoundingClientRect(), arrow;
    if (arrow = tooltip.querySelector(".cm-tooltip-arrow")) {
        let arrowRect = arrow.getBoundingClientRect();
        top = Math.min(arrowRect.top, top);
        bottom = Math.max(arrowRect.bottom, bottom);
    }
    return event.clientX >= left - $e1533ef606a339de$var$tooltipMargin && event.clientX <= right + $e1533ef606a339de$var$tooltipMargin && event.clientY >= top - $e1533ef606a339de$var$tooltipMargin && event.clientY <= bottom + $e1533ef606a339de$var$tooltipMargin;
}
function $e1533ef606a339de$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.

The return value is a valid [editor extension](https://codemirror.net/6/docs/ref/#state.Extension)
but also provides an `active` property holding a state field that
can be used to read the currently active tooltips produced by this
extension.
*/ function $e1533ef606a339de$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $0f49217316d01287$export$95000d4efaa4321f).define();
    let hoverState = (0, $0f49217316d01287$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
                if (tr.docChanged) {
                    let mapped = [];
                    for (let tooltip of value){
                        let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $0f49217316d01287$export$39cf3280165f92aa).TrackDel);
                        if (newPos != null) {
                            let copy = Object.assign(Object.create(null), tooltip);
                            copy.pos = newPos;
                            if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                            mapped.push(copy);
                        }
                    }
                    value = mapped;
                }
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($e1533ef606a339de$var$closeHoverTooltipEffect)) value = [];
            }
            return value;
        },
        provide: (f)=>$e1533ef606a339de$var$showHoverTooltip.from(f)
    });
    return {
        active: hoverState,
        extension: [
            hoverState,
            $e1533ef606a339de$export$44d5eccfd62adda7.define((view)=>new $e1533ef606a339de$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Hover.Time */ )),
            $e1533ef606a339de$var$showHoverTooltipHost
        ]
    };
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $e1533ef606a339de$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($e1533ef606a339de$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $e1533ef606a339de$export$7864d875805bc1b0(state) {
    return state.facet($e1533ef606a339de$var$showHoverTooltip).some((x)=>x);
}
const $e1533ef606a339de$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $e1533ef606a339de$export$f6974094db6525a = /*@__PURE__*/ $e1533ef606a339de$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $e1533ef606a339de$export$912859096d593b90(view) {
    let plugin = view.plugin($e1533ef606a339de$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $e1533ef606a339de$var$panelConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $e1533ef606a339de$export$8128819a2322681a(config) {
    return config ? [
        $e1533ef606a339de$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $e1533ef606a339de$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($e1533ef606a339de$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $e1533ef606a339de$var$panelPlugin = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($e1533ef606a339de$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($e1533ef606a339de$var$panelConfig);
        this.top = new $e1533ef606a339de$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $e1533ef606a339de$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($e1533ef606a339de$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $e1533ef606a339de$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $e1533ef606a339de$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($e1533ef606a339de$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$e1533ef606a339de$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $e1533ef606a339de$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $e1533ef606a339de$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $e1533ef606a339de$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $e1533ef606a339de$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $e1533ef606a339de$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    enables: $e1533ef606a339de$var$panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $e1533ef606a339de$export$591ab4c909549043 extends (0, $0f49217316d01287$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$e1533ef606a339de$export$591ab4c909549043.prototype.elementClass = "";
$e1533ef606a339de$export$591ab4c909549043.prototype.toDOM = undefined;
$e1533ef606a339de$export$591ab4c909549043.prototype.mapMode = (0, $0f49217316d01287$export$39cf3280165f92aa).TrackBefore;
$e1533ef606a339de$export$591ab4c909549043.prototype.startSide = $e1533ef606a339de$export$591ab4c909549043.prototype.endSide = -1;
$e1533ef606a339de$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $e1533ef606a339de$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
Facet used to add a class to all gutter elements next to a widget.
Should not provide widgets with a `toDOM` method.
*/ const $e1533ef606a339de$export$6dd229d2c0925f7a = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $0f49217316d01287$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
const $e1533ef606a339de$var$activeGutters = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $e1533ef606a339de$export$f2b922cb4a245974(config) {
    return [
        $e1533ef606a339de$export$ec15ef01b8fbae61(),
        $e1533ef606a339de$var$activeGutters.of(Object.assign(Object.assign({}, $e1533ef606a339de$var$defaults), config))
    ];
}
const $e1533ef606a339de$var$unfixGutters = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $e1533ef606a339de$export$ec15ef01b8fbae61(config) {
    let result = [
        $e1533ef606a339de$var$gutterView
    ];
    if (config && config.fixed === false) result.push($e1533ef606a339de$var$unfixGutters.of(true));
    return result;
}
const $e1533ef606a339de$var$gutterView = /*@__PURE__*/ $e1533ef606a339de$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($e1533ef606a339de$var$activeGutters).map((conf)=>new $e1533ef606a339de$var$SingleGutterView(view, conf));
        for (let gutter of this.gutters)this.dom.appendChild(gutter.dom);
        this.fixed = !view.state.facet($e1533ef606a339de$var$unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        if (this.view.state.facet($e1533ef606a339de$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        let lineClasses = (0, $0f49217316d01287$export$34cb5241245008dd).iter(this.view.state.facet($e1533ef606a339de$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $e1533ef606a339de$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $e1533ef606a339de$export$48808c686fe495c4.Text && first) {
                        $e1533ef606a339de$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $e1533ef606a339de$export$48808c686fe495c4.Text) {
                $e1533ef606a339de$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        let prev = update.startState.facet($e1533ef606a339de$var$activeGutters), cur = update.state.facet($e1533ef606a339de$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $0f49217316d01287$export$34cb5241245008dd).eq(update.startState.facet($e1533ef606a339de$export$113bd64f27ac1172), update.state.facet($e1533ef606a339de$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $e1533ef606a339de$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
    }
}, {
    provide: (plugin)=>$e1533ef606a339de$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == $e1533ef606a339de$export$cacd6541cfeeb6c1.LTR ? {
                left: value.dom.offsetWidth * view.scaleX
            } : {
                right: value.dom.offsetWidth * view.scaleX
            };
        })
});
function $e1533ef606a339de$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $e1533ef606a339de$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $e1533ef606a339de$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $0f49217316d01287$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $e1533ef606a339de$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $e1533ef606a339de$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [
            marker
        ] : null;
        for (let cls of view.state.facet($e1533ef606a339de$export$6dd229d2c0925f7a)){
            let marker = cls(view, block.widget, block);
            if (marker) (markers || (markers = [])).push(marker);
        }
        if (markers) this.addElement(view, block, markers);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $e1533ef606a339de$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $e1533ef606a339de$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $e1533ef606a339de$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $e1533ef606a339de$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $0f49217316d01287$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $e1533ef606a339de$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$e1533ef606a339de$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $e1533ef606a339de$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $e1533ef606a339de$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
Facet used to create markers in the line number gutter next to widgets.
*/ const $e1533ef606a339de$export$510194e22d36ff6c = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $e1533ef606a339de$var$lineNumberConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $e1533ef606a339de$var$NumberMarker extends $e1533ef606a339de$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $e1533ef606a339de$var$formatNumber(view, number) {
    return view.state.facet($e1533ef606a339de$var$lineNumberConfig).formatNumber(number, view.state);
}
const $e1533ef606a339de$var$lineNumberGutter = /*@__PURE__*/ $e1533ef606a339de$var$activeGutters.compute([
    $e1533ef606a339de$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($e1533ef606a339de$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $e1533ef606a339de$var$NumberMarker($e1533ef606a339de$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: (view, widget, block)=>{
            for (let m of view.state.facet($e1533ef606a339de$export$510194e22d36ff6c)){
                let result = m(view, widget, block);
                if (result) return result;
            }
            return null;
        },
        lineMarkerChange: (update)=>update.startState.facet($e1533ef606a339de$var$lineNumberConfig) != update.state.facet($e1533ef606a339de$var$lineNumberConfig),
        initialSpacer (view) {
            return new $e1533ef606a339de$var$NumberMarker($e1533ef606a339de$var$formatNumber(view, $e1533ef606a339de$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $e1533ef606a339de$var$formatNumber(update.view, $e1533ef606a339de$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $e1533ef606a339de$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($e1533ef606a339de$var$lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function $e1533ef606a339de$export$1a8cf111682eaa7d(config = {}) {
    return [
        $e1533ef606a339de$var$lineNumberConfig.of(config),
        $e1533ef606a339de$export$ec15ef01b8fbae61(),
        $e1533ef606a339de$var$lineNumberGutter
    ];
}
function $e1533ef606a339de$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $e1533ef606a339de$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $e1533ef606a339de$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $e1533ef606a339de$var$activeLineGutterHighlighter = /*@__PURE__*/ $e1533ef606a339de$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($e1533ef606a339de$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $0f49217316d01287$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $e1533ef606a339de$export$93b52f08bb2c759c() {
    return $e1533ef606a339de$var$activeLineGutterHighlighter;
}
function $e1533ef606a339de$var$matcher(decorator) {
    return $e1533ef606a339de$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $e1533ef606a339de$var$tabDeco = /*@__PURE__*/ $e1533ef606a339de$export$10e30b733df217ea.mark({
    class: "cm-highlightTab"
});
const $e1533ef606a339de$var$spaceDeco = /*@__PURE__*/ $e1533ef606a339de$export$10e30b733df217ea.mark({
    class: "cm-highlightSpace"
});
const $e1533ef606a339de$var$whitespaceHighlighter = /*@__PURE__*/ $e1533ef606a339de$var$matcher(/*@__PURE__*/ new $e1533ef606a339de$export$9b928b0ca20b25cb({
    regexp: /\t| /g,
    decoration: (match)=>match[0] == "\t" ? $e1533ef606a339de$var$tabDeco : $e1533ef606a339de$var$spaceDeco,
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $e1533ef606a339de$export$beeff585f23bdb79() {
    return $e1533ef606a339de$var$whitespaceHighlighter;
}
const $e1533ef606a339de$var$trailingHighlighter = /*@__PURE__*/ $e1533ef606a339de$var$matcher(/*@__PURE__*/ new $e1533ef606a339de$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $e1533ef606a339de$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    }),
    boundary: /\S/
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $e1533ef606a339de$export$6e66b0e142f44c26() {
    return $e1533ef606a339de$var$trailingHighlighter;
}
/**
@internal
*/ const $e1533ef606a339de$export$91afc2cf83e15b44 = {
    HeightMap: $e1533ef606a339de$var$HeightMap,
    HeightOracle: $e1533ef606a339de$var$HeightOracle,
    MeasuredHeights: $e1533ef606a339de$var$MeasuredHeights,
    QueryType: $e1533ef606a339de$var$QueryType,
    ChangedRange: $e1533ef606a339de$var$ChangedRange,
    computeOrder: $e1533ef606a339de$var$computeOrder,
    moveVisually: $e1533ef606a339de$var$moveVisually,
    clearHeightChangeFlag: $e1533ef606a339de$var$clearHeightChangeFlag,
    getHeightChangeFlag: ()=>$e1533ef606a339de$var$heightChangeFlag
};



/**
The default maximum length of a `TreeBuffer` node.
*/ const $b14321b77c1b25e4$export$de305a849879ffa = 1024;
let $b14321b77c1b25e4$var$nextPropID = 0;
class $b14321b77c1b25e4$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $b14321b77c1b25e4$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $b14321b77c1b25e4$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $b14321b77c1b25e4$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.closedBy = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.openedBy = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.group = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.isolate = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.contextHash = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.lookAhead = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $b14321b77c1b25e4$export$b8034b9bc18acd90.mounted = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $b14321b77c1b25e4$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$b14321b77c1b25e4$export$b8034b9bc18acd90.mounted.id];
    }
}
const $b14321b77c1b25e4$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $b14321b77c1b25e4$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $b14321b77c1b25e4$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $b14321b77c1b25e4$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == 'string') {
            if (this.name == name) return true;
            let group = this.prop($b14321b77c1b25e4$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($b14321b77c1b25e4$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $b14321b77c1b25e4$export$f06e977173f1857c.none = new $b14321b77c1b25e4$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $b14321b77c1b25e4$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $b14321b77c1b25e4$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $b14321b77c1b25e4$export$7fad5fb00d8de02c(newTypes);
    }
}
const $b14321b77c1b25e4$var$CachedNode = new WeakMap(), $b14321b77c1b25e4$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $b14321b77c1b25e4$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($b14321b77c1b25e4$export$b0e28367f55837aa || ($b14321b77c1b25e4$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $b14321b77c1b25e4$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $b14321b77c1b25e4$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $b14321b77c1b25e4$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $b14321b77c1b25e4$var$CachedNode.get(this) || this.topNode;
        let cursor = new $b14321b77c1b25e4$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $b14321b77c1b25e4$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $b14321b77c1b25e4$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $b14321b77c1b25e4$var$resolveNode($b14321b77c1b25e4$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $b14321b77c1b25e4$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $b14321b77c1b25e4$var$resolveNode($b14321b77c1b25e4$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $b14321b77c1b25e4$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $b14321b77c1b25e4$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $b14321b77c1b25e4$var$balanceRange($b14321b77c1b25e4$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $b14321b77c1b25e4$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $b14321b77c1b25e4$export$7fbedc92909ed28e($b14321b77c1b25e4$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $b14321b77c1b25e4$var$buildTree(data);
    }
}
/**
The empty tree
*/ $b14321b77c1b25e4$export$7fbedc92909ed28e.empty = new $b14321b77c1b25e4$export$7fbedc92909ed28e($b14321b77c1b25e4$export$f06e977173f1857c.none, [], [], 0);
class $b14321b77c1b25e4$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $b14321b77c1b25e4$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $b14321b77c1b25e4$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $b14321b77c1b25e4$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($b14321b77c1b25e4$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $b14321b77c1b25e4$export$33300581b70be371(copy, len, this.set);
    }
}
function $b14321b77c1b25e4$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $b14321b77c1b25e4$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $b14321b77c1b25e4$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $b14321b77c1b25e4$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $b14321b77c1b25e4$var$BaseNode {
    cursor(mode = 0) {
        return new $b14321b77c1b25e4$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $b14321b77c1b25e4$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $b14321b77c1b25e4$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $b14321b77c1b25e4$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $b14321b77c1b25e4$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $b14321b77c1b25e4$var$matchNodeContext(this.parent, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $b14321b77c1b25e4$var$TreeNode extends $b14321b77c1b25e4$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$b14321b77c1b25e4$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $b14321b77c1b25e4$export$33300581b70be371) {
                    if (mode & $b14321b77c1b25e4$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $b14321b77c1b25e4$var$BufferNode(new $b14321b77c1b25e4$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $b14321b77c1b25e4$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $b14321b77c1b25e4$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $b14321b77c1b25e4$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $b14321b77c1b25e4$var$TreeNode(next, start, i, parent);
                    return mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $b14321b77c1b25e4$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $b14321b77c1b25e4$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $b14321b77c1b25e4$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $b14321b77c1b25e4$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $b14321b77c1b25e4$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $b14321b77c1b25e4$var$BufferNode extends $b14321b77c1b25e4$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $b14321b77c1b25e4$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $b14321b77c1b25e4$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $b14321b77c1b25e4$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $b14321b77c1b25e4$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $b14321b77c1b25e4$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $b14321b77c1b25e4$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $b14321b77c1b25e4$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $b14321b77c1b25e4$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $b14321b77c1b25e4$var$StackIterator(newHeads, picked);
}
class $b14321b77c1b25e4$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $b14321b77c1b25e4$var$iterStack(this.heads);
    }
}
function $b14321b77c1b25e4$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $b14321b77c1b25e4$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $b14321b77c1b25e4$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $b14321b77c1b25e4$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($b14321b77c1b25e4$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $b14321b77c1b25e4$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $b14321b77c1b25e4$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, /**
    @internal
    */ mode = 0){
        this.mode = mode;
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        if (node instanceof $b14321b77c1b25e4$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $b14321b77c1b25e4$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $b14321b77c1b25e4$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $b14321b77c1b25e4$export$33300581b70be371 || !child.type.isAnonymous || $b14321b77c1b25e4$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traversal. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $b14321b77c1b25e4$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $b14321b77c1b25e4$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (!depth) return;
                if (this.nextSibling()) break;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $b14321b77c1b25e4$var$matchNodeContext(this.node.parent, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $b14321b77c1b25e4$var$matchNodeContext(this._tree, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $b14321b77c1b25e4$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $b14321b77c1b25e4$export$33300581b70be371 || !ch.type.isAnonymous || $b14321b77c1b25e4$var$hasChild(ch));
}
function $b14321b77c1b25e4$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $b14321b77c1b25e4$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $b14321b77c1b25e4$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $b14321b77c1b25e4$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type, contextAtStart);
                node = $b14321b77c1b25e4$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $b14321b77c1b25e4$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type, contextHash) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $b14321b77c1b25e4$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($b14321b77c1b25e4$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead, contextHash);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead, contextHash) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to, contextHash));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead, contextHash, props) {
        if (contextHash) {
            let pair = [
                $b14321b77c1b25e4$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $b14321b77c1b25e4$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $b14321b77c1b25e4$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $b14321b77c1b25e4$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $b14321b77c1b25e4$var$nodeSizeCache = new WeakMap;
function $b14321b77c1b25e4$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $b14321b77c1b25e4$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $b14321b77c1b25e4$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $b14321b77c1b25e4$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $b14321b77c1b25e4$var$nodeSize(balanceType, child);
        }
        $b14321b77c1b25e4$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $b14321b77c1b25e4$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $b14321b77c1b25e4$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $b14321b77c1b25e4$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $b14321b77c1b25e4$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($b14321b77c1b25e4$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $b14321b77c1b25e4$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $b14321b77c1b25e4$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $b14321b77c1b25e4$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $b14321b77c1b25e4$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $b14321b77c1b25e4$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $b14321b77c1b25e4$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $b14321b77c1b25e4$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $b14321b77c1b25e4$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $b14321b77c1b25e4$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $b14321b77c1b25e4$var$StringInput(input);
        ranges = !ranges ? [
            new $b14321b77c1b25e4$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $b14321b77c1b25e4$var$Range(r.from, r.to)) : [
            new $b14321b77c1b25e4$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $b14321b77c1b25e4$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $b14321b77c1b25e4$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $b14321b77c1b25e4$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $b14321b77c1b25e4$var$InnerParse {
    constructor(parser, parse, overlay, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.from = from;
    }
}
function $b14321b77c1b25e4$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $b14321b77c1b25e4$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $b14321b77c1b25e4$var$stoppedInner = new $b14321b77c1b25e4$export$b8034b9bc18acd90({
    perNode: true
});
class $b14321b77c1b25e4$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $b14321b77c1b25e4$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $b14321b77c1b25e4$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$b14321b77c1b25e4$export$b8034b9bc18acd90.mounted.id] = new $b14321b77c1b25e4$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $b14321b77c1b25e4$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $b14321b77c1b25e4$export$3ae4554f36e54a34(new $b14321b77c1b25e4$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous | $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $b14321b77c1b25e4$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) $b14321b77c1b25e4$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $b14321b77c1b25e4$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $b14321b77c1b25e4$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $b14321b77c1b25e4$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $b14321b77c1b25e4$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $b14321b77c1b25e4$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $b14321b77c1b25e4$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $b14321b77c1b25e4$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $b14321b77c1b25e4$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) {
                    let last = overlay.ranges.length - 1;
                    if (last >= 0 && overlay.ranges[last].to == range.from) overlay.ranges[last] = {
                        from: overlay.ranges[last].from,
                        to: range.to
                    };
                    else overlay.ranges.push(range);
                }
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $b14321b77c1b25e4$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $b14321b77c1b25e4$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $b14321b77c1b25e4$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $b14321b77c1b25e4$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $b14321b77c1b25e4$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $b14321b77c1b25e4$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $b14321b77c1b25e4$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $b14321b77c1b25e4$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $b14321b77c1b25e4$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $b14321b77c1b25e4$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $b14321b77c1b25e4$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $b14321b77c1b25e4$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $b14321b77c1b25e4$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $b14321b77c1b25e4$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($b14321b77c1b25e4$export$b0e28367f55837aa.IncludeAnonymous | $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $b14321b77c1b25e4$export$b0e28367f55837aa.IgnoreOverlays | $b14321b77c1b25e4$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $b14321b77c1b25e4$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $b14321b77c1b25e4$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($b14321b77c1b25e4$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $b14321b77c1b25e4$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($b14321b77c1b25e4$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $b14321b77c1b25e4$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($b14321b77c1b25e4$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $b14321b77c1b25e4$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $b14321b77c1b25e4$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $b14321b77c1b25e4$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $b14321b77c1b25e4$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $b14321b77c1b25e4$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $b14321b77c1b25e4$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $b14321b77c1b25e4$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $b14321b77c1b25e4$var$Range(r.from + pos, r.to + pos));
            let changes = $b14321b77c1b25e4$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $b14321b77c1b25e4$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $b14321b77c1b25e4$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $6fc2ba1913927f17$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $6fc2ba1913927f17$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The optional name of the base tag @internal
    */ name, /**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.name = name;
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $6fc2ba1913927f17$var$nextTagID++;
    }
    toString() {
        let { name: name } = this;
        for (let mod of this.modified)if (mod.name) name = `${mod.name}(${name})`;
        return name;
    }
    static define(nameOrParent, parent) {
        let name = typeof nameOrParent == "string" ? nameOrParent : "?";
        if (nameOrParent instanceof $6fc2ba1913927f17$export$3288d34c523a1192) parent = nameOrParent;
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $6fc2ba1913927f17$export$3288d34c523a1192(name, [], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier(name) {
        let mod = new $6fc2ba1913927f17$var$Modifier(name);
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $6fc2ba1913927f17$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $6fc2ba1913927f17$var$nextModifierID = 0;
class $6fc2ba1913927f17$var$Modifier {
    constructor(name){
        this.name = name;
        this.instances = [];
        this.id = $6fc2ba1913927f17$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $6fc2ba1913927f17$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $6fc2ba1913927f17$export$3288d34c523a1192(base.name, set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $6fc2ba1913927f17$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($6fc2ba1913927f17$var$Modifier.get(parent, config));
        return tag;
    }
}
function $6fc2ba1913927f17$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $6fc2ba1913927f17$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function $6fc2ba1913927f17$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $6fc2ba1913927f17$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $6fc2ba1913927f17$var$ruleNodeProp.add(byName);
}
const $6fc2ba1913927f17$var$ruleNodeProp = new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
class $6fc2ba1913927f17$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$6fc2ba1913927f17$var$Rule.empty = new $6fc2ba1913927f17$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $6fc2ba1913927f17$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $6fc2ba1913927f17$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $6fc2ba1913927f17$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $6fc2ba1913927f17$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $6fc2ba1913927f17$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $6fc2ba1913927f17$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $6fc2ba1913927f17$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $6fc2ba1913927f17$export$1519d79cc79711ec(cursor) || $6fc2ba1913927f17$var$Rule.empty;
        let tagCls = $6fc2ba1913927f17$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $6fc2ba1913927f17$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($6fc2ba1913927f17$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $6fc2ba1913927f17$var$t = $6fc2ba1913927f17$export$3288d34c523a1192.define;
const $6fc2ba1913927f17$var$comment = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$name = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$typeName = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name), $6fc2ba1913927f17$var$propertyName = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name), $6fc2ba1913927f17$var$literal = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$string = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal), $6fc2ba1913927f17$var$number = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal), $6fc2ba1913927f17$var$content = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$heading = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content), $6fc2ba1913927f17$var$keyword = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$operator = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$punctuation = $6fc2ba1913927f17$var$t(), $6fc2ba1913927f17$var$bracket = $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$punctuation), $6fc2ba1913927f17$var$meta = $6fc2ba1913927f17$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $6fc2ba1913927f17$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $6fc2ba1913927f17$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$comment),
    name: /**
    Any kind of identifier.
    */ $6fc2ba1913927f17$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $6fc2ba1913927f17$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $6fc2ba1913927f17$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$name),
    literal: /**
    A literal value.
    */ $6fc2ba1913927f17$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $6fc2ba1913927f17$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $6fc2ba1913927f17$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$literal),
    keyword: /**
    A language keyword.
    */ $6fc2ba1913927f17$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$keyword),
    operator: /**
    An operator.
    */ $6fc2ba1913927f17$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $6fc2ba1913927f17$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $6fc2ba1913927f17$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $6fc2ba1913927f17$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $6fc2ba1913927f17$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$heading),
    /**
    A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
    */ contentSeparator: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $6fc2ba1913927f17$var$t(),
    /**
    Deleted text.
    */ deleted: $6fc2ba1913927f17$var$t(),
    /**
    Changed text.
    */ changed: $6fc2ba1913927f17$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $6fc2ba1913927f17$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $6fc2ba1913927f17$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $6fc2ba1913927f17$var$t($6fc2ba1913927f17$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("definition"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("constant"),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("function"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("standard"),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("local"),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $6fc2ba1913927f17$export$3288d34c523a1192.defineModifier("special")
};
for(let name in $6fc2ba1913927f17$export$8b7a896ae75accbf){
    let val = $6fc2ba1913927f17$export$8b7a896ae75accbf[name];
    if (val instanceof $6fc2ba1913927f17$export$3288d34c523a1192) val.name = name;
}
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $6fc2ba1913927f17$export$bf3ffb24fb17216c = $6fc2ba1913927f17$export$b7f6332ce20f80fb([
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $6fc2ba1913927f17$export$8b7a896ae75accbf.regexp,
            $6fc2ba1913927f17$export$8b7a896ae75accbf.escape,
            $6fc2ba1913927f17$export$8b7a896ae75accbf.special($6fc2ba1913927f17$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.local($6fc2ba1913927f17$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.definition($6fc2ba1913927f17$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.special($6fc2ba1913927f17$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.definition($6fc2ba1913927f17$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $6fc2ba1913927f17$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $8a0ff9d7afd8a874$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $8a0ff9d7afd8a874$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $8a0ff9d7afd8a874$export$b57f683f43553b99(baseData) {
    return (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $8a0ff9d7afd8a874$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $0f49217316d01287$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $0f49217316d01287$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $8a0ff9d7afd8a874$export$789c912f57fe164c.of(this),
            (0, $0f49217316d01287$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $8a0ff9d7afd8a874$var$topNodeAt(state, pos, side), data = top.type.prop($8a0ff9d7afd8a874$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($8a0ff9d7afd8a874$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $8a0ff9d7afd8a874$var$topNodeAt(state, pos, side).type.prop($8a0ff9d7afd8a874$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($8a0ff9d7afd8a874$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($8a0ff9d7afd8a874$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($8a0ff9d7afd8a874$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
function $8a0ff9d7afd8a874$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($8a0ff9d7afd8a874$export$789c912f57fe164c), tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $b14321b77c1b25e4$export$b0e28367f55837aa).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $8a0ff9d7afd8a874$export$b243968d9fb6db03 extends $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $8a0ff9d7afd8a874$export$b57f683f43553b99(spec.languageData);
        return new $8a0ff9d7afd8a874$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $8a0ff9d7afd8a874$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $8a0ff9d7afd8a874$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(state) {
    let field = state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $8a0ff9d7afd8a874$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $8a0ff9d7afd8a874$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $8a0ff9d7afd8a874$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $8a0ff9d7afd8a874$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $8a0ff9d7afd8a874$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($8a0ff9d7afd8a874$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $8a0ff9d7afd8a874$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $8a0ff9d7afd8a874$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa(parser, state, [], (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $8a0ff9d7afd8a874$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $b14321b77c1b25e4$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $b14321b77c1b25e4$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $8a0ff9d7afd8a874$var$currentContext;
        $8a0ff9d7afd8a874$var$currentContext = this;
        try {
            return f();
        } finally{
            $8a0ff9d7afd8a874$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $8a0ff9d7afd8a874$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $b14321b77c1b25e4$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $8a0ff9d7afd8a874$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $b14321b77c1b25e4$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $8a0ff9d7afd8a874$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)((0, $b14321b77c1b25e4$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $8a0ff9d7afd8a874$var$currentContext;
    }
}
function $8a0ff9d7afd8a874$var$cutFragments(fragments, from, to) {
    return (0, $b14321b77c1b25e4$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $8a0ff9d7afd8a874$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $8a0ff9d7afd8a874$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa.create(state.facet($8a0ff9d7afd8a874$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $8a0ff9d7afd8a874$var$LanguageState(parseState);
    }
}
$8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create: $8a0ff9d7afd8a874$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($8a0ff9d7afd8a874$export$789c912f57fe164c) != tr.state.facet($8a0ff9d7afd8a874$export$789c912f57fe164c)) return $8a0ff9d7afd8a874$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $8a0ff9d7afd8a874$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $8a0ff9d7afd8a874$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $8a0ff9d7afd8a874$var$isInputPending = typeof navigator != "undefined" && (($8a0ff9d7afd8a874$var$_a = navigator.scheduling) === null || $8a0ff9d7afd8a874$var$_a === void 0 ? void 0 : $8a0ff9d7afd8a874$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $8a0ff9d7afd8a874$var$parseWorker = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $8a0ff9d7afd8a874$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$8a0ff9d7afd8a874$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $8a0ff9d7afd8a874$var$isInputPending && $8a0ff9d7afd8a874$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.setState.of(new $8a0ff9d7afd8a874$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $e1533ef606a339de$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $8a0ff9d7afd8a874$export$789c912f57fe164c = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a.state,
            $8a0ff9d7afd8a874$var$parseWorker,
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $8a0ff9d7afd8a874$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $8a0ff9d7afd8a874$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $8a0ff9d7afd8a874$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $8a0ff9d7afd8a874$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting either entirely of the same whitespace
character. When not set, this defaults to 2 spaces.
*/ const $8a0ff9d7afd8a874$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $8a0ff9d7afd8a874$export$ad3205d09311a797(state) {
    let unit = state.facet($8a0ff9d7afd8a874$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $8a0ff9d7afd8a874$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($8a0ff9d7afd8a874$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "\t") {
        while(cols >= ts){
            result += "\t";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $8a0ff9d7afd8a874$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $0f49217316d01287$export$afa855cbfaff27f2)) context = new $8a0ff9d7afd8a874$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($8a0ff9d7afd8a874$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $8a0ff9d7afd8a874$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $8a0ff9d7afd8a874$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $8a0ff9d7afd8a874$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $8a0ff9d7afd8a874$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $8a0ff9d7afd8a874$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $8a0ff9d7afd8a874$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $8a0ff9d7afd8a874$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $0f49217316d01287$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $8a0ff9d7afd8a874$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $8a0ff9d7afd8a874$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur != stack.node; cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $8a0ff9d7afd8a874$var$indentFor(stack, cx, pos);
}
function $8a0ff9d7afd8a874$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $8a0ff9d7afd8a874$var$indentStrategy(cur.node);
        if (strategy) return strategy($8a0ff9d7afd8a874$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $8a0ff9d7afd8a874$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $8a0ff9d7afd8a874$var$indentStrategy(tree) {
    let strategy = tree.type.prop($8a0ff9d7afd8a874$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$8a0ff9d7afd8a874$var$delimitedStrategy(cx, true, 1, undefined, closed && !$8a0ff9d7afd8a874$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $8a0ff9d7afd8a874$var$topIndent : null;
}
function $8a0ff9d7afd8a874$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $8a0ff9d7afd8a874$export$8aaeb0848a33f7c3 extends $8a0ff9d7afd8a874$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $8a0ff9d7afd8a874$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($8a0ff9d7afd8a874$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $8a0ff9d7afd8a874$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $8a0ff9d7afd8a874$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $8a0ff9d7afd8a874$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) {
            if (next.from >= lineEnd) return null;
            let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
            return {
                from: openToken.from,
                to: openToken.to + space
            };
        }
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $8a0ff9d7afd8a874$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$8a0ff9d7afd8a874$var$delimitedStrategy(context, align, units, closing);
}
function $8a0ff9d7afd8a874$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $8a0ff9d7afd8a874$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $8a0ff9d7afd8a874$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $8a0ff9d7afd8a874$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $8a0ff9d7afd8a874$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $8a0ff9d7afd8a874$export$9bcaf6e2125ee117() {
    return (0, $0f49217316d01287$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $8a0ff9d7afd8a874$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $8a0ff9d7afd8a874$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $8a0ff9d7afd8a874$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $8a0ff9d7afd8a874$export$40014037e3ef64a = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $8a0ff9d7afd8a874$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $8a0ff9d7afd8a874$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $8a0ff9d7afd8a874$var$syntaxFolding(state, start, end) {
    let tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($8a0ff9d7afd8a874$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$8a0ff9d7afd8a874$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $8a0ff9d7afd8a874$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($8a0ff9d7afd8a874$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $8a0ff9d7afd8a874$var$syntaxFolding(state, lineStart, lineEnd);
}
function $8a0ff9d7afd8a874$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $8a0ff9d7afd8a874$export$a123efe007ad265 = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map: $8a0ff9d7afd8a874$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $8a0ff9d7afd8a874$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map: $8a0ff9d7afd8a874$var$mapRange
});
function $8a0ff9d7afd8a874$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $8a0ff9d7afd8a874$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($8a0ff9d7afd8a874$export$a123efe007ad265) && !$8a0ff9d7afd8a874$var$foldExists(folded, e.value.from, e.value.to)) {
                let { preparePlaceholder: preparePlaceholder } = tr.state.facet($8a0ff9d7afd8a874$var$foldConfig);
                let widget = !preparePlaceholder ? $8a0ff9d7afd8a874$var$foldWidget : (0, $e1533ef606a339de$export$10e30b733df217ea).replace({
                    widget: new $8a0ff9d7afd8a874$var$PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                });
                folded = folded.update({
                    add: [
                        widget.range(e.value.from, e.value.to)
                    ]
                });
            } else if (e.is($8a0ff9d7afd8a874$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            let onSelection = false, { head: head } = tr.selection.main;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, $e1533ef606a339de$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($8a0ff9d7afd8a874$var$foldWidget.range(from, to));
        }
        return (0, $e1533ef606a339de$export$10e30b733df217ea).set(ranges, true);
    }
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $8a0ff9d7afd8a874$export$2b3c199812391e05(state) {
    return state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false) || (0, $0f49217316d01287$export$34cb5241245008dd).empty;
}
function $8a0ff9d7afd8a874$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $8a0ff9d7afd8a874$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $8a0ff9d7afd8a874$var$maybeEnable(state, other) {
    return state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false) ? other : other.concat((0, $0f49217316d01287$export$95000d4efaa4321f).appendConfig.of($8a0ff9d7afd8a874$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $8a0ff9d7afd8a874$export$52e96be2adbea02a = (view)=>{
    for (let line of $8a0ff9d7afd8a874$var$selectedLines(view)){
        let range = $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $8a0ff9d7afd8a874$var$maybeEnable(view.state, [
                    $8a0ff9d7afd8a874$export$a123efe007ad265.of(range),
                    $8a0ff9d7afd8a874$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $8a0ff9d7afd8a874$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $8a0ff9d7afd8a874$var$selectedLines(view)){
        let folded = $8a0ff9d7afd8a874$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($8a0ff9d7afd8a874$export$bf2507dc398fc1ab.of(folded), $8a0ff9d7afd8a874$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $8a0ff9d7afd8a874$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $e1533ef606a339de$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $8a0ff9d7afd8a874$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($8a0ff9d7afd8a874$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $8a0ff9d7afd8a874$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $8a0ff9d7afd8a874$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($8a0ff9d7afd8a874$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $8a0ff9d7afd8a874$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $8a0ff9d7afd8a874$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $8a0ff9d7afd8a874$var$selectedLines(view)){
        let folded = $8a0ff9d7afd8a874$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($8a0ff9d7afd8a874$export$bf2507dc398fc1ab.of(folded), $8a0ff9d7afd8a874$var$announceFold(view, folded, false));
        else {
            let foldRange = $8a0ff9d7afd8a874$var$foldableContainer(view, line);
            if (foldRange) effects.push($8a0ff9d7afd8a874$export$a123efe007ad265.of(foldRange), $8a0ff9d7afd8a874$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $8a0ff9d7afd8a874$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $8a0ff9d7afd8a874$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $8a0ff9d7afd8a874$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $8a0ff9d7afd8a874$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $8a0ff9d7afd8a874$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $8a0ff9d7afd8a874$export$5671b24df569b27d
    }
];
const $8a0ff9d7afd8a874$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $8a0ff9d7afd8a874$var$foldConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(values, $8a0ff9d7afd8a874$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $8a0ff9d7afd8a874$export$2c875b83a85d0f31(config) {
    let result = [
        $8a0ff9d7afd8a874$export$6955fe1f7c578abb,
        $8a0ff9d7afd8a874$var$baseTheme$1
    ];
    if (config) result.push($8a0ff9d7afd8a874$var$foldConfig.of(config));
    return result;
}
function $8a0ff9d7afd8a874$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($8a0ff9d7afd8a874$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $8a0ff9d7afd8a874$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $8a0ff9d7afd8a874$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $8a0ff9d7afd8a874$var$foldWidget = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $e1533ef606a339de$export$95cdd842edb044c5) {
        toDOM(view) {
            return $8a0ff9d7afd8a874$var$widgetToDOM(view, null);
        }
    }
});
class $8a0ff9d7afd8a874$var$PreparedFoldWidget extends (0, $e1533ef606a339de$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $8a0ff9d7afd8a874$var$widgetToDOM(view, this.value);
    }
}
const $8a0ff9d7afd8a874$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $8a0ff9d7afd8a874$var$FoldMarker extends (0, $e1533ef606a339de$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $8a0ff9d7afd8a874$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = Object.assign(Object.assign({}, $8a0ff9d7afd8a874$var$foldGutterDefaults), config);
    let canFold = new $8a0ff9d7afd8a874$var$FoldMarker(fullConfig, true), canUnfold = new $8a0ff9d7afd8a874$var$FoldMarker(fullConfig, false);
    let markers = (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($8a0ff9d7afd8a874$export$789c912f57fe164c) != update.state.facet($8a0ff9d7afd8a874$export$789c912f57fe164c) || update.startState.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false) != update.state.field($8a0ff9d7afd8a874$export$6955fe1f7c578abb, false) || $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(update.startState) != $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $0f49217316d01287$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $8a0ff9d7afd8a874$var$findFold(view.state, line.from, line.to) ? canUnfold : $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $e1533ef606a339de$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $0f49217316d01287$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $8a0ff9d7afd8a874$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $8a0ff9d7afd8a874$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $8a0ff9d7afd8a874$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $8a0ff9d7afd8a874$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $8a0ff9d7afd8a874$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        $8a0ff9d7afd8a874$export$2c875b83a85d0f31()
    ];
}
const $8a0ff9d7afd8a874$var$baseTheme$1 = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $8a0ff9d7afd8a874$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $df51ea96bfd6fa5c$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a ? (type)=>type.prop($8a0ff9d7afd8a874$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $6fc2ba1913927f17$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $df51ea96bfd6fa5c$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $8a0ff9d7afd8a874$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $8a0ff9d7afd8a874$var$highlighterFacet = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $8a0ff9d7afd8a874$var$fallbackHighlighter = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $8a0ff9d7afd8a874$var$getHighlighters(state) {
    let main = state.facet($8a0ff9d7afd8a874$var$highlighterFacet);
    return main.length ? main : state.facet($8a0ff9d7afd8a874$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $8a0ff9d7afd8a874$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $8a0ff9d7afd8a874$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $8a0ff9d7afd8a874$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $e1533ef606a339de$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($8a0ff9d7afd8a874$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($8a0ff9d7afd8a874$var$highlighterFacet.computeN([
        (0, $e1533ef606a339de$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $e1533ef606a339de$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($8a0ff9d7afd8a874$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $8a0ff9d7afd8a874$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $8a0ff9d7afd8a874$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $8a0ff9d7afd8a874$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $8a0ff9d7afd8a874$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(update.state), highlighters = $8a0ff9d7afd8a874$var$getHighlighters(update.state);
        let styleChange = highlighters != $8a0ff9d7afd8a874$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
        let builder = new (0, $0f49217316d01287$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $6fc2ba1913927f17$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $8a0ff9d7afd8a874$var$treeHighlighter = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).high(/*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass($8a0ff9d7afd8a874$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $8a0ff9d7afd8a874$export$bb02a6818dd48320 = /*@__PURE__*/ $8a0ff9d7afd8a874$export$4819f093bdd5b4a.define([
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).atom,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).bool,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).url,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).contentSeparator,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).literal,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).regexp,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).local((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).typeName,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $8a0ff9d7afd8a874$var$baseTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $8a0ff9d7afd8a874$var$DefaultScanDist = 10000, $8a0ff9d7afd8a874$var$DefaultBrackets = "()[]{}";
const $8a0ff9d7afd8a874$var$bracketMatchingConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $8a0ff9d7afd8a874$var$DefaultBrackets,
            maxScanDistance: $8a0ff9d7afd8a874$var$DefaultScanDist,
            renderMatch: $8a0ff9d7afd8a874$var$defaultRenderMatch
        });
    }
});
const $8a0ff9d7afd8a874$var$matchingMark = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $8a0ff9d7afd8a874$var$nonmatchingMark = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $8a0ff9d7afd8a874$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $8a0ff9d7afd8a874$var$matchingMark : $8a0ff9d7afd8a874$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $8a0ff9d7afd8a874$var$bracketMatchingState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($8a0ff9d7afd8a874$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $8a0ff9d7afd8a874$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $8a0ff9d7afd8a874$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($8a0ff9d7afd8a874$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $8a0ff9d7afd8a874$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $e1533ef606a339de$export$10e30b733df217ea).set(decorations, true);
    },
    provide: (f)=>(0, $e1533ef606a339de$export$eece2fccabbb77c5).decorations.from(f)
});
const $8a0ff9d7afd8a874$var$bracketMatchingUnique = [
    $8a0ff9d7afd8a874$var$bracketMatchingState,
    $8a0ff9d7afd8a874$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $8a0ff9d7afd8a874$export$cef7edfd214be605(config = {}) {
    return [
        $8a0ff9d7afd8a874$var$bracketMatchingConfig.of(config),
        $8a0ff9d7afd8a874$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $8a0ff9d7afd8a874$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)();
function $8a0ff9d7afd8a874$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $b14321b77c1b25e4$export$b8034b9bc18acd90).openedBy : (0, $b14321b77c1b25e4$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $8a0ff9d7afd8a874$var$findHandle(node) {
    let hasHandle = node.type.prop($8a0ff9d7afd8a874$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $8a0ff9d7afd8a874$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $8a0ff9d7afd8a874$var$DefaultScanDist, brackets = config.brackets || $8a0ff9d7afd8a874$var$DefaultBrackets;
    let tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $8a0ff9d7afd8a874$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $8a0ff9d7afd8a874$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $8a0ff9d7afd8a874$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $8a0ff9d7afd8a874$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $8a0ff9d7afd8a874$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $8a0ff9d7afd8a874$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($8a0ff9d7afd8a874$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($8a0ff9d7afd8a874$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $8a0ff9d7afd8a874$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $8a0ff9d7afd8a874$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $8a0ff9d7afd8a874$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $8a0ff9d7afd8a874$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $8a0ff9d7afd8a874$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $8a0ff9d7afd8a874$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $8a0ff9d7afd8a874$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $8a0ff9d7afd8a874$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $8a0ff9d7afd8a874$var$noTokens
    };
}
function $8a0ff9d7afd8a874$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $8a0ff9d7afd8a874$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $8a0ff9d7afd8a874$export$5ee3cc23916207d8 extends $8a0ff9d7afd8a874$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $8a0ff9d7afd8a874$export$b57f683f43553b99(parser.languageData);
        let p = $8a0ff9d7afd8a874$var$fullParser(parser), self;
        let impl = new class extends (0, $b14321b77c1b25e4$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $8a0ff9d7afd8a874$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [], parser.name);
        this.topNode = $8a0ff9d7afd8a874$var$docID(data, this);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $8a0ff9d7afd8a874$var$TokenTable(p.tokenTable) : $8a0ff9d7afd8a874$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $8a0ff9d7afd8a874$export$5ee3cc23916207d8(spec);
    }
    /**
    @internal
    */ getIndent(cx) {
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $8a0ff9d7afd8a874$var$IndentedFrom.get(cx.state);
            if (from != null && from < cx.pos - 1e4) from = undefined;
        }
        let start = $8a0ff9d7afd8a874$var$findState(this, cx.node.tree, cx.node.from, cx.node.from, from !== null && from !== void 0 ? from : cx.pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = cx.node.from;
        }
        if (cx.pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < cx.pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(cx.pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $8a0ff9d7afd8a874$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$8a0ff9d7afd8a874$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == cx.pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(cx.pos);
        if (overrideIndentation && from == null) $8a0ff9d7afd8a874$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $8a0ff9d7afd8a874$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e) && pos < before && $8a0ff9d7afd8a874$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $8a0ff9d7afd8a874$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && from == 0 && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)) {
            if (!(inner = $8a0ff9d7afd8a874$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $8a0ff9d7afd8a874$var$findStartInFragments(lang, fragments, startPos, endPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $8a0ff9d7afd8a874$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && found.pos <= endPos && (tree = $8a0ff9d7afd8a874$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $8a0ff9d7afd8a874$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).empty
    };
}
class $8a0ff9d7afd8a874$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $8a0ff9d7afd8a874$var$findStartInFragments(lang, fragments, from, this.to, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */  && ranges.some((r)=>r.from <= context.viewport.from && r.to >= context.viewport.from)) {
            this.state = this.lang.streamParser.startState($8a0ff9d7afd8a874$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $8a0ff9d7afd8a874$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, offset) {
        let size = 4;
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        let last = this.chunk.length - 4;
        if (size == 4 && last >= 0 && this.chunk[last] == id && this.chunk[last + 2] == from) this.chunk[last + 2] = to;
        else this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $8a0ff9d7afd8a874$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $8a0ff9d7afd8a874$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $8a0ff9d7afd8a874$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $8a0ff9d7afd8a874$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $8a0ff9d7afd8a874$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $8a0ff9d7afd8a874$var$noTokens = /*@__PURE__*/ Object.create(null);
const $8a0ff9d7afd8a874$var$typeArray = [
    (0, $b14321b77c1b25e4$export$f06e977173f1857c).none
];
const $8a0ff9d7afd8a874$var$nodeSet = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$7fad5fb00d8de02c)($8a0ff9d7afd8a874$var$typeArray);
const $8a0ff9d7afd8a874$var$warned = [];
// Cache of node types by name and tags
const $8a0ff9d7afd8a874$var$byTag = /*@__PURE__*/ Object.create(null);
const $8a0ff9d7afd8a874$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$8a0ff9d7afd8a874$var$defaultTable[legacyName] = /*@__PURE__*/ $8a0ff9d7afd8a874$var$createTokenType($8a0ff9d7afd8a874$var$noTokens, name);
class $8a0ff9d7afd8a874$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $8a0ff9d7afd8a874$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $8a0ff9d7afd8a874$var$createTokenType(this.extra, tag));
    }
}
const $8a0ff9d7afd8a874$var$defaultTokenTable = /*@__PURE__*/ new $8a0ff9d7afd8a874$var$TokenTable($8a0ff9d7afd8a874$var$noTokens);
function $8a0ff9d7afd8a874$var$warnForPart(part, msg) {
    if ($8a0ff9d7afd8a874$var$warned.indexOf(part) > -1) return;
    $8a0ff9d7afd8a874$var$warned.push(part);
    console.warn(msg);
}
function $8a0ff9d7afd8a874$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $6fc2ba1913927f17$export$8b7a896ae75accbf)[part];
            if (!value) $8a0ff9d7afd8a874$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $8a0ff9d7afd8a874$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $8a0ff9d7afd8a874$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $8a0ff9d7afd8a874$var$byTag[key];
    if (known) return known.id;
    let type = $8a0ff9d7afd8a874$var$byTag[key] = (0, $b14321b77c1b25e4$export$f06e977173f1857c).define({
        id: $8a0ff9d7afd8a874$var$typeArray.length,
        name: name,
        props: [
            (0, $6fc2ba1913927f17$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $8a0ff9d7afd8a874$var$typeArray.push(type);
    return type.id;
}
function $8a0ff9d7afd8a874$var$docID(data, lang) {
    let type = (0, $b14321b77c1b25e4$export$f06e977173f1857c).define({
        id: $8a0ff9d7afd8a874$var$typeArray.length,
        name: "Document",
        props: [
            $8a0ff9d7afd8a874$export$27a2e78097f753f7.add(()=>data),
            $8a0ff9d7afd8a874$export$72c7d4c52b3c6460.add(()=>(cx)=>lang.getIndent(cx))
        ],
        top: true
    });
    $8a0ff9d7afd8a874$var$typeArray.push(type);
    return type;
}
function $8a0ff9d7afd8a874$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $8a0ff9d7afd8a874$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($8a0ff9d7afd8a874$var$buildForLine(i.value)) return true;
    return false;
}
function $8a0ff9d7afd8a874$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $8a0ff9d7afd8a874$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $8a0ff9d7afd8a874$var$alwaysIsolate = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $8a0ff9d7afd8a874$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $8a0ff9d7afd8a874$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($8a0ff9d7afd8a874$var$alwaysIsolate.of(true));
    return extensions;
}
const $8a0ff9d7afd8a874$var$isolateMarks = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($8a0ff9d7afd8a874$var$alwaysIsolate) || view.textDirection != (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $e1533ef606a339de$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $8a0ff9d7afd8a874$var$textHasRTL(view.state.doc);
        this.tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $8a0ff9d7afd8a874$var$buildDeco(view, this.tree, this.always) : (0, $e1533ef606a339de$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($8a0ff9d7afd8a874$var$alwaysIsolate) || update.view.textDirection != (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $e1533ef606a339de$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $8a0ff9d7afd8a874$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $8a0ff9d7afd8a874$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $e1533ef606a339de$export$10e30b733df217ea).none;
        }
        return [
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $0f49217316d01287$export$b92464a736444411).lowest((0, $e1533ef606a339de$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $8a0ff9d7afd8a874$var$buildDeco(view, tree, always) {
    let deco = new (0, $0f49217316d01287$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $8a0ff9d7afd8a874$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $8a0ff9d7afd8a874$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $8a0ff9d7afd8a874$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $8a0ff9d7afd8a874$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $8a0ff9d7afd8a874$var$marks = {
    rtl: /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};






/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $549e4c3fcf3607ba$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $549e4c3fcf3607ba$var$getConfig(target.state, line.from);
    return config.line ? $549e4c3fcf3607ba$export$63a9abf96aaa3c5d(target) : config.block ? $549e4c3fcf3607ba$export$e88d9eff7cafcc34(target) : false;
};
function $549e4c3fcf3607ba$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $549e4c3fcf3607ba$export$63a9abf96aaa3c5d = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $549e4c3fcf3607ba$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $549e4c3fcf3607ba$export$5a43b8c36509b6fd = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $549e4c3fcf3607ba$export$19d6fa84ce3a55ab = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $549e4c3fcf3607ba$export$f2ae215066c4835a = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $549e4c3fcf3607ba$export$fddcfb23c3a05835 = /*@__PURE__*/ $549e4c3fcf3607ba$var$command($549e4c3fcf3607ba$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $549e4c3fcf3607ba$export$e88d9eff7cafcc34 = /*@__PURE__*/ $549e4c3fcf3607ba$var$command((o, s)=>$549e4c3fcf3607ba$var$changeBlockComment(o, s, $549e4c3fcf3607ba$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $549e4c3fcf3607ba$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos);
    return data.length ? data[0] : {};
}
const $549e4c3fcf3607ba$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $549e4c3fcf3607ba$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $549e4c3fcf3607ba$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $549e4c3fcf3607ba$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $549e4c3fcf3607ba$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $549e4c3fcf3607ba$var$SearchMargin);
        endText = state.sliceDoc(to - $549e4c3fcf3607ba$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $549e4c3fcf3607ba$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        if (toLine.from > fromLine.from && toLine.from == r.to) toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $549e4c3fcf3607ba$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$549e4c3fcf3607ba$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$549e4c3fcf3607ba$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $549e4c3fcf3607ba$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9;
        let token = $549e4c3fcf3607ba$var$getConfig(state, from).line;
        if (!token) continue;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $549e4c3fcf3607ba$var$fromHistory = /*@__PURE__*/ (0, $0f49217316d01287$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $549e4c3fcf3607ba$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $0f49217316d01287$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $549e4c3fcf3607ba$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define();
const $549e4c3fcf3607ba$var$historyConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $549e4c3fcf3607ba$var$historyField_ = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return $549e4c3fcf3607ba$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($549e4c3fcf3607ba$var$historyConfig);
        let fromHist = tr.annotation($549e4c3fcf3607ba$var$fromHistory);
        if (fromHist) {
            let item = $549e4c3fcf3607ba$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $549e4c3fcf3607ba$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $549e4c3fcf3607ba$var$addSelection(other, tr.startState.selection);
            return new $549e4c3fcf3607ba$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($549e4c3fcf3607ba$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $0f49217316d01287$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $549e4c3fcf3607ba$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $0f49217316d01287$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $0f49217316d01287$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $549e4c3fcf3607ba$var$HistoryState(json.done.map($549e4c3fcf3607ba$var$HistEvent.fromJSON), json.undone.map($549e4c3fcf3607ba$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $549e4c3fcf3607ba$export$55abd4691b317664(config = {}) {
    return [
        $549e4c3fcf3607ba$var$historyField_,
        $549e4c3fcf3607ba$var$historyConfig.of(config),
        (0, $e1533ef606a339de$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $549e4c3fcf3607ba$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $549e4c3fcf3607ba$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $549e4c3fcf3607ba$export$c00598b6ceeb3e9 = $549e4c3fcf3607ba$var$historyField_;
function $549e4c3fcf3607ba$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($549e4c3fcf3607ba$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $549e4c3fcf3607ba$export$21f930c44940fd98 = /*@__PURE__*/ $549e4c3fcf3607ba$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $549e4c3fcf3607ba$export$1688e416fee0a49e = /*@__PURE__*/ $549e4c3fcf3607ba$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $549e4c3fcf3607ba$export$43103d47530fe49f = /*@__PURE__*/ $549e4c3fcf3607ba$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $549e4c3fcf3607ba$export$2d87af80f1777f20 = /*@__PURE__*/ $549e4c3fcf3607ba$var$cmd(1 /* BranchName.Undone */ , true);
function $549e4c3fcf3607ba$var$depth(side) {
    return function(state) {
        let histState = state.field($549e4c3fcf3607ba$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $549e4c3fcf3607ba$export$f8a176c2b9a10bdb = /*@__PURE__*/ $549e4c3fcf3607ba$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $549e4c3fcf3607ba$export$3ffe6b288e7d941b = /*@__PURE__*/ $549e4c3fcf3607ba$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $549e4c3fcf3607ba$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $549e4c3fcf3607ba$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $549e4c3fcf3607ba$var$HistEvent(json.changes && (0, $0f49217316d01287$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $0f49217316d01287$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $0f49217316d01287$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $0f49217316d01287$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $549e4c3fcf3607ba$var$none;
        for (let invert of tr.startState.facet($549e4c3fcf3607ba$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $549e4c3fcf3607ba$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $549e4c3fcf3607ba$var$none);
    }
    static selection(selections) {
        return new $549e4c3fcf3607ba$var$HistEvent(undefined, $549e4c3fcf3607ba$var$none, undefined, undefined, selections);
    }
}
function $549e4c3fcf3607ba$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $549e4c3fcf3607ba$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $549e4c3fcf3607ba$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $549e4c3fcf3607ba$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $549e4c3fcf3607ba$var$none = [];
const $549e4c3fcf3607ba$var$MaxSelectionsPerEvent = 200;
function $549e4c3fcf3607ba$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $549e4c3fcf3607ba$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $549e4c3fcf3607ba$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $549e4c3fcf3607ba$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $549e4c3fcf3607ba$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $549e4c3fcf3607ba$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $549e4c3fcf3607ba$var$none;
    while(length){
        let event = $549e4c3fcf3607ba$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $549e4c3fcf3607ba$var$HistEvent.selection(selections)
    ] : $549e4c3fcf3607ba$var$none;
}
function $549e4c3fcf3607ba$var$mapEvent(event, mapping, extraSelections) {
    let selections = $549e4c3fcf3607ba$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $549e4c3fcf3607ba$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $549e4c3fcf3607ba$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $549e4c3fcf3607ba$var$HistEvent(mappedChanges, (0, $0f49217316d01287$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $549e4c3fcf3607ba$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $549e4c3fcf3607ba$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $549e4c3fcf3607ba$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $549e4c3fcf3607ba$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $549e4c3fcf3607ba$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $549e4c3fcf3607ba$var$updateBranch(done, done.length - 1, config.minDepth, new $549e4c3fcf3607ba$var$HistEvent(event.changes.compose(lastEvent.changes), $549e4c3fcf3607ba$var$conc((0, $0f49217316d01287$export$95000d4efaa4321f).mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $549e4c3fcf3607ba$var$none));
        else done = $549e4c3fcf3607ba$var$updateBranch(done, done.length, config.minDepth, event);
        return new $549e4c3fcf3607ba$var$HistoryState(done, $549e4c3fcf3607ba$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $549e4c3fcf3607ba$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $549e4c3fcf3607ba$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $549e4c3fcf3607ba$var$HistoryState($549e4c3fcf3607ba$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $549e4c3fcf3607ba$var$HistoryState($549e4c3fcf3607ba$var$addMappingToBranch(this.done, mapping), $549e4c3fcf3607ba$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || state.selection;
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $549e4c3fcf3607ba$var$fromHistory.of({
                side: side,
                rest: $549e4c3fcf3607ba$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $549e4c3fcf3607ba$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $549e4c3fcf3607ba$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $549e4c3fcf3607ba$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$549e4c3fcf3607ba$var$HistoryState.empty = /*@__PURE__*/ new $549e4c3fcf3607ba$var$HistoryState($549e4c3fcf3607ba$var$none, $549e4c3fcf3607ba$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $549e4c3fcf3607ba$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $549e4c3fcf3607ba$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $549e4c3fcf3607ba$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $549e4c3fcf3607ba$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $549e4c3fcf3607ba$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $549e4c3fcf3607ba$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $549e4c3fcf3607ba$var$updateSel(sel, by) {
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $549e4c3fcf3607ba$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $549e4c3fcf3607ba$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $549e4c3fcf3607ba$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($549e4c3fcf3607ba$var$setSel(state, selection));
    return true;
}
function $549e4c3fcf3607ba$var$rangeEnd(range, forward) {
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $549e4c3fcf3607ba$var$cursorByChar(view, forward) {
    return $549e4c3fcf3607ba$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $549e4c3fcf3607ba$var$rangeEnd(range, forward));
}
function $549e4c3fcf3607ba$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $549e4c3fcf3607ba$export$3447f2b737925430 = (view)=>$549e4c3fcf3607ba$var$cursorByChar(view, !$549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $549e4c3fcf3607ba$export$e45941411d098b = (view)=>$549e4c3fcf3607ba$var$cursorByChar(view, $549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $549e4c3fcf3607ba$export$25b7809021291927 = (view)=>$549e4c3fcf3607ba$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $549e4c3fcf3607ba$export$6ddc33d0aa7a1b65 = (view)=>$549e4c3fcf3607ba$var$cursorByChar(view, false);
function $549e4c3fcf3607ba$var$byCharLogical(state, range, forward) {
    let pos = range.head, line = state.doc.lineAt(pos);
    if (pos == (forward ? line.to : line.from)) pos = forward ? Math.min(state.doc.length, line.to + 1) : Math.max(0, line.from - 1);
    else pos = line.from + (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward);
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
}
function $549e4c3fcf3607ba$var$moveByCharLogical(target, forward) {
    return $549e4c3fcf3607ba$var$moveSel(target, (range)=>range.empty ? $549e4c3fcf3607ba$var$byCharLogical(target.state, range, forward) : $549e4c3fcf3607ba$var$rangeEnd(range, forward));
}
/**
Move the selection one character forward, in logical
(non-text-direction-aware) string index order.
*/ const $549e4c3fcf3607ba$export$7ce32ef700b0ef27 = (target)=>$549e4c3fcf3607ba$var$moveByCharLogical(target, true);
/**
Move the selection one character backward, in logical string index
order.
*/ const $549e4c3fcf3607ba$export$a4c56edc7f7903df = (target)=>$549e4c3fcf3607ba$var$moveByCharLogical(target, false);
function $549e4c3fcf3607ba$var$cursorByGroup(view, forward) {
    return $549e4c3fcf3607ba$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $549e4c3fcf3607ba$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $549e4c3fcf3607ba$export$137fb1611fb38377 = (view)=>$549e4c3fcf3607ba$var$cursorByGroup(view, !$549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $549e4c3fcf3607ba$export$8fb2c619d55341b4 = (view)=>$549e4c3fcf3607ba$var$cursorByGroup(view, $549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $549e4c3fcf3607ba$export$ce8d94762dbdebb8 = (view)=>$549e4c3fcf3607ba$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $549e4c3fcf3607ba$export$dd83d1d646f184d8 = (view)=>$549e4c3fcf3607ba$var$cursorByGroup(view, false);
const $549e4c3fcf3607ba$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $549e4c3fcf3607ba$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $0f49217316d01287$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $0f49217316d01287$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $0f49217316d01287$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $0f49217316d01287$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $0f49217316d01287$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($549e4c3fcf3607ba$var$segmenter && cat == (0, $0f49217316d01287$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($549e4c3fcf3607ba$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $549e4c3fcf3607ba$var$cursorBySubword(view, forward) {
    return $549e4c3fcf3607ba$var$moveSel(view, (range)=>range.empty ? $549e4c3fcf3607ba$var$moveBySubword(view, range, forward) : $549e4c3fcf3607ba$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $549e4c3fcf3607ba$export$d969a5b0dca9c3e2 = (view)=>$549e4c3fcf3607ba$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $549e4c3fcf3607ba$export$ade35f5607ad3d82 = (view)=>$549e4c3fcf3607ba$var$cursorBySubword(view, false);
function $549e4c3fcf3607ba$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $549e4c3fcf3607ba$var$moveBySyntax(state, start, forward) {
    let pos = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $b14321b77c1b25e4$export$b8034b9bc18acd90).closedBy : (0, $b14321b77c1b25e4$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($549e4c3fcf3607ba$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, pos.from, 1) : (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $549e4c3fcf3607ba$export$1e53c014543c10bb = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveBySyntax(view.state, range, !$549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $549e4c3fcf3607ba$export$62c6dc33f5d01e39 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveBySyntax(view.state, range, $549e4c3fcf3607ba$var$ltrAtCursor(view)));
function $549e4c3fcf3607ba$var$cursorByLine(view, forward) {
    return $549e4c3fcf3607ba$var$moveSel(view, (range)=>{
        if (!range.empty) return $549e4c3fcf3607ba$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $549e4c3fcf3607ba$export$fe179dad0485d99d = (view)=>$549e4c3fcf3607ba$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $549e4c3fcf3607ba$export$75f9b75ffb1a9dc5 = (view)=>$549e4c3fcf3607ba$var$cursorByLine(view, true);
function $549e4c3fcf3607ba$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $e1533ef606a339de$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $549e4c3fcf3607ba$var$cursorByPage(view, forward) {
    let page = $549e4c3fcf3607ba$var$pageInfo(view);
    let { state: state } = view, selection = $549e4c3fcf3607ba$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $549e4c3fcf3607ba$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $e1533ef606a339de$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($549e4c3fcf3607ba$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $549e4c3fcf3607ba$export$546ec71a9f854193 = (view)=>$549e4c3fcf3607ba$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $549e4c3fcf3607ba$export$6e407c2072d437f4 = (view)=>$549e4c3fcf3607ba$var$cursorByPage(view, true);
function $549e4c3fcf3607ba$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $549e4c3fcf3607ba$export$b59ae3b25af6ea13 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $549e4c3fcf3607ba$export$64939ebc49b03818 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $549e4c3fcf3607ba$export$515c8c77cfbd2e73 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, !$549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $549e4c3fcf3607ba$export$912e453a1e062a62 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, $549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $549e4c3fcf3607ba$export$9c7dea99650bd512 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $549e4c3fcf3607ba$export$2a3cdaf3ab2dcbf2 = (view)=>$549e4c3fcf3607ba$var$moveSel(view, (range)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $549e4c3fcf3607ba$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $549e4c3fcf3607ba$var$updateSel(state.selection, (range)=>{
        let matching = (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, range.head, -1) || (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $8a0ff9d7afd8a874$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($549e4c3fcf3607ba$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $549e4c3fcf3607ba$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $549e4c3fcf3607ba$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$toMatchingBracket(state, dispatch, true);
function $549e4c3fcf3607ba$var$extendSel(target, how) {
    let selection = $549e4c3fcf3607ba$var$updateSel(target.state.selection, (range)=>{
        let head = how(range);
        return (0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined);
    });
    if (selection.eq(target.state.selection)) return false;
    target.dispatch($549e4c3fcf3607ba$var$setSel(target.state, selection));
    return true;
}
function $549e4c3fcf3607ba$var$selectByChar(view, forward) {
    return $549e4c3fcf3607ba$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $549e4c3fcf3607ba$export$639be832433387f = (view)=>$549e4c3fcf3607ba$var$selectByChar(view, !$549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $549e4c3fcf3607ba$export$49e3d65796d89132 = (view)=>$549e4c3fcf3607ba$var$selectByChar(view, $549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $549e4c3fcf3607ba$export$6a18f0ec4e3aa4ba = (view)=>$549e4c3fcf3607ba$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $549e4c3fcf3607ba$export$1132822fa6924c1d = (view)=>$549e4c3fcf3607ba$var$selectByChar(view, false);
/**
Move the selection head one character forward by logical
(non-direction aware) string index order.
*/ const $549e4c3fcf3607ba$export$74309692c7a8e2d9 = (target)=>$549e4c3fcf3607ba$var$extendSel(target, (range)=>$549e4c3fcf3607ba$var$byCharLogical(target.state, range, true));
/**
Move the selection head one character backward by logical string
index order.
*/ const $549e4c3fcf3607ba$export$2bfcd2df135aa168 = (target)=>$549e4c3fcf3607ba$var$extendSel(target, (range)=>$549e4c3fcf3607ba$var$byCharLogical(target.state, range, false));
function $549e4c3fcf3607ba$var$selectByGroup(view, forward) {
    return $549e4c3fcf3607ba$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $549e4c3fcf3607ba$export$ef839611b4c2ba40 = (view)=>$549e4c3fcf3607ba$var$selectByGroup(view, !$549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $549e4c3fcf3607ba$export$5ebbb4cf65fe8a74 = (view)=>$549e4c3fcf3607ba$var$selectByGroup(view, $549e4c3fcf3607ba$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $549e4c3fcf3607ba$export$53ddb317471acf76 = (view)=>$549e4c3fcf3607ba$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $549e4c3fcf3607ba$export$65a2ce60964fa778 = (view)=>$549e4c3fcf3607ba$var$selectByGroup(view, false);
function $549e4c3fcf3607ba$var$selectBySubword(view, forward) {
    return $549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $549e4c3fcf3607ba$export$c4f4d945a8760145 = (view)=>$549e4c3fcf3607ba$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $549e4c3fcf3607ba$export$3a6caa1f1abce2e2 = (view)=>$549e4c3fcf3607ba$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $549e4c3fcf3607ba$export$67b15be4414061b5 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveBySyntax(view.state, range, !$549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $549e4c3fcf3607ba$export$74aa476df7791ce = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveBySyntax(view.state, range, $549e4c3fcf3607ba$var$ltrAtCursor(view)));
function $549e4c3fcf3607ba$var$selectByLine(view, forward) {
    return $549e4c3fcf3607ba$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $549e4c3fcf3607ba$export$92aa693a1ecd7061 = (view)=>$549e4c3fcf3607ba$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $549e4c3fcf3607ba$export$bf847527697a3040 = (view)=>$549e4c3fcf3607ba$var$selectByLine(view, true);
function $549e4c3fcf3607ba$var$selectByPage(view, forward) {
    return $549e4c3fcf3607ba$var$extendSel(view, (range)=>view.moveVertically(range, forward, $549e4c3fcf3607ba$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $549e4c3fcf3607ba$export$61eab34d4ff5cbaf = (view)=>$549e4c3fcf3607ba$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $549e4c3fcf3607ba$export$a4c186a0dadaf91c = (view)=>$549e4c3fcf3607ba$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $549e4c3fcf3607ba$export$df223d0097d57a86 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $549e4c3fcf3607ba$export$643176ee603b8e87 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $549e4c3fcf3607ba$export$769cc61da74090c5 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, !$549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ const $549e4c3fcf3607ba$export$de427496204690a6 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>$549e4c3fcf3607ba$var$moveByLineBoundary(view, range, $549e4c3fcf3607ba$var$ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ const $549e4c3fcf3607ba$export$a0e1e86f753956a4 = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $549e4c3fcf3607ba$export$bd34a38d148e23af = (view)=>$549e4c3fcf3607ba$var$extendSel(view, (range)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $549e4c3fcf3607ba$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($549e4c3fcf3607ba$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $549e4c3fcf3607ba$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($549e4c3fcf3607ba$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $549e4c3fcf3607ba$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($549e4c3fcf3607ba$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $549e4c3fcf3607ba$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($549e4c3fcf3607ba$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $549e4c3fcf3607ba$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $549e4c3fcf3607ba$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $549e4c3fcf3607ba$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $0f49217316d01287$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $549e4c3fcf3607ba$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $549e4c3fcf3607ba$var$updateSel(state.selection, (range)=>{
        let tree = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state), stack = tree.resolveStack(range.from, 1);
        if (range.empty) {
            let stackBefore = tree.resolveStack(range.from, -1);
            if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to) stack = stackBefore;
        }
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && cur.next) return (0, $0f49217316d01287$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    if (selection.eq(state.selection)) return false;
    dispatch($549e4c3fcf3607ba$var$setSel(state, selection));
    return true;
};
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $549e4c3fcf3607ba$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).create([
        (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($549e4c3fcf3607ba$var$setSel(state, selection));
    return true;
};
function $549e4c3fcf3607ba$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $549e4c3fcf3607ba$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $549e4c3fcf3607ba$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $549e4c3fcf3607ba$var$skipAtomic(target, from, false);
            to = $549e4c3fcf3607ba$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $e1533ef606a339de$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $549e4c3fcf3607ba$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $e1533ef606a339de$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $e1533ef606a339de$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $549e4c3fcf3607ba$var$deleteByChar = (target, forward, byIndentUnit)=>$549e4c3fcf3607ba$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "\t") return pos - 1;
            let col = (0, $0f49217316d01287$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $8a0ff9d7afd8a874$export$ad3205d09311a797)(state) || (0, $8a0ff9d7afd8a874$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $549e4c3fcf3607ba$export$1e8a14efe7ca9a33 = (view)=>$549e4c3fcf3607ba$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $549e4c3fcf3607ba$export$3365c1d7b1abe7df = (view)=>$549e4c3fcf3607ba$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $549e4c3fcf3607ba$export$d41683a0f042cb80 = (view)=>$549e4c3fcf3607ba$var$deleteByChar(view, true, false);
const $549e4c3fcf3607ba$var$deleteByGroup = (target, forward)=>$549e4c3fcf3607ba$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $549e4c3fcf3607ba$export$3072f591ab219e94 = (target)=>$549e4c3fcf3607ba$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $549e4c3fcf3607ba$export$56a4e2ef21b58242 = (target)=>$549e4c3fcf3607ba$var$deleteByGroup(target, true);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $549e4c3fcf3607ba$export$ae3820c4ce0e9c92 = (view)=>$549e4c3fcf3607ba$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $549e4c3fcf3607ba$export$dc80e21fb31e84a5 = (view)=>$549e4c3fcf3607ba$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $549e4c3fcf3607ba$export$d1072494cede984a = (view)=>$549e4c3fcf3607ba$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $549e4c3fcf3607ba$export$b87eb3a389c264a4 = (view)=>$549e4c3fcf3607ba$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $549e4c3fcf3607ba$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $549e4c3fcf3607ba$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $549e4c3fcf3607ba$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $0f49217316d01287$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $549e4c3fcf3607ba$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $549e4c3fcf3607ba$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $549e4c3fcf3607ba$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $549e4c3fcf3607ba$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $549e4c3fcf3607ba$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$moveLine(state, dispatch, true);
function $549e4c3fcf3607ba$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $549e4c3fcf3607ba$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $549e4c3fcf3607ba$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $549e4c3fcf3607ba$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$549e4c3fcf3607ba$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $549e4c3fcf3607ba$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($549e4c3fcf3607ba$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $549e4c3fcf3607ba$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $549e4c3fcf3607ba$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $549e4c3fcf3607ba$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $549e4c3fcf3607ba$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $549e4c3fcf3607ba$export$668310d2b1aa07d5 = /*@__PURE__*/ $549e4c3fcf3607ba$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $549e4c3fcf3607ba$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $549e4c3fcf3607ba$var$newlineAndIndent(true);
function $549e4c3fcf3607ba$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $549e4c3fcf3607ba$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $8a0ff9d7afd8a874$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $8a0ff9d7afd8a874$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $0f49217316d01287$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $8a0ff9d7afd8a874$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $8a0ff9d7afd8a874$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $549e4c3fcf3607ba$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $549e4c3fcf3607ba$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $8a0ff9d7afd8a874$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $549e4c3fcf3607ba$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $8a0ff9d7afd8a874$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $8a0ff9d7afd8a874$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $549e4c3fcf3607ba$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($549e4c3fcf3607ba$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $8a0ff9d7afd8a874$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $549e4c3fcf3607ba$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($549e4c3fcf3607ba$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $0f49217316d01287$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $8a0ff9d7afd8a874$export$db5a40e207b40576)(state, Math.max(0, col - (0, $8a0ff9d7afd8a874$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $549e4c3fcf3607ba$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $549e4c3fcf3607ba$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $549e4c3fcf3607ba$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $549e4c3fcf3607ba$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("\t"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $549e4c3fcf3607ba$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $549e4c3fcf3607ba$export$3447f2b737925430,
        shift: $549e4c3fcf3607ba$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $549e4c3fcf3607ba$export$e45941411d098b,
        shift: $549e4c3fcf3607ba$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $549e4c3fcf3607ba$export$fe179dad0485d99d,
        shift: $549e4c3fcf3607ba$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $549e4c3fcf3607ba$export$75f9b75ffb1a9dc5,
        shift: $549e4c3fcf3607ba$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $549e4c3fcf3607ba$export$9c7dea99650bd512,
        shift: $549e4c3fcf3607ba$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $549e4c3fcf3607ba$export$2a3cdaf3ab2dcbf2,
        shift: $549e4c3fcf3607ba$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $549e4c3fcf3607ba$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $549e4c3fcf3607ba$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $549e4c3fcf3607ba$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $549e4c3fcf3607ba$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $549e4c3fcf3607ba$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $549e4c3fcf3607ba$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $549e4c3fcf3607ba$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter and Shift-Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $549e4c3fcf3607ba$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $549e4c3fcf3607ba$export$3447f2b737925430,
        shift: $549e4c3fcf3607ba$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $549e4c3fcf3607ba$export$137fb1611fb38377,
        shift: $549e4c3fcf3607ba$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $549e4c3fcf3607ba$export$515c8c77cfbd2e73,
        shift: $549e4c3fcf3607ba$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $549e4c3fcf3607ba$export$e45941411d098b,
        shift: $549e4c3fcf3607ba$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $549e4c3fcf3607ba$export$8fb2c619d55341b4,
        shift: $549e4c3fcf3607ba$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $549e4c3fcf3607ba$export$912e453a1e062a62,
        shift: $549e4c3fcf3607ba$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $549e4c3fcf3607ba$export$fe179dad0485d99d,
        shift: $549e4c3fcf3607ba$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $549e4c3fcf3607ba$export$ff7ed6e6e1cb317f,
        shift: $549e4c3fcf3607ba$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $549e4c3fcf3607ba$export$546ec71a9f854193,
        shift: $549e4c3fcf3607ba$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $549e4c3fcf3607ba$export$75f9b75ffb1a9dc5,
        shift: $549e4c3fcf3607ba$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $549e4c3fcf3607ba$export$b12ef1671b2836da,
        shift: $549e4c3fcf3607ba$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $549e4c3fcf3607ba$export$6e407c2072d437f4,
        shift: $549e4c3fcf3607ba$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $549e4c3fcf3607ba$export$546ec71a9f854193,
        shift: $549e4c3fcf3607ba$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $549e4c3fcf3607ba$export$6e407c2072d437f4,
        shift: $549e4c3fcf3607ba$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $549e4c3fcf3607ba$export$64939ebc49b03818,
        shift: $549e4c3fcf3607ba$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $549e4c3fcf3607ba$export$ff7ed6e6e1cb317f,
        shift: $549e4c3fcf3607ba$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $549e4c3fcf3607ba$export$b59ae3b25af6ea13,
        shift: $549e4c3fcf3607ba$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $549e4c3fcf3607ba$export$b12ef1671b2836da,
        shift: $549e4c3fcf3607ba$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $549e4c3fcf3607ba$export$668310d2b1aa07d5,
        shift: $549e4c3fcf3607ba$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $549e4c3fcf3607ba$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $549e4c3fcf3607ba$export$1e8a14efe7ca9a33,
        shift: $549e4c3fcf3607ba$export$1e8a14efe7ca9a33
    },
    {
        key: "Delete",
        run: $549e4c3fcf3607ba$export$d41683a0f042cb80
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $549e4c3fcf3607ba$export$3072f591ab219e94
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $549e4c3fcf3607ba$export$56a4e2ef21b58242
    },
    {
        mac: "Mod-Backspace",
        run: $549e4c3fcf3607ba$export$d1072494cede984a
    },
    {
        mac: "Mod-Delete",
        run: $549e4c3fcf3607ba$export$b87eb3a389c264a4
    }
].concat(/*@__PURE__*/ $549e4c3fcf3607ba$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $549e4c3fcf3607ba$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $549e4c3fcf3607ba$export$1e53c014543c10bb,
        shift: $549e4c3fcf3607ba$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $549e4c3fcf3607ba$export$62c6dc33f5d01e39,
        shift: $549e4c3fcf3607ba$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $549e4c3fcf3607ba$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $549e4c3fcf3607ba$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $549e4c3fcf3607ba$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $549e4c3fcf3607ba$export$1ad385c375816d2f
    },
    {
        key: "Escape",
        run: $549e4c3fcf3607ba$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $549e4c3fcf3607ba$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $549e4c3fcf3607ba$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $549e4c3fcf3607ba$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $549e4c3fcf3607ba$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $549e4c3fcf3607ba$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $549e4c3fcf3607ba$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $549e4c3fcf3607ba$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $549e4c3fcf3607ba$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $549e4c3fcf3607ba$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $549e4c3fcf3607ba$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $549e4c3fcf3607ba$export$f118650570e71643
    }
].concat($549e4c3fcf3607ba$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $549e4c3fcf3607ba$export$893b77570f8af4da = {
    key: "Tab",
    run: $549e4c3fcf3607ba$export$a61bf6a946ffc826,
    shift: $549e4c3fcf3607ba$export$e4b902122bfe67ae
};




function $09d37cb85a5251a0$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$09d37cb85a5251a0$var$add(elt, arguments[i]);
    return elt;
}
function $09d37cb85a5251a0$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$09d37cb85a5251a0$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


const $8eb9b703bb167589$var$basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class $8eb9b703bb167589$export$4989b254f32490be {
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, from = 0, to = text.length, normalize, test){
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        */ this.value = {
            from: 0,
            to: 0
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize($8eb9b703bb167589$var$basicNormalize(x)) : $8eb9b703bb167589$var$basicNormalize;
        this.query = this.normalize(query);
    }
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, $0f49217316d01287$export$42977f40461e1360)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            let next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            let str = (0, $0f49217316d01287$export$73bfc63873071f74)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, $0f49217316d01287$export$a870abf234f6353c)(next);
            let norm = this.normalize(str);
            if (norm.length) for(let i = 0, pos = start;; i++){
                let code = norm.charCodeAt(i);
                let match = this.match(code, pos, this.bufferPos + this.bufferStart);
                if (i == norm.length - 1) {
                    if (match) {
                        this.value = match;
                        return this;
                    }
                    break;
                }
                if (pos == start && i < str.length && str.charCodeAt(i) == code) pos++;
            }
        }
    }
    match(code, pos, end) {
        let match = null;
        for(let i = 0; i < this.matches.length; i += 2){
            let index = this.matches[i], keep = false;
            if (this.query.charCodeAt(index) == code) {
                if (index == this.query.length - 1) match = {
                    from: this.matches[i + 1],
                    to: end
                };
                else {
                    this.matches[i]++;
                    keep = true;
                }
            }
            if (!keep) {
                this.matches.splice(i, 2);
                i -= 2;
            }
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end
            };
            else this.matches.push(1, pos);
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
}
if (typeof Symbol != "undefined") $8eb9b703bb167589$export$4989b254f32490be.prototype[Symbol.iterator] = function() {
    return this;
};
const $8eb9b703bb167589$var$empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec("")
};
const $8eb9b703bb167589$var$baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class $8eb9b703bb167589$export$234e2283eb9dcd35 {
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, from = 0, to = text.length){
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match.
        */ this.value = $8eb9b703bb167589$var$empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new $8eb9b703bb167589$var$MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, $8eb9b703bb167589$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        let startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = $8eb9b703bb167589$var$toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(let off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            let match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                let from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = $8eb9b703bb167589$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
}
const $8eb9b703bb167589$var$flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class $8eb9b703bb167589$var$FlattenedDoc {
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        let cached = $8eb9b703bb167589$var$flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            let flat = new $8eb9b703bb167589$var$FlattenedDoc(from, doc.sliceString(from, to));
            $8eb9b703bb167589$var$flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        let { text: text, from: cachedFrom } = cached;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        $8eb9b703bb167589$var$flattened.set(doc, new $8eb9b703bb167589$var$FlattenedDoc(cachedFrom, text));
        return new $8eb9b703bb167589$var$FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
}
class $8eb9b703bb167589$var$MultilineRegExpCursor {
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = $8eb9b703bb167589$var$empty;
        this.matchPos = $8eb9b703bb167589$var$toCharEnd(text, from);
        this.re = new RegExp(query, $8eb9b703bb167589$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = $8eb9b703bb167589$var$FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            let off = this.re.lastIndex = this.matchPos - this.flat.from;
            let match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                let from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    this.matchPos = $8eb9b703bb167589$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = $8eb9b703bb167589$var$FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
}
if (typeof Symbol != "undefined") $8eb9b703bb167589$export$234e2283eb9dcd35.prototype[Symbol.iterator] = $8eb9b703bb167589$var$MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function $8eb9b703bb167589$var$validRegExp(source) {
    try {
        new RegExp(source, $8eb9b703bb167589$var$baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function $8eb9b703bb167589$var$toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    let line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
function $8eb9b703bb167589$var$createLineDialog(view) {
    let line = String(view.state.doc.lineAt(view.state.selection.main.head).number);
    let input = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
        class: "cm-textfield",
        name: "line",
        value: line
    });
    let dom = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("form", {
        class: "cm-gotoLine",
        onkeydown: (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                view.dispatch({
                    effects: $8eb9b703bb167589$var$dialogEffect.of(false)
                });
                view.focus();
            } else if (event.keyCode == 13) {
                event.preventDefault();
                go();
            }
        },
        onsubmit: (event)=>{
            event.preventDefault();
            go();
        }
    }, (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("label", view.state.phrase("Go to line"), ": ", input), " ", (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("button", {
        class: "cm-button",
        type: "submit"
    }, view.state.phrase("go")));
    function go() {
        let match = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
        if (!match) return;
        let { state: state } = view, startLine = state.doc.lineAt(state.selection.main.head);
        let [, sign, ln, cl, percent] = match;
        let col = cl ? +cl.slice(1) : 0;
        let line = ln ? +ln : startLine.number;
        if (ln && percent) {
            let pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        let selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                $8eb9b703bb167589$var$dialogEffect.of(false),
                (0, $e1533ef606a339de$export$eece2fccabbb77c5).scrollIntoView(selection.from, {
                    y: 'center'
                })
            ],
            selection: selection
        });
        view.focus();
    }
    return {
        dom: dom
    };
}
const $8eb9b703bb167589$var$dialogEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $8eb9b703bb167589$var$dialogField = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return true;
    },
    update (value, tr) {
        for (let e of tr.effects)if (e.is($8eb9b703bb167589$var$dialogEffect)) value = e.value;
        return value;
    },
    provide: (f)=>(0, $e1533ef606a339de$export$e89c3c9af31c1e3b).from(f, (val)=>val ? $8eb9b703bb167589$var$createLineDialog : null)
});
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ const $8eb9b703bb167589$export$5d5b784f9a618ec3 = (view)=>{
    let panel = (0, $e1533ef606a339de$export$7361ed18ff57179e)(view, $8eb9b703bb167589$var$createLineDialog);
    if (!panel) {
        let effects = [
            $8eb9b703bb167589$var$dialogEffect.of(true)
        ];
        if (view.state.field($8eb9b703bb167589$var$dialogField, false) == null) effects.push((0, $0f49217316d01287$export$95000d4efaa4321f).appendConfig.of([
            $8eb9b703bb167589$var$dialogField,
            $8eb9b703bb167589$var$baseTheme$1
        ]));
        view.dispatch({
            effects: effects
        });
        panel = (0, $e1533ef606a339de$export$7361ed18ff57179e)(view, $8eb9b703bb167589$var$createLineDialog);
    }
    if (panel) panel.dom.querySelector("input").select();
    return true;
};
const $8eb9b703bb167589$var$baseTheme$1 = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        "& label": {
            fontSize: "80%"
        }
    }
});
const $8eb9b703bb167589$var$defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
const $8eb9b703bb167589$var$highlightConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (options) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(options, $8eb9b703bb167589$var$defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function $8eb9b703bb167589$export$f14efe56171a2e02(options) {
    let ext = [
        $8eb9b703bb167589$var$defaultTheme,
        $8eb9b703bb167589$var$matchHighlighter
    ];
    if (options) ext.push($8eb9b703bb167589$var$highlightConfig.of(options));
    return ext;
}
const $8eb9b703bb167589$var$matchDeco = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch"
});
const $8eb9b703bb167589$var$mainMatchDeco = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function $8eb9b703bb167589$var$insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word);
}
// Whether the characters directly at the given positions are word characters
function $8eb9b703bb167589$var$insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, $0f49217316d01287$export$239a3d59567c1401).Word && check(state.sliceDoc(to - 1, to)) == (0, $0f49217316d01287$export$239a3d59567c1401).Word;
}
const $8eb9b703bb167589$var$matchHighlighter = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let conf = view.state.facet($8eb9b703bb167589$var$highlightConfig);
        let { state: state } = view, sel = state.selection;
        if (sel.ranges.length > 1) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
        let range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
            let word = state.wordAt(range.head);
            if (!word) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            let len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!($8eb9b703bb167589$var$insideWordBoundaries(check, state, range.from, range.to) && $8eb9b703bb167589$var$insideWord(check, state, range.from, range.to))) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
            }
        }
        let deco = [];
        for (let part of view.visibleRanges){
            let cursor = new $8eb9b703bb167589$export$4989b254f32490be(state.doc, query, part.from, part.to);
            while(!cursor.next().done){
                let { from: from, to: to } = cursor.value;
                if (!check || $8eb9b703bb167589$var$insideWordBoundaries(check, state, from, to)) {
                    if (range.empty && from <= range.from && to >= range.to) deco.push($8eb9b703bb167589$var$mainMatchDeco.range(from, to));
                    else if (from >= range.to || to <= range.from) deco.push($8eb9b703bb167589$var$matchDeco.range(from, to));
                    if (deco.length > conf.maxMatches) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
                }
            }
        }
        return (0, $e1533ef606a339de$export$10e30b733df217ea).set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
const $8eb9b703bb167589$var$defaultTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
const $8eb9b703bb167589$var$selectWord = ({ state: state, dispatch: dispatch })=>{
    let { selection: selection } = state;
    let newSel = (0, $0f49217316d01287$export$3bb1bd44aee62999).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function $8eb9b703bb167589$var$findNextOccurrence(state, query) {
    let { main: main, ranges: ranges } = state.selection;
    let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(let cycled = false, cursor = new $8eb9b703bb167589$export$4989b254f32490be(state.doc, query, ranges[ranges.length - 1].to);;){
        cursor.next();
        if (cursor.done) {
            if (cycled) return null;
            cursor = new $8eb9b703bb167589$export$4989b254f32490be(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled = true;
        } else {
            if (cycled && ranges.some((r)=>r.from == cursor.value.from)) continue;
            if (fullWord) {
                let word = state.wordAt(cursor.value.from);
                if (!word || word.from != cursor.value.from || word.to != cursor.value.to) continue;
            }
            return cursor.value;
        }
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ const $8eb9b703bb167589$export$dd0e64cebe05ee17 = ({ state: state, dispatch: dispatch })=>{
    let { ranges: ranges } = state.selection;
    if (ranges.some((sel)=>sel.from === sel.to)) return $8eb9b703bb167589$var$selectWord({
        state: state,
        dispatch: dispatch
    });
    let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    let range = $8eb9b703bb167589$var$findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.from, range.to), false),
        effects: (0, $e1533ef606a339de$export$eece2fccabbb77c5).scrollIntoView(range.to)
    }));
    return true;
};
const $8eb9b703bb167589$var$searchConfigFacet = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new $8eb9b703bb167589$var$SearchPanel(view),
            scrollToMatch: (range)=>(0, $e1533ef606a339de$export$eece2fccabbb77c5).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function $8eb9b703bb167589$export$d76128d007d19019(config) {
    return config ? [
        $8eb9b703bb167589$var$searchConfigFacet.of(config),
        $8eb9b703bb167589$var$searchExtensions
    ] : $8eb9b703bb167589$var$searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class $8eb9b703bb167589$export$4bc63ef50ec3954e {
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || $8eb9b703bb167589$var$validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
    }
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "\t" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new $8eb9b703bb167589$var$RegExpQuery(this) : new $8eb9b703bb167589$var$StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state, from = 0, to) {
        let st = state.doc ? state : (0, $0f49217316d01287$export$afa855cbfaff27f2).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? $8eb9b703bb167589$var$regexpCursor(this, st, from, to) : $8eb9b703bb167589$var$stringCursor(this, st, from, to);
    }
}
class $8eb9b703bb167589$var$QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function $8eb9b703bb167589$var$stringCursor(spec, state, from, to) {
    return new $8eb9b703bb167589$export$4989b254f32490be(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), spec.wholeWord ? $8eb9b703bb167589$var$stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : undefined);
}
function $8eb9b703bb167589$var$stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer($8eb9b703bb167589$var$charBefore(buf, from - bufPos)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word || categorizer($8eb9b703bb167589$var$charAfter(buf, from - bufPos)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) && (categorizer($8eb9b703bb167589$var$charAfter(buf, to - bufPos)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word || categorizer($8eb9b703bb167589$var$charBefore(buf, to - bufPos)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word);
    };
}
class $8eb9b703bb167589$var$StringQuery extends $8eb9b703bb167589$var$QueryType {
    constructor(spec){
        super(spec);
    }
    nextMatch(state, curFrom, curTo) {
        let cursor = $8eb9b703bb167589$var$stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) {
            let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
            cursor = $8eb9b703bb167589$var$stringCursor(this.spec, state, 0, end).nextOverlapping();
        }
        return cursor.done || cursor.value.from == curFrom && cursor.value.to == curTo ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(let pos = to;;){
            let start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            let cursor = $8eb9b703bb167589$var$stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        let found = this.prevMatchInRange(state, 0, curFrom);
        if (!found) found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
        return found && (found.from != curFrom || found.to != curTo) ? found : null;
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        let cursor = $8eb9b703bb167589$var$stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $8eb9b703bb167589$var$stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
function $8eb9b703bb167589$var$regexpCursor(spec, state, from, to) {
    return new $8eb9b703bb167589$export$234e2283eb9dcd35(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: spec.wholeWord ? $8eb9b703bb167589$var$regexpWordTest(state.charCategorizer(state.selection.main.head)) : undefined
    }, from, to);
}
function $8eb9b703bb167589$var$charBefore(str, index) {
    return str.slice((0, $0f49217316d01287$export$a0fa439fd515e1ed)(str, index, false), index);
}
function $8eb9b703bb167589$var$charAfter(str, index) {
    return str.slice(index, (0, $0f49217316d01287$export$a0fa439fd515e1ed)(str, index));
}
function $8eb9b703bb167589$var$regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer($8eb9b703bb167589$var$charBefore(match.input, match.index)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word || categorizer($8eb9b703bb167589$var$charAfter(match.input, match.index)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) && (categorizer($8eb9b703bb167589$var$charAfter(match.input, match.index + match[0].length)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word || categorizer($8eb9b703bb167589$var$charBefore(match.input, match.index + match[0].length)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word);
}
class $8eb9b703bb167589$var$RegExpQuery extends $8eb9b703bb167589$var$QueryType {
    nextMatch(state, curFrom, curTo) {
        let cursor = $8eb9b703bb167589$var$regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = $8eb9b703bb167589$var$regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(let size = 1;; size++){
            let start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            let cursor = $8eb9b703bb167589$var$regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (m, i)=>i == "$" ? "$" : i == "&" ? result.match[0] : i != "0" && +i < result.match.length ? result.match[i] : m);
    }
    matchAll(state, limit) {
        let cursor = $8eb9b703bb167589$var$regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $8eb9b703bb167589$var$regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ const $8eb9b703bb167589$export$2cd1e14773f5e71b = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $8eb9b703bb167589$var$togglePanel = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $8eb9b703bb167589$var$searchState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create (state) {
        return new $8eb9b703bb167589$var$SearchState($8eb9b703bb167589$var$defaultQuery(state).create(), null);
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($8eb9b703bb167589$export$2cd1e14773f5e71b)) value = new $8eb9b703bb167589$var$SearchState(effect.value.create(), value.panel);
            else if (effect.is($8eb9b703bb167589$var$togglePanel)) value = new $8eb9b703bb167589$var$SearchState(value.query, effect.value ? $8eb9b703bb167589$var$createSearchPanel : null);
        }
        return value;
    },
    provide: (f)=>(0, $e1533ef606a339de$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function $8eb9b703bb167589$export$1664b92369554829(state) {
    let curState = state.field($8eb9b703bb167589$var$searchState, false);
    return curState ? curState.query.spec : $8eb9b703bb167589$var$defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function $8eb9b703bb167589$export$453cecf1765eeb62(state) {
    var _a;
    return ((_a = state.field($8eb9b703bb167589$var$searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class $8eb9b703bb167589$var$SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
const $8eb9b703bb167589$var$matchMark = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-searchMatch"
}), $8eb9b703bb167589$var$selectedMatchMark = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
const $8eb9b703bb167589$var$searchHighlighter = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field($8eb9b703bb167589$var$searchState));
    }
    update(update) {
        let state = update.state.field($8eb9b703bb167589$var$searchState);
        if (state != update.startState.field($8eb9b703bb167589$var$searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight({ query: query, panel: panel }) {
        if (!panel || !query.spec.valid) return (0, $e1533ef606a339de$export$10e30b733df217ea).none;
        let { view: view } = this;
        let builder = new (0, $0f49217316d01287$export$89e09ce03c7e8594)();
        for(let i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++){
            let { from: from, to: to } = ranges[i];
            while(i < l - 1 && to > ranges[i + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i].to;
            query.highlight(view.state, from, to, (from, to)=>{
                let selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? $8eb9b703bb167589$var$selectedMatchMark : $8eb9b703bb167589$var$matchMark);
            });
        }
        return builder.finish();
    }
}, {
    decorations: (v)=>v.decorations
});
function $8eb9b703bb167589$var$searchCommand(f) {
    return (view)=>{
        let state = view.state.field($8eb9b703bb167589$var$searchState, false);
        return state && state.query.spec.valid ? f(view, state) : $8eb9b703bb167589$export$8894af164d40b422(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ const $8eb9b703bb167589$export$ebdf538520f8717 = /*@__PURE__*/ $8eb9b703bb167589$var$searchCommand((view, { query: query })=>{
    let { to: to } = view.state.selection.main;
    let next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    let selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(next.from, next.to);
    let config = view.state.facet($8eb9b703bb167589$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $8eb9b703bb167589$var$announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $8eb9b703bb167589$var$selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ const $8eb9b703bb167589$export$eef4841c27f82c55 = /*@__PURE__*/ $8eb9b703bb167589$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from } = state.selection.main;
    let prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    let selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(prev.from, prev.to);
    let config = view.state.facet($8eb9b703bb167589$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $8eb9b703bb167589$var$announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $8eb9b703bb167589$var$selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ const $8eb9b703bb167589$export$5d21cfc86ff1ce1d = /*@__PURE__*/ $8eb9b703bb167589$var$searchCommand((view, { query: query })=>{
    let ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges.map((r)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ const $8eb9b703bb167589$export$6f1c98d8556667b5 = ({ state: state, dispatch: dispatch })=>{
    let sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    let { from: from, to: to } = sel.main;
    let ranges = [], main = 0;
    for(let cur = new $8eb9b703bb167589$export$4989b254f32490be(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, $0f49217316d01287$export$3bb1bd44aee62999).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ const $8eb9b703bb167589$export$f9afe47535eaf3d2 = /*@__PURE__*/ $8eb9b703bb167589$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from, to: to } = state.selection.main;
    if (state.readOnly) return false;
    let match = query.nextMatch(state, from, from);
    if (!match) return false;
    let next = match;
    let changes = [], selection, replacement;
    let effects = [];
    if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, $e1533ef606a339de$export$eece2fccabbb77c5).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    if (next) {
        let off = changes.length == 0 || changes[0].from >= match.to ? 0 : match.to - match.from - replacement.length;
        selection = (0, $0f49217316d01287$export$3bb1bd44aee62999).single(next.from - off, next.to - off);
        effects.push($8eb9b703bb167589$var$announceMatch(view, next));
        effects.push(state.facet($8eb9b703bb167589$var$searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes: changes,
        selection: selection,
        effects: effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ const $8eb9b703bb167589$export$b8b3234b4edfc4c2 = /*@__PURE__*/ $8eb9b703bb167589$var$searchCommand((view, { query: query })=>{
    if (view.state.readOnly) return false;
    let changes = query.matchAll(view.state, 1e9).map((match)=>{
        let { from: from, to: to } = match;
        return {
            from: from,
            to: to,
            insert: query.getReplacement(match)
        };
    });
    if (!changes.length) return false;
    let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes: changes,
        effects: (0, $e1533ef606a339de$export$eece2fccabbb77c5).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function $8eb9b703bb167589$var$createSearchPanel(view) {
    return view.state.facet($8eb9b703bb167589$var$searchConfigFacet).createPanel(view);
}
function $8eb9b703bb167589$var$defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    let sel = state.selection.main;
    let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    let config = state.facet($8eb9b703bb167589$var$searchConfigFacet);
    return new $8eb9b703bb167589$export$4bc63ef50ec3954e({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function $8eb9b703bb167589$var$getSearchInput(view) {
    let panel = (0, $e1533ef606a339de$export$7361ed18ff57179e)(view, $8eb9b703bb167589$var$createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function $8eb9b703bb167589$var$selectSearchInput(view) {
    let input = $8eb9b703bb167589$var$getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ const $8eb9b703bb167589$export$8894af164d40b422 = (view)=>{
    let state = view.state.field($8eb9b703bb167589$var$searchState, false);
    if (state && state.panel) {
        let searchInput = $8eb9b703bb167589$var$getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            let query = $8eb9b703bb167589$var$defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: $8eb9b703bb167589$export$2cd1e14773f5e71b.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            $8eb9b703bb167589$var$togglePanel.of(true),
            state ? $8eb9b703bb167589$export$2cd1e14773f5e71b.of($8eb9b703bb167589$var$defaultQuery(view.state, state.query.spec)) : (0, $0f49217316d01287$export$95000d4efaa4321f).appendConfig.of($8eb9b703bb167589$var$searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ const $8eb9b703bb167589$export$4c389f3929badbb8 = (view)=>{
    let state = view.state.field($8eb9b703bb167589$var$searchState, false);
    if (!state || !state.panel) return false;
    let panel = (0, $e1533ef606a339de$export$7361ed18ff57179e)(view, $8eb9b703bb167589$var$createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: $8eb9b703bb167589$var$togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ const $8eb9b703bb167589$export$2dba96787cbe0a4a = [
    {
        key: "Mod-f",
        run: $8eb9b703bb167589$export$8894af164d40b422,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: $8eb9b703bb167589$export$ebdf538520f8717,
        shift: $8eb9b703bb167589$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: $8eb9b703bb167589$export$ebdf538520f8717,
        shift: $8eb9b703bb167589$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: $8eb9b703bb167589$export$4c389f3929badbb8,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: $8eb9b703bb167589$export$6f1c98d8556667b5
    },
    {
        key: "Mod-Alt-g",
        run: $8eb9b703bb167589$export$5d5b784f9a618ec3
    },
    {
        key: "Mod-d",
        run: $8eb9b703bb167589$export$dd0e64cebe05ee17,
        preventDefault: true
    }
];
class $8eb9b703bb167589$var$SearchPanel {
    constructor(view){
        this.view = view;
        let query = this.query = view.state.field($8eb9b703bb167589$var$searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
            value: query.search,
            placeholder: $8eb9b703bb167589$var$phrase(view, "Find"),
            "aria-label": $8eb9b703bb167589$var$phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
            value: query.replace,
            placeholder: $8eb9b703bb167589$var$phrase(view, "Replace"),
            "aria-label": $8eb9b703bb167589$var$phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("button", {
                class: "cm-button",
                name: name,
                onclick: onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>$8eb9b703bb167589$export$ebdf538520f8717(view), [
                $8eb9b703bb167589$var$phrase(view, "next")
            ]),
            button("prev", ()=>$8eb9b703bb167589$export$eef4841c27f82c55(view), [
                $8eb9b703bb167589$var$phrase(view, "previous")
            ]),
            button("select", ()=>$8eb9b703bb167589$export$5d21cfc86ff1ce1d(view), [
                $8eb9b703bb167589$var$phrase(view, "all")
            ]),
            (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("label", null, [
                this.caseField,
                $8eb9b703bb167589$var$phrase(view, "match case")
            ]),
            (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("label", null, [
                this.reField,
                $8eb9b703bb167589$var$phrase(view, "regexp")
            ]),
            (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("label", null, [
                this.wordField,
                $8eb9b703bb167589$var$phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("br"),
                this.replaceField,
                button("replace", ()=>$8eb9b703bb167589$export$f9afe47535eaf3d2(view), [
                    $8eb9b703bb167589$var$phrase(view, "replace")
                ]),
                button("replaceAll", ()=>$8eb9b703bb167589$export$b8b3234b4edfc4c2(view), [
                    $8eb9b703bb167589$var$phrase(view, "replace all")
                ])
            ],
            (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("button", {
                name: "close",
                onclick: ()=>$8eb9b703bb167589$export$4c389f3929badbb8(view),
                "aria-label": $8eb9b703bb167589$var$phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
    commit() {
        let query = new $8eb9b703bb167589$export$4bc63ef50ec3954e({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: $8eb9b703bb167589$export$2cd1e14773f5e71b.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, $e1533ef606a339de$export$bce154f45536286e)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? $8eb9b703bb167589$export$eef4841c27f82c55 : $8eb9b703bb167589$export$ebdf538520f8717)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            $8eb9b703bb167589$export$f9afe47535eaf3d2(this.view);
        }
    }
    update(update) {
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($8eb9b703bb167589$export$2cd1e14773f5e71b) && !effect.value.eq(this.query)) this.setQuery(effect.value);
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet($8eb9b703bb167589$var$searchConfigFacet).top;
    }
}
function $8eb9b703bb167589$var$phrase(view, phrase) {
    return view.state.phrase(phrase);
}
const $8eb9b703bb167589$var$AnnounceMargin = 30;
const $8eb9b703bb167589$var$Break = /[\s\.,:;?!]/;
function $8eb9b703bb167589$var$announceMatch(view, { from: from, to: to }) {
    let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    let start = Math.max(line.from, from - $8eb9b703bb167589$var$AnnounceMargin), end = Math.min(lineEnd, to + $8eb9b703bb167589$var$AnnounceMargin);
    let text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(let i = 0; i < $8eb9b703bb167589$var$AnnounceMargin; i++)if (!$8eb9b703bb167589$var$Break.test(text[i + 1]) && $8eb9b703bb167589$var$Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(let i = text.length - 1; i > text.length - $8eb9b703bb167589$var$AnnounceMargin; i--)if (!$8eb9b703bb167589$var$Break.test(text[i - 1]) && $8eb9b703bb167589$var$Break.test(text[i])) {
            text = text.slice(0, i);
            break;
        }
    }
    return (0, $e1533ef606a339de$export$eece2fccabbb77c5).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const $8eb9b703bb167589$var$baseTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
const $8eb9b703bb167589$var$searchExtensions = [
    $8eb9b703bb167589$var$searchState,
    /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).low($8eb9b703bb167589$var$searchHighlighter),
    $8eb9b703bb167589$var$baseTheme
];





/**
An instance of this is passed to completion source functions.
*/ class $5d769baac6d563a1$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit, /**
    The editor view. May be undefined if the context was created
    in a situation where there is no such view available, such as
    in synchronous updates via
    [`CompletionResult.update`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.update)
    or when called by test code.
    */ view){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        this.view = view;
        /**
        @internal
        */ this.abortListeners = [];
        /**
        @internal
        */ this.abortOnDocChange = false;
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($5d769baac6d563a1$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    
    By default, running queries will not be aborted for regular
    typing or backspacing, on the assumption that they are likely to
    return a result with a
    [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
    allows the result to be used after all. Passing `onDocChange:
    true` will cause this query to be aborted for any document
    change.
    */ addEventListener(type, listener, options) {
        if (type == "abort" && this.abortListeners) {
            this.abortListeners.push(listener);
            if (options && options.onDocChange) this.abortOnDocChange = true;
        }
    }
}
function $5d769baac6d563a1$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $5d769baac6d563a1$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $5d769baac6d563a1$var$toSet(first) + $5d769baac6d563a1$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $5d769baac6d563a1$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $5d769baac6d563a1$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $5d769baac6d563a1$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $5d769baac6d563a1$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $5d769baac6d563a1$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $5d769baac6d563a1$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $5d769baac6d563a1$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $5d769baac6d563a1$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $0f49217316d01287$export$9279461326b8700a).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $5d769baac6d563a1$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
            range: range
        };
        let lines = state.toText(text);
        return {
            changes: {
                from: range.from + fromOff,
                to: to == main.from ? range.to : range.from + toOff,
                insert: lines
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.from + fromOff + lines.length)
        };
    })), {
        scrollIntoView: true,
        userEvent: "input.complete"
    });
}
const $5d769baac6d563a1$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $5d769baac6d563a1$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $5d769baac6d563a1$var$SourceCache.get(source);
    if (!known) $5d769baac6d563a1$var$SourceCache.set(source, known = $5d769baac6d563a1$export$db0ee7d2648a0c4b(source));
    return known;
}
const $5d769baac6d563a1$var$startCompletionEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $5d769baac6d563a1$var$closeCompletionEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $5d769baac6d563a1$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $0f49217316d01287$export$42977f40461e1360)(pattern, p), size = (0, $0f49217316d01287$export$a870abf234f6353c)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $0f49217316d01287$export$42977f40461e1360)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $0f49217316d01287$export$42977f40461e1360)(word, 0), firstSize = (0, $0f49217316d01287$export$a870abf234f6353c)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $0f49217316d01287$export$42977f40461e1360)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $0f49217316d01287$export$a870abf234f6353c)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $0f49217316d01287$export$42977f40461e1360)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $0f49217316d01287$export$73bfc63873071f74)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $0f49217316d01287$export$a870abf234f6353c)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $0f49217316d01287$export$a870abf234f6353c)((0, $0f49217316d01287$export$42977f40461e1360)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
}
class $5d769baac6d563a1$var$StrictMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
}
const $5d769baac6d563a1$var$completionConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $5d769baac6d563a1$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>a.label.localeCompare(b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$5d769baac6d563a1$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$5d769baac6d563a1$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $5d769baac6d563a1$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $5d769baac6d563a1$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $e1533ef606a339de$export$cacd6541cfeeb6c1).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function $5d769baac6d563a1$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $5d769baac6d563a1$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $5d769baac6d563a1$var$CompletionTooltip {
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($5d769baac6d563a1$var$completionConfig);
        this.optionContent = $5d769baac6d563a1$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $5d769baac6d563a1$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($5d769baac6d563a1$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $5d769baac6d563a1$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $5d769baac6d563a1$var$rangeAroundSelected(options.length, selected, update.state.facet($5d769baac6d563a1$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $5d769baac6d563a1$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($5d769baac6d563a1$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        if (this.updateSelectedOption(open.selected)) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $e1533ef606a339de$export$f86b2a1a2ce291b3)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult, completion);
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) $5d769baac6d563a1$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let win = this.dom.ownerDocument.defaultView || window;
            space = {
                left: 0,
                top: 0,
                right: win.innerWidth,
                bottom: win.innerHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($5d769baac6d563a1$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
}
function $5d769baac6d563a1$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $5d769baac6d563a1$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $5d769baac6d563a1$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $5d769baac6d563a1$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $5d769baac6d563a1$var$sortOptions(active, state) {
    let options = [];
    let sections = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($5d769baac6d563a1$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $5d769baac6d563a1$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $5d769baac6d563a1$var$StrictMatcher(pattern) : new $5d769baac6d563a1$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                addOption(new $5d769baac6d563a1$var$Option(option, a.source, matched, match.score + (option.boost || 0)));
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            var _a, _b;
            return ((_a = a.rank) !== null && _a !== void 0 ? _a : 1e9) - ((_b = b.rank) !== null && _b !== void 0 ? _b : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($5d769baac6d563a1$var$score(opt.completion) > $5d769baac6d563a1$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $5d769baac6d563a1$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $5d769baac6d563a1$var$CompletionDialog(this.options, $5d769baac6d563a1$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf, didSetActive) {
        if (prev && !didSetActive && active.some((s)=>s.isPending)) return prev.setDisabled();
        let options = $5d769baac6d563a1$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.isPending) ? prev.setDisabled() : null;
        let selected = state.facet($5d769baac6d563a1$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $5d769baac6d563a1$var$CompletionDialog(options, $5d769baac6d563a1$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $5d769baac6d563a1$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $5d769baac6d563a1$var$CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected, this.disabled);
    }
    setDisabled() {
        return new $5d769baac6d563a1$var$CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
    }
}
class $5d769baac6d563a1$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $5d769baac6d563a1$var$CompletionState($5d769baac6d563a1$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($5d769baac6d563a1$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $5d769baac6d563a1$var$cur(state)).map($5d769baac6d563a1$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $5d769baac6d563a1$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open, didSet = tr.effects.some((e)=>e.is($5d769baac6d563a1$var$setActiveEffect));
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$5d769baac6d563a1$var$sameResults(active, this.active) || didSet) open = $5d769baac6d563a1$var$CompletionDialog.build(active, state, this.id, open, conf, didSet);
        else if (open && open.disabled && !active.some((a)=>a.isPending)) open = null;
        if (!open && active.every((a)=>!a.isPending) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $5d769baac6d563a1$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($5d769baac6d563a1$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $5d769baac6d563a1$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $5d769baac6d563a1$var$baseAttrs : $5d769baac6d563a1$var$noAttrs;
    }
}
function $5d769baac6d563a1$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult())iA++;
        while(iB < b.length && !b[iB].hasResult())iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $5d769baac6d563a1$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $5d769baac6d563a1$var$noAttrs = {};
function $5d769baac6d563a1$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $5d769baac6d563a1$var$none = [];
function $5d769baac6d563a1$var$getUpdateType(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($5d769baac6d563a1$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return 12 /* UpdateType.Reset */ ;
    }
    let typing = tr.isUserEvent("input.type");
    return typing && conf.activateOnTyping ? 5 /* UpdateType.Typing */  : typing ? 1 /* UpdateType.Typing */  : tr.isUserEvent("delete.backward") ? 2 /* UpdateType.Backspacing */  : tr.selection ? 8 /* UpdateType.Reset */  : tr.docChanged ? 16 /* UpdateType.ResetIfTouching */  : 0 /* UpdateType.None */ ;
}
class $5d769baac6d563a1$var$ActiveSource {
    constructor(source, state, explicit = false){
        this.source = source;
        this.state = state;
        this.explicit = explicit;
    }
    hasResult() {
        return false;
    }
    get isPending() {
        return this.state == 1 /* State.Pending */ ;
    }
    update(tr, conf) {
        let type = $5d769baac6d563a1$var$getUpdateType(tr, conf), value = this;
        if (type & 8 /* UpdateType.Reset */  || type & 16 /* UpdateType.ResetIfTouching */  && this.touches(tr)) value = new $5d769baac6d563a1$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        if (type & 4 /* UpdateType.Activate */  && value.state == 0 /* State.Inactive */ ) value = new $5d769baac6d563a1$var$ActiveSource(this.source, 1 /* State.Pending */ );
        value = value.updateFor(tr, type);
        for (let effect of tr.effects){
            if (effect.is($5d769baac6d563a1$var$startCompletionEffect)) value = new $5d769baac6d563a1$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value);
            else if (effect.is($5d769baac6d563a1$var$closeCompletionEffect)) value = new $5d769baac6d563a1$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($5d769baac6d563a1$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    updateFor(tr, type) {
        return this.map(tr.changes);
    }
    map(changes) {
        return this;
    }
    touches(tr) {
        return tr.changes.touchesRange($5d769baac6d563a1$var$cur(tr.state));
    }
}
class $5d769baac6d563a1$var$ActiveResult extends $5d769baac6d563a1$var$ActiveSource {
    constructor(source, explicit, limit, result, from, to){
        super(source, 3 /* State.Result */ , explicit);
        this.limit = limit;
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    updateFor(tr, type) {
        var _a;
        if (!(type & 3 /* UpdateType.SimpleInteraction */ )) return this.map(tr.changes);
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $5d769baac6d563a1$var$cur(tr.state);
        if (pos > to || !result || type & 2 /* UpdateType.Backspacing */  && ($5d769baac6d563a1$var$cur(tr.startState) == this.from || pos < this.limit)) return new $5d769baac6d563a1$var$ActiveSource(this.source, type & 4 /* UpdateType.Activate */  ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let limit = tr.changes.mapPos(this.limit);
        if ($5d769baac6d563a1$var$checkValid(result.validFor, tr.state, from, to)) return new $5d769baac6d563a1$var$ActiveResult(this.source, this.explicit, limit, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $5d769baac6d563a1$export$7b73e80391102dce(tr.state, pos, false)))) return new $5d769baac6d563a1$var$ActiveResult(this.source, this.explicit, limit, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $5d769baac6d563a1$var$cur(tr.state));
        return new $5d769baac6d563a1$var$ActiveSource(this.source, 1 /* State.Pending */ , this.explicit);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $5d769baac6d563a1$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $5d769baac6d563a1$var$ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    touches(tr) {
        return tr.changes.touchesRange(this.from, this.to);
    }
}
function $5d769baac6d563a1$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $5d769baac6d563a1$var$ensureAnchor(validFor, true).test(text);
}
const $5d769baac6d563a1$var$setActiveEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $5d769baac6d563a1$var$setSelectedEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $5d769baac6d563a1$var$completionState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return $5d769baac6d563a1$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $e1533ef606a339de$export$dba11b50e1aa3c12).from(f, (val)=>val.tooltip),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $5d769baac6d563a1$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($5d769baac6d563a1$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $5d769baac6d563a1$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch(Object.assign(Object.assign({}, $5d769baac6d563a1$export$496ff43229d73eba(view.state, apply, result.from, result.to)), {
        annotations: $5d769baac6d563a1$export$6c84d44c1ceeb831.of(option.completion)
    }));
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $5d769baac6d563a1$var$createTooltip = /*@__PURE__*/ $5d769baac6d563a1$var$completionTooltip($5d769baac6d563a1$var$completionState, $5d769baac6d563a1$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $5d769baac6d563a1$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($5d769baac6d563a1$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($5d769baac6d563a1$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $e1533ef606a339de$export$46455b4476d4b8e1)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $5d769baac6d563a1$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $5d769baac6d563a1$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($5d769baac6d563a1$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($5d769baac6d563a1$var$completionConfig).interactionDelay) return false;
    return $5d769baac6d563a1$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $5d769baac6d563a1$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($5d769baac6d563a1$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $5d769baac6d563a1$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $5d769baac6d563a1$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($5d769baac6d563a1$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $5d769baac6d563a1$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $5d769baac6d563a1$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $5d769baac6d563a1$var$MaxUpdateCount = 50, $5d769baac6d563a1$var$MinAbortTime = 1000;
const $5d769baac6d563a1$var$completionPlugin = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($5d769baac6d563a1$var$completionState).active)if (active.isPending) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($5d769baac6d563a1$var$completionState);
        let conf = update.state.facet($5d769baac6d563a1$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($5d769baac6d563a1$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            let type = $5d769baac6d563a1$var$getUpdateType(tr, conf);
            return type & 8 /* UpdateType.Reset */  || (tr.selection || tr.docChanged) && !(type & 3 /* UpdateType.SimpleInteraction */ );
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > $5d769baac6d563a1$var$MaxUpdateCount && Date.now() - query.time > $5d769baac6d563a1$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $e1533ef606a339de$export$f86b2a1a2ce291b3)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($5d769baac6d563a1$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.isPending && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if (tr.isUserEvent("input.type")) this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($5d769baac6d563a1$var$completionState);
        for (let active of cState.active)if (active.isPending && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
        if (this.running.length && cState.open && cState.open.disabled) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($5d769baac6d563a1$var$completionConfig).updateSyncTime);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $5d769baac6d563a1$var$cur(state);
        let context = new $5d769baac6d563a1$export$7b73e80391102dce(state, pos, active.explicit, this.view);
        let pending = new $5d769baac6d563a1$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $5d769baac6d563a1$var$closeCompletionEffect.of(null)
            });
            (0, $e1533ef606a339de$export$f86b2a1a2ce291b3)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($5d769baac6d563a1$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($5d769baac6d563a1$var$completionConfig), cState = this.view.state.field($5d769baac6d563a1$var$completionState);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let pos = $5d769baac6d563a1$var$cur(query.updates.length ? query.updates[0].startState : this.view.state);
                let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
                let active = new $5d769baac6d563a1$var$ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : pos);
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = cState.active.find((a)=>a.source == query.active.source);
            if (current && current.isPending) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $5d769baac6d563a1$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (!active.isPending) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length || cState.open && cState.open.disabled) this.view.dispatch({
            effects: $5d769baac6d563a1$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($5d769baac6d563a1$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($5d769baac6d563a1$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $e1533ef606a339de$export$46455b4476d4b8e1)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $5d769baac6d563a1$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $5d769baac6d563a1$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $5d769baac6d563a1$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $5d769baac6d563a1$var$commitCharacters = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).highest(/*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($5d769baac6d563a1$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($5d769baac6d563a1$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $5d769baac6d563a1$var$applyCompletion(view, option);
        return false;
    }
}));
const $5d769baac6d563a1$var$baseTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box",
        whiteSpace: "pre-line"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $5d769baac6d563a1$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $5d769baac6d563a1$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $0f49217316d01287$export$39cf3280165f92aa).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $0f49217316d01287$export$39cf3280165f92aa).TrackDel);
        return from == null || to == null ? null : new $5d769baac6d563a1$var$FieldRange(this.field, from, to);
    }
}
class $5d769baac6d563a1$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $8a0ff9d7afd8a874$export$9e0d0c2ce4d3ceb5));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $5d769baac6d563a1$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                positions.push(new $5d769baac6d563a1$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $5d769baac6d563a1$var$Snippet(lines, positions);
    }
}
let $5d769baac6d563a1$var$fieldMarker = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).widget({
    widget: /*@__PURE__*/ new class extends (0, $e1533ef606a339de$export$95cdd842edb044c5) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $5d769baac6d563a1$var$fieldRange = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-snippetField"
});
class $5d769baac6d563a1$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $e1533ef606a339de$export$10e30b733df217ea).set(ranges.map((r)=>(r.from == r.to ? $5d769baac6d563a1$var$fieldMarker : $5d769baac6d563a1$var$fieldRange).range(r.from, r.to)));
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $5d769baac6d563a1$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $5d769baac6d563a1$var$setActive = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $5d769baac6d563a1$var$moveToField = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $5d769baac6d563a1$var$snippetState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($5d769baac6d563a1$var$setActive)) return effect.value;
            if (effect.is($5d769baac6d563a1$var$moveToField) && value) return new $5d769baac6d563a1$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $e1533ef606a339de$export$eece2fccabbb77c5).decorations.from(f, (val)=>val ? val.deco : (0, $e1533ef606a339de$export$10e30b733df217ea).none)
});
function $5d769baac6d563a1$var$fieldSelection(ranges, field) {
    return (0, $0f49217316d01287$export$3bb1bd44aee62999).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $0f49217316d01287$export$3bb1bd44aee62999).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $5d769baac6d563a1$export$f77f1ac5bf251232(template) {
    let snippet = $5d769baac6d563a1$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let { main: main } = editor.state.selection;
        let spec = {
            changes: {
                from: from,
                to: to == main.from ? main.to : to,
                insert: (0, $0f49217316d01287$export$5f1af8db9871e1d6).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $5d769baac6d563a1$export$6c84d44c1ceeb831.of(completion),
                (0, $0f49217316d01287$export$febc5573c75cefb0).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $5d769baac6d563a1$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $5d769baac6d563a1$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $5d769baac6d563a1$var$setActive.of(active)
            ];
            if (editor.state.field($5d769baac6d563a1$var$snippetState, false) === undefined) effects.push((0, $0f49217316d01287$export$95000d4efaa4321f).appendConfig.of([
                $5d769baac6d563a1$var$snippetState,
                $5d769baac6d563a1$var$addSnippetKeymap,
                $5d769baac6d563a1$var$snippetPointerHandler,
                $5d769baac6d563a1$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $5d769baac6d563a1$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($5d769baac6d563a1$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $5d769baac6d563a1$var$fieldSelection(active.ranges, next),
            effects: $5d769baac6d563a1$var$setActive.of(last ? null : new $5d769baac6d563a1$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $5d769baac6d563a1$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($5d769baac6d563a1$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $5d769baac6d563a1$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $5d769baac6d563a1$export$d8da8fdad886df2f = /*@__PURE__*/ $5d769baac6d563a1$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $5d769baac6d563a1$export$8d02b23b64ec425c = /*@__PURE__*/ $5d769baac6d563a1$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $5d769baac6d563a1$export$9c250e449e4af222(state) {
    let active = state.field($5d769baac6d563a1$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $5d769baac6d563a1$export$ace2e22fa9996777(state) {
    let active = state.field($5d769baac6d563a1$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $5d769baac6d563a1$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $5d769baac6d563a1$export$d8da8fdad886df2f,
        shift: $5d769baac6d563a1$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $5d769baac6d563a1$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $5d769baac6d563a1$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (maps) {
        return maps.length ? maps[0] : $5d769baac6d563a1$var$defaultSnippetKeymap;
    }
});
const $5d769baac6d563a1$var$addSnippetKeymap = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).highest(/*@__PURE__*/ (0, $e1533ef606a339de$export$5043418e2ef368d5).compute([
    $5d769baac6d563a1$export$1808c2f24fc99b36
], (state)=>state.facet($5d769baac6d563a1$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $5d769baac6d563a1$export$975ef56e648d23ad(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: $5d769baac6d563a1$export$f77f1ac5bf251232(template)
    });
}
const $5d769baac6d563a1$var$snippetPointerHandler = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($5d769baac6d563a1$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $5d769baac6d563a1$var$fieldSelection(active.ranges, match.field),
            effects: $5d769baac6d563a1$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $5d769baac6d563a1$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $5d769baac6d563a1$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $5d769baac6d563a1$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $5d769baac6d563a1$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $5d769baac6d563a1$var$wordCache(wordChars) {
    return $5d769baac6d563a1$var$wordCaches[wordChars] || ($5d769baac6d563a1$var$wordCaches[wordChars] = new WeakMap);
}
function $5d769baac6d563a1$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $5d769baac6d563a1$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $5d769baac6d563a1$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $5d769baac6d563a1$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $5d769baac6d563a1$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $5d769baac6d563a1$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $5d769baac6d563a1$var$wordRE(wordChars);
    let token = context.matchBefore($5d769baac6d563a1$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $5d769baac6d563a1$var$collectWords(context.state.doc, $5d769baac6d563a1$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $5d769baac6d563a1$var$mapRE(re, (s)=>"^" + s)
    };
};
const $5d769baac6d563a1$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $5d769baac6d563a1$var$closeBracketEffect = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $0f49217316d01287$export$39cf3280165f92aa).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $5d769baac6d563a1$var$closedBracket = /*@__PURE__*/ new class extends (0, $0f49217316d01287$export$d60f08ed93a48611) {
};
$5d769baac6d563a1$var$closedBracket.startSide = 1;
$5d769baac6d563a1$var$closedBracket.endSide = -1;
const $5d769baac6d563a1$var$bracketState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return (0, $0f49217316d01287$export$34cb5241245008dd).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($5d769baac6d563a1$var$closeBracketEffect)) value = value.update({
            add: [
                $5d769baac6d563a1$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $5d769baac6d563a1$export$69e4e9d3300ff824() {
    return [
        $5d769baac6d563a1$var$inputHandler,
        $5d769baac6d563a1$var$bracketState
    ];
}
const $5d769baac6d563a1$var$definedClosing = "()[]{}<>";
function $5d769baac6d563a1$var$closing(ch) {
    for(let i = 0; i < $5d769baac6d563a1$var$definedClosing.length; i += 2)if ($5d769baac6d563a1$var$definedClosing.charCodeAt(i) == ch) return $5d769baac6d563a1$var$definedClosing.charAt(i + 1);
    return (0, $0f49217316d01287$export$73bfc63873071f74)(ch < 128 ? ch : ch + 1);
}
function $5d769baac6d563a1$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $5d769baac6d563a1$var$defaults;
}
const $5d769baac6d563a1$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $5d769baac6d563a1$var$inputHandler = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).inputHandler.of((view, from, to, insert)=>{
    if (($5d769baac6d563a1$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $0f49217316d01287$export$a870abf234f6353c)((0, $0f49217316d01287$export$42977f40461e1360)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $5d769baac6d563a1$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $5d769baac6d563a1$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $5d769baac6d563a1$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $5d769baac6d563a1$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $5d769baac6d563a1$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $5d769baac6d563a1$var$nextChar(state.doc, range.head) == $5d769baac6d563a1$var$closing((0, $0f49217316d01287$export$42977f40461e1360)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $5d769baac6d563a1$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $5d769baac6d563a1$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $5d769baac6d563a1$export$7ce1ae5219095222(state, bracket) {
    let conf = $5d769baac6d563a1$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $5d769baac6d563a1$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $5d769baac6d563a1$var$closing((0, $0f49217316d01287$export$42977f40461e1360)(tok, 0));
        if (bracket == tok) return closed == tok ? $5d769baac6d563a1$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $5d769baac6d563a1$var$handleOpen(state, tok, closed, conf.before || $5d769baac6d563a1$var$defaults.before);
        if (bracket == closed && $5d769baac6d563a1$var$closedBracketAt(state, state.selection.main.from)) return $5d769baac6d563a1$var$handleClose(state, tok, closed);
    }
    return null;
}
function $5d769baac6d563a1$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($5d769baac6d563a1$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $5d769baac6d563a1$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $0f49217316d01287$export$a870abf234f6353c)((0, $0f49217316d01287$export$42977f40461e1360)(next, 0)));
}
function $5d769baac6d563a1$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $0f49217316d01287$export$a870abf234f6353c)((0, $0f49217316d01287$export$42977f40461e1360)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $5d769baac6d563a1$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $5d769baac6d563a1$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $5d769baac6d563a1$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $5d769baac6d563a1$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $5d769baac6d563a1$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $5d769baac6d563a1$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $5d769baac6d563a1$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $5d769baac6d563a1$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $5d769baac6d563a1$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $5d769baac6d563a1$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($5d769baac6d563a1$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $5d769baac6d563a1$var$closeBracketEffect.of(pos + token.length),
                range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
            else if ($5d769baac6d563a1$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $5d769baac6d563a1$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $5d769baac6d563a1$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $5d769baac6d563a1$var$closeBracketEffect.of(pos + token.length),
            range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) {
            if ($5d769baac6d563a1$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$5d769baac6d563a1$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $5d769baac6d563a1$var$closeBracketEffect.of(pos + token.length),
                range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $5d769baac6d563a1$var$nodeStart(state, pos) {
    let tree = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $5d769baac6d563a1$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $5d769baac6d563a1$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $0f49217316d01287$export$239a3d59567c1401).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $5d769baac6d563a1$export$f95786d390465556(config = {}) {
    return [
        $5d769baac6d563a1$var$commitCharacters,
        $5d769baac6d563a1$var$completionState,
        $5d769baac6d563a1$var$completionConfig.of(config),
        $5d769baac6d563a1$var$completionPlugin,
        $5d769baac6d563a1$var$completionKeymapExt,
        $5d769baac6d563a1$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space (and Alt-\` on macOS): [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $5d769baac6d563a1$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $5d769baac6d563a1$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-`",
        run: $5d769baac6d563a1$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $5d769baac6d563a1$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $5d769baac6d563a1$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $5d769baac6d563a1$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $5d769baac6d563a1$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $5d769baac6d563a1$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $5d769baac6d563a1$export$537623a3380ccdae
    }
];
const $5d769baac6d563a1$var$completionKeymapExt = /*@__PURE__*/ (0, $0f49217316d01287$export$b92464a736444411).highest(/*@__PURE__*/ (0, $e1533ef606a339de$export$5043418e2ef368d5).computeN([
    $5d769baac6d563a1$var$completionConfig
], (state)=>state.facet($5d769baac6d563a1$var$completionConfig).defaultKeymap ? [
        $5d769baac6d563a1$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $5d769baac6d563a1$export$9eb35bf27959eae5(state) {
    let cState = state.field($5d769baac6d563a1$var$completionState, false);
    return cState && cState.active.some((a)=>a.isPending) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $5d769baac6d563a1$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $5d769baac6d563a1$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($5d769baac6d563a1$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $5d769baac6d563a1$var$completionArrayCache.get(open.options);
    if (!completions) $5d769baac6d563a1$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $5d769baac6d563a1$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($5d769baac6d563a1$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $5d769baac6d563a1$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($5d769baac6d563a1$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $5d769baac6d563a1$export$64a726c2de6175b8(index) {
    return $5d769baac6d563a1$var$setSelectedEffect.of(index);
}





class $a1d5d2ed45a1681c$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $a1d5d2ed45a1681c$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let markedDiagnostics = diagnostics;
        let diagnosticFilter = state.facet($a1d5d2ed45a1681c$var$lintConfig).markerFilter;
        if (diagnosticFilter) markedDiagnostics = diagnosticFilter(markedDiagnostics, state);
        let sorted = diagnostics.slice().sort((a, b)=>a.from - b.from || a.to - b.to);
        let deco = new (0, $0f49217316d01287$export$89e09ce03c7e8594)(), active = [], pos = 0;
        for(let i = 0;;){
            let next = i == sorted.length ? null : sorted[i];
            if (!next && !active.length) break;
            let from, to;
            if (active.length) {
                from = pos;
                to = active.reduce((p, d)=>Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
            } else {
                from = next.from;
                to = next.to;
                active.push(next);
                i++;
            }
            while(i < sorted.length){
                let next = sorted[i];
                if (next.from == from && (next.to > next.from || next.to == from)) {
                    active.push(next);
                    i++;
                    to = Math.min(next.to, to);
                } else {
                    to = Math.min(next.from, to);
                    break;
                }
            }
            let sev = $a1d5d2ed45a1681c$var$maxSeverity(active);
            if (active.some((d)=>d.from == d.to || d.from == d.to - 1 && state.doc.lineAt(d.from).to == d.from)) deco.add(from, from, (0, $e1533ef606a339de$export$10e30b733df217ea).widget({
                widget: new $a1d5d2ed45a1681c$var$DiagnosticWidget(sev),
                diagnostics: active.slice()
            }));
            else {
                let markClass = active.reduce((c, d)=>d.markClass ? c + " " + d.markClass : c, "");
                deco.add(from, to, (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
                    class: "cm-lintRange cm-lintRange-" + sev + markClass,
                    diagnostics: active.slice(),
                    inclusiveEnd: active.some((a)=>a.to > to)
                }));
            }
            pos = to;
            for(let i = 0; i < active.length; i++)if (active[i].to <= pos) active.splice(i--, 1);
        }
        let set = deco.finish();
        return new $a1d5d2ed45a1681c$var$LintState(set, panel, $a1d5d2ed45a1681c$var$findDiagnostic(set));
    }
}
function $a1d5d2ed45a1681c$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0) return;
        if (!found) found = new $a1d5d2ed45a1681c$var$SelectedDiagnostic(from, to, diagnostic || spec.diagnostics[0]);
        else if (spec.diagnostics.indexOf(found.diagnostic) < 0) return false;
        else found = new $a1d5d2ed45a1681c$var$SelectedDiagnostic(found.from, to, found.diagnostic);
    });
    return found;
}
function $a1d5d2ed45a1681c$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($a1d5d2ed45a1681c$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($a1d5d2ed45a1681c$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $a1d5d2ed45a1681c$var$maybeEnableLint(state, effects) {
    return state.field($a1d5d2ed45a1681c$var$lintState, false) ? effects : effects.concat((0, $0f49217316d01287$export$95000d4efaa4321f).appendConfig.of($a1d5d2ed45a1681c$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $a1d5d2ed45a1681c$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $a1d5d2ed45a1681c$var$maybeEnableLint(state, [
            $a1d5d2ed45a1681c$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $a1d5d2ed45a1681c$export$9c7976977981c7bf = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $a1d5d2ed45a1681c$var$togglePanel = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $a1d5d2ed45a1681c$var$movePanelSelection = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $a1d5d2ed45a1681c$var$lintState = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return new $a1d5d2ed45a1681c$var$LintState((0, $e1533ef606a339de$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $a1d5d2ed45a1681c$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $a1d5d2ed45a1681c$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($a1d5d2ed45a1681c$var$lintConfig).autoPanel) panel = null;
            value = new $a1d5d2ed45a1681c$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($a1d5d2ed45a1681c$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($a1d5d2ed45a1681c$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $a1d5d2ed45a1681c$var$LintPanel.open : null;
                value = $a1d5d2ed45a1681c$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($a1d5d2ed45a1681c$var$togglePanel)) value = new $a1d5d2ed45a1681c$var$LintState(value.diagnostics, effect.value ? $a1d5d2ed45a1681c$var$LintPanel.open : null, value.selected);
            else if (effect.is($a1d5d2ed45a1681c$var$movePanelSelection)) value = new $a1d5d2ed45a1681c$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $e1533ef606a339de$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $a1d5d2ed45a1681c$export$31ce51ade4a789ff(state) {
    let lint = state.field($a1d5d2ed45a1681c$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $a1d5d2ed45a1681c$var$activeMark = /*@__PURE__*/ (0, $e1533ef606a339de$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $a1d5d2ed45a1681c$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($a1d5d2ed45a1681c$var$lintState);
    let found, start = -1, end = -1;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found = spec.diagnostics;
            start = from;
            end = to;
            return false;
        }
    });
    let diagnosticFilter = view.state.facet($a1d5d2ed45a1681c$var$lintConfig).tooltipFilter;
    if (found && diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found) return null;
    return {
        pos: start,
        end: end,
        above: view.state.doc.lineAt(start).to < end,
        create () {
            return {
                dom: $a1d5d2ed45a1681c$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $a1d5d2ed45a1681c$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$a1d5d2ed45a1681c$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $a1d5d2ed45a1681c$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($a1d5d2ed45a1681c$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $a1d5d2ed45a1681c$var$maybeEnableLint(view.state, [
            $a1d5d2ed45a1681c$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $e1533ef606a339de$export$7361ed18ff57179e)(view, $a1d5d2ed45a1681c$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $a1d5d2ed45a1681c$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($a1d5d2ed45a1681c$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $a1d5d2ed45a1681c$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $a1d5d2ed45a1681c$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($a1d5d2ed45a1681c$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
    if (!next.value) {
        next = field.diagnostics.iter(0);
        if (!next.value || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $a1d5d2ed45a1681c$export$f71c1dd1430b5cc1 = (view)=>{
    let { state: state } = view, field = state.field($a1d5d2ed45a1681c$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    view.dispatch({
        selection: {
            anchor: prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom,
            head: prevTo !== null && prevTo !== void 0 ? prevTo : lastTo
        },
        scrollIntoView: true
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $a1d5d2ed45a1681c$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $a1d5d2ed45a1681c$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $a1d5d2ed45a1681c$export$79abb131646e1359
    }
];
const $a1d5d2ed45a1681c$var$lintPlugin = /*@__PURE__*/ (0, $e1533ef606a339de$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($a1d5d2ed45a1681c$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($a1d5d2ed45a1681c$var$lintConfig);
            if (sources.length) $a1d5d2ed45a1681c$var$batchResults(sources.map((s)=>Promise.resolve(s(this.view))), (annotations)=>{
                if (this.view.state.doc == state.doc) this.view.dispatch($a1d5d2ed45a1681c$export$188c3c6ceeec4bb3(this.view.state, annotations.reduce((a, b)=>a.concat(b))));
            }, (error)=>{
                (0, $e1533ef606a339de$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($a1d5d2ed45a1681c$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($a1d5d2ed45a1681c$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
function $a1d5d2ed45a1681c$var$batchResults(promises, sink, error) {
    let collected = [], timeout = -1;
    for (let p of promises)p.then((value)=>{
        collected.push(value);
        clearTimeout(timeout);
        if (collected.length == promises.length) sink(collected);
        else timeout = setTimeout(()=>sink(collected), 200);
    }, error);
}
const $a1d5d2ed45a1681c$var$lintConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return Object.assign({
            sources: input.map((i)=>i.source).filter((x)=>x != null)
        }, (0, $0f49217316d01287$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
            delay: 750,
            markerFilter: null,
            tooltipFilter: null,
            needsRefresh: null,
            hideOn: ()=>null
        }, {
            needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u)
        }));
    }
});
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed). If `null` is given as
source, this only configures the lint extension.
*/ function $a1d5d2ed45a1681c$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $a1d5d2ed45a1681c$var$lintConfig.of({
            source: source,
            config: config
        }),
        $a1d5d2ed45a1681c$var$lintPlugin,
        $a1d5d2ed45a1681c$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $a1d5d2ed45a1681c$export$e917f1893924e285(view) {
    let plugin = view.plugin($a1d5d2ed45a1681c$var$lintPlugin);
    if (plugin) plugin.force();
}
function $a1d5d2ed45a1681c$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $a1d5d2ed45a1681c$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $a1d5d2ed45a1681c$var$assignKeys(diagnostic.actions) : [];
    return (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $a1d5d2ed45a1681c$var$findDiagnostic(view.state.field($a1d5d2ed45a1681c$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        return (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction",
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $a1d5d2ed45a1681c$var$DiagnosticWidget extends (0, $e1533ef606a339de$export$95cdd842edb044c5) {
    constructor(sev){
        super();
        this.sev = sev;
    }
    eq(other) {
        return other.sev == this.sev;
    }
    toDOM() {
        return (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.sev
        });
    }
}
class $a1d5d2ed45a1681c$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $a1d5d2ed45a1681c$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $a1d5d2ed45a1681c$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.keyCode == 27) {
                $a1d5d2ed45a1681c$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $a1d5d2ed45a1681c$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $a1d5d2ed45a1681c$var$findDiagnostic(this.view.state.field($a1d5d2ed45a1681c$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $09d37cb85a5251a0$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$a1d5d2ed45a1681c$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($a1d5d2ed45a1681c$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($a1d5d2ed45a1681c$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        let seen = new Set();
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            for (let diagnostic of spec.diagnostics){
                if (seen.has(diagnostic)) continue;
                seen.add(diagnostic);
                let found = -1, item;
                for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == diagnostic) {
                    found = j;
                    break;
                }
                if (found < 0) {
                    item = new $a1d5d2ed45a1681c$var$PanelItem(this.view, diagnostic);
                    this.items.splice(i, 0, item);
                    needsSync = true;
                } else {
                    item = this.items[found];
                    if (found > i) {
                        this.items.splice(i, found - i);
                        needsSync = true;
                    }
                }
                if (selected && item.diagnostic == selected.diagnostic) {
                    if (!item.dom.hasAttribute("aria-selected")) {
                        item.dom.setAttribute("aria-selected", "true");
                        newSelectedItem = item;
                    }
                } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
                i++;
            }
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $a1d5d2ed45a1681c$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($a1d5d2ed45a1681c$var$lintState);
        let selection = $a1d5d2ed45a1681c$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $a1d5d2ed45a1681c$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $a1d5d2ed45a1681c$var$LintPanel(view);
    }
}
function $a1d5d2ed45a1681c$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $a1d5d2ed45a1681c$var$underline(color) {
    return $a1d5d2ed45a1681c$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $a1d5d2ed45a1681c$var$baseTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $a1d5d2ed45a1681c$var$underline("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $a1d5d2ed45a1681c$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $a1d5d2ed45a1681c$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $a1d5d2ed45a1681c$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function $a1d5d2ed45a1681c$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function $a1d5d2ed45a1681c$var$maxSeverity(diagnostics) {
    let sev = "hint", weight = 1;
    for (let d of diagnostics){
        let w = $a1d5d2ed45a1681c$var$severityWeight(d.severity);
        if (w > weight) {
            weight = w;
            sev = d.severity;
        }
    }
    return sev;
}
class $a1d5d2ed45a1681c$var$LintGutterMarker extends (0, $e1533ef606a339de$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = $a1d5d2ed45a1681c$var$maxSeverity(diagnostics);
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($a1d5d2ed45a1681c$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$a1d5d2ed45a1681c$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $a1d5d2ed45a1681c$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($a1d5d2ed45a1681c$var$lintGutterTooltip)) view.dispatch({
            effects: $a1d5d2ed45a1681c$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $a1d5d2ed45a1681c$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $a1d5d2ed45a1681c$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                clip: false,
                create () {
                    return {
                        dom: $a1d5d2ed45a1681c$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $a1d5d2ed45a1681c$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($a1d5d2ed45a1681c$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $a1d5d2ed45a1681c$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $a1d5d2ed45a1681c$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $0f49217316d01287$export$34cb5241245008dd).of(markers, true);
}
const $a1d5d2ed45a1681c$var$lintGutterExtension = /*@__PURE__*/ (0, $e1533ef606a339de$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($a1d5d2ed45a1681c$var$lintGutterMarkers),
    widgetMarker: (view, widget, block)=>{
        let diagnostics = [];
        view.state.field($a1d5d2ed45a1681c$var$lintGutterMarkers).between(block.from, block.to, (from, to, value)=>{
            if (from > block.from && from < block.to) diagnostics.push(...value.diagnostics);
        });
        return diagnostics.length ? new $a1d5d2ed45a1681c$var$LintGutterMarker(diagnostics) : null;
    }
});
const $a1d5d2ed45a1681c$var$lintGutterMarkers = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return (0, $0f49217316d01287$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($a1d5d2ed45a1681c$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($a1d5d2ed45a1681c$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $a1d5d2ed45a1681c$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $a1d5d2ed45a1681c$var$setLintGutterTooltip = /*@__PURE__*/ (0, $0f49217316d01287$export$95000d4efaa4321f).define();
const $a1d5d2ed45a1681c$var$lintGutterTooltip = /*@__PURE__*/ (0, $0f49217316d01287$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $a1d5d2ed45a1681c$var$hideTooltip(tr, tooltip) ? null : Object.assign(Object.assign({}, tooltip), {
            pos: tr.changes.mapPos(tooltip.pos)
        });
        return tr.effects.reduce((t, e)=>e.is($a1d5d2ed45a1681c$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $e1533ef606a339de$export$dba11b50e1aa3c12).from(field)
});
const $a1d5d2ed45a1681c$var$lintGutterTheme = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $a1d5d2ed45a1681c$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $a1d5d2ed45a1681c$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $a1d5d2ed45a1681c$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $a1d5d2ed45a1681c$var$lintExtensions = [
    $a1d5d2ed45a1681c$var$lintState,
    /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).decorations.compute([
        $a1d5d2ed45a1681c$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($a1d5d2ed45a1681c$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $e1533ef606a339de$export$10e30b733df217ea).none : (0, $e1533ef606a339de$export$10e30b733df217ea).set([
            $a1d5d2ed45a1681c$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    /*@__PURE__*/ (0, $e1533ef606a339de$export$69f8d9e63c4aa884)($a1d5d2ed45a1681c$var$lintTooltip, {
        hideOn: $a1d5d2ed45a1681c$var$hideTooltip
    }),
    $a1d5d2ed45a1681c$var$baseTheme
];
const $a1d5d2ed45a1681c$var$lintGutterConfig = /*@__PURE__*/ (0, $0f49217316d01287$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $0f49217316d01287$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $a1d5d2ed45a1681c$export$3a68dabf7c007d32(config = {}) {
    return [
        $a1d5d2ed45a1681c$var$lintGutterConfig.of(config),
        $a1d5d2ed45a1681c$var$lintGutterMarkers,
        $a1d5d2ed45a1681c$var$lintGutterExtension,
        $a1d5d2ed45a1681c$var$lintGutterTheme,
        $a1d5d2ed45a1681c$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $a1d5d2ed45a1681c$export$7991d57589868fb2(state, f) {
    let lState = state.field($a1d5d2ed45a1681c$var$lintState, false);
    if (lState && lState.diagnostics.size) {
        let pending = [], pendingStart = [], lastEnd = -1;
        for(let iter = (0, $0f49217316d01287$export$34cb5241245008dd).iter([
            lState.diagnostics
        ]);; iter.next()){
            for(let i = 0; i < pending.length; i++)if (!iter.value || iter.value.spec.diagnostics.indexOf(pending[i]) < 0) {
                f(pending[i], pendingStart[i], lastEnd);
                pending.splice(i, 1);
                pendingStart.splice(i--, 1);
            }
            if (!iter.value) break;
            for (let d of iter.value.spec.diagnostics)if (pending.indexOf(d) < 0) {
                pending.push(d);
                pendingStart.push(iter.from);
            }
            lastEnd = iter.to;
        }
    }
}


// (The superfluous function calls around the list of extensions work
// around current limitations in tree-shaking software.)
/**
This is an extension value that just pulls together a number of
extensions that you might want in a basic editor. It is meant as a
convenient helper to quickly set up CodeMirror without installing
and importing a lot of separate packages.

Specifically, it includes...

 - [the default command bindings](https://codemirror.net/6/docs/ref/#commands.defaultKeymap)
 - [line numbers](https://codemirror.net/6/docs/ref/#view.lineNumbers)
 - [special character highlighting](https://codemirror.net/6/docs/ref/#view.highlightSpecialChars)
 - [the undo history](https://codemirror.net/6/docs/ref/#commands.history)
 - [a fold gutter](https://codemirror.net/6/docs/ref/#language.foldGutter)
 - [custom selection drawing](https://codemirror.net/6/docs/ref/#view.drawSelection)
 - [drop cursor](https://codemirror.net/6/docs/ref/#view.dropCursor)
 - [multiple selections](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
 - [reindentation on input](https://codemirror.net/6/docs/ref/#language.indentOnInput)
 - [the default highlight style](https://codemirror.net/6/docs/ref/#language.defaultHighlightStyle) (as fallback)
 - [bracket matching](https://codemirror.net/6/docs/ref/#language.bracketMatching)
 - [bracket closing](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets)
 - [autocompletion](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion)
 - [rectangular selection](https://codemirror.net/6/docs/ref/#view.rectangularSelection) and [crosshair cursor](https://codemirror.net/6/docs/ref/#view.crosshairCursor)
 - [active line highlighting](https://codemirror.net/6/docs/ref/#view.highlightActiveLine)
 - [active line gutter highlighting](https://codemirror.net/6/docs/ref/#view.highlightActiveLineGutter)
 - [selection match highlighting](https://codemirror.net/6/docs/ref/#search.highlightSelectionMatches)
 - [search](https://codemirror.net/6/docs/ref/#search.searchKeymap)
 - [linting](https://codemirror.net/6/docs/ref/#lint.lintKeymap)

(You'll probably want to add some language package to your setup
too.)

This extension does not allow customization. The idea is that,
once you decide you want to configure your editor more precisely,
you take this package's source (which is just a bunch of imports
and an array literal), copy it into your own code, and adjust it
as desired.
*/ const $ae72bdec652266e7$export$f4f2465c1e83499c = /*@__PURE__*/ (()=>[
        (0, $e1533ef606a339de$export$1a8cf111682eaa7d)(),
        (0, $e1533ef606a339de$export$93b52f08bb2c759c)(),
        (0, $e1533ef606a339de$export$76dc0899547f659c)(),
        (0, $549e4c3fcf3607ba$export$55abd4691b317664)(),
        (0, $8a0ff9d7afd8a874$export$c4dcf64f741b6228)(),
        (0, $e1533ef606a339de$export$17a3d0ab3687347d)(),
        (0, $e1533ef606a339de$export$b8e3092a3bfa2062)(),
        (0, $0f49217316d01287$export$afa855cbfaff27f2).allowMultipleSelections.of(true),
        (0, $8a0ff9d7afd8a874$export$9bcaf6e2125ee117)(),
        (0, $8a0ff9d7afd8a874$export$ec1b956ff3a16361)((0, $8a0ff9d7afd8a874$export$bb02a6818dd48320), {
            fallback: true
        }),
        (0, $8a0ff9d7afd8a874$export$cef7edfd214be605)(),
        (0, $5d769baac6d563a1$export$69e4e9d3300ff824)(),
        (0, $5d769baac6d563a1$export$f95786d390465556)(),
        (0, $e1533ef606a339de$export$dd482925db1aabd3)(),
        (0, $e1533ef606a339de$export$9b6525222ac3b7fb)(),
        (0, $e1533ef606a339de$export$1a7e096bee9035c)(),
        (0, $8eb9b703bb167589$export$f14efe56171a2e02)(),
        (0, $e1533ef606a339de$export$5043418e2ef368d5).of([
            ...(0, $5d769baac6d563a1$export$9477e95792b48f4a),
            ...(0, $549e4c3fcf3607ba$export$ab2e8d0ac5d2b69e),
            ...(0, $8eb9b703bb167589$export$2dba96787cbe0a4a),
            ...(0, $549e4c3fcf3607ba$export$ab4a28cb63e8a670),
            ...(0, $8a0ff9d7afd8a874$export$39c52376a8936d67),
            ...(0, $5d769baac6d563a1$export$2a3d759d156afab4),
            ...(0, $a1d5d2ed45a1681c$export$a21d7a0cde3cbb60)
        ])
    ])();
/**
A minimal set of extensions to create a functional editor. Only
includes [the default keymap](https://codemirror.net/6/docs/ref/#commands.defaultKeymap), [undo
history](https://codemirror.net/6/docs/ref/#commands.history), [special character
highlighting](https://codemirror.net/6/docs/ref/#view.highlightSpecialChars), [custom selection
drawing](https://codemirror.net/6/docs/ref/#view.drawSelection), and [default highlight
style](https://codemirror.net/6/docs/ref/#language.defaultHighlightStyle).
*/ const $ae72bdec652266e7$export$def279f8e103ce59 = /*@__PURE__*/ (()=>[
        (0, $e1533ef606a339de$export$76dc0899547f659c)(),
        (0, $549e4c3fcf3607ba$export$55abd4691b317664)(),
        (0, $e1533ef606a339de$export$17a3d0ab3687347d)(),
        (0, $8a0ff9d7afd8a874$export$ec1b956ff3a16361)((0, $8a0ff9d7afd8a874$export$bb02a6818dd48320), {
            fallback: true
        }),
        (0, $e1533ef606a339de$export$5043418e2ef368d5).of([
            ...(0, $549e4c3fcf3607ba$export$ab2e8d0ac5d2b69e),
            ...(0, $549e4c3fcf3607ba$export$ab4a28cb63e8a670)
        ])
    ])();



var $6f9b0422bf2ae8bc$exports = {};
// shim for using process in browser
var $6f9b0422bf2ae8bc$var$process = $6f9b0422bf2ae8bc$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6f9b0422bf2ae8bc$var$cachedSetTimeout;
var $6f9b0422bf2ae8bc$var$cachedClearTimeout;
function $6f9b0422bf2ae8bc$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $6f9b0422bf2ae8bc$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $6f9b0422bf2ae8bc$var$cachedSetTimeout = setTimeout;
        else $6f9b0422bf2ae8bc$var$cachedSetTimeout = $6f9b0422bf2ae8bc$var$defaultSetTimout;
    } catch (e) {
        $6f9b0422bf2ae8bc$var$cachedSetTimeout = $6f9b0422bf2ae8bc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $6f9b0422bf2ae8bc$var$cachedClearTimeout = clearTimeout;
        else $6f9b0422bf2ae8bc$var$cachedClearTimeout = $6f9b0422bf2ae8bc$var$defaultClearTimeout;
    } catch (e) {
        $6f9b0422bf2ae8bc$var$cachedClearTimeout = $6f9b0422bf2ae8bc$var$defaultClearTimeout;
    }
})();
function $6f9b0422bf2ae8bc$var$runTimeout(fun) {
    if ($6f9b0422bf2ae8bc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6f9b0422bf2ae8bc$var$cachedSetTimeout === $6f9b0422bf2ae8bc$var$defaultSetTimout || !$6f9b0422bf2ae8bc$var$cachedSetTimeout) && setTimeout) {
        $6f9b0422bf2ae8bc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6f9b0422bf2ae8bc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6f9b0422bf2ae8bc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6f9b0422bf2ae8bc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6f9b0422bf2ae8bc$var$runClearTimeout(marker) {
    if ($6f9b0422bf2ae8bc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6f9b0422bf2ae8bc$var$cachedClearTimeout === $6f9b0422bf2ae8bc$var$defaultClearTimeout || !$6f9b0422bf2ae8bc$var$cachedClearTimeout) && clearTimeout) {
        $6f9b0422bf2ae8bc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6f9b0422bf2ae8bc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6f9b0422bf2ae8bc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6f9b0422bf2ae8bc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6f9b0422bf2ae8bc$var$queue = [];
var $6f9b0422bf2ae8bc$var$draining = false;
var $6f9b0422bf2ae8bc$var$currentQueue;
var $6f9b0422bf2ae8bc$var$queueIndex = -1;
function $6f9b0422bf2ae8bc$var$cleanUpNextTick() {
    if (!$6f9b0422bf2ae8bc$var$draining || !$6f9b0422bf2ae8bc$var$currentQueue) return;
    $6f9b0422bf2ae8bc$var$draining = false;
    if ($6f9b0422bf2ae8bc$var$currentQueue.length) $6f9b0422bf2ae8bc$var$queue = $6f9b0422bf2ae8bc$var$currentQueue.concat($6f9b0422bf2ae8bc$var$queue);
    else $6f9b0422bf2ae8bc$var$queueIndex = -1;
    if ($6f9b0422bf2ae8bc$var$queue.length) $6f9b0422bf2ae8bc$var$drainQueue();
}
function $6f9b0422bf2ae8bc$var$drainQueue() {
    if ($6f9b0422bf2ae8bc$var$draining) return;
    var timeout = $6f9b0422bf2ae8bc$var$runTimeout($6f9b0422bf2ae8bc$var$cleanUpNextTick);
    $6f9b0422bf2ae8bc$var$draining = true;
    var len = $6f9b0422bf2ae8bc$var$queue.length;
    while(len){
        $6f9b0422bf2ae8bc$var$currentQueue = $6f9b0422bf2ae8bc$var$queue;
        $6f9b0422bf2ae8bc$var$queue = [];
        while(++$6f9b0422bf2ae8bc$var$queueIndex < len)if ($6f9b0422bf2ae8bc$var$currentQueue) $6f9b0422bf2ae8bc$var$currentQueue[$6f9b0422bf2ae8bc$var$queueIndex].run();
        $6f9b0422bf2ae8bc$var$queueIndex = -1;
        len = $6f9b0422bf2ae8bc$var$queue.length;
    }
    $6f9b0422bf2ae8bc$var$currentQueue = null;
    $6f9b0422bf2ae8bc$var$draining = false;
    $6f9b0422bf2ae8bc$var$runClearTimeout(timeout);
}
$6f9b0422bf2ae8bc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6f9b0422bf2ae8bc$var$queue.push(new $6f9b0422bf2ae8bc$var$Item(fun, args));
    if ($6f9b0422bf2ae8bc$var$queue.length === 1 && !$6f9b0422bf2ae8bc$var$draining) $6f9b0422bf2ae8bc$var$runTimeout($6f9b0422bf2ae8bc$var$drainQueue);
};
// v8 likes predictible objects
function $6f9b0422bf2ae8bc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6f9b0422bf2ae8bc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6f9b0422bf2ae8bc$var$process.title = 'browser';
$6f9b0422bf2ae8bc$var$process.browser = true;
$6f9b0422bf2ae8bc$var$process.env = {};
$6f9b0422bf2ae8bc$var$process.argv = [];
$6f9b0422bf2ae8bc$var$process.version = ''; // empty string to avoid regexp issues
$6f9b0422bf2ae8bc$var$process.versions = {};
function $6f9b0422bf2ae8bc$var$noop() {}
$6f9b0422bf2ae8bc$var$process.on = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.addListener = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.once = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.off = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.removeListener = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.removeAllListeners = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.emit = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.prependListener = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.prependOnceListener = $6f9b0422bf2ae8bc$var$noop;
$6f9b0422bf2ae8bc$var$process.listeners = function(name) {
    return [];
};
$6f9b0422bf2ae8bc$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$6f9b0422bf2ae8bc$var$process.cwd = function() {
    return '/';
};
$6f9b0422bf2ae8bc$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$6f9b0422bf2ae8bc$var$process.umask = function() {
    return 0;
};


/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $1e031cb73d044f87$export$694e0d28c7ffc90c {
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $1e031cb73d044f87$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $1e031cb73d044f87$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        let lookaheadRecord = this.reducePos < this.pos - 25 /* Lookahead.Margin */ ;
        if (lookaheadRecord) this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, mustSink = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!mustSink || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Term.Err */ ) {
                let mustMove = false;
                for(let scan = index; scan > 0 && this.buffer[scan - 2] > end; scan -= 4)if (this.buffer[scan - 1] >= 0) {
                    mustMove = true;
                    break;
                }
                if (mustMove) while(index > 0 && this.buffer[index - 2] > end){
                    // Move this record forward
                    this.buffer[index] = this.buffer[index - 4];
                    this.buffer[index + 1] = this.buffer[index - 3];
                    this.buffer[index + 2] = this.buffer[index - 2];
                    this.buffer[index + 3] = this.buffer[index - 1];
                    index -= 4;
                    if (size > 4) size -= 4;
                }
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $1e031cb73d044f87$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $1e031cb73d044f87$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $1e031cb73d044f87$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $1e031cb73d044f87$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $1e031cb73d044f87$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $1e031cb73d044f87$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $1e031cb73d044f87$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $1e031cb73d044f87$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $1e031cb73d044f87$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $1e031cb73d044f87$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $1e031cb73d044f87$var$nullToken = new $1e031cb73d044f87$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $1e031cb73d044f87$export$f22294a9362415e4 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $1e031cb73d044f87$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $1e031cb73d044f87$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/**
@internal
*/ class $1e031cb73d044f87$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        let { parser: parser } = stack.p;
        $1e031cb73d044f87$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
}
$1e031cb73d044f87$var$TokenGroup.prototype.contextual = $1e031cb73d044f87$var$TokenGroup.prototype.fallback = $1e031cb73d044f87$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $1e031cb73d044f87$export$dbe55ed82366d5e9 {
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $1e031cb73d044f87$var$decodeArray(data) : data;
    }
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $1e031cb73d044f87$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
}
$1e031cb73d044f87$export$dbe55ed82366d5e9.prototype.contextual = $1e031cb73d044f87$var$TokenGroup.prototype.fallback = $1e031cb73d044f87$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $1e031cb73d044f87$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $1e031cb73d044f87$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $1e031cb73d044f87$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $1e031cb73d044f87$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $1e031cb73d044f87$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $1e031cb73d044f87$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $1e031cb73d044f87$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $1e031cb73d044f87$var$verbose = typeof $6f9b0422bf2ae8bc$exports != "undefined" && $6f9b0422bf2ae8bc$exports.env && /\bparse\b/.test(undefined);
let $1e031cb73d044f87$var$stackIDs = null;
function $1e031cb73d044f87$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $b14321b77c1b25e4$export$b0e28367f55837aa).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $1e031cb73d044f87$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $1e031cb73d044f87$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $1e031cb73d044f87$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $1e031cb73d044f87$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $1e031cb73d044f87$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $1e031cb73d044f87$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $1e031cb73d044f87$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $1e031cb73d044f87$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($1e031cb73d044f87$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($1e031cb73d044f87$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
class $1e031cb73d044f87$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $1e031cb73d044f87$export$f22294a9362415e4(input, ranges);
        this.tokens = new $1e031cb73d044f87$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $1e031cb73d044f87$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $1e031cb73d044f87$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $1e031cb73d044f87$var$findFinished(stopped);
            if (finished) {
                if ($1e031cb73d044f87$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($1e031cb73d044f87$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($1e031cb73d044f87$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $1e031cb73d044f87$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $b14321b77c1b25e4$export$b8034b9bc18acd90).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $b14321b77c1b25e4$export$7fbedc92909ed28e) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $1e031cb73d044f87$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $1e031cb73d044f87$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; force.forceReduce() && j < 10 /* Rec.ForceReduceLimit */ ; j++){
                if ($1e031cb73d044f87$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($1e031cb73d044f87$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($1e031cb73d044f87$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $1e031cb73d044f87$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $b14321b77c1b25e4$export$7fbedc92909ed28e).build({
            buffer: $1e031cb73d044f87$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($1e031cb73d044f87$var$stackIDs || ($1e031cb73d044f87$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $1e031cb73d044f87$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $1e031cb73d044f87$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $1e031cb73d044f87$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $1e031cb73d044f87$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $1e031cb73d044f87$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $1e031cb73d044f87$var$id;
        this.reduce = spec.reduce || $1e031cb73d044f87$var$id;
        this.reuse = spec.reuse || $1e031cb73d044f87$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $1e031cb73d044f87$export$60c033f4cf02b410 extends (0, $b14321b77c1b25e4$export$7acfa6ed01010e37) {
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $b14321b77c1b25e4$export$b8034b9bc18acd90)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $b14321b77c1b25e4$export$7fad5fb00d8de02c)(nodeNames.map((name, i)=>(0, $b14321b77c1b25e4$export$f06e977173f1857c).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $b14321b77c1b25e4$export$de305a849879ffa);
        let tokenArray = $1e031cb73d044f87$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($1e031cb73d044f87$var$getSpecializer);
        this.states = $1e031cb73d044f87$var$decodeArray(spec.states, Uint32Array);
        this.data = $1e031cb73d044f87$var$decodeArray(spec.stateData);
        this.goto = $1e031cb73d044f87$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $1e031cb73d044f87$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $1e031cb73d044f87$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $1e031cb73d044f87$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $1e031cb73d044f87$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $1e031cb73d044f87$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $1e031cb73d044f87$var$pair(this.data, i + 2);
                else break;
            }
            result = action($1e031cb73d044f87$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $1e031cb73d044f87$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($1e031cb73d044f87$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $1e031cb73d044f87$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $1e031cb73d044f87$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $1e031cb73d044f87$export$60c033f4cf02b410(spec);
    }
}
function $1e031cb73d044f87$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $1e031cb73d044f87$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $1e031cb73d044f87$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}



// This file was generated by lezer-generator. You probably shouldn't edit it.
const $e8b59e5e7d87430d$var$noSemi = 314, $e8b59e5e7d87430d$var$noSemiType = 315, $e8b59e5e7d87430d$var$incdec = 1, $e8b59e5e7d87430d$var$incdecPrefix = 2, $e8b59e5e7d87430d$var$questionDot = 3, $e8b59e5e7d87430d$var$JSXStartTag = 4, $e8b59e5e7d87430d$var$insertSemi = 316, $e8b59e5e7d87430d$var$spaces = 318, $e8b59e5e7d87430d$var$newline = 319, $e8b59e5e7d87430d$var$LineComment = 5, $e8b59e5e7d87430d$var$BlockComment = 6, $e8b59e5e7d87430d$var$Dialect_jsx = 0;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ const $e8b59e5e7d87430d$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $e8b59e5e7d87430d$var$braceR = 125, $e8b59e5e7d87430d$var$semicolon = 59, $e8b59e5e7d87430d$var$slash = 47, $e8b59e5e7d87430d$var$star = 42, $e8b59e5e7d87430d$var$plus = 43, $e8b59e5e7d87430d$var$minus = 45, $e8b59e5e7d87430d$var$lt = 60, $e8b59e5e7d87430d$var$comma = 44, $e8b59e5e7d87430d$var$question = 63, $e8b59e5e7d87430d$var$dot = 46, $e8b59e5e7d87430d$var$bracketL = 91;
const $e8b59e5e7d87430d$var$trackNewline = new (0, $1e031cb73d044f87$export$88193367295cc46b)({
    start: false,
    shift (context, term) {
        return term == $e8b59e5e7d87430d$var$LineComment || term == $e8b59e5e7d87430d$var$BlockComment || term == $e8b59e5e7d87430d$var$spaces ? context : term == $e8b59e5e7d87430d$var$newline;
    },
    strict: false
});
const $e8b59e5e7d87430d$var$insertSemicolon = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $e8b59e5e7d87430d$var$braceR || next == -1 || stack.context) input.acceptToken($e8b59e5e7d87430d$var$insertSemi);
}, {
    contextual: true,
    fallback: true
});
const $e8b59e5e7d87430d$var$noSemicolon = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input, after;
    if ($e8b59e5e7d87430d$var$space.indexOf(next) > -1) return;
    if (next == $e8b59e5e7d87430d$var$slash && ((after = input.peek(1)) == $e8b59e5e7d87430d$var$slash || after == $e8b59e5e7d87430d$var$star)) return;
    if (next != $e8b59e5e7d87430d$var$braceR && next != $e8b59e5e7d87430d$var$semicolon && next != -1 && !stack.context) input.acceptToken($e8b59e5e7d87430d$var$noSemi);
}, {
    contextual: true
});
const $e8b59e5e7d87430d$var$noSemicolonType = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next == $e8b59e5e7d87430d$var$bracketL && !stack.context) input.acceptToken($e8b59e5e7d87430d$var$noSemiType);
}, {
    contextual: true
});
const $e8b59e5e7d87430d$var$operatorToken = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { next: next } = input;
    if (next == $e8b59e5e7d87430d$var$plus || next == $e8b59e5e7d87430d$var$minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            let mayPostfix = !stack.context && stack.canShift($e8b59e5e7d87430d$var$incdec);
            input.acceptToken(mayPostfix ? $e8b59e5e7d87430d$var$incdec : $e8b59e5e7d87430d$var$incdecPrefix);
        }
    } else if (next == $e8b59e5e7d87430d$var$question && input.peek(1) == $e8b59e5e7d87430d$var$dot) {
        input.advance();
        input.advance();
        if (input.next < 48 || input.next > 57) input.acceptToken($e8b59e5e7d87430d$var$questionDot);
    }
}, {
    contextual: true
});
function $e8b59e5e7d87430d$var$identifierChar(ch, start) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch == 95 || ch >= 192 || !start && ch >= 48 && ch <= 57;
}
const $e8b59e5e7d87430d$var$jsx = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    if (input.next != $e8b59e5e7d87430d$var$lt || !stack.dialectEnabled($e8b59e5e7d87430d$var$Dialect_jsx)) return;
    input.advance();
    if (input.next == $e8b59e5e7d87430d$var$slash) return;
    // Scan for an identifier followed by a comma or 'extends', don't
    // treat this as a start tag if present.
    let back = 0;
    while($e8b59e5e7d87430d$var$space.indexOf(input.next) > -1){
        input.advance();
        back++;
    }
    if ($e8b59e5e7d87430d$var$identifierChar(input.next, true)) {
        input.advance();
        back++;
        while($e8b59e5e7d87430d$var$identifierChar(input.next, false)){
            input.advance();
            back++;
        }
        while($e8b59e5e7d87430d$var$space.indexOf(input.next) > -1){
            input.advance();
            back++;
        }
        if (input.next == $e8b59e5e7d87430d$var$comma) return;
        for(let i = 0;; i++){
            if (i == 7) {
                if (!$e8b59e5e7d87430d$var$identifierChar(input.next, true)) return;
                break;
            }
            if (input.next != "extends".charCodeAt(i)) break;
            input.advance();
            back++;
        }
    }
    input.acceptToken($e8b59e5e7d87430d$var$JSXStartTag, -back);
});
const $e8b59e5e7d87430d$var$jsHighlight = (0, $6fc2ba1913927f17$export$c537e79bb7b94295)({
    "get set async static": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).modifier,
    "for while do if else switch try catch finally return throw break continue default case": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).controlKeyword,
    "in of await yield void typeof delete instanceof": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
    "let var const using function class extends": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definitionKeyword,
    "import export from": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).moduleKeyword,
    "with debugger as new": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).keyword,
    TemplateString: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string),
    super: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).atom,
    BooleanLiteral: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).bool,
    this: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).self,
    null: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).null,
    Star: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).modifier,
    VariableName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).function((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
    VariableDefinition: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
    Label: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).labelName,
    PropertyName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName,
    PrivatePropertyName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).function((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).function((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName)),
    "ClassDeclaration/VariableDefinition": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className),
    "NewExpression/VariableName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className,
    PropertyDefinition: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName),
    PrivatePropertyDefinition: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName)),
    UpdateOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).updateOperator,
    "LineComment Hashbang": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).lineComment,
    BlockComment: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).blockComment,
    Number: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).number,
    String: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string,
    Escape: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).escape,
    ArithOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).arithmeticOperator,
    LogicOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).logicOperator,
    BitOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).bitwiseOperator,
    CompareOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).compareOperator,
    RegExp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).regexp,
    Equals: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definitionOperator,
    Arrow: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).function((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).punctuation),
    ": Spread": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).punctuation,
    "( )": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).brace,
    "InterpolationStart InterpolationEnd": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).brace),
    ".": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).derefOperator,
    ", ;": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).separator,
    "@": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).meta,
    TypeName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).typeName,
    TypeDefinition: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).typeName),
    "type enum interface implements namespace module declare": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definitionKeyword,
    "abstract global Privacy readonly override": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).modifier,
    "is keyof unique infer asserts": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
    JSXAttributeValue: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).attributeValue,
    JSXText: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).attributeName,
    "JSXBuiltin/JSXIdentifier": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).standard((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).tagName)
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $e8b59e5e7d87430d$var$spec_identifier = {
    __proto__: null,
    export: 20,
    as: 25,
    from: 33,
    default: 36,
    async: 41,
    function: 42,
    const: 52,
    extends: 56,
    this: 60,
    true: 68,
    false: 68,
    null: 80,
    void: 84,
    typeof: 88,
    super: 104,
    new: 138,
    delete: 150,
    yield: 159,
    await: 163,
    class: 168,
    public: 231,
    private: 231,
    protected: 231,
    readonly: 233,
    instanceof: 252,
    satisfies: 255,
    in: 256,
    import: 290,
    keyof: 347,
    unique: 351,
    infer: 357,
    asserts: 393,
    is: 395,
    abstract: 415,
    implements: 417,
    type: 419,
    let: 422,
    var: 424,
    using: 427,
    interface: 433,
    enum: 437,
    namespace: 443,
    module: 445,
    declare: 449,
    global: 453,
    for: 472,
    of: 481,
    while: 484,
    with: 488,
    do: 492,
    if: 496,
    else: 498,
    switch: 502,
    case: 508,
    try: 514,
    catch: 518,
    finally: 522,
    return: 526,
    throw: 530,
    break: 534,
    continue: 538,
    debugger: 542
};
const $e8b59e5e7d87430d$var$spec_word = {
    __proto__: null,
    async: 125,
    get: 127,
    set: 129,
    declare: 191,
    public: 193,
    private: 193,
    protected: 193,
    static: 195,
    abstract: 197,
    override: 199,
    readonly: 205,
    accessor: 207,
    new: 399
};
const $e8b59e5e7d87430d$var$spec_LessThan = {
    __proto__: null,
    "<": 189
};
const $e8b59e5e7d87430d$export$8f49e4af10703ce3 = (0, $1e031cb73d044f87$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "$EOQ%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#D_O.QQlO'#DeO.bQlO'#DpO%[QlO'#DxO0fQlO'#EQOOQ!0Lf'#EY'#EYO1PQ`O'#EVOOQO'#En'#EnOOQO'#Ij'#IjO1XQ`O'#GrO1dQ`O'#EmO1iQ`O'#EmO3hQ!0MxO'#JpO6[Q!0MxO'#JqO6uQ`O'#F[O6zQ,UO'#FsOOQ!0Lf'#Fe'#FeO7VO7dO'#FeO7eQMhO'#F{O9UQ`O'#FzOOQ!0Lf'#Jq'#JqOOQ!0Lb'#Jp'#JpO9ZQ`O'#GvOOQ['#K]'#K]O9fQ`O'#IWO9kQ!0LrO'#IXOOQ['#J^'#J^OOQ['#I]'#I]Q`QlOOQ`QlOOO9sQ!L^O'#DtO9zQlO'#D|O:RQlO'#EOO9aQ`O'#GrO:YQMhO'#CoO:hQ`O'#ElO:sQ`O'#EwO:xQMhO'#FdO;gQ`O'#GrOOQO'#K^'#K^O;lQ`O'#K^O;zQ`O'#GzO;zQ`O'#G{O;zQ`O'#G}O9aQ`O'#HQO<qQ`O'#HTO>YQ`O'#CeO>jQ`O'#HaO>rQ`O'#HgO>rQ`O'#HiO`QlO'#HkO>rQ`O'#HmO>rQ`O'#HpO>wQ`O'#HvO>|Q!0LsO'#H|O%[QlO'#IOO?XQ!0LsO'#IQO?dQ!0LsO'#ISO9kQ!0LrO'#IUO?oQ!0MxO'#CiO@qQpO'#DjQOQ`OOO%[QlO'#EOOAXQ`O'#ERO:YQMhO'#ElOAdQ`O'#ElOAoQ!bO'#FdOOQ['#Cg'#CgOOQ!0Lb'#Do'#DoOOQ!0Lb'#Jt'#JtO%[QlO'#JtOOQO'#Jw'#JwOOQO'#If'#IfOBoQpO'#EeOOQ!0Lb'#Ed'#EdOOQ!0Lb'#J{'#J{OCkQ!0MSO'#EeOCuQpO'#EUOOQO'#Jv'#JvODZQpO'#JwOEhQpO'#EUOCuQpO'#EePEuO&2DjO'#CbPOOO)CD{)CD{OOOO'#I^'#I^OFQO#tO,59UOOQ!0Lh,59U,59UOOOO'#I_'#I_OF`O&jO,59UOFnQ!L^O'#DaOOOO'#Ia'#IaOFuO#@ItO,59yOOQ!0Lf,59y,59yOGTQlO'#IbOGhQ`O'#JrOIgQ!fO'#JrO+}QlO'#JrOInQ`O,5:POJUQ`O'#EnOJcQ`O'#KROJnQ`O'#KQOJnQ`O'#KQOJvQ`O,5;[OJ{Q`O'#KPOOQ!0Ln,5:[,5:[OKSQlO,5:[OMQQ!0MxO,5:dOMqQ`O,5:lON[Q!0LrO'#KOONcQ`O'#J}O9ZQ`O'#J}ONwQ`O'#J}O! PQ`O,5;ZO! UQ`O'#J}O!#ZQ!fO'#JqOOQ!0Lh'#Ci'#CiO%[QlO'#EQO!#yQ!fO,5:qOOQS'#Jx'#JxOOQO-E<h-E<hO9aQ`O,5=^O!$aQ`O,5=^O!$fQlO,5;XO!&iQMhO'#EiO!(SQ`O,5;XO!(XQlO'#DwO!(cQpO,5;bO!(kQpO,5;bO%[QlO,5;bOOQ['#FS'#FSOOQ['#FU'#FUO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cOOQ['#FY'#FYO!(yQlO,5;sOOQ!0Lf,5;x,5;xOOQ!0Lf,5;y,5;yOOQ!0Lf,5;{,5;{O%[QlO'#InO!*|Q!0LrO,5<hO%[QlO,5;cO!&iQMhO,5;cO!+kQMhO,5;cO!-]QMhO'#E[O%[QlO,5;vOOQ!0Lf,5;z,5;zO!-dQ,UO'#FiO!.aQ,UO'#KVO!-{Q,UO'#KVO!.hQ,UO'#KVOOQO'#KV'#KVO!.|Q,UO,5<ROOOW,5<_,5<_O!/_QlO'#FuOOOW'#Im'#ImO7VO7dO,5<PO!/fQ,UO'#FwOOQ!0Lf,5<P,5<PO!0VQ$IUO'#CwOOQ!0Lh'#C{'#C{O!0jO#@ItO'#DPO!1WQMjO,5<dO!1_Q`O,5<gO!2zQ(CWO'#GWO!3XQ`O'#GXO!3^Q`O'#GXO!4|Q(CWO'#G]O!6RQpO'#GaOOQO'#Gm'#GmO!+rQMhO'#GlOOQO'#Go'#GoO!+rQMhO'#GnO!6tQ$IUO'#JjOOQ!0Lh'#Jj'#JjO!7OQ`O'#JiO!7^Q`O'#JhO!7fQ`O'#CuOOQ!0Lh'#Cy'#CyO!7qQ`O'#C{OOQ!0Lh'#DT'#DTOOQ!0Lh'#DV'#DVO1SQ`O'#DXO!+rQMhO'#GOO!+rQMhO'#GQO!7vQ`O'#GSO!7{Q`O'#GTO!3^Q`O'#GZO!+rQMhO'#G`O;zQ`O'#JiO!8QQ`O'#EoO!8oQ`O,5<fOOQ!0Lb'#Cr'#CrO!8wQ`O'#EpO!9qQpO'#EqOOQ!0Lb'#KP'#KPO!9xQ!0LrO'#K_O9kQ!0LrO,5=bO`QlO,5>rOOQ['#Jf'#JfOOQ[,5>s,5>sOOQ[-E<Z-E<ZO!;wQ!0MxO,5:`O!9lQpO,5:^O!>bQ!0MxO,5:hO%[QlO,5:hO!@xQ!0MxO,5:jOOQO,5@x,5@xO!AiQMhO,5=^O!AwQ!0LrO'#JgO9UQ`O'#JgO!BYQ!0LrO,59ZO!BeQpO,59ZO!BmQMhO,59ZO:YQMhO,59ZO!BxQ`O,5;XO!CQQ`O'#H`O!CfQ`O'#KbO%[QlO,5;|O!9lQpO,5<OO!CnQ`O,5=yO!CsQ`O,5=yO!CxQ`O,5=yO9kQ!0LrO,5=yO;zQ`O,5=iOOQO'#Cw'#CwO!DWQpO,5=fO!D`QMhO,5=gO!DkQ`O,5=iO!DpQ!bO,5=lO!DxQ`O'#K^O>wQ`O'#HVO9aQ`O'#HXO!D}Q`O'#HXO:YQMhO'#HZO!ESQ`O'#HZOOQ[,5=o,5=oO!EXQ`O'#H[O!EjQ`O'#CoO!EoQ`O,59PO!EyQ`O,59PO!HOQlO,59POOQ[,59P,59PO!H`Q!0LrO,59PO%[QlO,59PO!JkQlO'#HcOOQ['#Hd'#HdOOQ['#He'#HeO`QlO,5={O!KRQ`O,5={O`QlO,5>RO`QlO,5>TO!KWQ`O,5>VO`QlO,5>XO!K]Q`O,5>[O!KbQlO,5>bOOQ[,5>h,5>hO%[QlO,5>hO9kQ!0LrO,5>jOOQ[,5>l,5>lO# lQ`O,5>lOOQ[,5>n,5>nO# lQ`O,5>nOOQ[,5>p,5>pO#!YQpO'#D]O%[QlO'#JtO#!{QpO'#JtO##VQpO'#DkO##hQpO'#DkO#%yQlO'#DkO#&QQ`O'#JsO#&YQ`O,5:UO#&_Q`O'#ErO#&mQ`O'#KSO#&uQ`O,5;]O#&zQpO'#DkO#'XQpO'#ETOOQ!0Lf,5:m,5:mO%[QlO,5:mO#'`Q`O,5:mO>wQ`O,5;WO!BeQpO,5;WO!BmQMhO,5;WO:YQMhO,5;WO#'hQ`O,5@`O#'mQ07dO,5:qOOQO-E<d-E<dO#(sQ!0MSO,5;POCuQpO,5:pO#(}QpO,5:pOCuQpO,5;PO!BYQ!0LrO,5:pOOQ!0Lb'#Eh'#EhOOQO,5;P,5;PO%[QlO,5;PO#)[Q!0LrO,5;PO#)gQ!0LrO,5;PO!BeQpO,5:pOOQO,5;V,5;VO#)uQ!0LrO,5;PPOOO'#I['#I[P#*ZO&2DjO,58|POOO,58|,58|OOOO-E<[-E<[OOQ!0Lh1G.p1G.pOOOO-E<]-E<]OOOO,59{,59{O#*fQ!bO,59{OOOO-E<_-E<_OOQ!0Lf1G/e1G/eO#*kQ!fO,5>|O+}QlO,5>|OOQO,5?S,5?SO#*uQlO'#IbOOQO-E<`-E<`O#+SQ`O,5@^O#+[Q!fO,5@^O#+cQ`O,5@lOOQ!0Lf1G/k1G/kO%[QlO,5@mO#+kQ`O'#IhOOQO-E<f-E<fO#+cQ`O,5@lOOQ!0Lb1G0v1G0vOOQ!0Ln1G/v1G/vOOQ!0Ln1G0W1G0WO%[QlO,5@jO#,PQ!0LrO,5@jO#,bQ!0LrO,5@jO#,iQ`O,5@iO9ZQ`O,5@iO#,qQ`O,5@iO#-PQ`O'#IkO#,iQ`O,5@iOOQ!0Lb1G0u1G0uO!(cQpO,5:sO!(nQpO,5:sOOQS,5:u,5:uO#-qQdO,5:uO#-yQMhO1G2xO9aQ`O1G2xOOQ!0Lf1G0s1G0sO#.XQ!0MxO1G0sO#/^Q!0MvO,5;TOOQ!0Lh'#GV'#GVO#/zQ!0MzO'#JjO!$fQlO1G0sO#2VQ!fO'#JuO%[QlO'#JuO#2aQ`O,5:cOOQ!0Lh'#D]'#D]OOQ!0Lf1G0|1G0|O%[QlO1G0|OOQ!0Lf1G1e1G1eO#2fQ`O1G0|O#4zQ!0MxO1G0}O#5RQ!0MxO1G0}O#7iQ!0MxO1G0}O#7pQ!0MxO1G0}O#:WQ!0MxO1G0}O#<nQ!0MxO1G0}O#<uQ!0MxO1G0}O#<|Q!0MxO1G0}O#?dQ!0MxO1G0}O#?kQ!0MxO1G0}O#AxQ?MtO'#CiO#CsQ?MtO1G1_O#CzQ?MtO'#JqO#D_Q!0MxO,5?YOOQ!0Lb-E<l-E<lO#FlQ!0MxO1G0}O#GiQ!0MzO1G0}OOQ!0Lf1G0}1G0}O#HlQMjO'#JzO#HvQ`O,5:vO#H{Q!0MxO1G1bO#IoQ,UO,5<VO#IwQ,UO,5<WO#JPQ,UO'#FnO#JhQ`O'#FmOOQO'#KW'#KWOOQO'#Il'#IlO#JmQ,UO1G1mOOQ!0Lf1G1m1G1mOOOW1G1x1G1xO#KOQ?MtO'#JpO#KYQ`O,5<aO!(yQlO,5<aOOOW-E<k-E<kOOQ!0Lf1G1k1G1kO#K_QpO'#KVOOQ!0Lf,5<c,5<cO#KgQpO,5<cO#KlQMhO'#DROOOO'#I`'#I`O#KsO#@ItO,59kOOQ!0Lh,59k,59kO%[QlO1G2OO!7{Q`O'#IpO#LOQ`O,5<yOOQ!0Lh,5<v,5<vO!+rQMhO'#IsO#LlQMjO,5=WO!+rQMhO'#IuO#M_QMjO,5=YO!&iQMhO,5=[OOQO1G2R1G2RO#MiQ!dO'#CrO#M|Q(CWO'#EpO$ RQpO'#GaO$ iQ!dO,5<rO$ pQ`O'#KYO9ZQ`O'#KYO$!OQ`O,5<tO!+rQMhO,5<sO$!TQ`O'#GYO$!fQ`O,5<sO$!kQ!dO'#GVO$!xQ!dO'#KZO$#SQ`O'#KZO!&iQMhO'#KZO$#XQ`O,5<wO$#^QlO'#JtO$#hQpO'#GbO##hQpO'#GbO$#yQ`O'#GfO!3^Q`O'#GjO$$OQ!0LrO'#IrO$$ZQpO,5<{OOQ!0Lp,5<{,5<{O$$bQpO'#GbO$$oQpO'#GcO$%QQpO'#GcO$%VQMjO,5=WO$%gQMjO,5=YOOQ!0Lh,5=],5=]O!+rQMhO,5@TO!+rQMhO,5@TO$%wQ`O'#IwO$&VQ`O,5@SO$&_Q`O,59aOOQ!0Lh,59g,59gO$'UQ$IYO,59sOOQ!0Lh'#Jn'#JnO$'wQMjO,5<jO$(jQMjO,5<lO@iQ`O,5<nOOQ!0Lh,5<o,5<oO$(tQ`O,5<uO$(yQMjO,5<zO$)ZQ`O,5@TO$)iQ`O'#J}O!$fQlO1G2QO$)nQ`O1G2QO9ZQ`O'#KQO9ZQ`O'#ErO%[QlO'#ErO9ZQ`O'#IyO$)sQ!0LrO,5@yOOQ[1G2|1G2|OOQ[1G4^1G4^OOQ!0Lf1G/z1G/zOOQ!0Lf1G/x1G/xO$+uQ!0MxO1G0SOOQ[1G2x1G2xO!&iQMhO1G2xO%[QlO1G2xO#-|Q`O1G2xO$-yQMhO'#EiOOQ!0Lb,5@R,5@RO$.WQ!0LrO,5@ROOQ[1G.u1G.uO!BYQ!0LrO1G.uO!BeQpO1G.uO!BmQMhO1G.uO$.iQ`O1G0sO$.nQ`O'#CiO$.yQ`O'#KcO$/RQ`O,5=zO$/WQ`O'#KcO$/]Q`O'#KcO$/kQ`O'#JPO$/yQ`O,5@|O$0RQ!fO1G1hOOQ!0Lf1G1j1G1jO9aQ`O1G3eO@iQ`O1G3eO$0YQ`O1G3eO$0_Q`O1G3eOOQ[1G3e1G3eO!DkQ`O1G3TO!&iQMhO1G3QO$0dQ`O1G3QOOQ[1G3R1G3RO!&iQMhO1G3RO$0iQ`O1G3RO$0qQpO'#HPOOQ[1G3T1G3TO!5|QpO'#I{O!DpQ!bO1G3WOOQ[1G3W1G3WOOQ[,5=q,5=qO$0yQMhO,5=sO9aQ`O,5=sO$#yQ`O,5=uO9UQ`O,5=uO!BeQpO,5=uO!BmQMhO,5=uO:YQMhO,5=uO$1XQ`O'#KaO$1dQ`O,5=vOOQ[1G.k1G.kO$1iQ!0LrO1G.kO@iQ`O1G.kO$1tQ`O1G.kO9kQ!0LrO1G.kO$3|Q!fO,5AOO$4ZQ`O,5AOO9ZQ`O,5AOO$4fQlO,5=}O$4mQ`O,5=}OOQ[1G3g1G3gO`QlO1G3gOOQ[1G3m1G3mOOQ[1G3o1G3oO>rQ`O1G3qO$4rQlO1G3sO$8vQlO'#HrOOQ[1G3v1G3vO$9TQ`O'#HxO>wQ`O'#HzOOQ[1G3|1G3|O$9]QlO1G3|O9kQ!0LrO1G4SOOQ[1G4U1G4UOOQ!0Lb'#G^'#G^O9kQ!0LrO1G4WO9kQ!0LrO1G4YO$=dQ`O,5@`O!(yQlO,5;^O9ZQ`O,5;^O>wQ`O,5:VO!(yQlO,5:VO!BeQpO,5:VO$=iQ?MtO,5:VOOQO,5;^,5;^O$=sQpO'#IcO$>ZQ`O,5@_OOQ!0Lf1G/p1G/pO$>cQpO'#IiO$>mQ`O,5@nOOQ!0Lb1G0w1G0wO##hQpO,5:VOOQO'#Ie'#IeO$>uQpO,5:oOOQ!0Ln,5:o,5:oO#'cQ`O1G0XOOQ!0Lf1G0X1G0XO%[QlO1G0XOOQ!0Lf1G0r1G0rO>wQ`O1G0rO!BeQpO1G0rO!BmQMhO1G0rOOQ!0Lb1G5z1G5zO!BYQ!0LrO1G0[OOQO1G0k1G0kO%[QlO1G0kO$>|Q!0LrO1G0kO$?XQ!0LrO1G0kO!BeQpO1G0[OCuQpO1G0[O$?gQ!0LrO1G0kOOQO1G0[1G0[O$?{Q!0MxO1G0kPOOO-E<Y-E<YPOOO1G.h1G.hOOOO1G/g1G/gO$@VQ!bO,5<hO$@_Q!fO1G4hOOQO1G4n1G4nO%[QlO,5>|O$@iQ`O1G5xO$@qQ`O1G6WO$@yQ!fO1G6XO9ZQ`O,5?SO$ATQ!0MxO1G6UO%[QlO1G6UO$AeQ!0LrO1G6UO$AvQ`O1G6TO$AvQ`O1G6TO9ZQ`O1G6TO$BOQ`O,5?VO9ZQ`O,5?VOOQO,5?V,5?VO$BdQ`O,5?VO$)iQ`O,5?VOOQO-E<i-E<iOOQS1G0_1G0_OOQS1G0a1G0aO#-tQ`O1G0aOOQ[7+(d7+(dO!&iQMhO7+(dO%[QlO7+(dO$BrQ`O7+(dO$B}QMhO7+(dO$C]Q!0MzO,5=WO$EhQ!0MzO,5=YO$GsQ!0MzO,5=WO$JUQ!0MzO,5=YO$LgQ!0MzO,59sO$NlQ!0MzO,5<jO%!wQ!0MzO,5<lO%%SQ!0MzO,5<zOOQ!0Lf7+&_7+&_O%'eQ!0MxO7+&_O%(XQlO'#IdO%(fQ`O,5@aO%(nQ!fO,5@aOOQ!0Lf1G/}1G/}O%(xQ`O7+&hOOQ!0Lf7+&h7+&hO%(}Q?MtO,5:dO%[QlO7+&yO%)XQ?MtO,5:`O%)fQ?MtO,5:hO%)pQ?MtO,5:jO%)zQMhO'#IgO%*UQ`O,5@fOOQ!0Lh1G0b1G0bOOQO1G1q1G1qOOQO1G1r1G1rO%*^Q!jO,5<YO!(yQlO,5<XOOQO-E<j-E<jOOQ!0Lf7+'X7+'XOOOW7+'d7+'dOOOW1G1{1G1{O%*iQ`O1G1{OOQ!0Lf1G1}1G1}OOOO,59m,59mO%*nQ!dO,59mOOOO-E<^-E<^OOQ!0Lh1G/V1G/VO%*uQ!0MxO7+'jOOQ!0Lh,5?[,5?[O%+iQMhO1G2eP%+pQ`O'#IpPOQ!0Lh-E<n-E<nO%,^QMjO,5?_OOQ!0Lh-E<q-E<qO%-PQMjO,5?aOOQ!0Lh-E<s-E<sO%-ZQ!dO1G2vO%-bQ!dO'#CrO%-xQMhO'#KQO$#^QlO'#JtOOQ!0Lh1G2^1G2^O%.PQ`O'#IoO%.eQ`O,5@tO%.eQ`O,5@tO%.mQ`O,5@tO%.xQ`O,5@tOOQO1G2`1G2`O%/WQMjO1G2_O!+rQMhO1G2_O%/hQ(CWO'#IqO%/uQ`O,5@uO!&iQMhO,5@uO%/}Q!dO,5@uOOQ!0Lh1G2c1G2cO%2_Q!fO'#CiO%2iQ`O,5=OOOQ!0Lb,5<|,5<|O%2qQpO,5<|OOQ!0Lb,5<},5<}OCfQ`O,5<|O%2|QpO,5<|OOQ!0Lb,5=Q,5=QO$)iQ`O,5=UOOQO,5?^,5?^OOQO-E<p-E<pOOQ!0Lp1G2g1G2gO##hQpO,5<|O$#^QlO,5=OO%3[Q`O,5<}O%3gQpO,5<}O!+rQMhO'#IsO%4aQMjO1G2rO!+rQMhO'#IuO%5SQMjO1G2tO%5^QMjO1G5oO%5hQMjO1G5oOOQO,5?c,5?cOOQO-E<u-E<uOOQO1G.{1G.{O!9lQpO,59uO%[QlO,59uOOQ!0Lh,5<i,5<iO%5uQ`O1G2YO!+rQMhO1G2aO!+rQMhO1G5oO!+rQMhO1G5oO%5zQ!0MxO7+'lOOQ!0Lf7+'l7+'lO!$fQlO7+'lO%6nQ`O,5;^OOQ!0Lb,5?e,5?eOOQ!0Lb-E<w-E<wO%6sQ!dO'#K[O#'cQ`O7+(dO4UQ!fO7+(dO$BuQ`O7+(dO%6}Q!0MvO'#CiO%7nQ!0LrO,5=RO%8PQ!0MvO,5=RO%8dQ`O,5=ROOQ!0Lb1G5m1G5mOOQ[7+$a7+$aO!BYQ!0LrO7+$aO!BeQpO7+$aO!$fQlO7+&_O%8lQ`O'#JOO%9TQ`O,5@}OOQO1G3f1G3fO9aQ`O,5@}O%9TQ`O,5@}O%9]Q`O,5@}OOQO,5?k,5?kOOQO-E<}-E<}OOQ!0Lf7+'S7+'SO%9bQ`O7+)PO9kQ!0LrO7+)PO9aQ`O7+)PO@iQ`O7+)POOQ[7+(o7+(oO%9gQ!0MvO7+(lO!&iQMhO7+(lO!DfQ`O7+(mOOQ[7+(m7+(mO!&iQMhO7+(mO%9qQ`O'#K`O%9|Q`O,5=kOOQO,5?g,5?gOOQO-E<y-E<yOOQ[7+(r7+(rO%;`QpO'#HYOOQ[1G3_1G3_O!&iQMhO1G3_O%[QlO1G3_O%;gQ`O1G3_O%;rQMhO1G3_O9kQ!0LrO1G3aO$#yQ`O1G3aO9UQ`O1G3aO!BeQpO1G3aO!BmQMhO1G3aO%<QQ`O'#I}O%<fQ`O,5@{O%<nQpO,5@{OOQ!0Lb1G3b1G3bOOQ[7+$V7+$VO@iQ`O7+$VO9kQ!0LrO7+$VO%<yQ`O7+$VO%[QlO1G6jO%[QlO1G6kO%=OQ!0LrO1G6jO%=YQlO1G3iO%=aQ`O1G3iO%=fQlO1G3iOOQ[7+)R7+)RO9kQ!0LrO7+)]O`QlO7+)_OOQ['#Kf'#KfOOQ['#JQ'#JQO%=mQlO,5>^OOQ[,5>^,5>^O%[QlO'#HsO%=zQ`O'#HuOOQ[,5>d,5>dO9ZQ`O,5>dOOQ[,5>f,5>fOOQ[7+)h7+)hOOQ[7+)n7+)nOOQ[7+)r7+)rOOQ[7+)t7+)tO%>PQpO1G5zO%>kQ?MtO1G0xO%>uQ`O1G0xOOQO1G/q1G/qO%?QQ?MtO1G/qO>wQ`O1G/qO!(yQlO'#DkOOQO,5>},5>}OOQO-E<a-E<aOOQO,5?T,5?TOOQO-E<g-E<gO!BeQpO1G/qOOQO-E<c-E<cOOQ!0Ln1G0Z1G0ZOOQ!0Lf7+%s7+%sO#'cQ`O7+%sOOQ!0Lf7+&^7+&^O>wQ`O7+&^O!BeQpO7+&^OOQO7+%v7+%vO$?{Q!0MxO7+&VOOQO7+&V7+&VO%[QlO7+&VO%?[Q!0LrO7+&VO!BYQ!0LrO7+%vO!BeQpO7+%vO%?gQ!0LrO7+&VO%?uQ!0MxO7++pO%[QlO7++pO%@VQ`O7++oO%@VQ`O7++oOOQO1G4q1G4qO9ZQ`O1G4qO%@_Q`O1G4qOOQS7+%{7+%{O#'cQ`O<<LOO4UQ!fO<<LOO%@mQ`O<<LOOOQ[<<LO<<LOO!&iQMhO<<LOO%[QlO<<LOO%@uQ`O<<LOO%AQQ!0MzO,5?_O%C]Q!0MzO,5?aO%EhQ!0MzO1G2_O%GyQ!0MzO1G2rO%JUQ!0MzO1G2tO%LaQ!fO,5?OO%[QlO,5?OOOQO-E<b-E<bO%LkQ`O1G5{OOQ!0Lf<<JS<<JSO%LsQ?MtO1G0sO%NzQ?MtO1G0}O& RQ?MtO1G0}O&#SQ?MtO1G0}O&#ZQ?MtO1G0}O&%[Q?MtO1G0}O&']Q?MtO1G0}O&'dQ?MtO1G0}O&'kQ?MtO1G0}O&)lQ?MtO1G0}O&)sQ?MtO1G0}O&)zQ!0MxO<<JeO&+rQ?MtO1G0}O&,oQ?MvO1G0}O&-rQ?MvO'#JjO&/xQ?MtO1G1bO&0VQ?MtO1G0SO&0aQMjO,5?ROOQO-E<e-E<eO!(yQlO'#FpOOQO'#KX'#KXOOQO1G1t1G1tO&0kQ`O1G1sO&0pQ?MtO,5?YOOOW7+'g7+'gOOOO1G/X1G/XO&0zQ!dO1G4vOOQ!0Lh7+(P7+(PP!&iQMhO,5?[O!+rQMhO7+(bO&1RQ`O,5?ZO9ZQ`O,5?ZOOQO-E<m-E<mO&1aQ`O1G6`O&1aQ`O1G6`O&1iQ`O1G6`O&1tQMjO7+'yO&2UQ!dO,5?]O&2`Q`O,5?]O!&iQMhO,5?]OOQO-E<o-E<oO&2eQ!dO1G6aO&2oQ`O1G6aO&2wQ`O1G2jO!&iQMhO1G2jOOQ!0Lb1G2h1G2hOOQ!0Lb1G2i1G2iO%2qQpO1G2hO!BeQpO1G2hOCfQ`O1G2hOOQ!0Lb1G2p1G2pO&2|QpO1G2hO&3[Q`O1G2jO$)iQ`O1G2iOCfQ`O1G2iO$#^QlO1G2jO&3dQ`O1G2iO&4WQMjO,5?_OOQ!0Lh-E<r-E<rO&4yQMjO,5?aOOQ!0Lh-E<t-E<tO!+rQMhO7++ZOOQ!0Lh1G/a1G/aO&5TQ`O1G/aOOQ!0Lh7+'t7+'tO&5YQMjO7+'{O&5jQMjO7++ZO&5tQMjO7++ZO&6RQ!0MxO<<KWOOQ!0Lf<<KW<<KWO&6uQ`O1G0xO!&iQMhO'#IxO&6zQ`O,5@vO&8|Q!fO<<LOO!&iQMhO1G2mO&9TQ!0LrO1G2mOOQ[<<G{<<G{O!BYQ!0LrO<<G{O&9fQ!0MxO<<IyOOQ!0Lf<<Iy<<IyOOQO,5?j,5?jO&:YQ`O,5?jO&:_Q`O,5?jOOQO-E<|-E<|O&:mQ`O1G6iO&:mQ`O1G6iO9aQ`O1G6iO@iQ`O<<LkOOQ[<<Lk<<LkO&:uQ`O<<LkO9kQ!0LrO<<LkOOQ[<<LW<<LWO%9gQ!0MvO<<LWOOQ[<<LX<<LXO!DfQ`O<<LXO&:zQpO'#IzO&;VQ`O,5@zO!(yQlO,5@zOOQ[1G3V1G3VOOQO'#I|'#I|O9kQ!0LrO'#I|O&;_QpO,5=tOOQ[,5=t,5=tO&;fQpO'#EeO&;mQpO'#GdO&;rQ`O7+(yO&;wQ`O7+(yOOQ[7+(y7+(yO!&iQMhO7+(yO%[QlO7+(yO&<PQ`O7+(yOOQ[7+({7+({O9kQ!0LrO7+({O$#yQ`O7+({O9UQ`O7+({O!BeQpO7+({O&<[Q`O,5?iOOQO-E<{-E<{OOQO'#H]'#H]O&<gQ`O1G6gO9kQ!0LrO<<GqOOQ[<<Gq<<GqO@iQ`O<<GqO&<oQ`O7+,UO&<tQ`O7+,VO%[QlO7+,UO%[QlO7+,VOOQ[7+)T7+)TO&<yQ`O7+)TO&=OQlO7+)TO&=VQ`O7+)TOOQ[<<Lw<<LwOOQ[<<Ly<<LyOOQ[-E=O-E=OOOQ[1G3x1G3xO&=[Q`O,5>_OOQ[,5>a,5>aO&=aQ`O1G4OO9ZQ`O7+&dO!(yQlO7+&dOOQO7+%]7+%]O&=fQ?MtO1G6XO>wQ`O7+%]OOQ!0Lf<<I_<<I_OOQ!0Lf<<Ix<<IxO>wQ`O<<IxOOQO<<Iq<<IqO$?{Q!0MxO<<IqO%[QlO<<IqOOQO<<Ib<<IbO!BYQ!0LrO<<IbO&=pQ!0LrO<<IqO&={Q!0MxO<= [O&>]Q`O<= ZOOQO7+*]7+*]O9ZQ`O7+*]OOQ[ANAjANAjO&>eQ!fOANAjO!&iQMhOANAjO#'cQ`OANAjO4UQ!fOANAjO&>lQ`OANAjO%[QlOANAjO&>tQ!0MzO7+'yO&AVQ!0MzO,5?_O&CbQ!0MzO,5?aO&EmQ!0MzO7+'{O&HOQ!fO1G4jO&HYQ?MtO7+&_O&J^Q?MvO,5=WO&LeQ?MvO,5=YO&LuQ?MvO,5=WO&MVQ?MvO,5=YO&MgQ?MvO,59sO' mQ?MvO,5<jO'#pQ?MvO,5<lO'&UQ?MvO,5<zO''zQ?MtO7+'jO'(XQ?MtO7+'lO'(fQ`O,5<[OOQO7+'_7+'_OOQ!0Lh7+*b7+*bO'(kQMjO<<K|OOQO1G4u1G4uO'(rQ`O1G4uO'(}Q`O1G4uO')]Q`O7++zO')]Q`O7++zO!&iQMhO1G4wO')eQ!dO1G4wO')oQ`O7++{O')wQ`O7+(UO'*SQ!dO7+(UOOQ!0Lb7+(S7+(SOOQ!0Lb7+(T7+(TO!BeQpO7+(SOCfQ`O7+(SO'*^Q`O7+(UO!&iQMhO7+(UO$)iQ`O7+(TO'*cQ`O7+(UOCfQ`O7+(TO'*kQMjO<<NuOOQ!0Lh7+${7+${O!+rQMhO<<NuO'*uQ!dO,5?dOOQO-E<v-E<vO'+PQ!0MvO7+(XO!&iQMhO7+(XOOQ[AN=gAN=gO9aQ`O1G5UOOQO1G5U1G5UO'+aQ`O1G5UO'+fQ`O7+,TO'+fQ`O7+,TO9kQ!0LrOANBVO@iQ`OANBVOOQ[ANBVANBVOOQ[ANArANArOOQ[ANAsANAsO'+nQ`O,5?fOOQO-E<x-E<xO'+yQ?MtO1G6fOOQO,5?h,5?hOOQO-E<z-E<zOOQ[1G3`1G3`O',TQ`O,5=OOOQ[<<Le<<LeO!&iQMhO<<LeO&;rQ`O<<LeO',YQ`O<<LeO%[QlO<<LeOOQ[<<Lg<<LgO9kQ!0LrO<<LgO$#yQ`O<<LgO9UQ`O<<LgO',bQpO1G5TO',mQ`O7+,ROOQ[AN=]AN=]O9kQ!0LrOAN=]OOQ[<= p<= pOOQ[<= q<= qO',uQ`O<= pO',zQ`O<= qOOQ[<<Lo<<LoO'-PQ`O<<LoO'-UQlO<<LoOOQ[1G3y1G3yO>wQ`O7+)jO'-]Q`O<<JOO'-hQ?MtO<<JOOOQO<<Hw<<HwOOQ!0LfAN?dAN?dOOQOAN?]AN?]O$?{Q!0MxOAN?]OOQOAN>|AN>|O%[QlOAN?]OOQO<<Mw<<MwOOQ[G27UG27UO!&iQMhOG27UO#'cQ`OG27UO'-rQ!fOG27UO4UQ!fOG27UO'-yQ`OG27UO'.RQ?MtO<<JeO'.`Q?MvO1G2_O'0UQ?MvO,5?_O'2XQ?MvO,5?aO'4[Q?MvO1G2rO'6_Q?MvO1G2tO'8bQ?MtO<<KWO'8oQ?MtO<<IyOOQO1G1v1G1vO!+rQMhOANAhOOQO7+*a7+*aO'8|Q`O7+*aO'9XQ`O<= fO'9aQ!dO7+*cOOQ!0Lb<<Kp<<KpO$)iQ`O<<KpOCfQ`O<<KpO'9kQ`O<<KpO!&iQMhO<<KpOOQ!0Lb<<Kn<<KnO!BeQpO<<KnO'9vQ!dO<<KpOOQ!0Lb<<Ko<<KoO':QQ`O<<KpO!&iQMhO<<KpO$)iQ`O<<KoO':VQMjOANDaO':aQ!0MvO<<KsOOQO7+*p7+*pO9aQ`O7+*pO':qQ`O<= oOOQ[G27qG27qO9kQ!0LrOG27qO!(yQlO1G5QO':yQ`O7+,QO';RQ`O1G2jO&;rQ`OANBPOOQ[ANBPANBPO!&iQMhOANBPO';WQ`OANBPOOQ[ANBRANBRO9kQ!0LrOANBRO$#yQ`OANBROOQO'#H^'#H^OOQO7+*o7+*oOOQ[G22wG22wOOQ[ANE[ANE[OOQ[ANE]ANE]OOQ[ANBZANBZO';`Q`OANBZOOQ[<<MU<<MUO!(yQlOAN?jOOQOG24wG24wO$?{Q!0MxOG24wO#'cQ`OLD,pOOQ[LD,pLD,pO!&iQMhOLD,pO';eQ!fOLD,pO';lQ?MvO7+'yO'=bQ?MvO,5?_O'?eQ?MvO,5?aO'AhQ?MvO7+'{O'C^QMjOG27SOOQO<<M{<<M{OOQ!0LbANA[ANA[O$)iQ`OANA[OCfQ`OANA[O'CnQ!dOANA[OOQ!0LbANAYANAYO'CuQ`OANA[O!&iQMhOANA[O'DQQ!dOANA[OOQ!0LbANAZANAZOOQO<<N[<<N[OOQ[LD-]LD-]O'D[Q?MtO7+*lOOQO'#Ge'#GeOOQ[G27kG27kO&;rQ`OG27kO!&iQMhOG27kOOQ[G27mG27mO9kQ!0LrOG27mOOQ[G27uG27uO'DfQ?MtOG25UOOQOLD*cLD*cOOQ[!$(![!$(![O#'cQ`O!$(![O!&iQMhO!$(![O'DpQ!0MzOG27SOOQ!0LbG26vG26vO$)iQ`OG26vO'GRQ`OG26vOCfQ`OG26vO'G^Q!dOG26vO!&iQMhOG26vOOQ[LD-VLD-VO&;rQ`OLD-VOOQ[LD-XLD-XOOQ[!)9Ev!)9EvO#'cQ`O!)9EvOOQ!0LbLD,bLD,bO$)iQ`OLD,bOCfQ`OLD,bO'GeQ`OLD,bO'GpQ!dOLD,bOOQ[!$(!q!$(!qOOQ[!.K;b!.K;bO'GwQ?MvOG27SOOQ!0Lb!$( |!$( |O$)iQ`O!$( |OCfQ`O!$( |O'ImQ`O!$( |OOQ!0Lb!)9Eh!)9EhO$)iQ`O!)9EhOCfQ`O!)9EhOOQ!0Lb!.K;S!.K;SO$)iQ`O!.K;SOOQ!0Lb!4/0n!4/0nO!(yQlO'#DxO1PQ`O'#EVO'IxQ!fO'#JpO'JPQ!L^O'#DtO'JWQlO'#D|O'J_Q!fO'#CiO'LuQ!fO'#CiO!(yQlO'#EOO'MVQlO,5;XO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO'#InO( YQ`O,5<hO!(yQlO,5;cO( bQMhO,5;cO(!{QMhO,5;cO!(yQlO,5;vO!&iQMhO'#GlO( bQMhO'#GlO!&iQMhO'#GnO( bQMhO'#GnO1SQ`O'#DXO1SQ`O'#DXO!&iQMhO'#GOO( bQMhO'#GOO!&iQMhO'#GQO( bQMhO'#GQO!&iQMhO'#G`O( bQMhO'#G`O!(yQlO,5:hO(#SQpO'#D]O(#^QpO'#JtO!(yQlO,5@mO'MVQlO1G0sO(#hQ?MtO'#CiO!(yQlO1G2OO!&iQMhO'#IsO( bQMhO'#IsO!&iQMhO'#IuO( bQMhO'#IuO(#rQ!dO'#CrO!&iQMhO,5<sO( bQMhO,5<sO'MVQlO1G2QO!(yQlO7+&yO!&iQMhO1G2_O( bQMhO1G2_O!&iQMhO'#IsO( bQMhO'#IsO!&iQMhO'#IuO( bQMhO'#IuO!&iQMhO1G2aO( bQMhO1G2aO'MVQlO7+'lO'MVQlO7+&_O!&iQMhOANAhO( bQMhOANAhO($VQ`O'#EmO($[Q`O'#EmO($dQ`O'#F[O($iQ`O'#EwO($nQ`O'#KRO($yQ`O'#KPO(%UQ`O,5;XO(%ZQMjO,5<dO(%bQ`O'#GXO(%gQ`O'#GXO(%lQ`O,5<fO(%tQ`O,5;XO(%|Q?MtO1G1_O(&TQ`O,5<sO(&YQ`O,5<sO(&_Q`O,5<uO(&dQ`O,5<uO(&iQ`O1G2QO(&nQ`O1G0sO(&sQMjO<<K|O(&zQMjO<<K|O7eQMhO'#F{O9UQ`O'#FzOAdQ`O'#ElO!(yQlO,5;sO!3^Q`O'#GXO!3^Q`O'#GXO!3^Q`O'#GZO!3^Q`O'#GZO!+rQMhO7+(bO!+rQMhO7+(bO%-ZQ!dO1G2vO%-ZQ!dO1G2vO!&iQMhO,5=[O!&iQMhO,5=[",
    stateData: "((P~O'zOS'{OSTOS'|RQ~OPYOQYOSfOY!VOaqOdzOeyOj!POnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]XO!guO!jZO!mYO!nYO!oYO!qvO!swO!vxO!z]O$V|O$miO%g}O%i!QO%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO%x!UO&U!WO&[!XO&^!YO&`!ZO&b![O&e!]O&k!^O&q!_O&s!`O&u!aO&w!bO&y!cO(RSO(TTO(WUO(_VO(m[O~OWtO~P`OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oa!wOq!nO!Q!oO!`!yO!a!vO!b!vO!z;wO#R!pO#S!pO#T!xO#U!pO#V!pO#Y!zO#Z!zO(S!lO(TTO(WUO(c!mO(m!sO~O'|!{O~OP]XR]X[]Xa]Xp]X!O]X!Q]X!Z]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X'x]X(_]X(p]X(w]X(x]X~O!e%QX~P(qO_!}O(T#PO(U!}O(V#PO~O_#QO(V#PO(W#PO(X#QO~Ov#SO!S#TO(`#TO(a#VO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R;{O(TTO(WUO(_VO(m[O~O!Y#ZO!Z#WO!W(fP!W(tP~P+}O![#cO~P`OPYOQYOSfOd!jOe!iOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(TTO(WUO(_VO(m[O~On#mO!Y#iO!z]O#g#lO#h#iO(R;|O!i(qP~P.iO!j#oO(R#nO~O!v#sO!z]O%g#tO~O#i#uO~O!e#vO#i#uO~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!Z$_O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~Oa(dX'x(dX'u(dX!i(dX!W(dX!](dX%h(dX!e(dX~P1qO#Q$dO#^$eO$P$eOP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#t(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX!](eX%h(eX~Oa(eX'x(eX'u(eX!W(eX!i(eXt(eX!e(eX~P4UO#^$eO~O$[$hO$^$gO$e$mO~OSfO!]$nO$h$oO$j$qO~Oh%VOj%cOn%WOp%XOq$tOr$tOx%YOz%ZO|%[O!Q${O!]$|O!g%aO!j$xO#h%bO$V%_O$s%]O$u%^O$x%`O(R$sO(TTO(WUO(_$uO(w$}O(x%POg([P~O!j%dO~O!Q%gO!]%hO(R%fO~O!e%lO~Oa%mO'x%mO~O!O%qO~P%[O(S!lO~P%[O%m%uO~P%[Oh%VO!j%dO(R%fO(S!lO~Oe%|O!j%dO(R%fO~O#t$RO~O!O&RO!]&OO!j&QO%i&UO(R%fO(S!lO(TTO(WUO`)UP~O!v#sO~O%r&WO!Q)QX!])QX(R)QX~O(R&XO~Oj!PO!s&^O%i!QO%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO~Od&cOe&bO!v&`O%g&aO%z&_O~P<POd&fOeyOj!PO!]&eO!s&^O!vxO!z]O%g}O%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO%x!UO~Ob&iO#^&lO%i&gO(S!lO~P=UO!j&mO!s&qO~O!j#oO~O!]XO~Oa%mO'v&yO'x%mO~Oa%mO'v&|O'x%mO~Oa%mO'v'OO'x%mO~O'u]X!W]Xt]X!i]X&Y]X!]]X%h]X!e]X~P(qO!`']O!a'UO!b'UO(S!lO(TTO(WUO~Oq'SO!Q'RO!Y'VO(c'QO![(gP![(vP~P@]Ol'`O!]'^O(R%fO~Oe'eO!j%dO(R%fO~O!O&RO!j&QO~Oq!nO!Q!oO!z;wO#R!pO#S!pO#U!pO#V!pO(S!lO(TTO(WUO(c!mO(m!sO~O!`'kO!a'jO!b'jO#T!pO#Y'lO#Z'lO~PAwOa%mOh%VO!e#vO!j%dO'x%mO(p'nO~O!n'rO#^'pO~PCVOq!nO!Q!oO(TTO(WUO(c!mO(m!sO~O!]XOq(kX!Q(kX!`(kX!a(kX!b(kX!z(kX#R(kX#S(kX#T(kX#U(kX#V(kX#Y(kX#Z(kX(S(kX(T(kX(W(kX(c(kX(m(kX~O!a'jO!b'jO(S!lO~PCuO'}'vO(O'vO(P'xO~O_!}O(T'zO(U!}O(V'zO~O_#QO(V'zO(W'zO(X#QO~Ot'|O~P%[Ov#SO!S#TO(`#TO(a(PO~O!Y(RO!W'UX!W'[X!Z'UX!Z'[X~P+}O!Z(TO!W(fX~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!Z(TO!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~O!W(fX~PGpO!W(YO~O!W(sX!Z(sX!e(sX!i(sX(p(sX~O#^(sX#i#bX![(sX~PIsO#^(ZO!W(uX!Z(uX~O!Z([O!W(tX~O!W(_O~O#^$eO~PIsO![(`O~P`OR#zO!O#yO!Q#{O!j#xO(_VOP!la[!lap!la!Z!la!n!la#P!la#l!la#m!la#n!la#o!la#p!la#q!la#r!la#s!la#t!la#u!la#w!la#y!la#z!la(p!la(w!la(x!la~Oa!la'x!la'u!la!W!la!i!lat!la!]!la%h!la!e!la~PKZO!i(aO~O!e#vO#^(bO(p'nO!Z(rXa(rX'x(rX~O!i(rX~PMvO!Q%gO!]%hO!z]O#g(gO#h(fO(R%fO~O!Z(hO!i(qX~O!i(jO~O!Q%gO!]%hO#h(fO(R%fO~OP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#t(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX~O!e#vO!i(eX~P! dOR(lO!O(kO!j#xO#Q$dO!z!ya!Q!ya~O!v!ya%g!ya!]!ya#g!ya#h!ya(R!ya~P!#eO!v(pO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]XO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~O#i(vO~O!Y(xO!i(iP~P%[O(c(zO(m[O~O!Q(|O!j#xO(c(zO(m[O~OP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]!eO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(R)ZO(TTO(WUO(_VO(m[O~O!Z$_Oa$pa'x$pa'u$pa!i$pa!W$pa!]$pa%h$pa!e$pa~Oj)bO~P!&iOh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|%[O!Q${O!]$|O!g%aO!j$xO#h%bO$V%_O$s%]O$u%^O$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~Og(nP~P!+rO!O)gO!e)fO!]$]X$Y$]X$[$]X$^$]X$e$]X~O!e)fO!](yX$Y(yX$[(yX$^(yX$e(yX~O!O)gO~P!-{O!O)gO!](yX$Y(yX$[(yX$^(yX$e(yX~O!])iO$Y)mO$[)hO$^)hO$e)nO~O!Y)qO~P!(yO$[$hO$^$gO$e)uO~Ol$yX!O$yX#Q$yX'w$yX(w$yX(x$yX~OgkXg$yXlkX!ZkX#^kX~P!/qOv)wO(`)xO(a)zO~Ol*TO!O)|O'w)}O(w$}O(x%PO~Og){O~P!0uOg*UO~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q*WO!]*XO!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(TTO(WUO(_$uO(w$}O(x%PO~O!Y*[O(R*VO!i(|P~P!1dO#i*^O~O!j*_O~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(R*aO(TTO(WUO(_$uO(w$}O(x%PO~O!Y*dO!W(}P~P!3cOp*pOq!nO!Q*fO!`*nO!a*hO!b*hO!j*_O#Y*oO%_*jO(S!lO(TTO(WUO(c!mO~O![*mO~P!5WO#Q$dOl(^X!O(^X'w(^X(w(^X(x(^X!Z(^X#^(^X~Og(^X#}(^X~P!6YOl*uO#^*tOg(]X!Z(]X~O!Z*vOg([X~Oj%cO(R&XOg([P~Oq*yO~O!j+OO~O(R(tO~On+TO!Q%gO!Y#iO!]%hO!z]O#g#lO#h#iO(R%fO!i(qP~O!e#vO#i+UO~O!Q%gO!Y+WO!Z([O!]%hO(R%fO!W(tP~Oq'YO!Q+YO!Y+XO(TTO(WUO(c(zO~O![(vP~P!9]O!Z+ZOa)RX'x)RX~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~Oa!ha!Z!ha'x!ha'u!ha!W!ha!i!hat!ha!]!ha%h!ha!e!ha~P!:TOR#zO!O#yO!Q#{O!j#xO(_VOP!pa[!pap!pa!Z!pa!n!pa#P!pa#l!pa#m!pa#n!pa#o!pa#p!pa#q!pa#r!pa#s!pa#t!pa#u!pa#w!pa#y!pa#z!pa(p!pa(w!pa(x!pa~Oa!pa'x!pa'u!pa!W!pa!i!pat!pa!]!pa%h!pa!e!pa~P!<kOR#zO!O#yO!Q#{O!j#xO(_VOP!ra[!rap!ra!Z!ra!n!ra#P!ra#l!ra#m!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#w!ra#y!ra#z!ra(p!ra(w!ra(x!ra~Oa!ra'x!ra'u!ra!W!ra!i!rat!ra!]!ra%h!ra!e!ra~P!?ROh%VOl+dO!]'^O%h+cO~O!e+fOa(ZX!](ZX'x(ZX!Z(ZX~Oa%mO!]XO'x%mO~Oh%VO!j%dO~Oh%VO!j%dO(R%fO~O!e#vO#i(vO~Ob+qO%i+rO(R+nO(TTO(WUO![)VP~O!Z+sO`)UX~O[+wO~O`+xO~O!]&OO(R%fO(S!lO`)UP~Oh%VO#^+}O~Oh%VOl,QO!]$|O~O!],SO~O!O,UO!]XO~O%m%uO~O!v,ZO~Oe,`O~Ob,aO(R#nO(TTO(WUO![)TP~Oe%|O~O%i!QO(R&XO~P=UO[,fO`,eO~OPYOQYOSfOdzOeyOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!guO!jZO!mYO!nYO!oYO!qvO!vxO!z]O$miO%g}O(TTO(WUO(_VO(m[O~O!]!eO!s!gO$V!kO(R!dO~P!FRO`,eOa%mO'x%mO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oa,kOj!OO!swO%k!OO%l!OO%m!OO~P!HkO!j&mO~O&[,qO~O!],sO~O&m,uO&o,vOP&jaQ&jaS&jaY&jaa&jad&jae&jaj&jan&jap&jaq&jar&jax&jaz&ja|&ja!Q&ja!U&ja!V&ja!]&ja!g&ja!j&ja!m&ja!n&ja!o&ja!q&ja!s&ja!v&ja!z&ja$V&ja$m&ja%g&ja%i&ja%k&ja%l&ja%m&ja%p&ja%r&ja%u&ja%v&ja%x&ja&U&ja&[&ja&^&ja&`&ja&b&ja&e&ja&k&ja&q&ja&s&ja&u&ja&w&ja&y&ja'u&ja(R&ja(T&ja(W&ja(_&ja(m&ja![&ja&c&jab&ja&h&ja~O(R,{O~Oh!cX!Z!PX![!PX!e!PX!e!cX!j!cX#^!PX~O!Z!cX![!cX~P# qO!e-QO#^-POh(hX!Z#fX![#fX!e(hX!j(hX~O!Z(hX![(hX~P#!dOh%VO!e-SO!j%dO!Z!_X![!_X~Oq!nO!Q!oO(TTO(WUO(c!mO~OP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]!eO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(TTO(WUO(_VO(m[O~O(R<rO~P##yO!Z-WO![(gX~O![-YO~O!e-QO#^-PO!Z#fX![#fX~O!Z-ZO![(vX~O![-]O~O!a-^O!b-^O(S!lO~P##hO![-aO~P'_Ol-dO!]'^O~O!W-iO~Oq!ya!`!ya!a!ya!b!ya#R!ya#S!ya#T!ya#U!ya#V!ya#Y!ya#Z!ya(S!ya(T!ya(W!ya(c!ya(m!ya~P!#eO!n-nO#^-lO~PCVO!a-pO!b-pO(S!lO~PCuOa%mO#^-lO'x%mO~Oa%mO!e#vO#^-lO'x%mO~Oa%mO!e#vO!n-nO#^-lO'x%mO(p'nO~O'}'vO(O'vO(P-uO~Ot-vO~O!W'Ua!Z'Ua~P!:TO!Y-zO!W'UX!Z'UX~P%[O!Z(TO!W(fa~O!W(fa~PGpO!Z([O!W(ta~O!Q%gO!Y.OO!]%hO(R%fO!W'[X!Z'[X~O#^.QO!Z(ra!i(raa(ra'x(ra~O!e#vO~P#,PO!Z(hO!i(qa~O!Q%gO!]%hO#h.UO(R%fO~On.ZO!Q%gO!Y.WO!]%hO!z]O#g.YO#h.WO(R%fO!Z'_X!i'_X~OR._O!j#xO~Oh%VOl.bO!]'^O%h.aO~Oa#ai!Z#ai'x#ai'u#ai!W#ai!i#ait#ai!]#ai%h#ai!e#ai~P!:TOl=|O!O)|O'w)}O(w$}O(x%PO~O#i#]aa#]a#^#]a'x#]a!Z#]a!i#]a!]#]a!W#]a~P#.{O#i(^XP(^XR(^X[(^Xa(^Xp(^X!Q(^X!j(^X!n(^X#P(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#s(^X#t(^X#u(^X#w(^X#y(^X#z(^X'x(^X(_(^X(p(^X!i(^X!W(^X'u(^Xt(^X!](^X%h(^X!e(^X~P!6YO!Z.oO!i(iX~P!:TO!i.rO~O!W.tO~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O(_VO[#kia#kip#ki!Z#ki#P#ki#m#ki#n#ki#o#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#l#ki~P#2kO#l$OO~P#2kOP$[OR#zOp$aO!O#yO!Q#{O!j#xO!n$[O#l$OO#m$PO#n$PO#o$PO(_VO[#kia#ki!Z#ki#P#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#p#ki~P#5YO#p$QO~P#5YOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO(_VOa#ki!Z#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#u#ki~P#7wOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO(_VO(x#}Oa#ki!Z#ki#y#ki#z#ki'x#ki(p#ki(w#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#w$UO~P#:_O#w#ki~P#:_O#u$SO~P#7wOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO(_VO(w#|O(x#}Oa#ki!Z#ki#z#ki'x#ki(p#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#y#ki~P#=TO#y$WO~P#=TOP]XR]X[]Xp]X!O]X!Q]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X!Z]X![]X~O#}]X~P#?rOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO#w<VO#y<XO#z<YO(_VO(p$YO(w#|O(x#}O~O#}.vO~P#BPO#Q$dO#^<`O$P<`O#}(eX![(eX~P! dOa'ba!Z'ba'x'ba'u'ba!i'ba!W'bat'ba!]'ba%h'ba!e'ba~P!:TO[#kia#kip#ki!Z#ki#P#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O#l$OO#m$PO#n$PO#o$PO(_VO(w#ki(x#ki~P#EROl=|O!O)|O'w)}O(w$}O(x%POP#kiR#ki!Q#ki!j#ki!n#ki#l#ki#m#ki#n#ki#o#ki(_#ki~P#ERO!Z.zOg(nX~P!0uOg.|O~Oa$Oi!Z$Oi'x$Oi'u$Oi!W$Oi!i$Oit$Oi!]$Oi%h$Oi!e$Oi~P!:TO$[.}O$^.}O~O$[/OO$^/OO~O!e)fO#^/PO!]$bX$Y$bX$[$bX$^$bX$e$bX~O!Y/QO~O!])iO$Y/SO$[)hO$^)hO$e/TO~O!Z<ZO![(dX~P#BPO![/UO~O!e)fO$e(yX~O$e/WO~Ot/XO~P!&iOv)wO(`)xO(a/[O~O!Q/_O~O(w$}Ol%`a!O%`a'w%`a(x%`a!Z%`a#^%`a~Og%`a#}%`a~P#LTO(x%POl%ba!O%ba'w%ba(w%ba!Z%ba#^%ba~Og%ba#}%ba~P#LvO!ZfX!efX!ifX!i$yX(pfX~P!/qO!Y/hO!Z([O(R/gO!W(tP!W(}P~P!1dOp*pO!`*nO!a*hO!b*hO!j*_O#Y*oO%_*jO(S!lO(TTO(WUO~Oq<oO!Q/iO!Y+XO![*mO(c<nO![(vP~P#NaO!i/jO~P#.{O!Z/kO!e#vO(p'nO!i(|X~O!i/pO~O!Q%gO!Y*[O!]%hO(R%fO!i(|P~O#i/rO~O!W$yX!Z$yX!e%QX~P!/qO!Z/sO!W(}X~P#.{O!e/uO~O!W/wO~OnkO(R/xO~P.iOh%VOp/}O!e#vO!j%dO(p'nO~O!e+fO~Oa%mO!Z0RO'x%mO~O![0TO~P!5WO!a0UO!b0UO(S!lO~P##hOq!nO!Q0VO(TTO(WUO(c!mO~O#Y0XO~Og%`a!Z%`a#^%`a#}%`a~P!0uOg%ba!Z%ba#^%ba#}%ba~P!0uOj%cO(R&XOg'kX!Z'kX~O!Z*vOg([a~Og0bO~OR0cO!O0cO!Q0dO#Q$dOl{a'w{a(w{a(x{a!Z{a#^{a~Og{a#}{a~P$&dO!O)|O'w)}Ol$ra(w$ra(x$ra!Z$ra#^$ra~Og$ra#}$ra~P$'`O!O)|O'w)}Ol$ta(w$ta(x$ta!Z$ta#^$ta~Og$ta#}$ta~P$(RO#i0gO~Og%Sa!Z%Sa#^%Sa#}%Sa~P!0uOl0iO#^0hOg(]a!Z(]a~O!e#vO~O#i0lO~O!Z+ZOa)Ra'x)Ra~OR#zO!O#yO!Q#{O!j#xO(_VOP!pi[!pip!pi!Z!pi!n!pi#P!pi#l!pi#m!pi#n!pi#o!pi#p!pi#q!pi#r!pi#s!pi#t!pi#u!pi#w!pi#y!pi#z!pi(p!pi(w!pi(x!pi~Oa!pi'x!pi'u!pi!W!pi!i!pit!pi!]!pi%h!pi!e!pi~P$*OOh%VOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(TTO(WUO(_$uO(w$}O(x%PO~On0vO%[0wO(R0tO~P$,fO!e+fOa(Za!](Za'x(Za!Z(Za~O#i0|O~O[]X!ZfX![fX~O!Z0}O![)VX~O![1PO~O[1QO~Ob1SO(R+nO(TTO(WUO~O!]&OO(R%fO`'sX!Z'sX~O!Z+sO`)Ua~O!i1VO~P!:TO[1YO~O`1ZO~O#^1^O~Ol1aO!]$|O~O(c(zO![)SP~Oh%VOl1jO!]1gO%h1iO~O[1tO!Z1rO![)TX~O![1uO~O`1wOa%mO'x%mO~O(R#nO(TTO(WUO~O#Q$dO#^$eO$P$eOP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX~O#t1zO&Y1{Oa(eX~P$2PO#^$eO#t1zO&Y1{O~Oa1}O~P%[Oa2PO~O&c2SOP&aiQ&aiS&aiY&aia&aid&aie&aij&ain&aip&aiq&air&aix&aiz&ai|&ai!Q&ai!U&ai!V&ai!]&ai!g&ai!j&ai!m&ai!n&ai!o&ai!q&ai!s&ai!v&ai!z&ai$V&ai$m&ai%g&ai%i&ai%k&ai%l&ai%m&ai%p&ai%r&ai%u&ai%v&ai%x&ai&U&ai&[&ai&^&ai&`&ai&b&ai&e&ai&k&ai&q&ai&s&ai&u&ai&w&ai&y&ai'u&ai(R&ai(T&ai(W&ai(_&ai(m&ai![&aib&ai&h&ai~Ob2YO![2WO&h2XO~P`O!]XO!j2[O~O&o,vOP&jiQ&jiS&jiY&jia&jid&jie&jij&jin&jip&jiq&jir&jix&jiz&ji|&ji!Q&ji!U&ji!V&ji!]&ji!g&ji!j&ji!m&ji!n&ji!o&ji!q&ji!s&ji!v&ji!z&ji$V&ji$m&ji%g&ji%i&ji%k&ji%l&ji%m&ji%p&ji%r&ji%u&ji%v&ji%x&ji&U&ji&[&ji&^&ji&`&ji&b&ji&e&ji&k&ji&q&ji&s&ji&u&ji&w&ji&y&ji'u&ji(R&ji(T&ji(W&ji(_&ji(m&ji![&ji&c&jib&ji&h&ji~O!W2bO~O!Z!_a![!_a~P#BPOq!nO!Q!oO!Y2hO(c!mO!Z'VX!['VX~P@]O!Z-WO![(ga~O!Z']X![']X~P!9]O!Z-ZO![(va~O![2oO~P'_Oa%mO#^2xO'x%mO~Oa%mO!e#vO#^2xO'x%mO~Oa%mO!e#vO!n2|O#^2xO'x%mO(p'nO~Oa%mO'x%mO~P!:TO!Z$_Ot$pa~O!W'Ui!Z'Ui~P!:TO!Z(TO!W(fi~O!Z([O!W(ti~O!W(ui!Z(ui~P!:TO!Z(ri!i(ria(ri'x(ri~P!:TO#^3OO!Z(ri!i(ria(ri'x(ri~O!Z(hO!i(qi~O!Q%gO!]%hO!z]O#g3TO#h3SO(R%fO~O!Q%gO!]%hO#h3SO(R%fO~Ol3[O!]'^O%h3ZO~Oh%VOl3[O!]'^O%h3ZO~O#i%`aP%`aR%`a[%`aa%`ap%`a!Q%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a'x%`a(_%`a(p%`a!i%`a!W%`a'u%`at%`a!]%`a%h%`a!e%`a~P#LTO#i%baP%baR%ba[%baa%bap%ba!Q%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba'x%ba(_%ba(p%ba!i%ba!W%ba'u%bat%ba!]%ba%h%ba!e%ba~P#LvO#i%`aP%`aR%`a[%`aa%`ap%`a!Q%`a!Z%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a'x%`a(_%`a(p%`a!i%`a!W%`a'u%`a#^%`at%`a!]%`a%h%`a!e%`a~P#.{O#i%baP%baR%ba[%baa%bap%ba!Q%ba!Z%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba'x%ba(_%ba(p%ba!i%ba!W%ba'u%ba#^%bat%ba!]%ba%h%ba!e%ba~P#.{O#i{aP{a[{aa{ap{a!j{a!n{a#P{a#l{a#m{a#n{a#o{a#p{a#q{a#r{a#s{a#t{a#u{a#w{a#y{a#z{a'x{a(_{a(p{a!i{a!W{a'u{at{a!]{a%h{a!e{a~P$&dO#i$raP$raR$ra[$raa$rap$ra!Q$ra!j$ra!n$ra#P$ra#l$ra#m$ra#n$ra#o$ra#p$ra#q$ra#r$ra#s$ra#t$ra#u$ra#w$ra#y$ra#z$ra'x$ra(_$ra(p$ra!i$ra!W$ra'u$rat$ra!]$ra%h$ra!e$ra~P$'`O#i$taP$taR$ta[$taa$tap$ta!Q$ta!j$ta!n$ta#P$ta#l$ta#m$ta#n$ta#o$ta#p$ta#q$ta#r$ta#s$ta#t$ta#u$ta#w$ta#y$ta#z$ta'x$ta(_$ta(p$ta!i$ta!W$ta'u$tat$ta!]$ta%h$ta!e$ta~P$(RO#i%SaP%SaR%Sa[%Saa%Sap%Sa!Q%Sa!Z%Sa!j%Sa!n%Sa#P%Sa#l%Sa#m%Sa#n%Sa#o%Sa#p%Sa#q%Sa#r%Sa#s%Sa#t%Sa#u%Sa#w%Sa#y%Sa#z%Sa'x%Sa(_%Sa(p%Sa!i%Sa!W%Sa'u%Sa#^%Sat%Sa!]%Sa%h%Sa!e%Sa~P#.{Oa#aq!Z#aq'x#aq'u#aq!W#aq!i#aqt#aq!]#aq%h#aq!e#aq~P!:TO!Y3dO!Z'WX!i'WX~P%[O!Z.oO!i(ia~O!Z.oO!i(ia~P!:TO!W3gO~O#}!la![!la~PKZO#}!ha!Z!ha![!ha~P#BPO#}!pa![!pa~P!<kO#}!ra![!ra~P!?ROg'ZX!Z'ZX~P!+rO!Z.zOg(na~OSfO!]3{O$c3|O~O![4QO~Ot4RO~P#.{Oa$lq!Z$lq'x$lq'u$lq!W$lq!i$lqt$lq!]$lq%h$lq!e$lq~P!:TO!W4TO~P!&iO!Q4UO~O!O)|O'w)}O(x%POl'ga(w'ga!Z'ga#^'ga~Og'ga#}'ga~P%+uO!O)|O'w)}Ol'ia(w'ia(x'ia!Z'ia#^'ia~Og'ia#}'ia~P%,hO(p$YO~P#.{O!WfX!W$yX!ZfX!Z$yX!e%QX#^fX~P!/qO(R<xO~P!1dO!Q%gO!Y4XO!]%hO(R%fO!Z'cX!i'cX~O!Z/kO!i(|a~O!Z/kO!e#vO!i(|a~O!Z/kO!e#vO(p'nO!i(|a~Og${i!Z${i#^${i#}${i~P!0uO!Y4aO!W'eX!Z'eX~P!3cO!Z/sO!W(}a~O!Z/sO!W(}a~P#.{OP]XR]X[]Xp]X!O]X!Q]X!W]X!Z]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X~O!e%XX#t%XX~P%0XO!e#vO#t4fO~Oh%VO!e#vO!j%dO~Oh%VOp4kO!j%dO(p'nO~Op4pO!e#vO(p'nO~Oq!nO!Q4qO(TTO(WUO(c!mO~O(w$}Ol%`i!O%`i'w%`i(x%`i!Z%`i#^%`i~Og%`i#}%`i~P%3xO(x%POl%bi!O%bi'w%bi(w%bi!Z%bi#^%bi~Og%bi#}%bi~P%4kOg(]i!Z(]i~P!0uO#^4wOg(]i!Z(]i~P!0uO!i4zO~Oa$nq!Z$nq'x$nq'u$nq!W$nq!i$nqt$nq!]$nq%h$nq!e$nq~P!:TO!W5QO~O!Z5RO!])OX~P#.{Oa]Xa$yX!]]X!]$yX%]]X'x]X'x$yX!Z]X!Z$yX~P!/qO%]5UOa%Za!]%Za'x%Za!Z%Za~OlmX!OmX'wmX(wmX(xmX~P%7nOn5VO(R#nO~Ob5]O%i5^O(R+nO(TTO(WUO!Z'rX!['rX~O!Z0}O![)Va~O[5bO~O`5cO~Oa%mO'x%mO~P#.{O!Z5kO#^5mO![)SX~O![5nO~Op5tOq!nO!Q*fO!`!yO!a!vO!b!vO!z;wO#R!pO#S!pO#T!pO#U!pO#V!pO#Y5sO#Z!zO(S!lO(TTO(WUO(c!mO(m!sO~O![5rO~P%:ROl5yO!]1gO%h5xO~Oh%VOl5yO!]1gO%h5xO~Ob6QO(R#nO(TTO(WUO!Z'qX!['qX~O!Z1rO![)Ta~O(TTO(WUO(c6SO~O`6WO~O#t6ZO&Y6[O~PMvO!i6]O~P%[Oa6_O~Oa6_O~P%[Ob2YO![6dO&h2XO~P`O!e6fO~O!e6hOh(hi!Z(hi![(hi!e(hi!j(hip(hi(p(hi~O!Z#fi![#fi~P#BPO#^6iO!Z#fi![#fi~O!Z!_i![!_i~P#BPOa%mO#^6rO'x%mO~Oa%mO!e#vO#^6rO'x%mO~O!Z(rq!i(rqa(rq'x(rq~P!:TO!Z(hO!i(qq~O!Q%gO!]%hO#h6yO(R%fO~O!]'^O%h6|O~Ol7QO!]'^O%h6|O~O#i'gaP'gaR'ga['gaa'gap'ga!Q'ga!j'ga!n'ga#P'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#t'ga#u'ga#w'ga#y'ga#z'ga'x'ga(_'ga(p'ga!i'ga!W'ga'u'gat'ga!]'ga%h'ga!e'ga~P%+uO#i'iaP'iaR'ia['iaa'iap'ia!Q'ia!j'ia!n'ia#P'ia#l'ia#m'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#w'ia#y'ia#z'ia'x'ia(_'ia(p'ia!i'ia!W'ia'u'iat'ia!]'ia%h'ia!e'ia~P%,hO#i${iP${iR${i[${ia${ip${i!Q${i!Z${i!j${i!n${i#P${i#l${i#m${i#n${i#o${i#p${i#q${i#r${i#s${i#t${i#u${i#w${i#y${i#z${i'x${i(_${i(p${i!i${i!W${i'u${i#^${it${i!]${i%h${i!e${i~P#.{O#i%`iP%`iR%`i[%`ia%`ip%`i!Q%`i!j%`i!n%`i#P%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#t%`i#u%`i#w%`i#y%`i#z%`i'x%`i(_%`i(p%`i!i%`i!W%`i'u%`it%`i!]%`i%h%`i!e%`i~P%3xO#i%biP%biR%bi[%bia%bip%bi!Q%bi!j%bi!n%bi#P%bi#l%bi#m%bi#n%bi#o%bi#p%bi#q%bi#r%bi#s%bi#t%bi#u%bi#w%bi#y%bi#z%bi'x%bi(_%bi(p%bi!i%bi!W%bi'u%bit%bi!]%bi%h%bi!e%bi~P%4kO!Z'Wa!i'Wa~P!:TO!Z.oO!i(ii~O#}#ai!Z#ai![#ai~P#BPOP$[OR#zO!O#yO!Q#{O!j#xO!n$[O(_VO[#kip#ki#P#ki#m#ki#n#ki#o#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#l#ki~P%MQO#l<PO~P%MQOP$[OR#zOp<]O!O#yO!Q#{O!j#xO!n$[O#l<PO#m<QO#n<QO#o<QO(_VO[#ki#P#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#p#ki~P& YO#p<RO~P& YOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO(_VO#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#u#ki~P&#bOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO(_VO(x#}O#y#ki#z#ki#}#ki(p#ki(w#ki!Z#ki![#ki~O#w<VO~P&%cO#w#ki~P&%cO#u<TO~P&#bOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO#w<VO(_VO(w#|O(x#}O#z#ki#}#ki(p#ki!Z#ki![#ki~O#y#ki~P&'rO#y<XO~P&'rOa#{y!Z#{y'x#{y'u#{y!W#{y!i#{yt#{y!]#{y%h#{y!e#{y~P!:TO[#kip#ki#P#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki!Z#ki![#ki~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O#l<PO#m<QO#n<QO#o<QO(_VO(w#ki(x#ki~P&*nOl=}O!O)|O'w)}O(w$}O(x%POP#kiR#ki!Q#ki!j#ki!n#ki#l#ki#m#ki#n#ki#o#ki(_#ki~P&*nO#Q$dOP(^XR(^X[(^Xl(^Xp(^X!O(^X!Q(^X!j(^X!n(^X#P(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#s(^X#t(^X#u(^X#w(^X#y(^X#z(^X#}(^X'w(^X(_(^X(p(^X(w(^X(x(^X!Z(^X![(^X~O#}$Oi!Z$Oi![$Oi~P#BPO#}!pi![!pi~P$*OOg'Za!Z'Za~P!0uO![7dO~O!Z'ba!['ba~P#BPO!W7eO~P#.{O!e#vO(p'nO!Z'ca!i'ca~O!Z/kO!i(|i~O!Z/kO!e#vO!i(|i~Og${q!Z${q#^${q#}${q~P!0uO!W'ea!Z'ea~P#.{O!e7lO~O!Z/sO!W(}i~P#.{O!Z/sO!W(}i~O!W7oO~Oh%VOp7tO!j%dO(p'nO~O!e#vO#t7vO~Op7yO!e#vO(p'nO~O!O)|O'w)}O(x%POl'ha(w'ha!Z'ha#^'ha~Og'ha#}'ha~P&3oO!O)|O'w)}Ol'ja(w'ja(x'ja!Z'ja#^'ja~Og'ja#}'ja~P&4bO!W7{O~Og$}q!Z$}q#^$}q#}$}q~P!0uOg(]q!Z(]q~P!0uO#^7|Og(]q!Z(]q~P!0uOa$ny!Z$ny'x$ny'u$ny!W$ny!i$nyt$ny!]$ny%h$ny!e$ny~P!:TO!e6hO~O!Z5RO!])Oa~O!]'^OP$SaR$Sa[$Sap$Sa!O$Sa!Q$Sa!Z$Sa!j$Sa!n$Sa#P$Sa#l$Sa#m$Sa#n$Sa#o$Sa#p$Sa#q$Sa#r$Sa#s$Sa#t$Sa#u$Sa#w$Sa#y$Sa#z$Sa(_$Sa(p$Sa(w$Sa(x$Sa~O%h6|O~P&7SO%]8QOa%Zi!]%Zi'x%Zi!Z%Zi~Oa#ay!Z#ay'x#ay'u#ay!W#ay!i#ayt#ay!]#ay%h#ay!e#ay~P!:TO[8SO~Ob8UO(R+nO(TTO(WUO~O!Z0}O![)Vi~O`8YO~O(c(zO!Z'nX!['nX~O!Z5kO![)Sa~O![8cO~P%:RO(m!sO~P$$oO#Y8dO~O!]1gO~O!]1gO%h8fO~Ol8iO!]1gO%h8fO~O[8nO!Z'qa!['qa~O!Z1rO![)Ti~O!i8rO~O!i8sO~O!i8vO~O!i8vO~P%[Oa8xO~O!e8yO~O!i8zO~O!Z(ui![(ui~P#BPOa%mO#^9SO'x%mO~O!Z(ry!i(rya(ry'x(ry~P!:TO!Z(hO!i(qy~O%h9VO~P&7SO!]'^O%h9VO~O#i${qP${qR${q[${qa${qp${q!Q${q!Z${q!j${q!n${q#P${q#l${q#m${q#n${q#o${q#p${q#q${q#r${q#s${q#t${q#u${q#w${q#y${q#z${q'x${q(_${q(p${q!i${q!W${q'u${q#^${qt${q!]${q%h${q!e${q~P#.{O#i'haP'haR'ha['haa'hap'ha!Q'ha!j'ha!n'ha#P'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#w'ha#y'ha#z'ha'x'ha(_'ha(p'ha!i'ha!W'ha'u'hat'ha!]'ha%h'ha!e'ha~P&3oO#i'jaP'jaR'ja['jaa'jap'ja!Q'ja!j'ja!n'ja#P'ja#l'ja#m'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#w'ja#y'ja#z'ja'x'ja(_'ja(p'ja!i'ja!W'ja'u'jat'ja!]'ja%h'ja!e'ja~P&4bO#i$}qP$}qR$}q[$}qa$}qp$}q!Q$}q!Z$}q!j$}q!n$}q#P$}q#l$}q#m$}q#n$}q#o$}q#p$}q#q$}q#r$}q#s$}q#t$}q#u$}q#w$}q#y$}q#z$}q'x$}q(_$}q(p$}q!i$}q!W$}q'u$}q#^$}qt$}q!]$}q%h$}q!e$}q~P#.{O!Z'Wi!i'Wi~P!:TO#}#aq!Z#aq![#aq~P#BPO(w$}OP%`aR%`a[%`ap%`a!Q%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a#}%`a(_%`a(p%`a!Z%`a![%`a~Ol%`a!O%`a'w%`a(x%`a~P&HgO(x%POP%baR%ba[%bap%ba!Q%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba#}%ba(_%ba(p%ba!Z%ba![%ba~Ol%ba!O%ba'w%ba(w%ba~P&JnOl=}O!O)|O'w)}O(x%PO~P&HgOl=}O!O)|O'w)}O(w$}O~P&JnOR0cO!O0cO!Q0dO#Q$dOP{a[{al{ap{a!j{a!n{a#P{a#l{a#m{a#n{a#o{a#p{a#q{a#r{a#s{a#t{a#u{a#w{a#y{a#z{a#}{a'w{a(_{a(p{a(w{a(x{a!Z{a![{a~O!O)|O'w)}OP$raR$ra[$ral$rap$ra!Q$ra!j$ra!n$ra#P$ra#l$ra#m$ra#n$ra#o$ra#p$ra#q$ra#r$ra#s$ra#t$ra#u$ra#w$ra#y$ra#z$ra#}$ra(_$ra(p$ra(w$ra(x$ra!Z$ra![$ra~O!O)|O'w)}OP$taR$ta[$tal$tap$ta!Q$ta!j$ta!n$ta#P$ta#l$ta#m$ta#n$ta#o$ta#p$ta#q$ta#r$ta#s$ta#t$ta#u$ta#w$ta#y$ta#z$ta#}$ta(_$ta(p$ta(w$ta(x$ta!Z$ta![$ta~Ol=}O!O)|O'w)}O(w$}O(x%PO~OP%SaR%Sa[%Sap%Sa!Q%Sa!j%Sa!n%Sa#P%Sa#l%Sa#m%Sa#n%Sa#o%Sa#p%Sa#q%Sa#r%Sa#s%Sa#t%Sa#u%Sa#w%Sa#y%Sa#z%Sa#}%Sa(_%Sa(p%Sa!Z%Sa![%Sa~P'%sO#}$lq!Z$lq![$lq~P#BPO#}$nq!Z$nq![$nq~P#BPO![9dO~O#}9eO~P!0uO!e#vO!Z'ci!i'ci~O!e#vO(p'nO!Z'ci!i'ci~O!Z/kO!i(|q~O!W'ei!Z'ei~P#.{O!Z/sO!W(}q~Op9lO!e#vO(p'nO~O[9nO!W9mO~P#.{O!W9mO~O!e#vO#t9tO~Og(]y!Z(]y~P!0uO!Z'la!]'la~P#.{Oa%Zq!]%Zq'x%Zq!Z%Zq~P#.{O[9yO~O!Z0}O![)Vq~O#^9}O!Z'na!['na~O!Z5kO![)Si~P#BPO!Q:PO~O!]1gO%h:SO~O(TTO(WUO(c:XO~O!Z1rO![)Tq~O!i:[O~O!i:]O~O!i:^O~O!i:^O~P%[O#^:aO!Z#fy![#fy~O!Z#fy![#fy~P#BPO%h:fO~P&7SO!]'^O%h:fO~O#}#{y!Z#{y![#{y~P#BPOP${iR${i[${ip${i!Q${i!j${i!n${i#P${i#l${i#m${i#n${i#o${i#p${i#q${i#r${i#s${i#t${i#u${i#w${i#y${i#z${i#}${i(_${i(p${i!Z${i![${i~P'%sO!O)|O'w)}O(x%POP'gaR'ga['gal'gap'ga!Q'ga!j'ga!n'ga#P'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#t'ga#u'ga#w'ga#y'ga#z'ga#}'ga(_'ga(p'ga(w'ga!Z'ga!['ga~O!O)|O'w)}OP'iaR'ia['ial'iap'ia!Q'ia!j'ia!n'ia#P'ia#l'ia#m'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#w'ia#y'ia#z'ia#}'ia(_'ia(p'ia(w'ia(x'ia!Z'ia!['ia~O(w$}OP%`iR%`i[%`il%`ip%`i!O%`i!Q%`i!j%`i!n%`i#P%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#t%`i#u%`i#w%`i#y%`i#z%`i#}%`i'w%`i(_%`i(p%`i(x%`i!Z%`i![%`i~O(x%POP%biR%bi[%bil%bip%bi!O%bi!Q%bi!j%bi!n%bi#P%bi#l%bi#m%bi#n%bi#o%bi#p%bi#q%bi#r%bi#s%bi#t%bi#u%bi#w%bi#y%bi#z%bi#}%bi'w%bi(_%bi(p%bi(w%bi!Z%bi![%bi~O#}$ny!Z$ny![$ny~P#BPO#}#ay!Z#ay![#ay~P#BPO!e#vO!Z'cq!i'cq~O!Z/kO!i(|y~O!W'eq!Z'eq~P#.{Op:pO!e#vO(p'nO~O[:tO!W:sO~P#.{O!W:sO~Og(]!R!Z(]!R~P!0uOa%Zy!]%Zy'x%Zy!Z%Zy~P#.{O!Z0}O![)Vy~O!Z5kO![)Sq~O(R:zO~O!]1gO%h:}O~O!i;QO~O%h;VO~P&7SOP${qR${q[${qp${q!Q${q!j${q!n${q#P${q#l${q#m${q#n${q#o${q#p${q#q${q#r${q#s${q#t${q#u${q#w${q#y${q#z${q#}${q(_${q(p${q!Z${q![${q~P'%sO!O)|O'w)}O(x%POP'haR'ha['hal'hap'ha!Q'ha!j'ha!n'ha#P'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#w'ha#y'ha#z'ha#}'ha(_'ha(p'ha(w'ha!Z'ha!['ha~O!O)|O'w)}OP'jaR'ja['jal'jap'ja!Q'ja!j'ja!n'ja#P'ja#l'ja#m'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#w'ja#y'ja#z'ja#}'ja(_'ja(p'ja(w'ja(x'ja!Z'ja!['ja~OP$}qR$}q[$}qp$}q!Q$}q!j$}q!n$}q#P$}q#l$}q#m$}q#n$}q#o$}q#p$}q#q$}q#r$}q#s$}q#t$}q#u$}q#w$}q#y$}q#z$}q#}$}q(_$}q(p$}q!Z$}q![$}q~P'%sOg%d!Z!Z%d!Z#^%d!Z#}%d!Z~P!0uO!W;ZO~P#.{Op;[O!e#vO(p'nO~O[;^O!W;ZO~P#.{O!Z'nq!['nq~P#BPO!Z#f!Z![#f!Z~P#BPO#i%d!ZP%d!ZR%d!Z[%d!Za%d!Zp%d!Z!Q%d!Z!Z%d!Z!j%d!Z!n%d!Z#P%d!Z#l%d!Z#m%d!Z#n%d!Z#o%d!Z#p%d!Z#q%d!Z#r%d!Z#s%d!Z#t%d!Z#u%d!Z#w%d!Z#y%d!Z#z%d!Z'x%d!Z(_%d!Z(p%d!Z!i%d!Z!W%d!Z'u%d!Z#^%d!Zt%d!Z!]%d!Z%h%d!Z!e%d!Z~P#.{Op;fO!e#vO(p'nO~O!W;gO~P#.{Op;nO!e#vO(p'nO~O!W;oO~P#.{OP%d!ZR%d!Z[%d!Zp%d!Z!Q%d!Z!j%d!Z!n%d!Z#P%d!Z#l%d!Z#m%d!Z#n%d!Z#o%d!Z#p%d!Z#q%d!Z#r%d!Z#s%d!Z#t%d!Z#u%d!Z#w%d!Z#y%d!Z#z%d!Z#}%d!Z(_%d!Z(p%d!Z!Z%d!Z![%d!Z~P'%sOp;rO!e#vO(p'nO~Ot(dX~P1qO!O%qO~P!(yO(S!lO~P!(yO!WfX!ZfX#^fX~P%0XOP]XR]X[]Xp]X!O]X!Q]X!Z]X!ZfX!j]X!n]X#P]X#Q]X#^]X#^fX#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X~O!efX!i]X!ifX(pfX~P'JlOP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]XO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(R)ZO(TTO(WUO(_VO(m[O~O!Z<ZO![$pa~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<fO!Q${O!]$|O!g=wO!j$xO#h<lO$V%_O$s<hO$u<jO$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~Oj)bO~P( bOp!cX(p!cX~P# qOp(hX(p(hX~P#!dO![]X![fX~P'JlO!WfX!W$yX!ZfX!Z$yX#^fX~P!/qO#i<OO~O!e#vO#i<OO~O#^<`O~O#t<SO~O#^<pO!Z(uX![(uX~O#^<`O!Z(sX![(sX~O#i<qO~Og<sO~P!0uO#i<yO~O#i<zO~O!e#vO#i<{O~O!e#vO#i<qO~O#}<|O~P#BPO#i<}O~O#i=OO~O#i=TO~O#i=UO~O#i=VO~O#i=WO~O#}=XO~P!0uO#}=YO~P!0uO#Q#R#S#U#V#Y#g#h#s$m$s$u$x%[%]%g%h%i%p%r%u%v%x%z~'|T#m!V'z(S#nq#l#op!O'{$['{(R$^(c~",
    goto: "$8f)ZPPPPPP)[PP)_P)pP+Q/VPPPP6aPP6wPP<oP@cP@yP@yPPP@yPCRP@yP@yP@yPCVPC[PCyPHsPPPHwPPPPHwKzPPPLQLrPHwPHwPP! QHwPPPHwPHwP!#XHwP!&o!'t!'}P!(q!(u!(q!,SPPPPPPP!,s!'tPP!-T!.uP!2RHwHw!2W!5d!:Q!:Q!>PPPP!>XHwPPPPPPPPPP!AhP!BuPPHw!DWPHwPHwHwHwHwHwPHw!EjP!HtP!KzP!LO!LY!L^!L^P!HqP!Lb!LbP# hP# lHwPHw# r#$wCV@yP@yP@y@yP#&U@y@y#(h@y#+`@y#-l@y@y#.[#0p#0p#0u#1O#0p#1ZPP#0pP@y#1s@y#5r@y@y6aPPP#9wPPP#:b#:bP#:bP#:x#:bPP#;OP#:uP#:u#;c#:u#;}#<T#<W)_#<Z)_P#<b#<b#<bP)_P)_P)_P)_PP)_P#<h#<kP#<k)_P#<oP#<rP)_P)_P)_P)_P)_P)_)_PP#<x#=O#=Z#=a#=g#=m#=s#>R#>X#>c#>i#>s#>y#?Z#?a#@R#@e#@k#@q#AP#Af#CZ#Ci#Cp#E[#Ej#G[#Gj#Gp#Gv#G|#HW#H^#Hd#Hn#IQ#IWPPPPPPPPPPP#I^PPPPPPP#JR#MY#Nr#Ny$ RPPP$&mP$&v$)o$0Y$0]$0`$1_$1b$1i$1qP$1w$1zP$2h$2l$3d$4r$4w$5_PP$5d$5j$5n$5q$5u$5y$6u$7^$7u$7y$7|$8P$8V$8Y$8^$8bR!|RoqOXst!Z#d%l&p&r&s&u,n,s2S2VY!vQ'^-`1g5qQ%svQ%{yQ&S|Q&h!VS'U!e-WQ'd!iS'j!r!yU*h$|*X*lQ+l%|Q+y&UQ,_&bQ-^']Q-h'eQ-p'kQ0U*nQ1q,`R<m;z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9SS#q];w!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU*{%[<e<fQ+q&OQ,a&eQ,h&mQ0r+dQ0u+fQ1S+rQ1y,fQ3W.bQ5V0wQ5]0}Q6Q1rQ7O3[Q8U5^R9Y7Q'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s!S!nQ!r!v!y!z$|'U']'^'j'k'l*h*l*n*o-W-^-`-p0U0X1g5q5s%[$ti#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q&V|Q'S!eS'Y%h-ZQ+q&OQ,a&eQ0f+OQ1S+rQ1X+xQ1x,eQ1y,fQ5]0}Q5f1ZQ6Q1rQ6T1tQ6U1wQ8U5^Q8X5cQ8q6WQ9|8YQ:Y8nR<o*XrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR,c&i&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=r=s[#]WZ#W#Z'V(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ%vxQ%zyS&P|&UQ&]!TQ'a!hQ'c!iQ(o#sS+k%{%|Q+o&OQ,Y&`Q,^&bS-g'd'eQ.d(pQ0{+lQ1R+rQ1T+sQ1W+wQ1l,ZS1p,_,`Q2t-hQ5[0}Q5`1QQ5e1YQ6P1qQ8T5^Q8W5bQ9x8SR:w9y!U$zi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y!^%xy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pQ+e%vQ,O&YQ,R&ZQ,]&bQ.c(oQ1k,YU1o,^,_,`Q3].dQ5z1lS6O1p1qQ8m6P#f=t#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o=u<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YW%Ti%V*v=pS&Y!Q&gQ&Z!RQ&[!SQ+S%cR+|&W%]%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}T)x$u)yV*{%[<e<fW'Y!e%h*X-ZS({#y#zQ+`%qQ+v&RS.](k(lQ1b,SQ4x0cR8^5k'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s$i$^c#Y#e%p%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.w.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ'W!eR2i-W!W!nQ!e!r!v!y!z$|'U']'^'j'k'l*X*h*l*n*o-W-^-`-p0U0X1g5q5sR1d,UnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&w!^Q't!xS(q#u<OQ+i%yQ,W&]Q,X&_Q-e'bQ-r'mS.m(v<qS0k+U<{Q0y+jQ1f,VQ2Z,uQ2],vQ2e-RQ2r-fQ2u-jS5P0l=VQ5W0zS5Z0|=WQ6j2gQ6n2sQ6s2zQ8R5XQ8}6lQ9O6oQ9R6tR:`8z$d$]c#Y#e%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gS(m#p'gQ(}#zS+_%p.wS.^(l(nR3U._'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS#q];wQ&r!XQ&s!YQ&u![Q&v!]R2R,qQ'_!hQ+b%vQ-c'aS.`(o+eQ2p-bW3Y.c.d0q0sQ6m2qW6z3V3X3]5TU9U6{6}7PU:e9W9X9ZS;T:d:gQ;b;UR;j;cU!wQ'^-`T5o1g5q!Q_OXZ`st!V!Z#d#h%d%l&g&i&p&r&s&u(h,n,s.V2S2V]!pQ!r'^-`1g5qT#q];w%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS({#y#zS.](k(l!s=^$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU$fd)],hS(n#p'gU*s%R(u3vU0e*z.i7]Q5T0rQ6{3WQ9X7OR:g9Ym!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sQ'r!uS(d#g1|S-n'i'uQ/n*ZQ/{*gQ2|-qQ4]/oQ4i/}Q4j0OQ4o0WQ7h4WS7s4k4mS7w4p4rQ9g7iQ9k7oQ9p7tQ9u7yS:o9l9mS;Y:p:sS;e;Z;[S;m;f;gS;q;n;oR;t;rQ#wbQ'q!uS(c#g1|S(e#m+TQ+V%eQ+g%wQ+m%}U-m'i'r'uQ.R(dQ/m*ZQ/|*gQ0P*iQ0x+hQ1m,[S2y-n-qQ3R.ZS4[/n/oQ4e/yS4h/{0WQ4l0QQ5|1nQ6u2|Q7g4WQ7k4]U7r4i4o4rQ7u4nQ8k5}S9f7h7iQ9j7oQ9r7wQ9s7xQ:V8lQ:m9gS:n9k9mQ:v9uQ;P:WS;X:o:sS;d;Y;ZS;l;e;gS;p;m;oQ;s;qQ;u;tQ=a=[Q=l=eR=m=fV!wQ'^-`%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS#wz!j!r=Z$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=a=r%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SQ%ej!^%wy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pS%}z!jQ+h%xQ,[&bW1n,],^,_,`U5}1o1p1qS8l6O6PQ:W8m!r=[$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ=e=qR=f=r%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SY#bWZ#W#Z(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ,i&m!p=]$Z$n)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=`'VU'Z!e%h*XR2k-Z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9S!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ,h&mQ0r+dQ3W.bQ7O3[R9Y7Q!b$Tc#Y%p(Q(W(r(w)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!P<U)[)o-U.w2c2f3h3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!f$Vc#Y%p(Q(W(r(w)U)V)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!T<W)[)o-U.w2c2f3h3n3o3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!^$Zc#Y%p(Q(W(r(w)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;xQ4V/fz=s)[)o-U.w2c2f3h3w4P6k7W7a7b8`8|9[9b9c:y;R=gQ=x=zR=y={'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS$oh$pR3|/P'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$kf$qQ$ifS)h$l)lR)t$qT$jf$qT)j$l)l'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$oh$pQ$rhR)s$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9S!s=q$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s#glOPXZst!Z!`!o#S#d#o#{$n%l&i&l&m&p&r&s&u&y'R'`(|)q*f+Y+d,k,n,s-d.b/Q/i0V0d1j1z1{1}2P2S2V2X3[3{4q5y6Z6[6_7Q8i8x!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}Q+P%`Q/^)|o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!U$yi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yQ*`$zU*i$|*X*lQ+Q%aQ0Q*j#f=c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n=d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YQ=h=tQ=i=uQ=j=vR=k=w!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YnoOXst!Z#d%l&p&r&s&u,n,s2S2VS*c${*WQ,|&|Q,}'OR4`/s%[%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q,P&ZQ1`,RQ5i1_R8]5jV*k$|*X*lU*k$|*X*lT5p1g5qS/y*f/iQ4n0VT7x4q:PQ+g%wQ0P*iQ0x+hQ1m,[Q5|1nQ8k5}Q:V8lR;P:W!U%Oi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yx*P$v)c*Q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=oS0Y*q0Z#f<a#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<b<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!d<t(s)a*Y*b.e.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={`<u3u7X7[7`9]:h:k;kS=P.g3aT=Q7Z9`!U%Qi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y|*R$v)c*S*q+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=oS0[*r0]#f<c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!h<v(s)a*Y*b.f.g.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={d<w3u7Y7Z7`9]9^:h:i:k;kS=R.h3bT=S7[9arnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ&d!UR,k&mrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR&d!UQ,T&[R1[+|snOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ1h,YS5w1k1lU8e5u5v5zS:R8g8hS:{:Q:TQ;_:|R;i;`Q&k!VR,d&gR6T1tR:Y8nS&P|&UR1T+sQ&p!WR,n&qR,t&vT2T,s2VR,x&wQ,w&wR2^,xQ'w!{R-t'wSsOtQ#dXT%os#dQ#OTR'y#OQ#RUR'{#RQ)y$uR/Z)yQ#UVR(O#UQ#XWU(U#X(V-{Q(V#YR-{(WQ-X'WR2j-XQ.p(wS3e.p3fR3f.qQ-`'^R2n-`Y!rQ'^-`1g5qR'h!rQ.{)cR3z.{U#_W%g*WU(]#_(^-|Q(^#`R-|(XQ-['ZR2l-[t`OXst!V!Z#d%l&g&i&p&r&s&u,n,s2S2VS#hZ%dU#r`#h.VR.V(hQ(i#jQ.S(eW.[(i.S3P6wQ3P.TR6w3QQ)l$lR/R)lQ$phR)r$pQ$`cU)_$`-w<[Q-w;xR<[)oQ/l*ZW4Y/l4Z7j9hU4Z/m/n/oS7j4[4]R9h7k$e*O$v(s)a)c*Y*b*q*r*|*}+R.g.h.j.k.l/Y/b/d/f/q/v0^0_0p1]3^3_3`3u3y4S4^4_4c4s4u4{4|4}5h7R7S7T7U7Z7[7^7_7`7f7m7p7z7}8P9]9^9_9i9q9v9w:h:i:j:k:l:q:u;W;];h;k=b=n=o=z={Q/t*bU4b/t4d7nQ4d/vR7n4cS*l$|*XR0S*lx*Q$v)c*q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=o!d.e(s)a*Y*b.g.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/c*Q.e7Xa7X3u7Z7[7`9]:h:k;kQ0Z*qQ3a.gU4t0Z3a9`R9`7Z|*S$v)c*q*r+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=o!h.f(s)a*Y*b.g.h.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/e*S.f7Ye7Y3u7Z7[7`9]9^:h:i:k;kQ0]*rQ3b.hU4v0]3b9aR9a7[Q*w%UR0a*wQ5S0pR8O5SQ+[%jR0o+[Q5l1bS8_5l:OR:O8`Q,V&]R1e,VQ5q1gR8b5qQ1s,aS6R1s8oR8o6TQ1O+oW5_1O5a8V9zQ5a1RQ8V5`R9z8WQ+t&PR1U+tQ2V,sR6c2VYrOXst#dQ&t!ZQ+^%lQ,m&pQ,o&rQ,p&sQ,r&uQ2Q,nS2T,s2VR6b2SQ%npQ&x!_Q&{!aQ&}!bQ'P!cQ'o!uQ+]%kQ+i%yQ+{&VQ,c&kQ,z&zW-k'i'q'r'uQ-r'mQ0R*kQ0y+jS1v,d,gQ2_,yQ2`,|Q2a,}Q2u-jW2w-m-n-q-sQ5W0zQ5d1XQ5g1]Q5{1mQ6V1xQ6a2RU6p2v2y2|Q6s2zQ8R5XQ8Z5fQ8[5hQ8a5pQ8j5|Q8p6US9P6q6uQ9R6tQ9{8XQ:U8kQ:Z8qQ:b9QQ:x9|Q;O:VQ;S:cR;a;PQ%yyQ'b!iQ'm!uU+j%z%{%|Q-R'TU-f'c'd'eS-j'i'sQ/z*gS0z+k+lQ2g-TS2s-g-hQ2z-oS4g/{0OQ5X0{Q6l2mQ6o2tQ6t2{U7q4i4j4mQ9o7sR:r9pS$wi=pR*x%VU%Ui%V=pR0`*vQ$viS(s#v+fS)a$b$cQ)c$dQ*Y$xS*b${*WQ*q%OQ*r%QQ*|%]Q*}%^Q+R%bQ.g<aQ.h<cQ.j<gQ.k<iQ.l<kQ/Y)wQ/b*PQ/d*RQ/f*TQ/q*^S/v*d/hQ0^*tQ0_*ul0p+c,Q.a1a1i3Z5x6|8f9V:S:f:};VQ1]+}Q3^<tQ3_<vQ3`<yS3u<^<_Q3y.zS4S/_4UQ4^/rQ4_/sQ4c/uQ4s0YQ4u0[Q4{0gQ4|0hQ4}0iQ5h1^Q7R<}Q7S=PQ7T=RQ7U=TQ7Z<bQ7[<dQ7^<hQ7_<jQ7`<lQ7f4VQ7m4aQ7p4fQ7z4wQ7}5RQ8P5UQ9]<zQ9^<uQ9_<wQ9i7lQ9q7vQ9v7|Q9w8QQ:h=OQ:i=QQ:j=SQ:k=UQ:l9eQ:q9nQ:u9tQ;W=XQ;]:tQ;h;^Q;k=YQ=b=pQ=n=xQ=o=yQ=z=|R={=}Q*z%[Q.i<eR7]<fnpOXst!Z#d%l&p&r&s&u,n,s2S2VQ!fPS#fZ#oQ&z!`W'f!o*f0V4qQ'}#SQ)O#{Q)p$nS,g&i&lQ,l&mQ,y&yS-O'R/iQ-b'`Q.s(|Q/V)qQ0m+YQ0s+dQ2O,kQ2q-dQ3X.bQ4O/QQ4y0dQ5v1jQ6X1zQ6Y1{Q6^1}Q6`2PQ6e2XQ7P3[Q7c3{Q8h5yQ8t6ZQ8u6[Q8w6_Q9Z7QQ:T8iR:_8x#[cOPXZst!Z!`!o#d#o#{%l&i&l&m&p&r&s&u&y'R'`(|*f+Y+d,k,n,s-d.b/i0V0d1j1z1{1}2P2S2V2X3[4q5y6Z6[6_7Q8i8xQ#YWQ#eYQ%puQ%rvS%tw!gS(Q#W(TQ(W#ZQ(r#uQ(w#xQ)P$OQ)Q$PQ)R$QQ)S$RQ)T$SQ)U$TQ)V$UQ)W$VQ)X$WQ)Y$XQ)[$ZQ)^$_Q)`$aQ)e$eW)o$n)q/Q3{Q+a%sQ+u&QS-U'V2hQ-s'pS-x(R-zQ-}(ZQ.P(bQ.n(vQ.q(xQ.u;vQ.w;yQ.x;zQ.y;}Q/]){Q0j+UQ2c-PQ2f-SQ2v-lQ2}.QQ3c.oQ3h<OQ3i<PQ3j<QQ3k<RQ3l<SQ3m<TQ3n<UQ3o<VQ3p<WQ3q<XQ3r<YQ3s.vQ3t<]Q3w<`Q3x<mQ4P<ZQ5O0lQ5Y0|Q6k<pQ6q2xQ6v3OQ7V3dQ7W<qQ7a<sQ7b<{Q8`5mQ8|6iQ9Q6rQ9[<|Q9b=VQ9c=WQ:c9SQ:y9}Q;R:aQ;x#SR=g=sR#[WR'X!el!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sS'T!e-WU*g$|*X*lS-T'U']S0O*h*nQ0W*oQ2m-^Q4m0UR4r0XR(y#xQ!fQT-_'^-`]!qQ!r'^-`1g5qQ#p]R'g;wR)d$dY!uQ'^-`1g5qQ'i!rS's!v!yS'u!z5sS-o'j'kQ-q'lR2{-pT#kZ%dS#jZ%dS%jm,jU(e#h#i#lS.T(f(gQ.X(hQ0n+ZQ3Q.UU3R.V.W.YS6x3S3TR9T6yd#^W#W#Z%g(R([*W+W.O/hr#gZm#h#i#l%d(f(g(h+Z.U.V.W.Y3S3T6yS*Z$x*_Q/o*[Q1|,jQ2d-QQ4W/kQ6g2[Q7i4XQ8{6hT=_'V+XV#aW%g*WU#`W%g*WS(S#W([U(X#Z+W/hS-V'V+XT-y(R.OV'[!e%h*XQ$lfR)v$qT)k$l)lR3}/PT*]$x*_T*e${*WQ0q+cQ1_,QQ3V.aQ5j1aQ5u1iQ6}3ZQ8g5xQ9W6|Q:Q8fQ:d9VQ:|:SQ;U:fQ;`:}R;c;VnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&j!VR,c&gtmOXst!U!V!Z#d%l&g&p&r&s&u,n,s2S2VR,j&mT%km,jR1c,SR,b&eQ&T|R+z&UR+p&OT&n!W&qT&o!W&qT2U,s2V",
    nodeNames: "\u26A0 ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
    maxTerm: 378,
    context: $e8b59e5e7d87430d$var$trackNewline,
    nodeProps: [
        [
            "isolate",
            -8,
            5,
            6,
            14,
            35,
            37,
            49,
            51,
            53,
            ""
        ],
        [
            "group",
            -26,
            9,
            17,
            19,
            66,
            206,
            210,
            214,
            215,
            217,
            220,
            223,
            233,
            235,
            241,
            243,
            245,
            247,
            250,
            256,
            262,
            264,
            266,
            268,
            270,
            272,
            273,
            "Statement",
            -34,
            13,
            14,
            30,
            33,
            34,
            40,
            49,
            52,
            53,
            55,
            60,
            68,
            70,
            74,
            78,
            80,
            82,
            83,
            108,
            109,
            118,
            119,
            135,
            138,
            140,
            141,
            142,
            143,
            144,
            146,
            147,
            166,
            168,
            170,
            "Expression",
            -23,
            29,
            31,
            35,
            39,
            41,
            43,
            172,
            174,
            176,
            177,
            179,
            180,
            181,
            183,
            184,
            185,
            187,
            188,
            189,
            200,
            202,
            204,
            205,
            "Type",
            -3,
            86,
            101,
            107,
            "ClassItem"
        ],
        [
            "openedBy",
            23,
            "<",
            36,
            "InterpolationStart",
            54,
            "[",
            58,
            "{",
            71,
            "(",
            159,
            "JSXStartCloseTag"
        ],
        [
            "closedBy",
            -2,
            24,
            167,
            ">",
            38,
            "InterpolationEnd",
            48,
            "]",
            59,
            "}",
            72,
            ")",
            164,
            "JSXEndTag"
        ]
    ],
    propSources: [
        $e8b59e5e7d87430d$var$jsHighlight
    ],
    skippedNodes: [
        0,
        5,
        6,
        276
    ],
    repeatNodeCount: 37,
    tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$h&j(X!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(X!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$h&j(UpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(UpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$h&j(Up(X!b'z0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(V#S$h&j'{0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$h&j(Up(X!b'{0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$h&j!n),Q(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#u(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#u(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(T':f$h&j(X!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$h&j(X!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$h&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$c`$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$c``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$c`$h&j(X!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(X!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$c`(X!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$h&j(Up(X!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$h&j(Up(X!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$h&j(X!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$h&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(X!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$h&j(UpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(UpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Up(X!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$h&j(m%1l(Up(X!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$h&j(Up(X!b$[#t(R,2j(c$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$h&j(Up(X!b$[#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$h&j(Up(X!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$h&j$P(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(x+JY$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$h&j#y(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(W';W$h&j(UpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$h&j(UpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$h&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$c`$h&j(UpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(UpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$c`(UpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!j/.^$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!i!Lf$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$h&j(Up(X!b(S%&f#o(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$h&j(Up(X!b#l(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$h&j(Up(X!bp+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!Z+Jf$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$h&j(Up(X!b!O.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_!Y!L^$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$h&j(Up(X!b#m(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$h&j(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$h&j(X!b!V7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$h&j!V7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$h&j!V7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!V7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!V7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$h&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$h&j(X!b!V7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(X!b!V7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(X!b!V7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(X!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$h&j(X!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$h&j(Up!V7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$h&j(Up!V7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Up!V7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Up!V7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(UpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$h&j(UpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$h&j(Up(X!b!V7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Up(X!b!V7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Up(X!b!V7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Up(X!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$h&j(Up(X!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$h&j(Up(X!b'|0/l!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$h&j(Up(X!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$h&j(X!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$h&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(X!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$h&j(UpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(UpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Up(X!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$h&j$P(Ch(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Y#t$h&j(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!e$b$h&j#})Lv(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#P-<U(Up(X!b$m7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$j&j(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#p(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$P(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#q(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#^*!Y$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#i(Cl$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#q(Ch$e#|$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#q(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#p(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#p(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(p(Ct$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$h&j#z(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!z$Ip$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!Q0,v$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$h&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$h&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$h&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$h&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$h&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!W#)l$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#w(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$h&j(Up(X!b(_+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$h&j(Up(X!b(R,2j$^#t(c$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$h&j(Up(X!b$^#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!]#Hb(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(w+JY$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_![(CdtBr$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!o7`$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$h&j(Up(X!b'z0/l$[#t(R,2j(c$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$h&j(Up(X!b'{0/l$[#t(R,2j(c$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
        $e8b59e5e7d87430d$var$noSemicolon,
        $e8b59e5e7d87430d$var$noSemicolonType,
        $e8b59e5e7d87430d$var$operatorToken,
        $e8b59e5e7d87430d$var$jsx,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        $e8b59e5e7d87430d$var$insertSemicolon,
        new (0, $1e031cb73d044f87$export$dbe55ed82366d5e9)("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOv~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!S~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(a~~", 141, 338),
        new (0, $1e031cb73d044f87$export$dbe55ed82366d5e9)("j~RQYZXz{^~^O(O~~aP!P!Qd~iO(P~~", 25, 321)
    ],
    topRules: {
        "Script": [
            0,
            7
        ],
        "SingleExpression": [
            1,
            274
        ],
        "SingleClassItem": [
            2,
            275
        ]
    },
    dialects: {
        jsx: 0,
        ts: 15091
    },
    dynamicPrecedences: {
        "78": 1,
        "80": 1,
        "92": 1,
        "168": 1,
        "198": 1
    },
    specialized: [
        {
            term: 325,
            get: (value)=>$e8b59e5e7d87430d$var$spec_identifier[value] || -1
        },
        {
            term: 341,
            get: (value)=>$e8b59e5e7d87430d$var$spec_word[value] || -1
        },
        {
            term: 93,
            get: (value)=>$e8b59e5e7d87430d$var$spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 15116
});







/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ const $6d2caf576f84b9f7$export$c7c03ffcb9c131fc = [
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("function ${name}(${params}) {\n\t${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n\t${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("for (let ${name} of ${collection}) {\n\t${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("do {\n\t${}\n} while (${})", {
        label: "do",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("while (${}) {\n\t${}\n}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("try {\n\t${}\n} catch (${error}) {\n\t${}\n}", {
        label: "try",
        detail: "/ catch block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("if (${}) {\n\t${}\n}", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("if (${}) {\n\t${}\n} else {\n\t${}\n}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("class ${name} {\n\tconstructor(${params}) {\n\t\t${}\n\t}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("import {${names}} from \"${module}\"\n${}", {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("import ${name} from \"${module}\"\n${}", {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
/**
A collection of snippet completions for TypeScript. Includes the
JavaScript [snippets](https://codemirror.net/6/docs/ref/#lang-javascript.snippets).
*/ const $6d2caf576f84b9f7$export$4e97f270e7f6c0ba = /*@__PURE__*/ $6d2caf576f84b9f7$export$c7c03ffcb9c131fc.concat([
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("interface ${name} {\n\t${}\n}", {
        label: "interface",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("type ${name} = ${type}", {
        label: "type",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $5d769baac6d563a1$export$975ef56e648d23ad)("enum ${name} {\n\t${}\n}", {
        label: "enum",
        detail: "definition",
        type: "keyword"
    })
]);
const $6d2caf576f84b9f7$var$cache = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$7f13b5dc44c541ae)();
const $6d2caf576f84b9f7$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function $6d2caf576f84b9f7$var$defID(type) {
    return (node, def)=>{
        let id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
const $6d2caf576f84b9f7$var$functionContext = [
    "FunctionDeclaration"
];
const $6d2caf576f84b9f7$var$gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ $6d2caf576f84b9f7$var$defID("function"),
    ClassDeclaration: /*@__PURE__*/ $6d2caf576f84b9f7$var$defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ $6d2caf576f84b9f7$var$defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ $6d2caf576f84b9f7$var$defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ $6d2caf576f84b9f7$var$defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext($6d2caf576f84b9f7$var$functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function $6d2caf576f84b9f7$var$getScope(doc, node) {
    let cached = $6d2caf576f84b9f7$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $b14321b77c1b25e4$export$b0e28367f55837aa).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            let gather = $6d2caf576f84b9f7$var$gatherCompletions[node.name];
            if (gather && gather(node, def) || $6d2caf576f84b9f7$var$ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $6d2caf576f84b9f7$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $6d2caf576f84b9f7$var$cache.set(node, completions);
    return completions;
}
const $6d2caf576f84b9f7$var$Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
const $6d2caf576f84b9f7$var$dontComplete = [
    "TemplateString",
    "String",
    "RegExp",
    "LineComment",
    "BlockComment",
    "VariableDefinition",
    "TypeDefinition",
    "Label",
    "PropertyDefinition",
    "PropertyName",
    "PrivatePropertyDefinition",
    "PrivatePropertyName",
    ".",
    "?."
];
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function $6d2caf576f84b9f7$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if ($6d2caf576f84b9f7$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $6d2caf576f84b9f7$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($6d2caf576f84b9f7$var$ScopeNodes.has(pos.name)) options = options.concat($6d2caf576f84b9f7$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $6d2caf576f84b9f7$var$Identifier
    };
}
function $6d2caf576f84b9f7$var$pathFor(read, member, name) {
    var _a;
    let path = [];
    for(;;){
        let obj = member.firstChild, prop;
        if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
            path.push(read(obj));
            return {
                path: path.reverse(),
                name: name
            };
        } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a = prop = obj.lastChild) === null || _a === void 0 ? void 0 : _a.name) == "PropertyName") {
            path.push(read(prop));
            member = obj;
        } else return null;
    }
}
/**
Helper function for defining JavaScript completion sources. It
returns the completable name and object path for a completion
context, or null if no name/property completion should happen at
that position. For example, when completing after `a.b.c` it will
return `{path: ["a", "b"], name: "c"}`. When completing after `x`
it will return `{path: [], name: "x"}`. When not in a property or
name, it will return null if `context.explicit` is false, and
`{path: [], name: ""}` otherwise.
*/ function $6d2caf576f84b9f7$export$744a796701708158(context) {
    let read = (node)=>context.state.doc.sliceString(node.from, node.to);
    let inner = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if (inner.name == "PropertyName") return $6d2caf576f84b9f7$var$pathFor(read, inner.parent, read(inner));
    else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") return $6d2caf576f84b9f7$var$pathFor(read, inner.parent, "");
    else if ($6d2caf576f84b9f7$var$dontComplete.indexOf(inner.name) > -1) return null;
    else if (inner.name == "VariableName" || inner.to - inner.from < 20 && $6d2caf576f84b9f7$var$Identifier.test(read(inner))) return {
        path: [],
        name: read(inner)
    };
    else if (inner.name == "MemberExpression") return $6d2caf576f84b9f7$var$pathFor(read, inner, "");
    else return context.explicit ? {
        path: [],
        name: ""
    } : null;
}
function $6d2caf576f84b9f7$var$enumeratePropertyCompletions(obj, top) {
    let options = [], seen = new Set;
    for(let depth = 0;; depth++){
        for (let name of (Object.getOwnPropertyNames || Object.keys)(obj)){
            if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(name) || seen.has(name)) continue;
            seen.add(name);
            let value;
            try {
                value = obj[name];
            } catch (_) {
                continue;
            }
            options.push({
                label: name,
                type: typeof value == "function" ? /^[A-Z]/.test(name) ? "class" : top ? "function" : "method" : top ? "variable" : "property",
                boost: -depth
            });
        }
        let next = Object.getPrototypeOf(obj);
        if (!next) return options;
        obj = next;
    }
}
/**
Defines a [completion source](https://codemirror.net/6/docs/ref/#autocomplete.CompletionSource) that
completes from the given scope object (for example `globalThis`).
Will enter properties of the object when completing properties on
a directly-named path.
*/ function $6d2caf576f84b9f7$export$fc7787e70db1f2c3(scope) {
    let cache = new Map;
    return (context)=>{
        let path = $6d2caf576f84b9f7$export$744a796701708158(context);
        if (!path) return null;
        let target = scope;
        for (let step of path.path){
            target = target[step];
            if (!target) return null;
        }
        let options = cache.get(target);
        if (!options) cache.set(target, options = $6d2caf576f84b9f7$var$enumeratePropertyCompletions(target, !path.path.length));
        return {
            from: context.pos - path.name.length,
            options: options,
            validFor: $6d2caf576f84b9f7$var$Identifier
        };
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ const $6d2caf576f84b9f7$export$93859f94713968c6 = /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$b243968d9fb6db03).define({
    name: "javascript",
    parser: /*@__PURE__*/ (0, $e8b59e5e7d87430d$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$72c7d4c52b3c6460).add({
                IfStatement: /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$688ff433e7e7cc5c)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$688ff433e7e7cc5c)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, $8a0ff9d7afd8a874$export$4764c629086182f2),
                SwitchBody: (context)=>{
                    let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$60e82ea306899488)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>null,
                "Statement Property": /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$688ff433e7e7cc5c)({
                    except: /^{/
                }),
                JSXElement (context) {
                    let closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    let closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$9b075a85eb4377d8).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": (0, $8a0ff9d7afd8a874$export$48672beae16a681b),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
const $6d2caf576f84b9f7$var$jsxSublanguage = {
    test: (node)=>/^JSX/.test(node.name),
    facet: /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$b57f683f43553b99)({
        commentTokens: {
            block: {
                open: "{/*",
                close: "*/}"
            }
        }
    })
};
/**
A language provider for TypeScript.
*/ const $6d2caf576f84b9f7$export$5a3c1a94be83ebb = /*@__PURE__*/ $6d2caf576f84b9f7$export$93859f94713968c6.configure({
    dialect: "ts"
}, "typescript");
/**
Language provider for JSX.
*/ const $6d2caf576f84b9f7$export$cf3118f4eee6176c = /*@__PURE__*/ $6d2caf576f84b9f7$export$93859f94713968c6.configure({
    dialect: "jsx",
    props: [
        /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $6d2caf576f84b9f7$var$jsxSublanguage
            ] : undefined)
    ]
});
/**
Language provider for JSX + TypeScript.
*/ const $6d2caf576f84b9f7$export$5e6bf9a8e977a24e = /*@__PURE__*/ $6d2caf576f84b9f7$export$93859f94713968c6.configure({
    dialect: "jsx ts",
    props: [
        /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$4afc6f37514bbb67).add((n)=>n.isTop ? [
                $6d2caf576f84b9f7$var$jsxSublanguage
            ] : undefined)
    ]
}, "typescript");
let $6d2caf576f84b9f7$var$kwCompletion = (name)=>({
        label: name,
        type: "keyword"
    });
const $6d2caf576f84b9f7$var$keywords = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map($6d2caf576f84b9f7$var$kwCompletion);
const $6d2caf576f84b9f7$var$typescriptKeywords = /*@__PURE__*/ $6d2caf576f84b9f7$var$keywords.concat(/*@__PURE__*/ [
    "declare",
    "implements",
    "private",
    "protected",
    "public"
].map($6d2caf576f84b9f7$var$kwCompletion));
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
and local variable completion.
*/ function $6d2caf576f84b9f7$export$755219397dca4f08(config = {}) {
    let lang = config.jsx ? config.typescript ? $6d2caf576f84b9f7$export$5e6bf9a8e977a24e : $6d2caf576f84b9f7$export$cf3118f4eee6176c : config.typescript ? $6d2caf576f84b9f7$export$5a3c1a94be83ebb : $6d2caf576f84b9f7$export$93859f94713968c6;
    let completions = config.typescript ? $6d2caf576f84b9f7$export$4e97f270e7f6c0ba.concat($6d2caf576f84b9f7$var$typescriptKeywords) : $6d2caf576f84b9f7$export$c7c03ffcb9c131fc.concat($6d2caf576f84b9f7$var$keywords);
    return new (0, $8a0ff9d7afd8a874$export$cbdefefa8a51dd3b)(lang, [
        $6d2caf576f84b9f7$export$93859f94713968c6.data.of({
            autocomplete: (0, $5d769baac6d563a1$export$1dfdaeb1e91714c0)($6d2caf576f84b9f7$var$dontComplete, (0, $5d769baac6d563a1$export$db0ee7d2648a0c4b)(completions))
        }),
        $6d2caf576f84b9f7$export$93859f94713968c6.data.of({
            autocomplete: $6d2caf576f84b9f7$export$a2e0a5b87b9b861c
        }),
        config.jsx ? $6d2caf576f84b9f7$export$f1d931274ca0e1f1 : []
    ]);
}
function $6d2caf576f84b9f7$var$findOpenTag(node) {
    for(;;){
        if (node.name == "JSXOpenTag" || node.name == "JSXSelfClosingTag" || node.name == "JSXFragmentTag") return node;
        if (node.name == "JSXEscape" || !node.parent) return null;
        node = node.parent;
    }
}
function $6d2caf576f84b9f7$var$elementName(doc, tree, max = doc.length) {
    for(let ch = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch; ch = ch.nextSibling){
        if (ch.name == "JSXIdentifier" || ch.name == "JSXBuiltin" || ch.name == "JSXNamespacedName" || ch.name == "JSXMemberExpression") return doc.sliceString(ch.from, Math.min(ch.to, max));
    }
    return "";
}
const $6d2caf576f84b9f7$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ const $6d2caf576f84b9f7$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).inputHandler.of((view, from, to, text, defaultInsert)=>{
    if (($6d2caf576f84b9f7$var$android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !$6d2caf576f84b9f7$export$93859f94713968c6.isActiveAt(view.state, from, -1)) return false;
    let base = defaultInsert(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a;
        let { head: head } = range, around = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(head - 1, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (state.doc.sliceString(head - 1, head) != text || around.name == "JSXAttributeValue" && around.to > head) ;
        else if (text == ">" && around.name == "JSXFragmentTag") return {
            range: range,
            changes: {
                from: head,
                insert: `</>`
            }
        };
        else if (text == "/" && around.name == "JSXStartCloseTag") {
            let empty = around.parent, base = empty.parent;
            if (base && empty.from == head - 2 && ((name = $6d2caf576f84b9f7$var$elementName(state.doc, base.firstChild, head)) || ((_a = base.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "JSXFragmentTag")) {
                let insert = `${name}>`;
                return {
                    range: (0, $0f49217316d01287$export$3bb1bd44aee62999).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        } else if (text == ">") {
            let openTag = $6d2caf576f84b9f7$var$findOpenTag(around);
            if (openTag && openTag.name == "JSXOpenTag" && !/^\/?>|^<\//.test(state.doc.sliceString(head, head + 2)) && (name = $6d2caf576f84b9f7$var$elementName(state.doc, openTag, head))) return {
                range: range,
                changes: {
                    from: head,
                    insert: `</${name}>`
                }
            };
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The
[eslint-linter-browserify](https://github.com/UziTech/eslint-linter-browserify)
package may help with that (see
[example](https://github.com/UziTech/eslint-linter-browserify/blob/master/example/script.js)).
*/ function $6d2caf576f84b9f7$export$5f7cd04a95ec53e6(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            if (desc.meta.docs.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        let { state: state } = view, found = [];
        for (let { from: from, to: to } of $6d2caf576f84b9f7$export$93859f94713968c6.findRegions(state)){
            let fromLine = state.doc.lineAt(from), offset = {
                line: fromLine.number - 1,
                col: from - fromLine.from,
                pos: from
            };
            for (let d of eslint.verify(state.sliceDoc(from, to), config))found.push($6d2caf576f84b9f7$var$translateDiagnostic(d, state.doc, offset));
        }
        return found;
    };
}
function $6d2caf576f84b9f7$var$mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function $6d2caf576f84b9f7$var$translateDiagnostic(input, doc, offset) {
    let start = $6d2caf576f84b9f7$var$mapPos(input.line, input.column, doc, offset);
    let result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? $6d2caf576f84b9f7$var$mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        let { range: range, text: text } = input.fix, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}




// This file was generated by lezer-generator. You probably shouldn't edit it.
const $3c9f6e032ac605c2$var$descendantOp = 99, $3c9f6e032ac605c2$var$Unit = 1, $3c9f6e032ac605c2$var$callee = 100, $3c9f6e032ac605c2$var$identifier = 101, $3c9f6e032ac605c2$var$VariableName = 2;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ const $3c9f6e032ac605c2$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $3c9f6e032ac605c2$var$colon = 58, $3c9f6e032ac605c2$var$parenL = 40, $3c9f6e032ac605c2$var$underscore = 95, $3c9f6e032ac605c2$var$bracketL = 91, $3c9f6e032ac605c2$var$dash = 45, $3c9f6e032ac605c2$var$period = 46, $3c9f6e032ac605c2$var$hash = 35, $3c9f6e032ac605c2$var$percent = 37, $3c9f6e032ac605c2$var$ampersand = 38, $3c9f6e032ac605c2$var$backslash = 92, $3c9f6e032ac605c2$var$newline = 10;
function $3c9f6e032ac605c2$var$isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $3c9f6e032ac605c2$var$isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
const $3c9f6e032ac605c2$var$identifiers = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input, stack)=>{
    for(let inside = false, dashes = 0, i = 0;; i++){
        let { next: next } = input;
        if ($3c9f6e032ac605c2$var$isAlpha(next) || next == $3c9f6e032ac605c2$var$dash || next == $3c9f6e032ac605c2$var$underscore || inside && $3c9f6e032ac605c2$var$isDigit(next)) {
            if (!inside && (next != $3c9f6e032ac605c2$var$dash || i > 0)) inside = true;
            if (dashes === i && next == $3c9f6e032ac605c2$var$dash) dashes++;
            input.advance();
        } else if (next == $3c9f6e032ac605c2$var$backslash && input.peek(1) != $3c9f6e032ac605c2$var$newline) {
            input.advance();
            if (input.next > -1) input.advance();
            inside = true;
        } else {
            if (inside) input.acceptToken(next == $3c9f6e032ac605c2$var$parenL ? $3c9f6e032ac605c2$var$callee : dashes == 2 && stack.canShift($3c9f6e032ac605c2$var$VariableName) ? $3c9f6e032ac605c2$var$VariableName : $3c9f6e032ac605c2$var$identifier);
            break;
        }
    }
});
const $3c9f6e032ac605c2$var$descendant = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input)=>{
    if ($3c9f6e032ac605c2$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if ($3c9f6e032ac605c2$var$isAlpha(next) || next == $3c9f6e032ac605c2$var$underscore || next == $3c9f6e032ac605c2$var$hash || next == $3c9f6e032ac605c2$var$period || next == $3c9f6e032ac605c2$var$bracketL || next == $3c9f6e032ac605c2$var$colon && $3c9f6e032ac605c2$var$isAlpha(input.peek(1)) || next == $3c9f6e032ac605c2$var$dash || next == $3c9f6e032ac605c2$var$ampersand) input.acceptToken($3c9f6e032ac605c2$var$descendantOp);
    }
});
const $3c9f6e032ac605c2$var$unitToken = new (0, $1e031cb73d044f87$export$6e56a42e94c6b2cb)((input)=>{
    if (!$3c9f6e032ac605c2$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if (next == $3c9f6e032ac605c2$var$percent) {
            input.advance();
            input.acceptToken($3c9f6e032ac605c2$var$Unit);
        }
        if ($3c9f6e032ac605c2$var$isAlpha(next)) {
            do input.advance();
            while ($3c9f6e032ac605c2$var$isAlpha(input.next) || $3c9f6e032ac605c2$var$isDigit(input.next));
            input.acceptToken($3c9f6e032ac605c2$var$Unit);
        }
    }
});
const $3c9f6e032ac605c2$var$cssHighlighting = (0, $6fc2ba1913927f17$export$c537e79bb7b94295)({
    "AtKeyword import charset namespace keyframes media supports": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definitionKeyword,
    "from to selector": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).keyword,
    NamespaceName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).namespace,
    KeyframeName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).labelName,
    KeyframeRangeName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
    TagName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).tagName,
    ClassName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className,
    PseudoClassName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).constant((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className),
    IdName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).labelName,
    "FeatureName PropertyName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName,
    AttributeName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).attributeName,
    NumberLiteral: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).number,
    KeywordQuery: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).keyword,
    UnaryQueryOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
    "CallTag ValueName": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).atom,
    VariableName: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName,
    Callee: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
    Unit: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).unit,
    "UniversalSelector NestingSelector": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definitionOperator,
    MatchOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).logicOperator,
    BinOp: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).arithmeticOperator,
    Important: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).modifier,
    Comment: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).blockComment,
    ColorLiteral: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).color,
    "ParenthesizedContent StringLiteral": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string,
    ":": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).punctuation,
    "PseudoOp #": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).derefOperator,
    "; ,": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).separator,
    "( )": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $3c9f6e032ac605c2$var$spec_callee = {
    __proto__: null,
    lang: 32,
    "nth-child": 32,
    "nth-last-child": 32,
    "nth-of-type": 32,
    "nth-last-of-type": 32,
    dir: 32,
    "host-context": 32,
    url: 60,
    "url-prefix": 60,
    domain: 60,
    regexp: 60,
    selector: 138
};
const $3c9f6e032ac605c2$var$spec_AtKeyword = {
    __proto__: null,
    "@import": 118,
    "@media": 142,
    "@charset": 146,
    "@namespace": 150,
    "@keyframes": 156,
    "@supports": 168
};
const $3c9f6e032ac605c2$var$spec_identifier = {
    __proto__: null,
    not: 132,
    only: 132
};
const $3c9f6e032ac605c2$export$8f49e4af10703ce3 = (0, $1e031cb73d044f87$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: ":jQYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DTO$vQ[O'#DWOOQP'#Em'#EmO${QdO'#DgO%jQ[O'#DtO${QdO'#DvO%{Q[O'#DxO&WQ[O'#D{O&`Q[O'#ERO&nQ[O'#ETOOQS'#El'#ElOOQS'#EW'#EWQYQ[OOO&uQXO'#CdO'jQWO'#DcO'oQWO'#EsO'zQ[O'#EsQOQWOOP(UO#tO'#C_POOO)C@[)C@[OOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(aQ[O'#E[O({QWO,58{O)TQ[O,59SO$qQ[O,59oO$vQ[O,59rO(aQ[O,59uO(aQ[O,59wO(aQ[O,59xO)`Q[O'#DbOOQS,58{,58{OOQP'#Ck'#CkOOQO'#DR'#DROOQP,59S,59SO)gQWO,59SO)lQWO,59SOOQP'#DV'#DVOOQP,59o,59oOOQO'#DX'#DXO)qQ`O,59rOOQS'#Cp'#CpO${QdO'#CqO)yQvO'#CsO+ZQtO,5:ROOQO'#Cx'#CxO)lQWO'#CwO+oQWO'#CyO+tQ[O'#DOOOQS'#Ep'#EpOOQO'#Dj'#DjO+|Q[O'#DqO,[QWO'#EtO&`Q[O'#DoO,jQWO'#DrOOQO'#Eu'#EuO)OQWO,5:`O,oQpO,5:bOOQS'#Dz'#DzO,wQWO,5:dO,|Q[O,5:dOOQO'#D}'#D}O-UQWO,5:gO-ZQWO,5:mO-cQWO,5:oOOQS-E8U-E8UO-kQdO,59}O-{Q[O'#E^O.YQWO,5;_O.YQWO,5;_POOO'#EV'#EVP.eO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO/[QXO,5:vOOQO-E8Y-E8YOOQS1G.g1G.gOOQP1G.n1G.nO)gQWO1G.nO)lQWO1G.nOOQP1G/Z1G/ZO/iQ`O1G/^O0SQXO1G/aO0jQXO1G/cO1QQXO1G/dO1hQWO,59|O1mQ[O'#DSO1tQdO'#CoOOQP1G/^1G/^O${QdO1G/^O1{QpO,59]OOQS,59_,59_O${QdO,59aO2TQWO1G/mOOQS,59c,59cO2YQ!bO,59eOOQS'#DP'#DPOOQS'#EY'#EYO2eQ[O,59jOOQS,59j,59jO2mQWO'#DjO2xQWO,5:VO2}QWO,5:]O&`Q[O,5:XO&`Q[O'#E_O3VQWO,5;`O3bQWO,5:ZO(aQ[O,5:^OOQS1G/z1G/zOOQS1G/|1G/|OOQS1G0O1G0OO3sQWO1G0OO3xQdO'#EOOOQS1G0R1G0ROOQS1G0X1G0XOOQS1G0Z1G0ZO4TQtO1G/iOOQO1G/i1G/iOOQO,5:x,5:xO4kQ[O,5:xOOQO-E8[-E8[O4xQWO1G0yPOOO-E8T-E8TPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$x7+$xO${QdO7+$xOOQS1G/h1G/hO5TQXO'#ErO5[QWO,59nO5aQtO'#EXO6XQdO'#EoO6cQWO,59ZO6hQpO7+$xOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%X7+%XOOQS1G/P1G/PO6pQWO1G/POOQS-E8W-E8WOOQS1G/U1G/UO${QdO1G/qOOQO1G/w1G/wOOQO1G/s1G/sO6uQWO,5:yOOQO-E8]-E8]O7TQXO1G/xOOQS7+%j7+%jO7[QYO'#CsOOQO'#EQ'#EQO7gQ`O'#EPOOQO'#EP'#EPO7rQWO'#E`O7zQdO,5:jOOQS,5:j,5:jO8VQtO'#E]O${QdO'#E]O9WQdO7+%TOOQO7+%T7+%TOOQO1G0d1G0dO9kQpO<<HdO9sQWO,5;^OOQP1G/Y1G/YOOQS-E8V-E8VO${QdO'#EZO9{QWO,5;ZOOQT1G.u1G.uOOQP<<Hd<<HdOOQS7+$k7+$kO:TQdO7+%]OOQO7+%d7+%dOOQO,5:k,5:kO3{QdO'#EaO7rQWO,5:zOOQS,5:z,5:zOOQS-E8^-E8^OOQS1G0U1G0UO:[QtO,5:wOOQS-E8Z-E8ZOOQO<<Ho<<HoOOQPAN>OAN>OO;]QdO,5:uOOQO-E8X-E8XOOQO<<Hw<<HwOOQO,5:{,5:{OOQO-E8_-E8_OOQS1G0f1G0f",
    stateData: ";o~O#ZOS#[QQ~OUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XRO#bTO~OQfOUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XeO#bTO~O#U#gP~P!ZO#[jO~O#XlO~O]qO^qOqsOtoOxrO!OtO!RvO#VuO#bnO~O!TwO~P#pO`}O#WzO#XyO~O#X!OO~O#X!QO~OQ![Ob!TOf![Oh![On!YOq!ZO#W!WO#X!SO#e!UO~Ob!^O!d!`O!g!aO#X!]O!T#hP~Oh!fOn!YO#X!eO~Oh!hO#X!hO~Ob!^O!d!`O!g!aO#X!]O~O!Y#hP~P%jO]WX]!WX^WXqWXtWXxWX!OWX!RWX!TWX#VWX#bWX~O]!mO~O!Y!nO#U#gX!S#gX~O#U#gX!S#gX~P!ZO#]!qO#^!qO#_!sO~OUYOXYO]VO^VOqXOxWO#XRO#bTO~OtoO!TwO~O`!zO#WzO#XyO~O!S#gP~P!ZOb#RO~Ob#SO~Op#TO|#UO~OP#WObgXjgX!YgX!dgX!ggX#XgXagXQgXfgXhgXngXqgXtgX!XgX#UgX#WgX#egXpgX!SgX~Ob!^Oj#XO!d!`O!g!aO#X!]O!Y#hP~Ob#[O~Op#`O#X#]O~Ob!^O!d!`O!g!aO#X#aO~Ot#eO!b#dO!T#hX!Y#hX~Ob#hO~Oj#XO!Y#jO~O!Y#kO~Oh#lOn!YO~O!T#mO~O!TwO!b#dO~O!TwO!Y#pO~O!X#rO!Y!Va#U!Va!S!Va~P${O!Y#QX#U#QX!S#QX~P!ZO!Y!nO#U#ga!S#ga~O#]!qO#^!qO#_#xO~O]qO^qOqsOxrO!OtO!RvO#VuO#bnO~Ot#Oa!T#Oaa#Oa~P.pOp#zO|#{O~O]qO^qOqsOxrO#bnO~Ot}i!O}i!R}i!T}i#V}ia}i~P/qOt!Pi!O!Pi!R!Pi!T!Pi#V!Pia!Pi~P/qOt!Qi!O!Qi!R!Qi!T!Qi#V!Qia!Qi~P/qO!S#|O~Oa#fP~P(aOa#cP~P${Oa$TOj#XO~O!Y$VO~Oa$WOh$XOo$XO~Op$ZO#X#]O~O]!`Xa!^X!b!^X~O]$[O~Oa$]O!b#dO~Ot#eO!T#ha!Y#ha~O!b#dOt!ca!T!ca!Y!caa!ca~O!Y$bO~O!S$iO#X$dO#e$cO~Oj#XOt$kO!X$mO!Y!Vi#U!Vi!S!Vi~P${O!Y#Qa#U#Qa!S#Qa~P!ZO!Y!nO#U#gi!S#gi~Oa#fX~P#pOa$qO~Oj#XOQ!{Xa!{Xb!{Xf!{Xh!{Xn!{Xq!{Xt!{X#W!{X#X!{X#e!{X~Ot$sOa#cX~P${Oa$uO~Oj#XOp$vO~Oa$wO~O!b#dOt#Ra!T#Ra!Y#Ra~Oa$yO~P.pOP#WOtgX!TgX~O#e$cOt!sX!T!sX~Ot${O!TwO~O!S%PO#X$dO#e$cO~Oj#XOQ#PXb#PXf#PXh#PXn#PXq#PXt#PX!X#PX!Y#PX#U#PX#W#PX#X#PX#e#PX!S#PX~Ot$kO!X%SO!Y!Vq#U!Vq!S!Vq~P${Oj#XOp%TO~OtoOa#fa~Ot$sOa#ca~Oa%WO~P${Oj#XOQ#Pab#Paf#Pah#Pan#Paq#Pat#Pa!X#Pa!Y#Pa#U#Pa#W#Pa#X#Pa#e#Pa!S#Pa~Oa!}at!}a~P${O#Zo#[#ej!R#e~",
    goto: "-g#jPPP#kP#nP#w$WP#w$g#wPP$mPPP$s$|$|P%`P$|P$|%z&^PPPP$|&vP&z'Q#wP'W#w'^P#wP#w#wPPP'd'y(WPP#nPP(_(_(i(_P(_P(_(_P#nP#nP#nP(l#nP(o(r(u(|#nP#nP)R)X)h)v)|*S*^*d*n*t*zPPPPPPPPPP+Q+ZP+v+yP,o,r,x-RRkQ_bOPdhw!n#tkYOPdhotuvw!n#R#h#tkSOPdhotuvw!n#R#h#tQmTR!tnQ{VR!xqQ!x}Q#Z!XR#y!zq![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%Up![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%UU$f#m$h${R$z$eq!XZ]!T!m#S#U#X#q#{$Q$[$k$l$s$x%Up![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%UQ!f^R#l!gT#^!Z#_Q|VR!yqQ!x|R#y!yQ!PWR!{rQ!RXR!|sQxUQ!wpQ#i!cQ#o!jQ#p!kQ$}$gR%Z$|SgPwQ!phQ#s!nR$n#tZfPhw!n#ta!b[`a!V!^!`#d#eR#b!^R!g^R!i_R#n!iS$g#m$hR%X${V$e#m$h${Q!rjR#w!rQdOShPwU!ldh#tR#t!nQ$Q#SU$r$Q$x%UQ$x$[R%U$sQ#_!ZR$Y#_Q$t$QR%V$tQpUS!vp$pR$p#}Q$l#qR%R$lQ!ogS#u!o#vR#v!pQ#f!_R$`#fQ$h#mR%O$hQ$|$gR%Y$|_cOPdhw!n#t^UOPdhw!n#tQ!uoQ!}tQ#OuQ#PvQ#}#RR$a#hR$R#SQ!VZQ!d]Q#V!TQ#q!m[$P#S$Q$[$s$x%UQ$S#UQ$U#XS$j#q$lQ$o#{R%Q$kR$O#RQiPR#QwQ!c[Q!kaR#Y!VU!_[a!VQ!j`Q#c!^Q#g!`Q$^#dR$_#e",
    nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent ] [ LineNames LineName , PseudoClassName ArgList IdSelector # IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
    maxTerm: 117,
    nodeProps: [
        [
            "isolate",
            -2,
            3,
            24,
            ""
        ],
        [
            "openedBy",
            17,
            "(",
            32,
            "[",
            50,
            "{"
        ],
        [
            "closedBy",
            18,
            ")",
            33,
            "]",
            51,
            "}"
        ]
    ],
    propSources: [
        $3c9f6e032ac605c2$var$cssHighlighting
    ],
    skippedNodes: [
        0,
        3,
        87
    ],
    repeatNodeCount: 11,
    tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#Z~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#Z~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!X[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYxQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QS|So`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!RQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#e[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#e[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSt^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#bQOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#[~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!Y^Oy%^z;'S%^;'S;=`%o<%lO%^dCoS|SOy%^z;'S%^;'S;=`%o<%lO%^bDQU!OQOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS!OQo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[![Qo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^nFfSq^Oy%^z;'S%^;'S;=`%o<%lO%^nFwSp^Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!bQo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!TUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!S^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!RQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
    tokenizers: [
        $3c9f6e032ac605c2$var$descendant,
        $3c9f6e032ac605c2$var$unitToken,
        $3c9f6e032ac605c2$var$identifiers,
        1,
        2,
        3,
        4,
        new (0, $1e031cb73d044f87$export$dbe55ed82366d5e9)("m~RRYZ[z{a~~g~aO#^~~dP!P!Qg~lO#_~~", 28, 105)
    ],
    topRules: {
        "StyleSheet": [
            0,
            4
        ],
        "Styles": [
            1,
            86
        ]
    },
    specialized: [
        {
            term: 100,
            get: (value)=>$3c9f6e032ac605c2$var$spec_callee[value] || -1
        },
        {
            term: 58,
            get: (value)=>$3c9f6e032ac605c2$var$spec_AtKeyword[value] || -1
        },
        {
            term: 101,
            get: (value)=>$3c9f6e032ac605c2$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 1219
});




let $cd68c9f5362aa690$var$_properties = null;
function $cd68c9f5362aa690$var$properties() {
    if (!$cd68c9f5362aa690$var$_properties && typeof document == "object" && document.body) {
        let { style: style } = document.body, names = [], seen = new Set;
        for(let prop in style)if (prop != "cssText" && prop != "cssFloat") {
            if (typeof style[prop] == "string") {
                if (/[A-Z]/.test(prop)) prop = prop.replace(/[A-Z]/g, (ch)=>"-" + ch.toLowerCase());
                if (!seen.has(prop)) {
                    names.push(prop);
                    seen.add(prop);
                }
            }
        }
        $cd68c9f5362aa690$var$_properties = names.sort().map((name)=>({
                type: "property",
                label: name,
                apply: name + ": "
            }));
    }
    return $cd68c9f5362aa690$var$_properties || [];
}
const $cd68c9f5362aa690$var$pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "any-link",
    "autofill",
    "backdrop",
    "before",
    "checked",
    "cue",
    "default",
    "defined",
    "disabled",
    "empty",
    "enabled",
    "file-selector-button",
    "first",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "focus-visible",
    "focus-within",
    "fullscreen",
    "has",
    "host",
    "host-context",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "marker",
    "modal",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "part",
    "placeholder",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "selection",
    "slotted",
    "target",
    "target-text",
    "valid",
    "visited",
    "where"
].map((name)=>({
        type: "class",
        label: name
    }));
const $cd68c9f5362aa690$var$values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
const $cd68c9f5362aa690$var$tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
const $cd68c9f5362aa690$var$atRules = /*@__PURE__*/ [
    "@charset",
    "@color-profile",
    "@container",
    "@counter-style",
    "@font-face",
    "@font-feature-values",
    "@font-palette-values",
    "@import",
    "@keyframes",
    "@layer",
    "@media",
    "@namespace",
    "@page",
    "@position-try",
    "@property",
    "@scope",
    "@starting-style",
    "@supports",
    "@view-transition"
].map((label)=>({
        type: "keyword",
        label: label
    }));
const $cd68c9f5362aa690$var$identifier = /^(\w[\w-]*|-\w[\w-]*|)$/, $cd68c9f5362aa690$var$variable = /^-(-[\w-]*)?$/;
function $cd68c9f5362aa690$var$isVarArg(node, doc) {
    var _a;
    if (node.name == "(" || node.type.isError) node = node.parent || node;
    if (node.name != "ArgList") return false;
    let callee = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.firstChild;
    if ((callee === null || callee === void 0 ? void 0 : callee.name) != "Callee") return false;
    return doc.sliceString(callee.from, callee.to) == "var";
}
const $cd68c9f5362aa690$var$VariablesByNode = /*@__PURE__*/ new (0, $b14321b77c1b25e4$export$7f13b5dc44c541ae)();
const $cd68c9f5362aa690$var$declSelector = [
    "Declaration"
];
function $cd68c9f5362aa690$var$astTop(node) {
    for(let cur = node;;){
        if (cur.type.isTop) return cur;
        if (!(cur = cur.parent)) return node;
    }
}
function $cd68c9f5362aa690$var$variableNames(doc, node, isVariable) {
    if (node.to - node.from > 4096) {
        let known = $cd68c9f5362aa690$var$VariablesByNode.get(node);
        if (known) return known;
        let result = [], seen = new Set, cursor = node.cursor((0, $b14321b77c1b25e4$export$b0e28367f55837aa).IncludeAnonymous);
        if (cursor.firstChild()) do {
            for (let option of $cd68c9f5362aa690$var$variableNames(doc, cursor.node, isVariable))if (!seen.has(option.label)) {
                seen.add(option.label);
                result.push(option);
            }
        }while (cursor.nextSibling());
        $cd68c9f5362aa690$var$VariablesByNode.set(node, result);
        return result;
    } else {
        let result = [], seen = new Set;
        node.cursor().iterate((node)=>{
            var _a;
            if (isVariable(node) && node.matchContext($cd68c9f5362aa690$var$declSelector) && ((_a = node.node.nextSibling) === null || _a === void 0 ? void 0 : _a.name) == ":") {
                let name = doc.sliceString(node.from, node.to);
                if (!seen.has(name)) {
                    seen.add(name);
                    result.push({
                        label: name,
                        type: "variable"
                    });
                }
            }
        });
        return result;
    }
}
/**
Create a completion source for a CSS dialect, providing a
predicate for determining what kind of syntax node can act as a
completable variable. This is used by language modes like Sass and
Less to reuse this package's completion logic.
*/ const $cd68c9f5362aa690$export$d81c1c660b46cb31 = (isVariable)=>(context)=>{
        let { state: state, pos: pos } = context, node = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
        let isDash = node.type.isError && node.from == node.to - 1 && state.doc.sliceString(node.from, node.to) == "-";
        if (node.name == "PropertyName" || (isDash || node.name == "TagName") && /^(Block|Styles)$/.test(node.resolve(node.to).name)) return {
            from: node.from,
            options: $cd68c9f5362aa690$var$properties(),
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (node.name == "ValueName") return {
            from: node.from,
            options: $cd68c9f5362aa690$var$values,
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (node.name == "PseudoClassName") return {
            from: node.from,
            options: $cd68c9f5362aa690$var$pseudoClasses,
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (isVariable(node) || (context.explicit || isDash) && $cd68c9f5362aa690$var$isVarArg(node, state.doc)) return {
            from: isVariable(node) || isDash ? node.from : pos,
            options: $cd68c9f5362aa690$var$variableNames(state.doc, $cd68c9f5362aa690$var$astTop(node), isVariable),
            validFor: $cd68c9f5362aa690$var$variable
        };
        if (node.name == "TagName") {
            for(let { parent: parent } = node; parent; parent = parent.parent)if (parent.name == "Block") return {
                from: node.from,
                options: $cd68c9f5362aa690$var$properties(),
                validFor: $cd68c9f5362aa690$var$identifier
            };
            return {
                from: node.from,
                options: $cd68c9f5362aa690$var$tags,
                validFor: $cd68c9f5362aa690$var$identifier
            };
        }
        if (node.name == "AtKeyword") return {
            from: node.from,
            options: $cd68c9f5362aa690$var$atRules,
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (!context.explicit) return null;
        let above = node.resolve(pos), before = above.childBefore(pos);
        if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
            from: pos,
            options: $cd68c9f5362aa690$var$pseudoClasses,
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
            from: pos,
            options: $cd68c9f5362aa690$var$values,
            validFor: $cd68c9f5362aa690$var$identifier
        };
        if (above.name == "Block" || above.name == "Styles") return {
            from: pos,
            options: $cd68c9f5362aa690$var$properties(),
            validFor: $cd68c9f5362aa690$var$identifier
        };
        return null;
    };
/**
CSS property, variable, and value keyword completion source.
*/ const $cd68c9f5362aa690$export$62bc29ba0658e894 = /*@__PURE__*/ $cd68c9f5362aa690$export$d81c1c660b46cb31((n)=>n.name == "VariableName");
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ const $cd68c9f5362aa690$export$93323d80d661fcda = /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$b243968d9fb6db03).define({
    name: "css",
    parser: /*@__PURE__*/ (0, $3c9f6e032ac605c2$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$72c7d4c52b3c6460).add({
                Declaration: /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$688ff433e7e7cc5c)()
            }),
            /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$9b075a85eb4377d8).add({
                "Block KeyframeList": (0, $8a0ff9d7afd8a874$export$48672beae16a681b)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function $cd68c9f5362aa690$export$dbf350e5966cf602() {
    return new (0, $8a0ff9d7afd8a874$export$cbdefefa8a51dd3b)($cd68c9f5362aa690$export$93323d80d661fcda, $cd68c9f5362aa690$export$93323d80d661fcda.data.of({
        autocomplete: $cd68c9f5362aa690$export$62bc29ba0658e894
    }));
}





// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const $a11afc17e0dd6580$var$chalky = "#e5c07b", $a11afc17e0dd6580$var$coral = "#e06c75", $a11afc17e0dd6580$var$cyan = "#56b6c2", $a11afc17e0dd6580$var$invalid = "#ffffff", $a11afc17e0dd6580$var$ivory = "#abb2bf", $a11afc17e0dd6580$var$stone = "#7d8799", $a11afc17e0dd6580$var$malibu = "#61afef", $a11afc17e0dd6580$var$sage = "#98c379", $a11afc17e0dd6580$var$whiskey = "#d19a66", $a11afc17e0dd6580$var$violet = "#c678dd", $a11afc17e0dd6580$var$darkBackground = "#21252b", $a11afc17e0dd6580$var$highlightBackground = "#2c313a", $a11afc17e0dd6580$var$background = "#282c34", $a11afc17e0dd6580$var$tooltipBackground = "#353a42", $a11afc17e0dd6580$var$selection = "#3E4451", $a11afc17e0dd6580$var$cursor = "#528bff";
/**
The colors used in the theme, as CSS color strings.
*/ const $a11afc17e0dd6580$export$35e9368ef982300f = {
    chalky: $a11afc17e0dd6580$var$chalky,
    coral: $a11afc17e0dd6580$var$coral,
    cyan: $a11afc17e0dd6580$var$cyan,
    invalid: $a11afc17e0dd6580$var$invalid,
    ivory: $a11afc17e0dd6580$var$ivory,
    stone: $a11afc17e0dd6580$var$stone,
    malibu: $a11afc17e0dd6580$var$malibu,
    sage: $a11afc17e0dd6580$var$sage,
    whiskey: $a11afc17e0dd6580$var$whiskey,
    violet: $a11afc17e0dd6580$var$violet,
    darkBackground: $a11afc17e0dd6580$var$darkBackground,
    highlightBackground: $a11afc17e0dd6580$var$highlightBackground,
    background: $a11afc17e0dd6580$var$background,
    tooltipBackground: $a11afc17e0dd6580$var$tooltipBackground,
    selection: $a11afc17e0dd6580$var$selection,
    cursor: $a11afc17e0dd6580$var$cursor
};
/**
The editor theme styles for One Dark.
*/ const $a11afc17e0dd6580$export$71837134942a888d = /*@__PURE__*/ (0, $e1533ef606a339de$export$eece2fccabbb77c5).theme({
    "&": {
        color: $a11afc17e0dd6580$var$ivory,
        backgroundColor: $a11afc17e0dd6580$var$background
    },
    ".cm-content": {
        caretColor: $a11afc17e0dd6580$var$cursor
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: $a11afc17e0dd6580$var$cursor
    },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
        backgroundColor: $a11afc17e0dd6580$var$selection
    },
    ".cm-panels": {
        backgroundColor: $a11afc17e0dd6580$var$darkBackground,
        color: $a11afc17e0dd6580$var$ivory
    },
    ".cm-panels.cm-panels-top": {
        borderBottom: "2px solid black"
    },
    ".cm-panels.cm-panels-bottom": {
        borderTop: "2px solid black"
    },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": {
        backgroundColor: "#6699ff0b"
    },
    ".cm-selectionMatch": {
        backgroundColor: "#aafe661a"
    },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
        backgroundColor: $a11afc17e0dd6580$var$background,
        color: $a11afc17e0dd6580$var$stone,
        border: "none"
    },
    ".cm-activeLineGutter": {
        backgroundColor: $a11afc17e0dd6580$var$highlightBackground
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: $a11afc17e0dd6580$var$tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: $a11afc17e0dd6580$var$tooltipBackground,
        borderBottomColor: $a11afc17e0dd6580$var$tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: $a11afc17e0dd6580$var$highlightBackground,
            color: $a11afc17e0dd6580$var$ivory
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the One Dark theme.
*/ const $a11afc17e0dd6580$export$e74990644b6794ed = /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$4819f093bdd5b4a).define([
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).keyword,
        color: $a11afc17e0dd6580$var$violet
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).name,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).deleted,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).character,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).propertyName,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).macroName
        ],
        color: $a11afc17e0dd6580$var$coral
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).function((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName),
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).labelName
        ],
        color: $a11afc17e0dd6580$var$malibu
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).constant((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).standard((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).name)
        ],
        color: $a11afc17e0dd6580$var$whiskey
    },
    {
        tag: [
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).definition((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).name),
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).separator
        ],
        color: $a11afc17e0dd6580$var$ivory
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).typeName,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).className,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).number,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).changed,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).annotation,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).modifier,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).self,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).namespace
        ],
        color: $a11afc17e0dd6580$var$chalky
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operator,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).operatorKeyword,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).url,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).escape,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).regexp,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).link,
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string)
        ],
        color: $a11afc17e0dd6580$var$cyan
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).meta,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).comment
        ],
        color: $a11afc17e0dd6580$var$stone
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).link,
        color: $a11afc17e0dd6580$var$stone,
        textDecoration: "underline"
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).heading,
        fontWeight: "bold",
        color: $a11afc17e0dd6580$var$coral
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).atom,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).special((0, $6fc2ba1913927f17$export$8b7a896ae75accbf).variableName)
        ],
        color: $a11afc17e0dd6580$var$whiskey
    },
    {
        tag: [
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).processingInstruction,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).string,
            (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).inserted
        ],
        color: $a11afc17e0dd6580$var$sage
    },
    {
        tag: (0, $6fc2ba1913927f17$export$8b7a896ae75accbf).invalid,
        color: $a11afc17e0dd6580$var$invalid
    }
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/ const $a11afc17e0dd6580$export$97539a48bdf87cbf = [
    $a11afc17e0dd6580$export$71837134942a888d,
    /*@__PURE__*/ (0, $8a0ff9d7afd8a874$export$ec1b956ff3a16361)($a11afc17e0dd6580$export$e74990644b6794ed)
];





const $4675e9287485f7c9$var$linterCompartment = new (0, $0f49217316d01287$export$d51c0172eb2c2431);
const $4675e9287485f7c9$var$visitorLinterCompartment = new (0, $0f49217316d01287$export$d51c0172eb2c2431);
let $4675e9287485f7c9$var$wasm;
let $4675e9287485f7c9$var$editor, $4675e9287485f7c9$var$visitorEditor, $4675e9287485f7c9$var$outputEditor, $4675e9287485f7c9$var$modulesEditor, $4675e9287485f7c9$var$depsEditor;
let $4675e9287485f7c9$var$enc = new TextEncoder();
let $4675e9287485f7c9$var$dec = new TextDecoder();
let $4675e9287485f7c9$var$inputs = document.querySelectorAll('input[type=number]');
async function $4675e9287485f7c9$var$loadVersions() {
    const { versions: versions } = await fetch('https://data.jsdelivr.com/v1/package/npm/lightningcss-wasm').then((r)=>r.json());
    versions.map((v)=>{
        const option = document.createElement('option');
        option.value = v;
        option.textContent = v;
        return option;
    }).forEach((o)=>{
        version.appendChild(o);
    });
}
async function $4675e9287485f7c9$var$loadWasm() {
    if (version.value === 'local') $4675e9287485f7c9$var$wasm = $4e05f0b265294e4f$exports;
    else $4675e9287485f7c9$var$wasm = await new Function('version', 'return import(`https://esm.sh/lightningcss-wasm@${version}?bundle`)')(version.value);
    await $4675e9287485f7c9$var$wasm.default();
}
function $4675e9287485f7c9$var$loadPlaygroundState() {
    const hash = window.location.hash.slice(1);
    try {
        return JSON.parse(decodeURIComponent(hash));
    } catch  {
        return {
            minify: minify.checked,
            visitorEnabled: visitorEnabled.checked,
            targets: $4675e9287485f7c9$var$getTargets(),
            include: 0,
            exclude: 0,
            source: `@custom-media --modern (color), (hover);

.foo {
  background: yellow;

  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;

  -webkit-transition: background 200ms;
  -moz-transition: background 200ms;
  transition: background 200ms;

  &.bar {
    color: green;
  }
}

@media (--modern) and (width > 1024px) {
  .a {
    color: green;
  }
}`,
            version: version.value,
            visitor: `{
  Color(color) {
    if (color.type === 'rgb') {
      color.g = 0;
      return color;
    }
  }
}`
        };
    }
}
function $4675e9287485f7c9$var$reflectPlaygroundState(playgroundState) {
    if (typeof playgroundState.minify !== 'undefined') minify.checked = playgroundState.minify;
    if (typeof playgroundState.cssModules !== 'undefined') {
        cssModules.checked = playgroundState.cssModules;
        compiledModules.hidden = !playgroundState.cssModules;
    }
    if (typeof playgroundState.analyzeDependencies !== 'undefined') {
        analyzeDependencies.checked = playgroundState.analyzeDependencies;
        compiledDependencies.hidden = !playgroundState.analyzeDependencies;
    }
    if (typeof playgroundState.customMedia !== 'undefined') customMedia.checked = playgroundState.customMedia;
    if (typeof playgroundState.visitorEnabled !== 'undefined') visitorEnabled.checked = playgroundState.visitorEnabled;
    if (playgroundState.targets) {
        const { targets: targets } = playgroundState;
        for (let input of $4675e9287485f7c9$var$inputs){
            let value = targets[input.id];
            input.value = value == null ? '' : value >> 16;
        }
    }
    $4675e9287485f7c9$var$updateFeatures(sidebar.elements.include, playgroundState.include);
    $4675e9287485f7c9$var$updateFeatures(sidebar.elements.exclude, playgroundState.exclude);
    if (playgroundState.include) include.parentElement.open = true;
    if (playgroundState.exclude) exclude.parentElement.open = true;
    if (playgroundState.unusedSymbols) unusedSymbols.value = playgroundState.unusedSymbols.join('\n');
    if (playgroundState.version) version.value = playgroundState.version;
}
function $4675e9287485f7c9$var$savePlaygroundState() {
    let data = new FormData(sidebar);
    const playgroundState = {
        minify: minify.checked,
        customMedia: customMedia.checked,
        cssModules: cssModules.checked,
        analyzeDependencies: analyzeDependencies.checked,
        targets: $4675e9287485f7c9$var$getTargets(),
        include: $4675e9287485f7c9$var$getFeatures(data.getAll('include')),
        exclude: $4675e9287485f7c9$var$getFeatures(data.getAll('exclude')),
        source: $4675e9287485f7c9$var$editor.state.doc.toString(),
        visitorEnabled: visitorEnabled.checked,
        visitor: $4675e9287485f7c9$var$visitorEditor.state.doc.toString(),
        unusedSymbols: unusedSymbols.value.split('\n').map((v)=>v.trim()).filter(Boolean),
        version: version.value
    };
    const hash = encodeURIComponent(JSON.stringify(playgroundState));
    if (typeof URL === 'function' && typeof history === 'object' && typeof history.replaceState === 'function') {
        const url = new URL(location.href);
        url.hash = hash;
        history.replaceState(null, null, url);
    } else location.hash = hash;
}
function $4675e9287485f7c9$var$getTargets() {
    let targets = {};
    for (let input of $4675e9287485f7c9$var$inputs)if (input.value !== '') targets[input.id] = input.valueAsNumber << 16;
    return targets;
}
function $4675e9287485f7c9$var$getFeatures(vals) {
    let features = 0;
    for (let name of vals)features |= $4675e9287485f7c9$var$wasm.Features[name];
    return features;
}
function $4675e9287485f7c9$var$updateFeatures(elements, include1) {
    for (let checkbox of elements){
        let feature = $4675e9287485f7c9$var$wasm.Features[checkbox.value];
        checkbox.checked = (include1 & feature) === feature;
        checkbox.indeterminate = !checkbox.checked && include1 & feature;
    }
}
function $4675e9287485f7c9$var$update() {
    const { transform: transform } = $4675e9287485f7c9$var$wasm;
    const targets = $4675e9287485f7c9$var$getTargets();
    let data = new FormData(sidebar);
    let include1 = $4675e9287485f7c9$var$getFeatures(data.getAll('include'));
    let exclude1 = $4675e9287485f7c9$var$getFeatures(data.getAll('exclude'));
    try {
        let res = transform({
            filename: 'test.css',
            code: $4675e9287485f7c9$var$enc.encode($4675e9287485f7c9$var$editor.state.doc.toString()),
            minify: minify.checked,
            targets: Object.keys(targets).length === 0 ? null : targets,
            include: include1,
            exclude: exclude1,
            drafts: {
                customMedia: customMedia.checked
            },
            cssModules: cssModules.checked,
            analyzeDependencies: analyzeDependencies.checked,
            unusedSymbols: unusedSymbols.value.split('\n').map((v)=>v.trim()).filter(Boolean),
            visitor: visitorEnabled.checked ? (0, eval)('(' + $4675e9287485f7c9$var$visitorEditor.state.doc.toString() + ')') : undefined
        });
        let update = $4675e9287485f7c9$var$outputEditor.state.update({
            changes: {
                from: 0,
                to: $4675e9287485f7c9$var$outputEditor.state.doc.length,
                insert: $4675e9287485f7c9$var$dec.decode(res.code)
            }
        });
        $4675e9287485f7c9$var$outputEditor.update([
            update
        ]);
        if (res.exports) {
            let update = $4675e9287485f7c9$var$modulesEditor.state.update({
                changes: {
                    from: 0,
                    to: $4675e9287485f7c9$var$modulesEditor.state.doc.length,
                    insert: '// CSS module exports\n' + JSON.stringify(res.exports, false, 2)
                }
            });
            $4675e9287485f7c9$var$modulesEditor.update([
                update
            ]);
        }
        if (res.dependencies) {
            let update = $4675e9287485f7c9$var$depsEditor.state.update({
                changes: {
                    from: 0,
                    to: $4675e9287485f7c9$var$depsEditor.state.doc.length,
                    insert: '// Dependencies\n' + JSON.stringify(res.dependencies, false, 2)
                }
            });
            $4675e9287485f7c9$var$depsEditor.update([
                update
            ]);
        }
        compiledModules.hidden = !cssModules.checked;
        compiledDependencies.hidden = !analyzeDependencies.checked;
        visitor.hidden = !visitorEnabled.checked;
        source.dataset.expanded = visitor.hidden;
        compiled.dataset.expanded = compiledModules.hidden && compiledDependencies.hidden;
        compiledModules.dataset.expanded = compiledDependencies.hidden;
        compiledDependencies.dataset.expanded = compiledModules.hidden;
        $4675e9287485f7c9$var$editor.dispatch({
            effects: $4675e9287485f7c9$var$linterCompartment.reconfigure($4675e9287485f7c9$var$createCssLinter(null, res.warnings))
        });
        $4675e9287485f7c9$var$visitorEditor.dispatch({
            effects: $4675e9287485f7c9$var$visitorLinterCompartment.reconfigure($4675e9287485f7c9$var$createVisitorLinter(null))
        });
    } catch (e) {
        let update = $4675e9287485f7c9$var$outputEditor.state.update({
            changes: {
                from: 0,
                to: $4675e9287485f7c9$var$outputEditor.state.doc.length,
                insert: `/* ERROR: ${e.message} */`
            }
        });
        $4675e9287485f7c9$var$outputEditor.update([
            update
        ]);
        $4675e9287485f7c9$var$editor.dispatch({
            effects: $4675e9287485f7c9$var$linterCompartment.reconfigure($4675e9287485f7c9$var$createCssLinter(e))
        });
        $4675e9287485f7c9$var$visitorEditor.dispatch({
            effects: $4675e9287485f7c9$var$visitorLinterCompartment.reconfigure($4675e9287485f7c9$var$createVisitorLinter(e))
        });
    }
    $4675e9287485f7c9$var$savePlaygroundState();
}
function $4675e9287485f7c9$var$createCssLinter(lastError, warnings) {
    return (0, $a1d5d2ed45a1681c$export$8bb7ef7a8be4cb1c)((view)=>{
        let diagnostics = [];
        if (lastError && lastError.loc) {
            let l = view.state.doc.line(lastError.loc.line);
            let loc = l.from + lastError.loc.column - 1;
            let node = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(view.state).resolveInner(loc, 1);
            diagnostics.push({
                from: node.from,
                to: node.to,
                message: lastError.message,
                severity: 'error'
            });
        }
        if (warnings) for (let warning of warnings){
            let l = view.state.doc.line(warning.loc.line);
            let loc = l.from + warning.loc.column - 1;
            let node = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(view.state).resolveInner(loc, 1);
            diagnostics.push({
                from: node.from,
                to: node.to,
                message: warning.message,
                severity: 'warning'
            });
        }
        return diagnostics;
    }, {
        delay: 0
    });
}
function $4675e9287485f7c9$var$createVisitorLinter(lastError) {
    return (0, $a1d5d2ed45a1681c$export$8bb7ef7a8be4cb1c)((view)=>{
        if (lastError && !lastError.loc) {
            // Firefox has lineNumber and columnNumber, Safari has line and column.
            let line = lastError.lineNumber ?? lastError.line;
            let column = lastError.columnNumber ?? lastError.column;
            if (lastError.column != null) column--;
            if (line == null) {
                // Chrome.
                let match = lastError.stack.match(/(?:(?:eval.*<anonymous>:)|(?:eval:))(?<line>\d+):(?<column>\d+)/);
                if (match) {
                    line = Number(match.groups.line);
                    column = Number(match.groups.column);
                    // Chrome's column numbers are off by the amount of leading whitespace in the line.
                    let l = view.state.doc.line(line);
                    let m = l.text.match(/^\s*/);
                    if (m) column += m[0].length;
                }
            }
            if (line != null) {
                let l = view.state.doc.line(line);
                let loc = l.from + column;
                let node = (0, $8a0ff9d7afd8a874$export$7fc98e56a4ca6be1)(view.state).resolveInner(loc, -1);
                return [
                    {
                        from: node.from,
                        to: node.to,
                        message: lastError.message,
                        severity: 'error'
                    }
                ];
            }
        }
        return [];
    }, {
        delay: 0
    });
}
function $4675e9287485f7c9$var$renderFeatures(parent, name) {
    for(let feature in $4675e9287485f7c9$var$wasm.Features){
        let label = document.createElement('label');
        let checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = name;
        checkbox.value = feature;
        checkbox.oninput = ()=>{
            let data = new FormData(sidebar);
            let flags = $4675e9287485f7c9$var$getFeatures(data.getAll(name));
            let f = $4675e9287485f7c9$var$wasm.Features[feature];
            if (checkbox.checked) flags |= f;
            else flags &= ~f;
            $4675e9287485f7c9$var$updateFeatures(sidebar.elements[name], flags);
        };
        label.appendChild(checkbox);
        label.appendChild(document.createTextNode(' ' + feature));
        parent.appendChild(label);
    }
}
async function $4675e9287485f7c9$var$main() {
    await $4675e9287485f7c9$var$loadWasm();
    $4675e9287485f7c9$var$renderFeatures(include, 'include');
    $4675e9287485f7c9$var$renderFeatures(exclude, 'exclude');
    let state = $4675e9287485f7c9$var$loadPlaygroundState();
    $4675e9287485f7c9$var$reflectPlaygroundState(state);
    $4675e9287485f7c9$var$editor = new (0, $e1533ef606a339de$export$eece2fccabbb77c5)({
        extensions: [
            (0, $a1d5d2ed45a1681c$export$3a68dabf7c007d32)(),
            (0, $ae72bdec652266e7$export$f4f2465c1e83499c),
            (0, $cd68c9f5362aa690$export$dbf350e5966cf602)(),
            (0, $a11afc17e0dd6580$export$97539a48bdf87cbf),
            $4675e9287485f7c9$var$linterCompartment.of($4675e9287485f7c9$var$createCssLinter())
        ],
        parent: source,
        doc: state.source,
        dispatch (tr) {
            $4675e9287485f7c9$var$editor.update([
                tr
            ]);
            if (tr.docChanged) $4675e9287485f7c9$var$update();
        }
    });
    $4675e9287485f7c9$var$visitorEditor = new (0, $e1533ef606a339de$export$eece2fccabbb77c5)({
        extensions: [
            (0, $a1d5d2ed45a1681c$export$3a68dabf7c007d32)(),
            (0, $ae72bdec652266e7$export$f4f2465c1e83499c),
            (0, $6d2caf576f84b9f7$export$755219397dca4f08)(),
            (0, $a11afc17e0dd6580$export$97539a48bdf87cbf),
            $4675e9287485f7c9$var$visitorLinterCompartment.of($4675e9287485f7c9$var$createVisitorLinter())
        ],
        parent: visitor,
        doc: state.visitor,
        dispatch (tr) {
            $4675e9287485f7c9$var$visitorEditor.update([
                tr
            ]);
            if (tr.docChanged) $4675e9287485f7c9$var$update();
        }
    });
    $4675e9287485f7c9$var$outputEditor = new (0, $e1533ef606a339de$export$eece2fccabbb77c5)({
        extensions: [
            (0, $ae72bdec652266e7$export$f4f2465c1e83499c),
            (0, $cd68c9f5362aa690$export$dbf350e5966cf602)(),
            (0, $a11afc17e0dd6580$export$97539a48bdf87cbf),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).editable.of(false),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).lineWrapping
        ],
        parent: compiled
    });
    $4675e9287485f7c9$var$modulesEditor = new (0, $e1533ef606a339de$export$eece2fccabbb77c5)({
        extensions: [
            (0, $ae72bdec652266e7$export$f4f2465c1e83499c),
            (0, $6d2caf576f84b9f7$export$755219397dca4f08)(),
            (0, $a11afc17e0dd6580$export$97539a48bdf87cbf),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).editable.of(false),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).lineWrapping
        ],
        parent: compiledModules
    });
    $4675e9287485f7c9$var$depsEditor = new (0, $e1533ef606a339de$export$eece2fccabbb77c5)({
        extensions: [
            (0, $ae72bdec652266e7$export$f4f2465c1e83499c),
            (0, $6d2caf576f84b9f7$export$755219397dca4f08)(),
            (0, $a11afc17e0dd6580$export$97539a48bdf87cbf),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).editable.of(false),
            (0, $e1533ef606a339de$export$eece2fccabbb77c5).lineWrapping
        ],
        parent: compiledDependencies
    });
    $4675e9287485f7c9$var$update();
    sidebar.oninput = $4675e9287485f7c9$var$update;
    await $4675e9287485f7c9$var$loadVersions();
    version.onchange = async ()=>{
        await $4675e9287485f7c9$var$loadWasm();
        $4675e9287485f7c9$var$update();
    };
}
$4675e9287485f7c9$var$main();


//# sourceMappingURL=index.55723f0c.js.map
